(function() {
    const CONSUMERLITE_CHAT_WIDGET_VERSION = "V35.3.31_CONTEXT_CONFIRMATIONS";

    function init() {
        if (window.__CONSUMERLITE_CHAT_WIDGET_VERSION__ === CONSUMERLITE_CHAT_WIDGET_VERSION) return;
        document.querySelectorAll(".cl-chat-launcher").forEach(function(el) {
            el.remove()
        }), document.querySelectorAll("style[data-consumerlite-chat-style]").forEach(function(el) {
            el.remove()
        }), window.__CONSUMERLITE_CHAT_WIDGET_VERSION__ = CONSUMERLITE_CHAT_WIDGET_VERSION;
        let consumerliteConversationGeneration = 0, consumerliteEditRevision = 0, consumerlitePendingSendCount = 0;
        const CHAT_SESSION_STORAGE_KEY = "consumerlite_chat_session_v35_3_3",
            LEGACY_CHAT_SESSION_KEYS = ["consumerlite_chat_session_v1", "consumerlite_chat_session_v2", "consumerlite_chat_session_v3", "consumerlite_chat_session_v4", "consumerlite_chat_session_v5", "consumerlite_chat_session_v6", "consumerlite_chat_session_v7", "consumerlite_chat_session_v8", "consumerlite_chat_session_v9", "consumerlite_chat_session_v10", "consumerlite_chat_session_v11", "consumerlite_chat_session_v12", "consumerlite_chat_session_v13", "consumerlite_chat_session_v14", "consumerlite_chat_session_v15", "consumerlite_chat_session_v16", "consumerlite_chat_session_v17", "consumerlite_chat_session_v18", "consumerlite_chat_session_v19", "consumerlite_chat_session_v20", "consumerlite_chat_session_v21", "consumerlite_chat_session_v22", "consumerlite_chat_session_v23", "consumerlite_chat_session_v24", "consumerlite_chat_session_v25", "consumerlite_chat_session_v26", "consumerlite_chat_session_v27", "consumerlite_chat_session_v28", "consumerlite_chat_session_v29", "consumerlite_chat_session_v30", "consumerlite_chat_session_v31", "consumerlite_chat_session_v32", "consumerlite_chat_session_v33", "consumerlite_chat_session_v34", "consumerlite_chat_session_v35", "consumerlite_chat_session_v35_1", "consumerlite_chat_session_v35_3_1"],
            CHAT_SESSION_TTL_MS = 1e3 * 60 * 60 * 6,
            MAX_HISTORY_ITEMS = 24,
            MAX_UI_ITEMS = 48;
        clearLegacyChatSessions();
        const restoredSession = loadStoredChatSession(),
            conversationHistory = Array.isArray(restoredSession.history) ? restoredSession.history.slice(-MAX_HISTORY_ITEMS) : [],
            conversationContext = restoredSession.context && typeof restoredSession.context == "object" ? restoredSession.context : {},
            conversationUiItems = Array.isArray(restoredSession.uiItems) ? restoredSession.uiItems.slice(-MAX_UI_ITEMS) : [],
            trustedCartVariantIds = new Set,
            consumerliteVariantLoadCache = new Map,
            CONSUMERLITE_VARIANT_LOAD_CACHE_TTL_MS = 300 * 1e3,
            consumerliteSelectedVariants = new Map,
            restoredSelectedVariants = restoredSession.selectedVariants && typeof restoredSession.selectedVariants == "object" ? restoredSession.selectedVariants : {};
        Object.keys(restoredSelectedVariants).slice(0, 12).forEach(function(handle) {
            const record = restoredSelectedVariants[handle];
            !record || !record.variant || !record.variant.id || (consumerliteSelectedVariants.set(String(handle), record), trustedCartVariantIds.add(String(record.variant.id)))
        });
        let consumerliteAtelierState = restoredSession.atelierState && typeof restoredSession.atelierState == "object" ? Object.assign({
                collapsed: !0
            }, restoredSession.atelierState) : {
                currentLook: [],
                previousLook: [],
                refinedLook: [],
                comparison: null,
                readiness: null,
                sessionToken: "",
                sessionId: "",
                revision: 0,
                collapsed: !0,
                updatedAt: 0
            },
            consumerliteMemberAtelierState = {
                status: "unknown",
                authenticated: !1,
                items: [],
                itemCount: 0,
                chatIdentityToken: "",
                chatIdentityExpiresAt: 0,
                updatedAt: 0
            },
            consumerliteMemberAtelierLoadPromise = null,
            consumerliteAtelierSyncTimer = null,
            consumerliteAtelierSyncInFlight = !1,
            activeConsumerliteCommerceOverlay = null,
            activeConsumerliteCommerceReturnFocus = null,
            lastPersistedPanelOpen = !!restoredSession.panelOpen;
        const INTRO_TEXT = "Weather-aware styling. Curated luxury. Effortless shopping, tailored to you.",
            TRACKING_TELLUS_CONTEXT_KEY = "consumerlite:tellus:tracking-context:v31",
            TRACKING_AUTO_STYLE_PROMPT = "Build a full outfit around this exact purchased product.",
            TRACKING_AUTO_STYLE_SOURCE = "tracking_purchase_cta",
            TRACKING_DIVERSITY_STORAGE_KEY = "consumerlite:tellus:tracking-diversity:v1",
            TRACKING_DIVERSITY_TTL_MS = 336 * 60 * 60 * 1e3,
            TRACKING_DIVERSITY_MAX_ANCHORS = 24,
            TRACKING_DIVERSITY_MAX_HANDLES = 48,
            TRACKING_DIVERSITY_MAX_SIGNATURES = 18;
        let trackingPurchaseAutoStyleInFlight = !1,
            lastTrackingPurchaseActivationId = "";

        let consumerliteOrders = {active:false,orders:[],selected:null,ownerRef:"",checkedAt:"",hasNextPage:false,endCursor:""};
        let consumerliteOrderEpoch = 0, consumerliteOrderBusy = false, consumerliteOrderRoot = null;
        let consumerlitePurchaseEpoch = 0, consumerlitePurchaseBusy = false, consumerlitePurchaseRoot = null;
        let consumerlitePurchase = {stage:"",product:null,selectedOptions:[]};


        function consumerliteOpeningGreetingText(options) {
            let member = null;
            try {
                member = window.ConsumerliteTellusGreeting && window.ConsumerliteTellusGreeting.get(options || {});
            } catch {}
            if (!member || !member.text) {
                delete conversationContext.tellusOpeningGreeting;
                return INTRO_TEXT;
            }
            const previous = conversationContext.tellusOpeningGreeting;
            if (!(options && options.newConversation) && previous && previous.firstName === member.firstName && previous.text) {
                return previous.text;
            }
            const text = sanitizeReplyText(member.text).slice(0, 240);
            conversationContext.tellusOpeningGreeting = {firstName: member.firstName, text};
            return text;
        }

        function isConsumerliteOpeningGreetingText(text) {
            return text === INTRO_TEXT || text === (conversationContext.tellusOpeningGreeting || {}).text;
        }

        function reconcileConsumerliteOpeningGreeting() {
            const previous = conversationContext.tellusOpeningGreeting;
            const oldText = previous && previous.text || INTRO_TEXT;
            const nextText = consumerliteOpeningGreetingText();
            // Update only the opening, never insert a new greeting into an ongoing exchange.
            // Re-check the server-rendered identity instead of trusting a cached name after logout.
            if (oldText === nextText) return;
            conversationUiItems.forEach(function(item) {
                if (item && item.type === "msg" && item.role !== "user" && item.text === oldText) item.text = nextText;
            });
            conversationHistory.forEach(function(item) {
                if (item && normalizeRole(item.role) === "assistant" && item.text === oldText) item.text = nextText;
            });
        }

        function isConsumerliteTrackingPage() {
            try {
                return /\/tools\/tracking(?:\/|$)/i.test(String(window.location && window.location.pathname || ""))
            } catch {
                return !1
            }
        }

        function normalizeTrackingPurchaseAudience(value) {
            const clean = normalizeLiteText(value || "");
            return /^(men|mens|man|male)$/.test(clean) ? "MEN" : /^(women|womens|woman|female|ladies)$/.test(clean) ? "WOMEN" : /^(unisex|all gender|all genders|gender neutral)$/.test(clean) ? "UNISEX" : "UNKNOWN"
        }

        function sanitizeConsumerliteTrackingPurchaseContext(source) {
            const raw = source && typeof source == "object" ? source : null;
            if (!raw || normalizeLiteText(raw.source || "") !== "tracking" || normalizeLiteText(raw.intent || "").replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim() !== "style purchased item") return null;
            const title = String(raw.title || "").trim().slice(0, 180),
                handle = String(raw.handle || "").trim().replace(/^\/+|\/+$/g, "").slice(0, 180),
                productUrl = safeUrl(raw.product_url || raw.url || (handle ? "/products/" + handle : ""));
            if (!title && !handle && !productUrl) return null;
            const audienceHint = normalizeTrackingPurchaseAudience(raw.audience || raw.audienceHint || ""),
                department = normalizeLiteText(raw.department || "").slice(0, 60),
                category = normalizeLiteText(raw.category || "").slice(0, 80),
                variant = String(raw.variant || raw.variant_title || "").trim().slice(0, 140);
            return {
                hasPageProduct: !0,
                locked: !0,
                source: "tracking_purchase",
                anchorSource: "tracking_purchase",
                title,
                handle,
                url: productUrl,
                image: safeUrl(raw.image || ""),
                price: "",
                productType: category,
                vendor: "Consumerlite",
                tags: [],
                collectionHandles: [],
                collectionTitles: [],
                productIntelligence: {
                    gender: audienceHint,
                    department,
                    category
                },
                audienceHint,
                variant,
                variantTitle: variant,
                shipmentState: String(raw.shipment_state || "").trim().slice(0, 80),
                productId: String(raw.product_id || "").trim().slice(0, 80),
                trackingContextVersion: String(raw.version || "3.1").trim().slice(0, 20),
                autoBuild: raw.auto_build === !0 || raw.autoBuild === !0,
                styleMode: normalizeLiteText(raw.style_mode || raw.styleMode || "full_outfit").replace(/\s+/g, "_").slice(0, 40),
                activationSource: String(raw.activation_source || raw.activationSource || "").trim().slice(0, 80),
                activationId: String(raw.activation_id || raw.activationId || "").trim().slice(0, 120)
            }
        }

        function clearConsumerliteTrackingPurchaseAnchor(options) {
            const opts = options && typeof options == "object" ? options : {};
            if (delete conversationContext.trackingPurchaseAnchor, conversationContext.trackingPurchaseAnchorActive = !1, conversationContext.trackingPurchaseAnchorCleared = !0, opts.clearSharedContext !== !1) {
                try {
                    window.sessionStorage.removeItem(TRACKING_TELLUS_CONTEXT_KEY)
                } catch {}
                try {
                    window.ConsumerliteTellusTrackingContext = null
                } catch {}
            }
            persistChatSession()
        }

        function activateConsumerliteTrackingPurchaseAnchor(source) {
            if (!isConsumerliteTrackingPage()) return null;
            const anchor = sanitizeConsumerliteTrackingPurchaseContext(source);
            return anchor ? (conversationContext.trackingPurchaseAnchor = anchor, conversationContext.trackingPurchaseAnchorActive = !0, conversationContext.trackingPurchaseAnchorCleared = !1, persistChatSession(), anchor) : null
        }

        function getActiveConsumerliteTrackingPurchaseAnchor() {
            if (!isConsumerliteTrackingPage() || conversationContext.trackingPurchaseAnchorCleared === !0) return null;
            const stored = conversationContext.trackingPurchaseAnchor && typeof conversationContext.trackingPurchaseAnchor == "object" ? sanitizeConsumerliteTrackingPurchaseContext(Object.assign({
                source: "tracking",
                intent: "style-purchased-item"
            }, conversationContext.trackingPurchaseAnchor, {
                source: "tracking",
                intent: "style-purchased-item"
            })) : null;
            return stored || (sanitizeConsumerliteTrackingPurchaseContext(window.ConsumerliteTellusTrackingContext || null) ? activateConsumerliteTrackingPurchaseAnchor(window.ConsumerliteTellusTrackingContext) : null)
        }

        function handleConsumerliteTellusTrackingContext(event) {
            const detail = event && event.detail && typeof event.detail == "object" ? event.detail : null;
            activateConsumerliteTrackingPurchaseAnchor(detail)
        }

        function trackingPurchaseActivationId(anchor) {
            const supplied = String(anchor && anchor.activationId || "").trim();
            if (supplied) return supplied;
            let nonce = "";
            try {
                if (window.crypto && typeof window.crypto.randomUUID == "function") nonce = window.crypto.randomUUID();
                else if (window.crypto && typeof window.crypto.getRandomValues == "function") {
                    const values = new Uint32Array(2);
                    window.crypto.getRandomValues(values), nonce = Array.from(values).map(function(value) {
                        return value.toString(36)
                    }).join("")
                }
            } catch {}
            return nonce || (nonce = Math.random().toString(36).slice(2, 12)), ["tracking", String(anchor && (anchor.productId || anchor.handle || anchor.title) || "product"), String(Date.now()), nonce].join(":")
        }

        function trackingDiversityAnchorKey(anchor) {
            const audience = String(anchor && anchor.audienceHint || "UNKNOWN").toUpperCase(),
                identity = String(anchor && (anchor.handle || anchor.productId || anchor.title) || "product").toLowerCase().replace(/[^a-z0-9:_-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 180);
            return [audience, identity || "product"].join("|")
        }

        function trackingDiversitySlotOrder(product) {
            const slot = String(product && (product.outfitSlot || product.productLabelKey || product.__outfitSlot) || "").toLowerCase();
            return Number({
                top: 1,
                onepiece: 1,
                bottom: 2,
                layer: 3,
                shoes: 4,
                footwear: 4,
                bag: 5,
                accessory: 6
            } [slot] || 9)
        }

        function trackingDiversityOutfitSignature(products) {
            return (Array.isArray(products) ? products : []).filter(function(product) {
                return product && product.handle
            }).slice().sort(function(a, b) {
                return trackingDiversitySlotOrder(a) - trackingDiversitySlotOrder(b)
            }).map(function(product) {
                return String(product.handle || "").toLowerCase()
            }).join("|").slice(0, 700)
        }

        function loadTrackingDiversityStore() {
            const fallback = {
                version: 1,
                entries: {}
            };
            try {
                if (!window.localStorage) return fallback;
                const raw = window.localStorage.getItem(TRACKING_DIVERSITY_STORAGE_KEY);
                if (!raw) return fallback;
                const parsed = JSON.parse(raw),
                    source = parsed && typeof parsed == "object" ? parsed : fallback,
                    entries = source.entries && typeof source.entries == "object" ? source.entries : {},
                    now = Date.now(),
                    cleanEntries = {};
                Object.keys(entries).forEach(function(key) {
                    const entry = entries[key],
                        updatedAt = Number(entry && entry.updatedAt || 0);
                    !updatedAt || now - updatedAt > TRACKING_DIVERSITY_TTL_MS || (cleanEntries[key] = {
                        updatedAt,
                        recentProductHandles: Array.isArray(entry.recentProductHandles) ? entry.recentProductHandles.map(String).filter(Boolean).slice(-TRACKING_DIVERSITY_MAX_HANDLES) : [],
                        recentOutfitSignatures: Array.isArray(entry.recentOutfitSignatures) ? entry.recentOutfitSignatures.map(String).filter(Boolean).slice(-TRACKING_DIVERSITY_MAX_SIGNATURES) : []
                    })
                });
                const orderedKeys = Object.keys(cleanEntries).sort(function(a, b) {
                        return Number(cleanEntries[b].updatedAt || 0) - Number(cleanEntries[a].updatedAt || 0)
                    }).slice(0, TRACKING_DIVERSITY_MAX_ANCHORS),
                    limited = {};
                return orderedKeys.forEach(function(key) {
                    limited[key] = cleanEntries[key]
                }), {
                    version: 1,
                    entries: limited
                }
            } catch {
                return fallback
            }
        }

        function saveTrackingDiversityStore(store) {
            try {
                if (!window.localStorage) return;
                window.localStorage.setItem(TRACKING_DIVERSITY_STORAGE_KEY, JSON.stringify(store && typeof store == "object" ? store : {
                    version: 1,
                    entries: {}
                }))
            } catch {}
        }

        function readTrackingSharedDiversity(anchor) {
            const store = loadTrackingDiversityStore(),
                key = trackingDiversityAnchorKey(anchor),
                entry = store.entries && store.entries[key] && typeof store.entries[key] == "object" ? store.entries[key] : {};
            return {
                recentProductHandles: Array.isArray(entry.recentProductHandles) ? entry.recentProductHandles.slice(-TRACKING_DIVERSITY_MAX_HANDLES) : [],
                recentOutfitSignatures: Array.isArray(entry.recentOutfitSignatures) ? entry.recentOutfitSignatures.slice(-TRACKING_DIVERSITY_MAX_SIGNATURES) : [],
                updatedAt: Number(entry.updatedAt || 0)
            }
        }

        function rememberTrackingSharedDiversity(anchor, products) {
            if (!anchor || !Array.isArray(products) || !products.length) return;
            const key = trackingDiversityAnchorKey(anchor);
            if (!key) return;
            const store = loadTrackingDiversityStore(),
                existing = store.entries[key] && typeof store.entries[key] == "object" ? store.entries[key] : {},
                newHandles = products.map(function(product) {
                    return String(product && product.handle || "").toLowerCase()
                }).filter(Boolean),
                recentHandles = Array.isArray(existing.recentProductHandles) ? existing.recentProductHandles.slice() : [];
            newHandles.forEach(function(handle) {
                const filtered = recentHandles.filter(function(item) {
                    return item !== handle
                });
                recentHandles.splice(0, recentHandles.length), Array.prototype.push.apply(recentHandles, filtered), recentHandles.push(handle)
            });
            const signature = trackingDiversityOutfitSignature(products),
                signatures = Array.isArray(existing.recentOutfitSignatures) ? existing.recentOutfitSignatures.filter(Boolean) : [],
                nextSignatures = signature ? signatures.filter(function(item) {
                    return item !== signature
                }).concat([signature]) : signatures;
            store.entries[key] = {
                updatedAt: Date.now(),
                recentProductHandles: recentHandles.slice(-TRACKING_DIVERSITY_MAX_HANDLES),
                recentOutfitSignatures: nextSignatures.slice(-TRACKING_DIVERSITY_MAX_SIGNATURES)
            }, saveTrackingDiversityStore(store), conversationContext.trackingPurchaseSharedRecentProductHandles = store.entries[key].recentProductHandles.slice(), conversationContext.trackingPurchaseSharedRecentOutfitSignatures = store.entries[key].recentOutfitSignatures.slice(), conversationContext.trackingPurchaseSharedDiversityUpdatedAt = store.entries[key].updatedAt
        }

        function applyTrackingSharedDiversityToContext(anchor) {
            const shared = readTrackingSharedDiversity(anchor);
            return conversationContext.trackingPurchaseSharedRecentProductHandles = shared.recentProductHandles.slice(), conversationContext.trackingPurchaseSharedRecentOutfitSignatures = shared.recentOutfitSignatures.slice(), conversationContext.trackingPurchaseSharedDiversityUpdatedAt = shared.updatedAt, shared
        }

        function isPristineGenericIntroState() {
            const ui = Array.isArray(conversationUiItems) ? conversationUiItems : [],
                history = Array.isArray(conversationHistory) ? conversationHistory : [],
                hasUserUiMessage = ui.some(function(item) {
                    return item && item.type === "msg" && item.role === "user" && String(item.text || "").trim()
                }),
                hasResultUi = ui.some(function(item) {
                    return item && (item.type === "products" || item.type === "collections" || item.type === "cta" || item.type === "anchor_note" || item.type === "fullLookAction")
                }),
                assistantUiMessages = ui.filter(function(item) {
                    return item && item.type === "msg" && item.role !== "user"
                }).map(function(item) {
                    return String(item.text || "").trim()
                }).filter(Boolean),
                meaningfulHistory = history.some(function(item) {
                    const role = normalizeRole(item && item.role || ""),
                        text = String(item && (item.text || item.content) || "").trim();
                    return !(!text || role === "assistant" && isConsumerliteOpeningGreetingText(text))
                });
            return hasUserUiMessage || hasResultUi || meaningfulHistory ? !1 : assistantUiMessages.every(function(text) {
                return isConsumerliteOpeningGreetingText(text)
            })
        }

        function clearPristineGenericIntroForTrackingAutoStyle() {
            if (!isPristineGenericIntroState()) return !1;
            conversationUiItems.splice(0, conversationUiItems.length);
            for (let i = conversationHistory.length - 1; i >= 0; i--) {
                const role = normalizeRole(conversationHistory[i] && conversationHistory[i].role || ""),
                    text = String(conversationHistory[i] && (conversationHistory[i].text || conversationHistory[i].content) || "").trim();
                role === "assistant" && isConsumerliteOpeningGreetingText(text) && conversationHistory.splice(i, 1)
            }
            return body && (body.innerHTML = "", delete body.dataset.inited), persistChatSession(), !0
        }

        function resetTrackingActivationContextState(targetContext) {
            const ctx = targetContext && typeof targetContext == "object" ? targetContext : {};
            return ["pendingRequest", "originalRequest", "lastMeaningfulUserText", "pendingAudience", "pendingWeatherRequest", "pendingWeatherDate", "pendingWeatherOutfitContext", "pendingGiftAdvisorRequest", "pendingGiftAdvisorAudience", "pendingGiftRecipient", "pendingCollectionBrowseCategory", "pendingPageProductStyleRequest", "pendingPageProductStyleAudience", "pendingActivityRequest", "pendingActivityId", "pendingOccasionMicroQuestionType", "pendingOccasionMicroQuestionRequest", "pendingRetailConfidenceRequest", "tailoringRequestType", "partialPersonalization", "pageProductContext", "lastPageProductContext", "pageProduct", "currentPageProduct", "memberAtelierAnchor", "anchorProduct", "anchorSlot", "anchorSource", "styleAroundNote", "refinement", "lookComparison"].forEach(function(key) {
                delete ctx[key]
            }), ["weatherOutfitDetailsNeeded", "weatherLocationNeeded", "tailoringDetailsNeeded", "pendingWeatherOutfitOffer", "pendingGiftAdvisor", "pendingGiftAdvisorBudget", "pendingCollectionBrowse", "pendingPageProductStyleMode", "pendingActivityClarification", "pendingOccasionMicroQuestion", "pendingRetailConfidenceClarification", "pendingTrendingRequest", "anchorProductLocked", "currentLookLocked", "currentLookMemoryLocked", "canUndoRefinement", "canRedoRefinement", "trackingPurchaseWeatherPrecisionPending", "trackingPurchasePrecisionDismissed", "trackingInitialBuildHardRoute"].forEach(function(key) {
                ctx[key] = !1
            }), ["lastProducts", "currentLookProducts", "previousLookProducts", "proposedLookProducts", "redoLookProducts", "lastProductHandles", "lastOutfitProductHandles"].forEach(function(key) {
                ctx[key] = []
            }), ["currentLookRequest", "lastOutfitRequest", "lastOutfitAudience", "refinementStatus", "replacementStatus", "refinementHistoryMode", "comparisonStatus", "trackingPurchasePrecisionActivationId", "trackingPurchasePrecisionOccasion", "trackingPurchasePrecisionLocation", "trackingPurchasePrecisionDateTime", "trackingPurchaseLastPrecisionOccasion", "trackingPurchaseLastPrecisionLocation", "trackingPurchaseLastPrecisionDateTime", "trackingPurchaseStyleProfile"].forEach(function(key) {
                ctx[key] = ""
            }), ["trackingPurchaseSharedRecentProductHandles", "trackingPurchaseSharedRecentOutfitSignatures"].forEach(function(key) {
                ctx[key] = []
            }), ctx.trackingPurchaseSharedDiversityUpdatedAt = 0, ctx.clearProductCards = !1, ctx.preserveCurrentLook = !1, ctx
        }

        function resetConsumerliteTrackingActivationScope(anchor, activationId) {
            clearConsumerlitePurchaseHelp();
            clearConsumerlitePrivateOrders();
            resetTrackingActivationContextState(conversationContext), conversationHistory.splice(0, conversationHistory.length), conversationUiItems.splice(0, conversationUiItems.length), consumerliteSelectedVariants.clear();
            const priorAtelier = consumerliteAtelierState && typeof consumerliteAtelierState == "object" ? consumerliteAtelierState : {};
            return consumerliteAtelierState = {
                currentLook: [],
                previousLook: [],
                refinedLook: [],
                comparison: null,
                readiness: null,
                sessionToken: String(priorAtelier.sessionToken || ""),
                sessionId: String(priorAtelier.sessionId || ""),
                revision: Number(priorAtelier.revision || 0),
                collapsed: !0,
                updatedAt: Date.now()
            }, consumerliteAtelierSyncTimer && (window.clearTimeout(consumerliteAtelierSyncTimer), consumerliteAtelierSyncTimer = null), closeConsumerliteCommerceOverlay(), atelier && (atelier.innerHTML = "", atelier.setAttribute("hidden", "")), body && (body.innerHTML = "", body.removeAttribute("data-inited")), conversationContext.trackingPurchaseAnchor = anchor, conversationContext.trackingPurchaseAnchorActive = !0, conversationContext.trackingPurchaseAnchorCleared = !1, conversationContext.trackingPurchaseAutoStyleRequested = !0, conversationContext.trackingPurchaseActivationSource = TRACKING_AUTO_STYLE_SOURCE, conversationContext.trackingPurchaseActivationId = String(activationId || ""), applyTrackingSharedDiversityToContext(anchor), anchor && (anchor.audienceHint === "MEN" || anchor.audienceHint === "WOMEN") && (conversationContext.lastAudience = anchor.audienceHint), persistChatSession(), renderConsumerliteAtelierWorkspace(), conversationContext
        }
        async function styleConsumerliteTrackingPurchaseFromPublic(source) {
            if (!isConsumerliteTrackingPage()) return !1;
            const anchor = sanitizeConsumerliteTrackingPurchaseContext(source);
            if (!anchor || !anchor.hasPageProduct) return !1;
            const activationId = trackingPurchaseActivationId(anchor);
            if (trackingPurchaseAutoStyleInFlight && lastTrackingPurchaseActivationId === activationId) return !0;
            trackingPurchaseAutoStyleInFlight = !0, lastTrackingPurchaseActivationId = activationId, resetConsumerliteTrackingActivationScope(anchor, activationId), open({
                suppressIntro: !0
            }), trackConsumerliteChatEvent("tracking_purchase_auto_style_started", {
                productHandle: String(anchor.handle || ""),
                audience: String(anchor.audienceHint || ""),
                category: String(anchor.productType || "")
            });
            try {
                return await doSend({
                    sendText: TRACKING_AUTO_STYLE_PROMPT,
                    historyText: TRACKING_AUTO_STYLE_PROMPT,
                    source: TRACKING_AUTO_STYLE_SOURCE,
                    suppressUserBubble: !0,
                    preserveLanguage: !0,
                    loadingText: "Styling your new arrival\u2026"
                }), !0
            } finally {
                trackingPurchaseAutoStyleInFlight = !1, conversationContext.trackingPurchaseAutoStyleRequested = !1, persistChatSession()
            }
        }

        function handleConsumerliteTellusTrackingAutoStyle(event) {
            const detail = event && event.detail && typeof event.detail == "object" ? event.detail : null;
            styleConsumerliteTrackingPurchaseFromPublic(detail)
        }
        isConsumerliteTrackingPage() ? window.ConsumerliteTellusTrackingContext && activateConsumerliteTrackingPurchaseAnchor(window.ConsumerliteTellusTrackingContext) : (delete conversationContext.trackingPurchaseAnchor, conversationContext.trackingPurchaseAnchorActive = !1, conversationContext.trackingPurchaseAnchorCleared = !1), window.addEventListener("consumerlite:tellus-context", handleConsumerliteTellusTrackingContext), window.addEventListener("consumerlite:tellus-style-purchase", handleConsumerliteTellusTrackingAutoStyle);
        const INTRO_SUGGESTIONS = [{
            key: "SEASONAL_OUTFIT",
            label: "Seasonal outfit",
            prompt: "Seasonal outfit",
            action: "SHOW_SEASONS"
        }, {
            key: "WEATHER_OUTFIT",
            label: "Weather outfit",
            prompt: "I want a weather-aware outfit"
        }, {
            key: "OCCASION_OUTFIT",
            label: "Occasion outfit",
            prompt: "I want an outfit for an occasion"
        }, {
            key: "TRENDING",
            label: "Trending",
            prompt: "What is trending?"
        }, {
            key: "BROWSE_COLLECTIONS",
            label: "Browse collections",
            prompt: "Show me all collections"
        }, {
            key: "WHAT_CAN_YOU_DO",
            label: "What can you do?",
            prompt: "What can you do?"
        }];

        function getIntroSuggestions() {
            const base = INTRO_SUGGESTIONS.map(function(item) {
                return Object.assign({
                    canonicalPrompt: item.prompt || item.label || ""
                }, item)
            });
            return !conversationContext.tellusFreshStartHome && extractCurrentPageProductContext() ? [{
                key: "COMPLETE_LOOK_PRODUCT_PAGE",
                label: "Complete the look",
                prompt: "Complete the look",
                canonicalPrompt: "Complete the look"
            }, {
                key: "STYLE_THIS_PRODUCT",
                label: "Style this product",
                prompt: "Style this product",
                canonicalPrompt: "Style this product"
            }].concat(base) : base
        }
        const UI_TRANSLATIONS = {
                en: {
                    PLACEHOLDER: "Ask about styling, products, occasions\u2026",
                    SEND: "Send",
                    CHAT: "Chat",
                    OPEN_CHAT: "Open chat",
                    CLOSE: "Close",
                    BETA: "Beta Online Assistant",
                    ONE_MOMENT: "One moment\u2026",
                    FALLBACK: "Sorry, something went wrong. Please try again.",
                    PRODUCT: "Product",
                    COLLECTION: "Collection",
                    VIEW_PIECE: "View piece",
                    ADD_TO_CART: "Add to cart",
                    ADDING_TO_CART: "Adding\u2026",
                    ADDED_TO_CART: "Added to cart",
                    ADD_TO_CART_ERROR: "View piece",
                    CHOOSE_OPTIONS: "Choose options",
                    OPTIONS_AVAILABLE_NOTE: "Options available. View the product page to choose yours.",
                    SHOP_FULL_LOOK: "Shop full look",
                    SHOPPING_FULL_LOOK: "Adding look\u2026",
                    SHOP_FULL_LOOK_ADDED: "Look added",
                    SHOP_FULL_LOOK_ERROR: "Choose options",
                    SHOP_FULL_LOOK_OPTIONS_NOTE: "Some pieces need options before checkout. Open the product pages to choose yours.",
                    VIEW_COLLECTION: "Open collection",
                    TOP: "Top",
                    BOTTOM: "Bottom",
                    SHOES: "Shoes",
                    FOOTWEAR: "Footwear",
                    OPTIONAL_LAYER: "Optional layer",
                    OPTIONAL_ACCESSORY: "Optional accessory",
                    OPTIONAL_BAG: "Optional bag",
                    ACCESSORY: "Accessory",
                    BAG: "Bag",
                    LAYER: "Layer",
                    ONE_PIECE: "One piece",
                    SET: "Set",
                    BROWSE_COLLECTIONS: "Browse collections",
                    BROWSE_ALL: "Browse all",
                    SEE_MORE: "See more",
                    SEASON_PROMPT: "Which season would you like me to style an outfit for?",
                    COMPLETE_LOOK: "Complete look",
                    WEATHER_OUTFIT: "Weather outfit",
                    OCCASION_OUTFIT: "Occasion outfit",
                    TRENDING: "Trending",
                    BACK: "Back",
                    START_OVER: "Start over",
                    SUMMER_OUTFIT: "Summer",
                    SEASONAL_OUTFIT: "Seasonal outfit",
                    SPRING_OUTFIT: "Spring",
                    FALL_OUTFIT: "Fall",
                    WINTER_OUTFIT: "Winter",
                    WORK_OUTFIT: "Work outfit",
                    WHAT_CAN_YOU_DO: "What can you do?",
                    START_NEW_LOOK: "Start a new look",
                    PRODUCT_SEARCH: "Product search",
                    REROLL_OUTFIT: "Show another outfit",
                    CHANGE_FOOTWEAR: "Change footwear",
                    REMOVE_ACCESSORY: "Remove accessory",
                    MORE_CASUAL: "More casual",
                    MORE_ELEVATED: "More elevated",
                    TOO_EXPENSIVE: "Less expensive",
                    MEN: "Men",
                    WOMEN: "Women"
                },
                es: {
                    PLACEHOLDER: "Pregunta por estilo, productos u ocasiones\u2026",
                    SEND: "Enviar",
                    CHAT: "Chat",
                    OPEN_CHAT: "Abrir chat",
                    CLOSE: "Cerrar",
                    BETA: "Asistente en l\xEDnea beta",
                    ONE_MOMENT: "Un momento\u2026",
                    FALLBACK: "Lo siento, algo sali\xF3 mal. Int\xE9ntalo de nuevo.",
                    PRODUCT: "Producto",
                    COLLECTION: "Colecci\xF3n",
                    VIEW_PIECE: "Ver pieza",
                    VIEW_COLLECTION: "Ver colecci\xF3n",
                    TOP: "Parte superior",
                    BOTTOM: "Parte inferior",
                    SHOES: "Zapatos",
                    ACCESSORY: "Accesorio",
                    BAG: "Bolso",
                    LAYER: "Capa",
                    ONE_PIECE: "Una pieza",
                    SET: "Conjunto",
                    BROWSE_COLLECTIONS: "Ver colecciones",
                    BROWSE_ALL: "Ver todo",
                    SEE_MORE: "Ver m\xE1s",
                    SEASON_PROMPT: "\xBFPara qu\xE9 temporada te gustar\xEDa que creara un look?",
                    COMPLETE_LOOK: "Look completo",
                    WEATHER_OUTFIT: "Outfit seg\xFAn el clima",
                    OCCASION_OUTFIT: "Outfit para ocasi\xF3n",
                    SUMMER_OUTFIT: "Verano",
                    SEASONAL_OUTFIT: "Outfit de temporada",
                    SPRING_OUTFIT: "Primavera",
                    FALL_OUTFIT: "Oto\xF1o",
                    WINTER_OUTFIT: "Invierno",
                    WORK_OUTFIT: "Outfit para el trabajo",
                    WHAT_CAN_YOU_DO: "\xBFQu\xE9 puedes hacer?",
                    START_NEW_LOOK: "Crear otro look",
                    PRODUCT_SEARCH: "Buscar producto",
                    REROLL_OUTFIT: "Mostrar otro look",
                    MEN: "Hombre",
                    WOMEN: "Mujer"
                },
                pt: {
                    PLACEHOLDER: "Pergunte sobre estilo, produtos ou ocasi\xF5es\u2026",
                    SEND: "Enviar",
                    CHAT: "Chat",
                    OPEN_CHAT: "Abrir chat",
                    CLOSE: "Fechar",
                    BETA: "Assistente online beta",
                    ONE_MOMENT: "Um momento\u2026",
                    FALLBACK: "Desculpe, algo deu errado. Tente novamente.",
                    PRODUCT: "Produto",
                    COLLECTION: "Cole\xE7\xE3o",
                    VIEW_PIECE: "Ver pe\xE7a",
                    VIEW_COLLECTION: "Ver cole\xE7\xE3o",
                    TOP: "Parte superior",
                    BOTTOM: "Parte inferior",
                    SHOES: "Sapatos",
                    ACCESSORY: "Acess\xF3rio",
                    BAG: "Bolsa",
                    LAYER: "Camada",
                    ONE_PIECE: "Pe\xE7a \xFAnica",
                    SET: "Conjunto",
                    BROWSE_COLLECTIONS: "Ver cole\xE7\xF5es",
                    BROWSE_ALL: "Ver tudo",
                    SEE_MORE: "Ver mais",
                    SEASON_PROMPT: "Para qual esta\xE7\xE3o voc\xEA gostaria que eu criasse um look?",
                    COMPLETE_LOOK: "Look completo",
                    WEATHER_OUTFIT: "Look pelo clima",
                    OCCASION_OUTFIT: "Look para ocasi\xE3o",
                    SUMMER_OUTFIT: "Ver\xE3o",
                    SEASONAL_OUTFIT: "Look de temporada",
                    SPRING_OUTFIT: "Primavera",
                    FALL_OUTFIT: "Outono",
                    WINTER_OUTFIT: "Inverno",
                    WORK_OUTFIT: "Look para trabalho",
                    WHAT_CAN_YOU_DO: "O que voc\xEA pode fazer?",
                    START_NEW_LOOK: "Criar outro look",
                    PRODUCT_SEARCH: "Buscar produto",
                    REROLL_OUTFIT: "Mostrar outro look",
                    MEN: "Homem",
                    WOMEN: "Mulher"
                },
                fr: {
                    PLACEHOLDER: "Demandez du style, des produits ou des occasions\u2026",
                    SEND: "Envoyer",
                    CHAT: "Chat",
                    OPEN_CHAT: "Ouvrir le chat",
                    CLOSE: "Fermer",
                    BETA: "Assistant en ligne b\xEAta",
                    ONE_MOMENT: "Un instant\u2026",
                    FALLBACK: "D\xE9sol\xE9, une erreur s\u2019est produite. Veuillez r\xE9essayer.",
                    PRODUCT: "Produit",
                    COLLECTION: "Collection",
                    VIEW_PIECE: "Voir la pi\xE8ce",
                    VIEW_COLLECTION: "Voir la collection",
                    TOP: "Haut",
                    BOTTOM: "Bas",
                    SHOES: "Chaussures",
                    ACCESSORY: "Accessoire",
                    BAG: "Sac",
                    LAYER: "Couche",
                    ONE_PIECE: "Une pi\xE8ce",
                    SET: "Ensemble",
                    BROWSE_COLLECTIONS: "Voir les collections",
                    BROWSE_ALL: "Tout voir",
                    SEE_MORE: "Voir plus",
                    SEASON_PROMPT: "Pour quelle saison souhaitez-vous que je cr\xE9e une tenue?",
                    COMPLETE_LOOK: "Look complet",
                    WEATHER_OUTFIT: "Tenue m\xE9t\xE9o",
                    OCCASION_OUTFIT: "Tenue d\u2019occasion",
                    SUMMER_OUTFIT: "\xC9t\xE9",
                    SEASONAL_OUTFIT: "Tenue saisonni\xE8re",
                    SPRING_OUTFIT: "Printemps",
                    FALL_OUTFIT: "Automne",
                    WINTER_OUTFIT: "Hiver",
                    WORK_OUTFIT: "Tenue de travail",
                    WHAT_CAN_YOU_DO: "Que peux-tu faire?",
                    START_NEW_LOOK: "Cr\xE9er un autre look",
                    PRODUCT_SEARCH: "Recherche produit",
                    REROLL_OUTFIT: "Montrer une autre tenue",
                    MEN: "Homme",
                    WOMEN: "Femme"
                },
                it: {
                    PLACEHOLDER: "Chiedi di stile, prodotti o occasioni\u2026",
                    SEND: "Invia",
                    CHAT: "Chat",
                    OPEN_CHAT: "Apri chat",
                    CLOSE: "Chiudi",
                    BETA: "Assistente online beta",
                    ONE_MOMENT: "Un momento\u2026",
                    FALLBACK: "Spiacenti, qualcosa \xE8 andato storto. Riprova.",
                    PRODUCT: "Prodotto",
                    COLLECTION: "Collezione",
                    VIEW_PIECE: "Vedi pezzo",
                    VIEW_COLLECTION: "Vedi collezione",
                    TOP: "Top",
                    BOTTOM: "Pantaloni/Gonna",
                    SHOES: "Scarpe",
                    ACCESSORY: "Accessorio",
                    BAG: "Borsa",
                    LAYER: "Strato",
                    ONE_PIECE: "Pezzo unico",
                    SET: "Set",
                    BROWSE_COLLECTIONS: "Vedi collezioni",
                    BROWSE_ALL: "Vedi tutto",
                    SEE_MORE: "Vedi altro",
                    SEASON_PROMPT: "Per quale stagione vuoi che crei un look?",
                    COMPLETE_LOOK: "Look completo",
                    WEATHER_OUTFIT: "Look per il meteo",
                    OCCASION_OUTFIT: "Look per occasione",
                    SUMMER_OUTFIT: "Estate",
                    SEASONAL_OUTFIT: "Look stagionale",
                    SPRING_OUTFIT: "Primavera",
                    FALL_OUTFIT: "Autunno",
                    WINTER_OUTFIT: "Inverno",
                    WORK_OUTFIT: "Look da lavoro",
                    WHAT_CAN_YOU_DO: "Cosa puoi fare?",
                    START_NEW_LOOK: "Crea un altro look",
                    PRODUCT_SEARCH: "Cerca prodotto",
                    REROLL_OUTFIT: "Mostra un altro look",
                    MEN: "Uomo",
                    WOMEN: "Donna"
                },
                de: {
                    PLACEHOLDER: "Fragen Sie nach Styling, Produkten oder Anl\xE4ssen\u2026",
                    SEND: "Senden",
                    CHAT: "Chat",
                    OPEN_CHAT: "Chat \xF6ffnen",
                    CLOSE: "Schlie\xDFen",
                    BETA: "Beta-Online-Assistent",
                    ONE_MOMENT: "Einen Moment\u2026",
                    FALLBACK: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
                    PRODUCT: "Produkt",
                    COLLECTION: "Kollektion",
                    VIEW_PIECE: "Teil ansehen",
                    VIEW_COLLECTION: "Kollektion ansehen",
                    TOP: "Oberteil",
                    BOTTOM: "Unterteil",
                    SHOES: "Schuhe",
                    ACCESSORY: "Accessoire",
                    BAG: "Tasche",
                    LAYER: "Layer",
                    ONE_PIECE: "Einzelteil",
                    BROWSE_COLLECTIONS: "Kollektionen ansehen",
                    BROWSE_ALL: "Alle ansehen",
                    SEE_MORE: "Mehr sehen",
                    SEASON_PROMPT: "F\xFCr welche Saison soll ich einen Look stylen?",
                    COMPLETE_LOOK: "Kompletter Look",
                    WEATHER_OUTFIT: "Wetter-Look",
                    OCCASION_OUTFIT: "Look f\xFCr Anlass",
                    SUMMER_OUTFIT: "Sommer",
                    SEASONAL_OUTFIT: "Saisonaler Look",
                    SPRING_OUTFIT: "Fr\xFChling",
                    FALL_OUTFIT: "Herbst",
                    WINTER_OUTFIT: "Winter",
                    WORK_OUTFIT: "Business-Look",
                    WHAT_CAN_YOU_DO: "Was kannst du tun?",
                    START_NEW_LOOK: "Neuen Look erstellen",
                    PRODUCT_SEARCH: "Produktsuche",
                    REROLL_OUTFIT: "Anderen Look anzeigen",
                    MEN: "Herren",
                    WOMEN: "Damen"
                },
                nl: {
                    PLACEHOLDER: "Vraag naar styling, producten of gelegenheden\u2026",
                    SEND: "Versturen",
                    CHAT: "Chat",
                    OPEN_CHAT: "Chat openen",
                    CLOSE: "Sluiten",
                    BETA: "Beta online assistent",
                    ONE_MOMENT: "Een moment\u2026",
                    FALLBACK: "Sorry, er ging iets mis. Probeer het opnieuw.",
                    PRODUCT: "Product",
                    COLLECTION: "Collectie",
                    VIEW_PIECE: "Bekijk item",
                    VIEW_COLLECTION: "Bekijk collectie",
                    TOP: "Top",
                    BOTTOM: "Onderstuk",
                    SHOES: "Schoenen",
                    ACCESSORY: "Accessoire",
                    BAG: "Tas",
                    LAYER: "Laag",
                    ONE_PIECE: "One-piece",
                    BROWSE_COLLECTIONS: "Collecties bekijken",
                    BROWSE_ALL: "Alles bekijken",
                    SEE_MORE: "Meer zien",
                    SEASON_PROMPT: "Voor welk seizoen wil je dat ik een look style?",
                    COMPLETE_LOOK: "Complete look",
                    WEATHER_OUTFIT: "Weer-look",
                    OCCASION_OUTFIT: "Look voor gelegenheid",
                    SUMMER_OUTFIT: "Zomer",
                    SEASONAL_OUTFIT: "Seizoenslook",
                    SPRING_OUTFIT: "Lente",
                    FALL_OUTFIT: "Herfst",
                    WINTER_OUTFIT: "Winter",
                    WORK_OUTFIT: "Werklook",
                    WHAT_CAN_YOU_DO: "Wat kun je doen?",
                    START_NEW_LOOK: "Nieuwe look maken",
                    PRODUCT_SEARCH: "Product zoeken",
                    REROLL_OUTFIT: "Toon andere look",
                    MEN: "Heren",
                    WOMEN: "Dames"
                },
                ar: {
                    PLACEHOLDER: "\u0627\u0633\u0623\u0644 \u0639\u0646 \u0627\u0644\u062A\u0646\u0633\u064A\u0642 \u0623\u0648 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0623\u0648 \u0627\u0644\u0645\u0646\u0627\u0633\u0628\u0627\u062A\u2026",
                    SEND: "\u0625\u0631\u0633\u0627\u0644",
                    CHAT: "\u062F\u0631\u062F\u0634\u0629",
                    OPEN_CHAT: "\u0641\u062A\u062D \u0627\u0644\u062F\u0631\u062F\u0634\u0629",
                    CLOSE: "\u0625\u063A\u0644\u0627\u0642",
                    BETA: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u062A\u062C\u0631\u064A\u0628\u064A",
                    ONE_MOMENT: "\u0644\u062D\u0638\u0629 \u0648\u0627\u062D\u062F\u0629\u2026",
                    FALLBACK: "\u0639\u0630\u0631\u064B\u0627\u060C \u062D\u062F\u062B \u062E\u0637\u0623. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.",
                    PRODUCT: "\u0645\u0646\u062A\u062C",
                    COLLECTION: "\u0645\u062C\u0645\u0648\u0639\u0629",
                    VIEW_PIECE: "\u0639\u0631\u0636 \u0627\u0644\u0642\u0637\u0639\u0629",
                    VIEW_COLLECTION: "\u0639\u0631\u0636 \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629",
                    TOP: "\u0642\u0637\u0639\u0629 \u0639\u0644\u0648\u064A\u0629",
                    BOTTOM: "\u0642\u0637\u0639\u0629 \u0633\u0641\u0644\u064A\u0629",
                    SHOES: "\u0623\u062D\u0630\u064A\u0629",
                    ACCESSORY: "\u0625\u0643\u0633\u0633\u0648\u0627\u0631",
                    BAG: "\u062D\u0642\u064A\u0628\u0629",
                    LAYER: "\u0637\u0628\u0642\u0629",
                    ONE_PIECE: "\u0642\u0637\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
                    BROWSE_COLLECTIONS: "\u062A\u0635\u0641\u062D \u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0627\u062A",
                    BROWSE_ALL: "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644",
                    SEE_MORE: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F",
                    SEASON_PROMPT: "\u0644\u0623\u064A \u0645\u0648\u0633\u0645 \u062A\u0631\u064A\u062F \u0623\u0646 \u0623\u064F\u0646\u0633\u0651\u0642 \u0644\u0643 \u0625\u0637\u0644\u0627\u0644\u0629\u061F",
                    COMPLETE_LOOK: "\u0625\u0637\u0644\u0627\u0644\u0629 \u0643\u0627\u0645\u0644\u0629",
                    WEATHER_OUTFIT: "\u0625\u0637\u0644\u0627\u0644\u0629 \u062D\u0633\u0628 \u0627\u0644\u0637\u0642\u0633",
                    OCCASION_OUTFIT: "\u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u0645\u0646\u0627\u0633\u0628\u0629",
                    SUMMER_OUTFIT: "\u0627\u0644\u0635\u064A\u0641",
                    SEASONAL_OUTFIT: "\u0625\u0637\u0644\u0627\u0644\u0629 \u0645\u0648\u0633\u0645\u064A\u0629",
                    SPRING_OUTFIT: "\u0627\u0644\u0631\u0628\u064A\u0639",
                    FALL_OUTFIT: "\u0627\u0644\u062E\u0631\u064A\u0641",
                    WINTER_OUTFIT: "\u0627\u0644\u0634\u062A\u0627\u0621",
                    WORK_OUTFIT: "\u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u0639\u0645\u0644",
                    WHAT_CAN_YOU_DO: "\u0645\u0627\u0630\u0627 \u064A\u0645\u0643\u0646\u0643 \u0623\u0646 \u062A\u0641\u0639\u0644\u061F",
                    START_NEW_LOOK: "\u0625\u0646\u0634\u0627\u0621 \u0625\u0637\u0644\u0627\u0644\u0629 \u0623\u062E\u0631\u0649",
                    PRODUCT_SEARCH: "\u0628\u062D\u062B \u0639\u0646 \u0645\u0646\u062A\u062C",
                    REROLL_OUTFIT: "\u0639\u0631\u0636 \u0625\u0637\u0644\u0627\u0644\u0629 \u0623\u062E\u0631\u0649",
                    MEN: "\u0631\u062C\u0627\u0644",
                    WOMEN: "\u0646\u0633\u0627\u0621"
                },
                zh: {
                    PLACEHOLDER: "\u8BE2\u95EE\u642D\u914D\u3001\u4EA7\u54C1\u6216\u573A\u5408\u2026",
                    SEND: "\u53D1\u9001",
                    CHAT: "\u804A\u5929",
                    OPEN_CHAT: "\u6253\u5F00\u804A\u5929",
                    CLOSE: "\u5173\u95ED",
                    BETA: "Beta \u5728\u7EBF\u52A9\u624B",
                    ONE_MOMENT: "\u8BF7\u7A0D\u5019\u2026",
                    FALLBACK: "\u62B1\u6B49\uFF0C\u51FA\u73B0\u4E86\u95EE\u9898\u3002\u8BF7\u518D\u8BD5\u4E00\u6B21\u3002",
                    PRODUCT: "\u4EA7\u54C1",
                    COLLECTION: "\u7CFB\u5217",
                    VIEW_PIECE: "\u67E5\u770B\u5355\u54C1",
                    VIEW_COLLECTION: "\u67E5\u770B\u7CFB\u5217",
                    TOP: "\u4E0A\u88C5",
                    BOTTOM: "\u4E0B\u88C5",
                    SHOES: "\u978B\u5C65",
                    ACCESSORY: "\u914D\u9970",
                    BAG: "\u5305\u888B",
                    LAYER: "\u5916\u642D",
                    ONE_PIECE: "\u8FDE\u4F53/\u8FDE\u8863",
                    BROWSE_COLLECTIONS: "\u6D4F\u89C8\u7CFB\u5217",
                    BROWSE_ALL: "\u67E5\u770B\u5168\u90E8",
                    SEE_MORE: "\u67E5\u770B\u66F4\u591A",
                    SEASON_PROMPT: "\u4F60\u5E0C\u671B\u6211\u4E3A\u54EA\u4E2A\u5B63\u8282\u642D\u914D\u9020\u578B\uFF1F",
                    COMPLETE_LOOK: "\u5B8C\u6574\u9020\u578B",
                    WEATHER_OUTFIT: "\u5929\u6C14\u9020\u578B",
                    OCCASION_OUTFIT: "\u573A\u5408\u9020\u578B",
                    SUMMER_OUTFIT: "\u590F\u5B63",
                    SEASONAL_OUTFIT: "\u5B63\u8282\u9020\u578B",
                    SPRING_OUTFIT: "\u6625\u5B63",
                    FALL_OUTFIT: "\u79CB\u5B63",
                    WINTER_OUTFIT: "\u51AC\u5B63",
                    WORK_OUTFIT: "\u804C\u573A\u9020\u578B",
                    WHAT_CAN_YOU_DO: "\u4F60\u80FD\u505A\u4EC0\u4E48\uFF1F",
                    START_NEW_LOOK: "\u521B\u5EFA\u65B0\u9020\u578B",
                    PRODUCT_SEARCH: "\u641C\u7D22\u4EA7\u54C1",
                    REROLL_OUTFIT: "\u663E\u793A\u53E6\u4E00\u5957\u9020\u578B",
                    MEN: "\u7537\u58EB",
                    WOMEN: "\u5973\u58EB"
                },
                ja: {
                    PLACEHOLDER: "\u30B9\u30BF\u30A4\u30EA\u30F3\u30B0\u3001\u5546\u54C1\u3001\u30B7\u30FC\u30F3\u306B\u3064\u3044\u3066\u8CEA\u554F\u2026",
                    SEND: "\u9001\u4FE1",
                    CHAT: "\u30C1\u30E3\u30C3\u30C8",
                    OPEN_CHAT: "\u30C1\u30E3\u30C3\u30C8\u3092\u958B\u304F",
                    CLOSE: "\u9589\u3058\u308B",
                    BETA: "\u30D9\u30FC\u30BF\u7248\u30AA\u30F3\u30E9\u30A4\u30F3\u30A2\u30B7\u30B9\u30BF\u30F3\u30C8",
                    ONE_MOMENT: "\u5C11\u3005\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u2026",
                    FALLBACK: "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u3002\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
                    PRODUCT: "\u5546\u54C1",
                    COLLECTION: "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3",
                    VIEW_PIECE: "\u5546\u54C1\u3092\u898B\u308B",
                    VIEW_COLLECTION: "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u3092\u898B\u308B",
                    TOP: "\u30C8\u30C3\u30D7\u30B9",
                    BOTTOM: "\u30DC\u30C8\u30E0\u30B9",
                    SHOES: "\u30B7\u30E5\u30FC\u30BA",
                    ACCESSORY: "\u30A2\u30AF\u30BB\u30B5\u30EA\u30FC",
                    BAG: "\u30D0\u30C3\u30B0",
                    LAYER: "\u30EC\u30A4\u30E4\u30FC",
                    ONE_PIECE: "\u30EF\u30F3\u30D4\u30FC\u30B9",
                    BROWSE_COLLECTIONS: "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u3092\u898B\u308B",
                    BROWSE_ALL: "\u3059\u3079\u3066\u898B\u308B",
                    SEE_MORE: "\u3082\u3063\u3068\u898B\u308B",
                    SEASON_PROMPT: "\u3069\u306E\u5B63\u7BC0\u306E\u30B3\u30FC\u30C7\u3092\u63D0\u6848\u3057\u307E\u3057\u3087\u3046\u304B\uFF1F",
                    COMPLETE_LOOK: "\u30D5\u30EB\u30B3\u30FC\u30C7",
                    WEATHER_OUTFIT: "\u5929\u6C17\u306B\u5408\u308F\u305B\u305F\u30B3\u30FC\u30C7",
                    OCCASION_OUTFIT: "\u30B7\u30FC\u30F3\u5225\u30B3\u30FC\u30C7",
                    SUMMER_OUTFIT: "\u590F",
                    SEASONAL_OUTFIT: "\u5B63\u7BC0\u306E\u30B3\u30FC\u30C7",
                    SPRING_OUTFIT: "\u6625",
                    FALL_OUTFIT: "\u79CB",
                    WINTER_OUTFIT: "\u51AC",
                    WORK_OUTFIT: "\u4ED5\u4E8B\u7528\u30B3\u30FC\u30C7",
                    WHAT_CAN_YOU_DO: "\u4F55\u304C\u3067\u304D\u307E\u3059\u304B\uFF1F",
                    START_NEW_LOOK: "\u5225\u306E\u30B3\u30FC\u30C7\u3092\u4F5C\u308B",
                    PRODUCT_SEARCH: "\u5546\u54C1\u691C\u7D22",
                    REROLL_OUTFIT: "\u5225\u306E\u30B3\u30FC\u30C7\u3092\u898B\u308B",
                    MEN: "\u30E1\u30F3\u30BA",
                    WOMEN: "\u30A6\u30A3\u30E1\u30F3\u30BA"
                },
                ko: {
                    PLACEHOLDER: "\uC2A4\uD0C0\uC77C\uB9C1, \uC0C1\uD488, \uC0C1\uD669\uC744 \uBB3C\uC5B4\uBCF4\uC138\uC694\u2026",
                    SEND: "\uBCF4\uB0B4\uAE30",
                    CHAT: "\uCC44\uD305",
                    OPEN_CHAT: "\uCC44\uD305 \uC5F4\uAE30",
                    CLOSE: "\uB2EB\uAE30",
                    BETA: "\uBCA0\uD0C0 \uC628\uB77C\uC778 \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
                    ONE_MOMENT: "\uC7A0\uC2DC\uB9CC\uC694\u2026",
                    FALLBACK: "\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
                    PRODUCT: "\uC0C1\uD488",
                    COLLECTION: "\uCEEC\uB809\uC158",
                    VIEW_PIECE: "\uC0C1\uD488 \uBCF4\uAE30",
                    VIEW_COLLECTION: "\uCEEC\uB809\uC158 \uBCF4\uAE30",
                    TOP: "\uC0C1\uC758",
                    BOTTOM: "\uD558\uC758",
                    SHOES: "\uC2E0\uBC1C",
                    ACCESSORY: "\uC561\uC138\uC11C\uB9AC",
                    BAG: "\uAC00\uBC29",
                    LAYER: "\uB808\uC774\uC5B4",
                    ONE_PIECE: "\uC6D0\uD53C\uC2A4",
                    BROWSE_COLLECTIONS: "\uCEEC\uB809\uC158 \uBCF4\uAE30",
                    BROWSE_ALL: "\uC804\uCCB4 \uBCF4\uAE30",
                    SEE_MORE: "\uB354 \uBCF4\uAE30",
                    SEASON_PROMPT: "\uC5B4\uB290 \uACC4\uC808\uC758 \uB8E9\uC744 \uC2A4\uD0C0\uC77C\uB9C1\uD574 \uB4DC\uB9B4\uAE4C\uC694?",
                    COMPLETE_LOOK: "\uC804\uCCB4 \uB8E9",
                    WEATHER_OUTFIT: "\uB0A0\uC528 \uB9DE\uCDA4 \uB8E9",
                    OCCASION_OUTFIT: "\uC0C1\uD669\uBCC4 \uB8E9",
                    SUMMER_OUTFIT: "\uC5EC\uB984",
                    SEASONAL_OUTFIT: "\uC2DC\uC98C \uB8E9",
                    SPRING_OUTFIT: "\uBD04",
                    FALL_OUTFIT: "\uAC00\uC744",
                    WINTER_OUTFIT: "\uACA8\uC6B8",
                    WORK_OUTFIT: "\uC5C5\uBB34 \uB8E9",
                    WHAT_CAN_YOU_DO: "\uBB34\uC5C7\uC744 \uD560 \uC218 \uC788\uB098\uC694?",
                    START_NEW_LOOK: "\uB2E4\uB978 \uB8E9 \uB9CC\uB4E4\uAE30",
                    PRODUCT_SEARCH: "\uC0C1\uD488 \uAC80\uC0C9",
                    REROLL_OUTFIT: "\uB2E4\uB978 \uB8E9 \uBCF4\uAE30",
                    MEN: "\uB0A8\uC131",
                    WOMEN: "\uC5EC\uC131"
                },
                ru: {
                    PLACEHOLDER: "\u0421\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u043E \u0441\u0442\u0438\u043B\u0435, \u0442\u043E\u0432\u0430\u0440\u0430\u0445 \u0438\u043B\u0438 \u0441\u043B\u0443\u0447\u0430\u044F\u0445\u2026",
                    SEND: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
                    CHAT: "\u0427\u0430\u0442",
                    OPEN_CHAT: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0447\u0430\u0442",
                    CLOSE: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                    BETA: "\u0411\u0435\u0442\u0430 \u043E\u043D\u043B\u0430\u0439\u043D-\u0430\u0441\u0441\u0438\u0441\u0442\u0435\u043D\u0442",
                    ONE_MOMENT: "\u041E\u0434\u0438\u043D \u043C\u043E\u043C\u0435\u043D\u0442\u2026",
                    FALLBACK: "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437.",
                    PRODUCT: "\u0422\u043E\u0432\u0430\u0440",
                    COLLECTION: "\u041A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F",
                    VIEW_PIECE: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0435\u0449\u044C",
                    VIEW_COLLECTION: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E",
                    TOP: "\u0412\u0435\u0440\u0445",
                    BOTTOM: "\u041D\u0438\u0437",
                    SHOES: "\u041E\u0431\u0443\u0432\u044C",
                    ACCESSORY: "\u0410\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440",
                    BAG: "\u0421\u0443\u043C\u043A\u0430",
                    LAYER: "\u0421\u043B\u043E\u0439",
                    ONE_PIECE: "\u0426\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u0431\u0440\u0430\u0437",
                    SET: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442",
                    BROWSE_COLLECTIONS: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438",
                    BROWSE_ALL: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435",
                    SEE_MORE: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
                    SEASON_PROMPT: "\u0414\u043B\u044F \u043A\u0430\u043A\u043E\u0433\u043E \u0441\u0435\u0437\u043E\u043D\u0430 \u043F\u043E\u0434\u043E\u0431\u0440\u0430\u0442\u044C \u043E\u0431\u0440\u0430\u0437?",
                    COMPLETE_LOOK: "\u041F\u043E\u043B\u043D\u044B\u0439 \u043E\u0431\u0440\u0430\u0437",
                    WEATHER_OUTFIT: "\u041E\u0431\u0440\u0430\u0437 \u043F\u043E \u043F\u043E\u0433\u043E\u0434\u0435",
                    OCCASION_OUTFIT: "\u041E\u0431\u0440\u0430\u0437 \u0434\u043B\u044F \u0441\u043B\u0443\u0447\u0430\u044F",
                    SUMMER_OUTFIT: "\u041B\u0435\u0442\u043E",
                    SEASONAL_OUTFIT: "\u0421\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u043E\u0431\u0440\u0430\u0437",
                    SPRING_OUTFIT: "\u0412\u0435\u0441\u043D\u0430",
                    FALL_OUTFIT: "\u041E\u0441\u0435\u043D\u044C",
                    WINTER_OUTFIT: "\u0417\u0438\u043C\u0430",
                    WORK_OUTFIT: "\u041E\u0431\u0440\u0430\u0437 \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B",
                    WHAT_CAN_YOU_DO: "\u0427\u0442\u043E \u0442\u044B \u0443\u043C\u0435\u0435\u0448\u044C?",
                    START_NEW_LOOK: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043E\u0431\u0440\u0430\u0437",
                    PRODUCT_SEARCH: "\u041F\u043E\u0438\u0441\u043A \u0442\u043E\u0432\u0430\u0440\u0430",
                    REROLL_OUTFIT: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u043E\u0431\u0440\u0430\u0437",
                    MEN: "\u041C\u0443\u0436\u0447\u0438\u043D\u044B",
                    WOMEN: "\u0416\u0435\u043D\u0449\u0438\u043D\u044B"
                }
            },
            UI_LANGUAGE_ALIASES = {
                eng: "en",
                english: "en",
                spa: "es",
                spanish: "es",
                espanol: "es",
                espa\u00F1ol: "es",
                es: "es",
                por: "pt",
                portuguese: "pt",
                portugues: "pt",
                portugu\u00EAs: "pt",
                pt: "pt",
                fre: "fr",
                fra: "fr",
                french: "fr",
                francais: "fr",
                fran\u00E7ais: "fr",
                fr: "fr",
                ita: "it",
                italian: "it",
                italiano: "it",
                it: "it",
                ger: "de",
                deu: "de",
                german: "de",
                deutsch: "de",
                de: "de",
                dutch: "nl",
                nederlands: "nl",
                nl: "nl",
                arabic: "ar",
                ar: "ar",
                \u0639\u0631\u0628\u064A: "ar",
                \u0627\u0644\u0639\u0631\u0628\u064A\u0629: "ar",
                chinese: "zh",
                mandarin: "zh",
                zh: "zh",
                \u4E2D\u6587: "zh",
                \u6C49\u8BED: "zh",
                japanese: "ja",
                ja: "ja",
                \u65E5\u672C\u8A9E: "ja",
                korean: "ko",
                ko: "ko",
                \uD55C\uAD6D\uC5B4: "ko",
                russian: "ru",
                ru: "ru",
                \u0440\u0443\u0441\u0441\u043A\u0438\u0439: "ru"
            },
            SUGGESTION_PROMPTS = {
                en: {
                    COMPLETE_LOOK: "I want a complete outfit",
                    WEATHER_OUTFIT: "I want a weather-aware outfit",
                    OCCASION_OUTFIT: "I want an outfit for an occasion",
                    TRENDING: "What is trending?",
                    BACK: "Back",
                    START_OVER: "Start over",
                    SUMMER_OUTFIT: "I want a summer outfit",
                    SEASONAL_OUTFIT: "Seasonal outfit",
                    SPRING_OUTFIT: "I want a spring outfit",
                    FALL_OUTFIT: "I want a fall outfit",
                    WINTER_OUTFIT: "I want a winter outfit",
                    WORK_OUTFIT: "I want a work outfit",
                    WHAT_CAN_YOU_DO: "What can you do?",
                    START_NEW_LOOK: "I want a new outfit",
                    PRODUCT_SEARCH: "I am looking for a specific product",
                    REROLL_OUTFIT: "Show me another outfit",
                    BROWSE_COLLECTIONS: "Show me all collections",
                    MEN: "men",
                    WOMEN: "women"
                },
                es: {
                    COMPLETE_LOOK: "Quiero un look completo",
                    WEATHER_OUTFIT: "Quiero un outfit seg\xFAn el clima",
                    OCCASION_OUTFIT: "Quiero un outfit para una ocasi\xF3n",
                    SUMMER_OUTFIT: "Quiero un outfit de verano",
                    SEASONAL_OUTFIT: "Outfit de temporada",
                    SPRING_OUTFIT: "Quiero un outfit de primavera",
                    FALL_OUTFIT: "Quiero un outfit de oto\xF1o",
                    WINTER_OUTFIT: "Quiero un outfit de invierno",
                    WORK_OUTFIT: "Quiero un outfit para el trabajo",
                    WHAT_CAN_YOU_DO: "\xBFQu\xE9 puedes hacer?",
                    START_NEW_LOOK: "Quiero un nuevo look",
                    PRODUCT_SEARCH: "Estoy buscando un producto espec\xEDfico",
                    REROLL_OUTFIT: "Mu\xE9strame otro look",
                    BROWSE_COLLECTIONS: "Mu\xE9strame todas las colecciones",
                    MEN: "hombre",
                    WOMEN: "mujer"
                },
                pt: {
                    COMPLETE_LOOK: "Quero um look completo",
                    WEATHER_OUTFIT: "Quero um look pelo clima",
                    OCCASION_OUTFIT: "Quero um look para uma ocasi\xE3o",
                    SUMMER_OUTFIT: "Quero um look de ver\xE3o",
                    SEASONAL_OUTFIT: "Look de temporada",
                    SPRING_OUTFIT: "Quero um look de primavera",
                    FALL_OUTFIT: "Quero um look de outono",
                    WINTER_OUTFIT: "Quero um look de inverno",
                    WORK_OUTFIT: "Quero um look para trabalho",
                    WHAT_CAN_YOU_DO: "O que voc\xEA pode fazer?",
                    START_NEW_LOOK: "Quero um novo look",
                    PRODUCT_SEARCH: "Estou procurando um produto espec\xEDfico",
                    REROLL_OUTFIT: "Mostre outro look",
                    BROWSE_COLLECTIONS: "Mostre todas as cole\xE7\xF5es",
                    MEN: "homem",
                    WOMEN: "mulher"
                },
                fr: {
                    COMPLETE_LOOK: "Je veux un look complet",
                    WEATHER_OUTFIT: "Je veux une tenue selon la m\xE9t\xE9o",
                    OCCASION_OUTFIT: "Je veux une tenue pour une occasion",
                    SUMMER_OUTFIT: "Je veux une tenue d\u2019\xE9t\xE9",
                    SEASONAL_OUTFIT: "Tenue saisonni\xE8re",
                    SPRING_OUTFIT: "Je veux une tenue de printemps",
                    FALL_OUTFIT: "Je veux une tenue d\u2019automne",
                    WINTER_OUTFIT: "Je veux une tenue d\u2019hiver",
                    WORK_OUTFIT: "Je veux une tenue de travail",
                    WHAT_CAN_YOU_DO: "Que peux-tu faire?",
                    START_NEW_LOOK: "Je veux un nouveau look",
                    PRODUCT_SEARCH: "Je cherche un produit pr\xE9cis",
                    REROLL_OUTFIT: "Montre-moi une autre tenue",
                    BROWSE_COLLECTIONS: "Montre-moi toutes les collections",
                    MEN: "homme",
                    WOMEN: "femme"
                }
            };

        function normalizeLanguageCode(code) {
            const raw = String(code || "").trim();
            if (!raw) return "en";
            const lower = raw.toLowerCase().replace("_", "-"),
                base = lower.split("-")[0];
            return UI_LANGUAGE_ALIASES[lower] || UI_LANGUAGE_ALIASES[base] || base || "en"
        }

        function getCurrentLanguageCode() {
            const candidate = conversationContext.languageCode || conversationContext.replyLanguageCode || conversationContext.detectedLanguageCode || conversationContext.language || "en",
                code = normalizeLanguageCode(candidate);
            return UI_TRANSLATIONS[code] ? code : "en"
        }
        const PREMIUM_UI_TRANSLATIONS = {
            en: {
                SELECT_OPTIONS: "Select options",
                WHY_THIS_PIECE: "Why this piece",
                HIDE_NOTE: "Hide note",
                VIEW_FULL_DETAILS: "View full details",
                ADD_TO_BAG: "Add to bag",
                SELECT_ALL_OPTIONS: "Select all options",
                CHECKING_AVAILABILITY: "Checking availability\u2026",
                UNAVAILABLE: "Unavailable",
                CLOSE_OPTIONS: "Close options",
                OPTIONS_TITLE: "Select your options",
                LOADING_OPTIONS: "Loading options\u2026",
                TRY_ANOTHER_OPTION: "Choose another option.",
                USE_SELECTION: "Use this selection",
                PREPARE_LOOK: "Prepare this look",
                COMPLETE_SELECTIONS: "Complete selections",
                ADD_LOOK_TO_BAG: "Add look to bag",
                LOOK_ADDED: "Look added",
                SELECT: "Select",
                SELECTED: "Selected",
                READY: "Ready",
                CHANGE: "Change",
                BACK_TO_LOOK: "Back to your look",
                LIVE_PRICE_NOTE: "Price and availability are checked before adding.",
                ATELIER_TITLE: "Your Tellus edit",
                LOOK_READY: "Your edit is ready",
                NEEDS_OPTIONS: "Needs options",
                COMPLETE_YOUR_LOOK: "Complete your look",
                TELLUS_ATELIER: "Tellus Atelier",
                MY_ATELIER: "Atelier",
                ADD_TO_MY_ATELIER: "Add to Atelier",
                SAVED_TO_MY_ATELIER: "Saved to Atelier",
                REMOVE_FROM_MY_ATELIER: "Remove from Atelier",
                STYLE_AROUND_THIS: "Style around this piece",
                ADD_READY_LOOK: "Add ready look",
                REFINE_LOOK: "Refine",
                COMPARE_LOOKS: "Compare",
                HIDE_WORKSPACE: "Minimize look",
                SHOW_WORKSPACE: "Show look",
                CURRENT_LOOK: "Current",
                PREVIOUS_LOOK: "Previous",
                REFINED_LOOK: "Refined",
                KEEP_CURRENT: "Keep current",
                KEEP_PREVIOUS: "Keep previous",
                KEEP_REFINED: "Keep refined",
                KEEP_CHEAPER: "Keep lower-priced look",
                SELECTED_OPTIONS: "Selected",
                NEXT_STEP: "Recommended next step",
                UNDERSTANDING_REQUEST: "Understanding your request\u2026",
                BUILDING_EDIT: "Building the edit\u2026",
                CHECKING_OPTIONS: "Checking available options\u2026",
                PREPARING_LOOK: "Preparing your look\u2026"
            },
            es: {
                SELECT_OPTIONS: "Elegir opciones",
                WHY_THIS_PIECE: "Por qu\xE9 esta pieza",
                HIDE_NOTE: "Ocultar nota",
                VIEW_FULL_DETAILS: "Ver todos los detalles",
                ADD_TO_BAG: "A\xF1adir a la bolsa",
                SELECT_ALL_OPTIONS: "Elige todas las opciones",
                CHECKING_AVAILABILITY: "Comprobando disponibilidad\u2026",
                UNAVAILABLE: "No disponible",
                CLOSE_OPTIONS: "Cerrar opciones",
                OPTIONS_TITLE: "Elige tus opciones",
                LOADING_OPTIONS: "Cargando opciones\u2026",
                USE_SELECTION: "Usar esta selecci\xF3n",
                PREPARE_LOOK: "Preparar este look",
                COMPLETE_SELECTIONS: "Completar selecciones",
                ADD_LOOK_TO_BAG: "A\xF1adir look a la bolsa",
                LOOK_ADDED: "Look a\xF1adido",
                SELECT: "Elegir",
                SELECTED: "Elegido",
                READY: "Listo",
                CHANGE: "Cambiar"
            },
            pt: {
                SELECT_OPTIONS: "Selecionar op\xE7\xF5es",
                WHY_THIS_PIECE: "Por que esta pe\xE7a",
                HIDE_NOTE: "Ocultar nota",
                VIEW_FULL_DETAILS: "Ver detalhes completos",
                ADD_TO_BAG: "Adicionar \xE0 sacola",
                SELECT_ALL_OPTIONS: "Selecione todas as op\xE7\xF5es",
                CHECKING_AVAILABILITY: "Verificando disponibilidade\u2026",
                UNAVAILABLE: "Indispon\xEDvel",
                CLOSE_OPTIONS: "Fechar op\xE7\xF5es",
                OPTIONS_TITLE: "Selecione suas op\xE7\xF5es",
                LOADING_OPTIONS: "Carregando op\xE7\xF5es\u2026",
                USE_SELECTION: "Usar esta sele\xE7\xE3o",
                PREPARE_LOOK: "Preparar este look",
                COMPLETE_SELECTIONS: "Concluir sele\xE7\xF5es",
                ADD_LOOK_TO_BAG: "Adicionar look \xE0 sacola",
                LOOK_ADDED: "Look adicionado",
                SELECT: "Selecionar",
                SELECTED: "Selecionado",
                READY: "Pronto",
                CHANGE: "Alterar"
            },
            fr: {
                SELECT_OPTIONS: "Choisir les options",
                WHY_THIS_PIECE: "Pourquoi cette pi\xE8ce",
                HIDE_NOTE: "Masquer la note",
                VIEW_FULL_DETAILS: "Voir tous les d\xE9tails",
                ADD_TO_BAG: "Ajouter au panier",
                SELECT_ALL_OPTIONS: "Choisissez toutes les options",
                CHECKING_AVAILABILITY: "V\xE9rification de la disponibilit\xE9\u2026",
                UNAVAILABLE: "Indisponible",
                CLOSE_OPTIONS: "Fermer les options",
                OPTIONS_TITLE: "Choisissez vos options",
                LOADING_OPTIONS: "Chargement des options\u2026",
                USE_SELECTION: "Utiliser cette s\xE9lection",
                PREPARE_LOOK: "Pr\xE9parer ce look",
                COMPLETE_SELECTIONS: "Terminer les s\xE9lections",
                ADD_LOOK_TO_BAG: "Ajouter le look au panier",
                LOOK_ADDED: "Look ajout\xE9",
                SELECT: "Choisir",
                SELECTED: "Choisi",
                READY: "Pr\xEAt",
                CHANGE: "Modifier"
            },
            it: {
                SELECT_OPTIONS: "Seleziona opzioni",
                WHY_THIS_PIECE: "Perch\xE9 questo capo",
                HIDE_NOTE: "Nascondi nota",
                VIEW_FULL_DETAILS: "Vedi tutti i dettagli",
                ADD_TO_BAG: "Aggiungi alla borsa",
                SELECT_ALL_OPTIONS: "Seleziona tutte le opzioni",
                CHECKING_AVAILABILITY: "Controllo disponibilit\xE0\u2026",
                UNAVAILABLE: "Non disponibile",
                CLOSE_OPTIONS: "Chiudi opzioni",
                OPTIONS_TITLE: "Seleziona le opzioni",
                LOADING_OPTIONS: "Caricamento opzioni\u2026",
                USE_SELECTION: "Usa questa selezione",
                PREPARE_LOOK: "Prepara questo look",
                COMPLETE_SELECTIONS: "Completa le selezioni",
                ADD_LOOK_TO_BAG: "Aggiungi look alla borsa",
                LOOK_ADDED: "Look aggiunto",
                SELECT: "Seleziona",
                SELECTED: "Selezionato",
                READY: "Pronto",
                CHANGE: "Cambia"
            },
            de: {
                SELECT_OPTIONS: "Optionen w\xE4hlen",
                WHY_THIS_PIECE: "Warum dieses Teil",
                HIDE_NOTE: "Hinweis ausblenden",
                VIEW_FULL_DETAILS: "Alle Details ansehen",
                ADD_TO_BAG: "In den Warenkorb",
                SELECT_ALL_OPTIONS: "Alle Optionen w\xE4hlen",
                CHECKING_AVAILABILITY: "Verf\xFCgbarkeit wird gepr\xFCft\u2026",
                UNAVAILABLE: "Nicht verf\xFCgbar",
                CLOSE_OPTIONS: "Optionen schlie\xDFen",
                OPTIONS_TITLE: "Optionen ausw\xE4hlen",
                LOADING_OPTIONS: "Optionen werden geladen\u2026",
                USE_SELECTION: "Diese Auswahl verwenden",
                PREPARE_LOOK: "Look vorbereiten",
                COMPLETE_SELECTIONS: "Auswahl abschlie\xDFen",
                ADD_LOOK_TO_BAG: "Look in den Warenkorb",
                LOOK_ADDED: "Look hinzugef\xFCgt",
                SELECT: "Ausw\xE4hlen",
                SELECTED: "Ausgew\xE4hlt",
                READY: "Bereit",
                CHANGE: "\xC4ndern"
            },
            nl: {
                SELECT_OPTIONS: "Opties kiezen",
                WHY_THIS_PIECE: "Waarom dit item",
                HIDE_NOTE: "Notitie verbergen",
                VIEW_FULL_DETAILS: "Alle details bekijken",
                ADD_TO_BAG: "Toevoegen aan tas",
                SELECT_ALL_OPTIONS: "Kies alle opties",
                CHECKING_AVAILABILITY: "Beschikbaarheid controleren\u2026",
                UNAVAILABLE: "Niet beschikbaar",
                CLOSE_OPTIONS: "Opties sluiten",
                OPTIONS_TITLE: "Kies je opties",
                LOADING_OPTIONS: "Opties laden\u2026",
                USE_SELECTION: "Deze selectie gebruiken",
                PREPARE_LOOK: "Deze look voorbereiden",
                COMPLETE_SELECTIONS: "Selecties voltooien",
                ADD_LOOK_TO_BAG: "Look aan tas toevoegen",
                LOOK_ADDED: "Look toegevoegd",
                SELECT: "Kiezen",
                SELECTED: "Gekozen",
                READY: "Klaar",
                CHANGE: "Wijzigen"
            },
            ar: {
                SELECT_OPTIONS: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
                WHY_THIS_PIECE: "\u0644\u0645\u0627\u0630\u0627 \u0647\u0630\u0647 \u0627\u0644\u0642\u0637\u0639\u0629",
                HIDE_NOTE: "\u0625\u062E\u0641\u0627\u0621 \u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0629",
                VIEW_FULL_DETAILS: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u0644\u0629",
                ADD_TO_BAG: "\u0623\u0636\u0641 \u0625\u0644\u0649 \u0627\u0644\u062D\u0642\u064A\u0628\u0629",
                SELECT_ALL_OPTIONS: "\u0627\u062E\u062A\u0631 \u062C\u0645\u064A\u0639 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
                CHECKING_AVAILABILITY: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062A\u0648\u0641\u0631\u2026",
                UNAVAILABLE: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
                CLOSE_OPTIONS: "\u0625\u063A\u0644\u0627\u0642 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A",
                OPTIONS_TITLE: "\u0627\u062E\u062A\u0631 \u062E\u064A\u0627\u0631\u0627\u062A\u0643",
                LOADING_OPTIONS: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u062E\u064A\u0627\u0631\u0627\u062A\u2026",
                USE_SELECTION: "\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0630\u0627 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631",
                PREPARE_LOOK: "\u062A\u062C\u0647\u064A\u0632 \u0627\u0644\u0625\u0637\u0644\u0627\u0644\u0629",
                COMPLETE_SELECTIONS: "\u0625\u0643\u0645\u0627\u0644 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631\u0627\u062A",
                ADD_LOOK_TO_BAG: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0625\u0637\u0644\u0627\u0644\u0629 \u0625\u0644\u0649 \u0627\u0644\u062D\u0642\u064A\u0628\u0629",
                LOOK_ADDED: "\u062A\u0645\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0625\u0637\u0644\u0627\u0644\u0629",
                SELECT: "\u0627\u062E\u062A\u064A\u0627\u0631",
                SELECTED: "\u062A\u0645 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631",
                READY: "\u062C\u0627\u0647\u0632",
                CHANGE: "\u062A\u063A\u064A\u064A\u0631"
            },
            zh: {
                SELECT_OPTIONS: "\u9009\u62E9\u9009\u9879",
                WHY_THIS_PIECE: "\u4E3A\u4F55\u9009\u62E9\u8FD9\u4EF6",
                HIDE_NOTE: "\u9690\u85CF\u8BF4\u660E",
                VIEW_FULL_DETAILS: "\u67E5\u770B\u5B8C\u6574\u8BE6\u60C5",
                ADD_TO_BAG: "\u52A0\u5165\u8D2D\u7269\u888B",
                SELECT_ALL_OPTIONS: "\u8BF7\u9009\u62E9\u6240\u6709\u9009\u9879",
                CHECKING_AVAILABILITY: "\u6B63\u5728\u786E\u8BA4\u5E93\u5B58\u2026",
                UNAVAILABLE: "\u4E0D\u53EF\u7528",
                CLOSE_OPTIONS: "\u5173\u95ED\u9009\u9879",
                OPTIONS_TITLE: "\u9009\u62E9\u5546\u54C1\u9009\u9879",
                LOADING_OPTIONS: "\u6B63\u5728\u52A0\u8F7D\u9009\u9879\u2026",
                USE_SELECTION: "\u4F7F\u7528\u6B64\u9009\u62E9",
                PREPARE_LOOK: "\u51C6\u5907\u6574\u5957\u9020\u578B",
                COMPLETE_SELECTIONS: "\u5B8C\u6210\u9009\u62E9",
                ADD_LOOK_TO_BAG: "\u6574\u5957\u52A0\u5165\u8D2D\u7269\u888B",
                LOOK_ADDED: "\u9020\u578B\u5DF2\u52A0\u5165",
                SELECT: "\u9009\u62E9",
                SELECTED: "\u5DF2\u9009\u62E9",
                READY: "\u5DF2\u5C31\u7EEA",
                CHANGE: "\u66F4\u6539"
            },
            ja: {
                SELECT_OPTIONS: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u3076",
                WHY_THIS_PIECE: "\u3053\u306E\u30A2\u30A4\u30C6\u30E0\u3092\u9078\u3093\u3060\u7406\u7531",
                HIDE_NOTE: "\u8AAC\u660E\u3092\u96A0\u3059",
                VIEW_FULL_DETAILS: "\u8A73\u7D30\u3092\u898B\u308B",
                ADD_TO_BAG: "\u30D0\u30C3\u30B0\u306B\u8FFD\u52A0",
                SELECT_ALL_OPTIONS: "\u3059\u3079\u3066\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E",
                CHECKING_AVAILABILITY: "\u5728\u5EAB\u3092\u78BA\u8A8D\u4E2D\u2026",
                UNAVAILABLE: "\u5728\u5EAB\u306A\u3057",
                CLOSE_OPTIONS: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9589\u3058\u308B",
                OPTIONS_TITLE: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E",
                LOADING_OPTIONS: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
                USE_SELECTION: "\u3053\u306E\u9078\u629E\u3092\u4F7F\u3046",
                PREPARE_LOOK: "\u3053\u306E\u30EB\u30C3\u30AF\u3092\u6E96\u5099",
                COMPLETE_SELECTIONS: "\u9078\u629E\u3092\u5B8C\u4E86",
                ADD_LOOK_TO_BAG: "\u30EB\u30C3\u30AF\u3092\u30D0\u30C3\u30B0\u306B\u8FFD\u52A0",
                LOOK_ADDED: "\u30EB\u30C3\u30AF\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F",
                SELECT: "\u9078\u629E",
                SELECTED: "\u9078\u629E\u6E08\u307F",
                READY: "\u6E96\u5099\u5B8C\u4E86",
                CHANGE: "\u5909\u66F4"
            },
            ko: {
                SELECT_OPTIONS: "\uC635\uC158 \uC120\uD0DD",
                WHY_THIS_PIECE: "\uC774 \uC81C\uD488\uC744 \uC120\uD0DD\uD55C \uC774\uC720",
                HIDE_NOTE: "\uC124\uBA85 \uC228\uAE30\uAE30",
                VIEW_FULL_DETAILS: "\uC804\uCCB4 \uC0C1\uC138 \uBCF4\uAE30",
                ADD_TO_BAG: "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uCD94\uAC00",
                SELECT_ALL_OPTIONS: "\uBAA8\uB4E0 \uC635\uC158\uC744 \uC120\uD0DD\uD558\uC138\uC694",
                CHECKING_AVAILABILITY: "\uC7AC\uACE0 \uD655\uC778 \uC911\u2026",
                UNAVAILABLE: "\uD488\uC808",
                CLOSE_OPTIONS: "\uC635\uC158 \uB2EB\uAE30",
                OPTIONS_TITLE: "\uC635\uC158 \uC120\uD0DD",
                LOADING_OPTIONS: "\uC635\uC158 \uBD88\uB7EC\uC624\uB294 \uC911\u2026",
                USE_SELECTION: "\uC774 \uC120\uD0DD \uC0AC\uC6A9",
                PREPARE_LOOK: "\uC774 \uB8E9 \uC900\uBE44\uD558\uAE30",
                COMPLETE_SELECTIONS: "\uC120\uD0DD \uC644\uB8CC",
                ADD_LOOK_TO_BAG: "\uB8E9\uC744 \uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uCD94\uAC00",
                LOOK_ADDED: "\uB8E9 \uCD94\uAC00\uB428",
                SELECT: "\uC120\uD0DD",
                SELECTED: "\uC120\uD0DD\uB428",
                READY: "\uC900\uBE44\uB428",
                CHANGE: "\uBCC0\uACBD"
            },
            ru: {
                SELECT_OPTIONS: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B",
                WHY_THIS_PIECE: "\u041F\u043E\u0447\u0435\u043C\u0443 \u044D\u0442\u0430 \u0432\u0435\u0449\u044C",
                HIDE_NOTE: "\u0421\u043A\u0440\u044B\u0442\u044C \u0437\u0430\u043C\u0435\u0442\u043A\u0443",
                VIEW_FULL_DETAILS: "\u0412\u0441\u0435 \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F",
                ADD_TO_BAG: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443",
                SELECT_ALL_OPTIONS: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0441\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B",
                CHECKING_AVAILABILITY: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u043C \u043D\u0430\u043B\u0438\u0447\u0438\u0435\u2026",
                UNAVAILABLE: "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
                CLOSE_OPTIONS: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B",
                OPTIONS_TITLE: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B",
                LOADING_OPTIONS: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u2026",
                USE_SELECTION: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440",
                PREPARE_LOOK: "\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0437",
                COMPLETE_SELECTIONS: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440",
                ADD_LOOK_TO_BAG: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0437 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443",
                LOOK_ADDED: "\u041E\u0431\u0440\u0430\u0437 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D",
                SELECT: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C",
                SELECTED: "\u0412\u044B\u0431\u0440\u0430\u043D\u043E",
                READY: "\u0413\u043E\u0442\u043E\u0432\u043E",
                CHANGE: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
            }
        };

        function uiText(key) {
            if (key === "BETA") return "Tellus Stylist Assistant";
            if (key === "CHAT") return "Stylist";
            if (key === "OPEN_CHAT") return "Open stylist assistant";
            const code = getCurrentLanguageCode();
            if (PREMIUM_UI_TRANSLATIONS[code] && PREMIUM_UI_TRANSLATIONS[code][key]) return PREMIUM_UI_TRANSLATIONS[code][key];
            if (PREMIUM_UI_TRANSLATIONS.en[key]) return PREMIUM_UI_TRANSLATIONS.en[key];
            const smartLabelTranslations = {
                es: {
                    FOOTWEAR: "Calzado",
                    OPTIONAL_LAYER: "Capa opcional",
                    OPTIONAL_ACCESSORY: "Accesorio opcional",
                    OPTIONAL_BAG: "Bolso opcional",
                    SET: "Conjunto"
                },
                pt: {
                    FOOTWEAR: "Cal\xE7ado",
                    OPTIONAL_LAYER: "Camada opcional",
                    OPTIONAL_ACCESSORY: "Acess\xF3rio opcional",
                    OPTIONAL_BAG: "Bolsa opcional",
                    SET: "Conjunto"
                },
                fr: {
                    FOOTWEAR: "Chaussures",
                    OPTIONAL_LAYER: "Couche optionnelle",
                    OPTIONAL_ACCESSORY: "Accessoire optionnel",
                    OPTIONAL_BAG: "Sac optionnel",
                    SET: "Ensemble"
                },
                it: {
                    FOOTWEAR: "Calzature",
                    OPTIONAL_LAYER: "Strato opzionale",
                    OPTIONAL_ACCESSORY: "Accessorio opzionale",
                    OPTIONAL_BAG: "Borsa opzionale",
                    SET: "Set"
                },
                de: {
                    FOOTWEAR: "Schuhe",
                    OPTIONAL_LAYER: "Optionale Schicht",
                    OPTIONAL_ACCESSORY: "Optionales Accessoire",
                    OPTIONAL_BAG: "Optionale Tasche",
                    SET: "Set"
                },
                ar: {
                    FOOTWEAR: "\u0623\u062D\u0630\u064A\u0629",
                    OPTIONAL_LAYER: "\u0637\u0628\u0642\u0629 \u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629",
                    OPTIONAL_ACCESSORY: "\u0625\u0643\u0633\u0633\u0648\u0627\u0631 \u0627\u062E\u062A\u064A\u0627\u0631\u064A",
                    OPTIONAL_BAG: "\u062D\u0642\u064A\u0628\u0629 \u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629",
                    SET: "\u0637\u0642\u0645"
                },
                zh: {
                    FOOTWEAR: "\u978B\u5C65",
                    OPTIONAL_LAYER: "\u53EF\u9009\u5916\u642D",
                    OPTIONAL_ACCESSORY: "\u53EF\u9009\u914D\u9970",
                    OPTIONAL_BAG: "\u53EF\u9009\u5305\u888B",
                    SET: "\u5957\u88C5"
                },
                ja: {
                    FOOTWEAR: "\u30D5\u30C3\u30C8\u30A6\u30A7\u30A2",
                    OPTIONAL_LAYER: "\u4EFB\u610F\u306E\u30EC\u30A4\u30E4\u30FC",
                    OPTIONAL_ACCESSORY: "\u4EFB\u610F\u306E\u30A2\u30AF\u30BB\u30B5\u30EA\u30FC",
                    OPTIONAL_BAG: "\u4EFB\u610F\u306E\u30D0\u30C3\u30B0",
                    SET: "\u30BB\u30C3\u30C8"
                },
                ko: {
                    FOOTWEAR: "\uC2E0\uBC1C",
                    OPTIONAL_LAYER: "\uC120\uD0DD \uB808\uC774\uC5B4",
                    OPTIONAL_ACCESSORY: "\uC120\uD0DD \uC561\uC138\uC11C\uB9AC",
                    OPTIONAL_BAG: "\uC120\uD0DD \uAC00\uBC29",
                    SET: "\uC138\uD2B8"
                },
                ru: {
                    FOOTWEAR: "\u041E\u0431\u0443\u0432\u044C",
                    OPTIONAL_LAYER: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u043B\u043E\u0439",
                    OPTIONAL_ACCESSORY: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440",
                    OPTIONAL_BAG: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043A\u0430",
                    SET: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442"
                }
            };
            return smartLabelTranslations[code] && smartLabelTranslations[code][key] ? smartLabelTranslations[code][key] : (UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en)[key] || UI_TRANSLATIONS.en[key] || key
        }

        function getLanguageDirection() {
            const code = getCurrentLanguageCode();
            return ["ar", "he", "fa", "ur", "ps", "dv", "ku", "ckb"].includes(code) ? "rtl" : "ltr"
        }

        function normalizeLiteText(text) {
            return String(text || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
        }

        function detectUiLanguageFromText(text) {
            const raw = String(text || "").trim(),
                m = normalizeLiteText(raw);
            return m ? /\b(spanish|espanol|español|en espanol|en español|habla espanol|habla español)\b/.test(m) ? "es" : /\b(portuguese|portugues|português|em portugues|em português)\b/.test(m) ? "pt" : /\b(french|francais|français|en francais|en français)\b/.test(m) ? "fr" : /\b(italian|italiano)\b/.test(m) ? "it" : /\b(german|deutsch)\b/.test(m) ? "de" : /\b(arabic|العربية|عربي)\b/.test(m) ? "ar" : /\b(hola|buenos dias|buenos días|buenas tardes|buenas noches|necesito|quiero|mujer|hombre|conjunto|fiesta|zapatos|vestido)\b/.test(m) ? "es" : /\b(ola|olá|bom dia|boa tarde|boa noite|preciso|quero|mulher|homem|roupa|look)\b/.test(m) ? "pt" : /\b(bonjour|bonsoir|salut|je veux|j ai besoin|femme|homme|tenue)\b/.test(m) ? "fr" : /\b(buongiorno|buonasera|ciao|voglio|donna|uomo|look)\b/.test(m) ? "it" : /\b(guten morgen|guten tag|hallo|ich brauche|ich mochte|frau|mann)\b/.test(m) ? "de" : /\b(goedemorgen|hallo|ik wil|vrouw|man)\b/.test(m) ? "nl" : /\b(привет|здравствуйте|доброе утро|женщина|мужчина)\b/.test(m) ? "ru" : /[\u0600-\u06FF]/.test(raw) ? "ar" : /[\u4E00-\u9FFF]/.test(raw) ? "zh" : /[\u3040-\u30FF]/.test(raw) ? "ja" : /[\uAC00-\uD7AF]/.test(raw) ? "ko" : "" : ""
        }

        function setUiLanguageFromText(text) {
            const detected = detectUiLanguageFromText(text);
            detected && (conversationContext.languageCode = detected, conversationContext.replyLanguageCode = detected, persistChatSession(), applyInterfaceLocalization())
        }

        function inferSuggestionKey(label, prompt) {
            const combined = normalizeLiteText(String(label || "") + " " + String(prompt || ""));
            return combined ? /\b(complete look|complete outfit|full outfit|look completo|look complet|look completo|kompletter look|full look)\b/.test(combined) ? "COMPLETE_LOOK" : /\b(weather outfit|weather-aware outfit|weather aware|clima|meteo|météo|wetter)\b/.test(combined) ? "WEATHER_OUTFIT" : /\b(occasion outfit|occasion|ocasion|ocasi[oó]n|occasion|anlass)\b/.test(combined) ? "OCCASION_OUTFIT" : /\b(seasonal outfit|seasonal look|season outfit|temporada|saison|stagionale|saisonaler|seizoenslook|موسمية|季节|季節|시즌|сезонный)\b/.test(combined) ? "SEASONAL_OUTFIT" : /\b(spring outfit|spring look|primavera|printemps|frühling|lente|الربيع|春季|春|봄|весна)\b/.test(combined) ? "SPRING_OUTFIT" : /\b(summer outfit|summer look|verano|verao|verão|ete|été|sommer|estate|zomer|الصيف|夏季|夏|여름|летний)\b/.test(combined) ? "SUMMER_OUTFIT" : /\b(fall outfit|fall look|autumn outfit|autumn look|otono|otoño|outono|automne|autunno|herbst|herfst|الخريف|秋季|秋|가을|осень)\b/.test(combined) ? "FALL_OUTFIT" : /\b(winter outfit|winter look|invierno|inverno|hiver|winter|الشتاء|冬季|冬|겨울|зима)\b/.test(combined) ? "WINTER_OUTFIT" : /\b(work outfit|workwear|trabajo|trabalho|travail|arbeit|office|oficina)\b/.test(combined) ? "WORK_OUTFIT" : /\b(what can you do|que puedes hacer|o que voce pode fazer|que peux-tu faire|cosa puoi fare|was kannst du tun)\b/.test(combined) ? "WHAT_CAN_YOU_DO" : /\b(start a new look|new outfit|nuevo look|novo look|nouveau look|new look)\b/.test(combined) ? "START_NEW_LOOK" : /\b(product search|specific product|buscar producto|buscar produto|produit précis)\b/.test(combined) ? "PRODUCT_SEARCH" : /\b(show another outfit|another outfit|different look|reroll|otro look|outro look|autre tenue|anderer look)\b/.test(combined) ? "REROLL_OUTFIT" : /\b(browse collections|show me all collections|colecciones|colecoes|coleções|collections|kollektionen)\b/.test(combined) ? "BROWSE_COLLECTIONS" : /\b(men|mens|man|male|hombre|homem|homme|uomo|mann)\b/.test(combined) ? "MEN" : /\b(women|womens|woman|female|mujer|mulher|femme|donna|frau)\b/.test(combined) ? "WOMEN" : "" : ""
        }

        function localizeSuggestionForUi(item) {
            const normalized = normalizeSuggestion(item);
            if (!normalized) return null;
            const code = getCurrentLanguageCode(),
                labelDictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en,
                promptDictionary = SUGGESTION_PROMPTS[code] || SUGGESTION_PROMPTS.en,
                key = normalized.key || inferSuggestionKey(normalized.label, normalized.prompt);
            if (!key) return normalized;
            if (key === "COMPLETE_LOOK") return null;
            const seasonalPromptFallbacks = {
                    it: {
                        SEASONAL_OUTFIT: "Look stagionale",
                        SPRING_OUTFIT: "Voglio un look primaverile",
                        SUMMER_OUTFIT: "Voglio un look estivo",
                        FALL_OUTFIT: "Voglio un look autunnale",
                        WINTER_OUTFIT: "Voglio un look invernale"
                    },
                    de: {
                        SEASONAL_OUTFIT: "Saisonaler Look",
                        SPRING_OUTFIT: "Ich m\xF6chte einen Fr\xFChlings-Look",
                        SUMMER_OUTFIT: "Ich m\xF6chte einen Sommer-Look",
                        FALL_OUTFIT: "Ich m\xF6chte einen Herbst-Look",
                        WINTER_OUTFIT: "Ich m\xF6chte einen Winter-Look"
                    },
                    nl: {
                        SEASONAL_OUTFIT: "Seizoenslook",
                        SPRING_OUTFIT: "Ik wil een lentelook",
                        SUMMER_OUTFIT: "Ik wil een zomerlook",
                        FALL_OUTFIT: "Ik wil een herfstlook",
                        WINTER_OUTFIT: "Ik wil een winterlook"
                    },
                    ar: {
                        SEASONAL_OUTFIT: "\u0625\u0637\u0644\u0627\u0644\u0629 \u0645\u0648\u0633\u0645\u064A\u0629",
                        SPRING_OUTFIT: "\u0623\u0631\u064A\u062F \u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u0631\u0628\u064A\u0639",
                        SUMMER_OUTFIT: "\u0623\u0631\u064A\u062F \u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u0635\u064A\u0641",
                        FALL_OUTFIT: "\u0623\u0631\u064A\u062F \u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u062E\u0631\u064A\u0641",
                        WINTER_OUTFIT: "\u0623\u0631\u064A\u062F \u0625\u0637\u0644\u0627\u0644\u0629 \u0644\u0644\u0634\u062A\u0627\u0621"
                    },
                    zh: {
                        SEASONAL_OUTFIT: "\u5B63\u8282\u9020\u578B",
                        SPRING_OUTFIT: "\u6211\u60F3\u8981\u6625\u5B63\u9020\u578B",
                        SUMMER_OUTFIT: "\u6211\u60F3\u8981\u590F\u5B63\u9020\u578B",
                        FALL_OUTFIT: "\u6211\u60F3\u8981\u79CB\u5B63\u9020\u578B",
                        WINTER_OUTFIT: "\u6211\u60F3\u8981\u51AC\u5B63\u9020\u578B"
                    },
                    ja: {
                        SEASONAL_OUTFIT: "\u5B63\u7BC0\u306E\u30B3\u30FC\u30C7",
                        SPRING_OUTFIT: "\u6625\u306E\u30B3\u30FC\u30C7\u3092\u63D0\u6848\u3057\u3066",
                        SUMMER_OUTFIT: "\u590F\u306E\u30B3\u30FC\u30C7\u3092\u63D0\u6848\u3057\u3066",
                        FALL_OUTFIT: "\u79CB\u306E\u30B3\u30FC\u30C7\u3092\u63D0\u6848\u3057\u3066",
                        WINTER_OUTFIT: "\u51AC\u306E\u30B3\u30FC\u30C7\u3092\u63D0\u6848\u3057\u3066"
                    },
                    ko: {
                        SEASONAL_OUTFIT: "\uC2DC\uC98C \uB8E9",
                        SPRING_OUTFIT: "\uBD04 \uB8E9\uC744 \uC6D0\uD574\uC694",
                        SUMMER_OUTFIT: "\uC5EC\uB984 \uB8E9\uC744 \uC6D0\uD574\uC694",
                        FALL_OUTFIT: "\uAC00\uC744 \uB8E9\uC744 \uC6D0\uD574\uC694",
                        WINTER_OUTFIT: "\uACA8\uC6B8 \uB8E9\uC744 \uC6D0\uD574\uC694"
                    },
                    ru: {
                        SEASONAL_OUTFIT: "\u0421\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u043E\u0431\u0440\u0430\u0437",
                        SPRING_OUTFIT: "\u0425\u043E\u0447\u0443 \u0432\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u043E\u0431\u0440\u0430\u0437",
                        SUMMER_OUTFIT: "\u0425\u043E\u0447\u0443 \u043B\u0435\u0442\u043D\u0438\u0439 \u043E\u0431\u0440\u0430\u0437",
                        FALL_OUTFIT: "\u0425\u043E\u0447\u0443 \u043E\u0441\u0435\u043D\u043D\u0438\u0439 \u043E\u0431\u0440\u0430\u0437",
                        WINTER_OUTFIT: "\u0425\u043E\u0447\u0443 \u0437\u0438\u043C\u043D\u0438\u0439 \u043E\u0431\u0440\u0430\u0437"
                    }
                },
                seasonalPrompt = seasonalPromptFallbacks[code] && seasonalPromptFallbacks[code][key];
            return {
                key,
                label: labelDictionary[key] || normalized.label,
                prompt: seasonalPrompt || promptDictionary[key] || normalized.prompt,
                action: normalized.action || (key === "SEASONAL_OUTFIT" ? "SHOW_SEASONS" : ""),
                canonicalPrompt: normalized.canonicalPrompt || ""
            }
        }

        function localizeSuggestionsForUi(suggestions) {
            return Array.isArray(suggestions) ? suggestions.map(localizeSuggestionForUi).filter(Boolean) : []
        }

        function localizeCtaForUi(cta) {
            if (!cta || typeof cta != "object") return cta;
            const copy = Object.assign({}, cta),
                code = getCurrentLanguageCode(),
                dictionary = UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en,
                key = inferSuggestionKey(copy.label || copy.linkText || "", "");
            return key && dictionary[key] && (copy.label = dictionary[key]), /^see more$/i.test(String(copy.label || "")) && (copy.label = uiText("SEE_MORE")), /^browse collections$/i.test(String(copy.label || "")) && (copy.label = uiText("BROWSE_COLLECTIONS")), (/^browse all$/i.test(String(copy.label || "")) || /^view all$/i.test(String(copy.label || ""))) && (copy.label = uiText("BROWSE_ALL")), (/^here$/i.test(String(copy.linkText || "")) || /^see more$/i.test(String(copy.linkText || ""))) && (copy.linkText = uiText("SEE_MORE")), copy
        }

        function applyInterfaceLocalization() {
            const direction = getLanguageDirection();
            try {
                panel && (panel.setAttribute("dir", direction), panel.classList.toggle("cl-rtl", direction === "rtl"), panel.classList.toggle("cl-ltr", direction !== "rtl")), body && body.setAttribute("dir", direction), input && (input.placeholder = uiText("PLACEHOLDER"), input.setAttribute("aria-label", uiText("PLACEHOLDER")), input.setAttribute("dir", direction)), send && (send.textContent = uiText("SEND")), btn && (btn.textContent = uiText("CHAT"), btn.setAttribute("aria-label", uiText("OPEN_CHAT"))), closeBtn && closeBtn.setAttribute("aria-label", uiText("CLOSE"));
                const sub = launcher ? launcher.querySelector(".cl-chat-sub") : null;
                sub && (sub.textContent = uiText("BETA"))
            } catch {}
        }
        const STYLE = `
      .cl-chat-launcher{
        position:fixed;
        right:22px;
        bottom:22px;
        z-index:2147483647;
        font-family: Georgia, "Times New Roman", serif;
      }

      [data-consumerlite-chat-open]{
        cursor:pointer;
      }

      .cl-chat-btn{
        width:58px;
        height:58px;
        border-radius:999px;
        border:1px solid rgba(255,255,255,.16);
        cursor:pointer;
        box-shadow:0 18px 46px rgba(0,0,0,.22);
        background:#101010;
        color:#fff;
        font:700 12px/1.1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.02em;
        transition:transform .22s ease, box-shadow .22s ease, background .22s ease;
      }

      .cl-chat-panel{
        position:fixed;
        right:22px;
        bottom:92px;
        width:410px;
        max-width:92vw;
        height:660px;
        max-height:80vh;
        background:#fff;
        border:1px solid rgba(0,0,0,.10);
        border-radius:24px;
        box-shadow:0 28px 80px rgba(0,0,0,.24);
        overflow:hidden;
        display:none;
        flex-direction:column;
        box-sizing:border-box;
        z-index:2147483647;
        isolation:isolate;
        animation:clPanelIn .24s ease both;
      }

      @keyframes clPanelIn{
        from{ opacity:0; transform:translateY(12px) scale(.985); }
        to{ opacity:1; transform:translateY(0) scale(1); }
      }

      .cl-chat-head{
        flex:0 0 auto;
        padding:18px 18px 15px;
        border-bottom:1px solid rgba(0,0,0,.08);
        display:flex;
        align-items:center;
        justify-content:space-between;
        background:linear-gradient(180deg,#fff 0%,#fbfaf8 100%);
      }

      .cl-chat-brand{
        display:flex;
        flex-direction:column;
        gap:4px;
      }

      .cl-chat-title{
        font:700 14px/1.1 Georgia, "Times New Roman", serif;
        letter-spacing:.20em;
        text-transform:uppercase;
        color:#111;
      }

      .cl-chat-sub{
        font:500 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color:rgba(0,0,0,.52);
        letter-spacing:.01em;
      }

      .cl-chat-close{
        width:32px;
        height:32px;
        border-radius:999px;
        border:1px solid transparent;
        background:transparent;
        font-size:22px;
        line-height:1;
        cursor:pointer;
        color:rgba(0,0,0,.55);
        transition:background .18s ease, border-color .18s ease, color .18s ease;
      }

      .cl-chat-body{
        flex:1 1 auto;
        min-height:0;
        height:auto;
        padding:16px 14px 18px;
        overflow:auto;
        background:
          radial-gradient(circle at 20% 0%, rgba(180,160,130,.12), transparent 30%),
          linear-gradient(180deg,#fff 0%,#fbfaf8 100%);
        position:relative;
        z-index:1;
        pointer-events:auto;
        scroll-behavior:auto;
      }

      .cl-chat-body::-webkit-scrollbar{
        width:8px;
      }

      .cl-chat-body::-webkit-scrollbar-track{
        background:transparent;
      }

      .cl-chat-body::-webkit-scrollbar-thumb{
        background:rgba(0,0,0,.16);
        border-radius:999px;
      }

      .cl-msg{
        margin:12px 0;
        display:flex;
        animation:clMsgIn .20s ease both;
      }

      @keyframes clMsgIn{
        from{ opacity:0; transform:translateY(6px); }
        to{ opacity:1; transform:translateY(0); }
      }

      .cl-msg.user{
        justify-content:flex-end;
      }

      .cl-chat-panel[dir="rtl"] .cl-chat-head,
      .cl-chat-panel[dir="rtl"] .cl-chat-title,
      .cl-chat-panel[dir="rtl"] .cl-chat-sub{
        text-align:right;
      }

      .cl-chat-panel[dir="rtl"] .cl-msg.ai{
        justify-content:flex-end;
      }

      .cl-chat-panel[dir="rtl"] .cl-msg.user{
        justify-content:flex-start;
      }

      .cl-chat-panel[dir="rtl"] .cl-msg.ai .cl-bubble{
        border-top-left-radius:18px;
        border-top-right-radius:7px;
        text-align:right;
      }

      .cl-chat-panel[dir="rtl"] .cl-msg.user .cl-bubble{
        border-top-left-radius:7px;
        border-top-right-radius:18px;
        text-align:right;
      }


      .cl-bubble{
        max-width:86%;
        padding:12px 14px;
        border-radius:18px;
        font:500 14px/1.58 Georgia, "Times New Roman", serif;
        white-space:pre-wrap;
        box-sizing:border-box;
      }

      .cl-msg.ai .cl-bubble{
        background:#101010;
        color:#fff;
        border-top-left-radius:7px;
        box-shadow:0 14px 34px rgba(0,0,0,.14);
      }

      .cl-msg.user .cl-bubble{
        background:#f0efed;
        color:#111;
        border-top-right-radius:7px;
        box-shadow:0 8px 22px rgba(0,0,0,.04);
      }

      .cl-anchor-note{
        margin:10px 14px 8px;
        padding:9px 12px;
        border:1px solid rgba(0,0,0,.10);
        border-radius:999px;
        background:rgba(255,255,255,.86);
        color:rgba(0,0,0,.66);
        font:600 11px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.05em;
        text-transform:none;
        max-width:calc(100% - 28px);
        display:inline-flex;
        align-items:center;
        gap:6px;
      }

      .cl-chat-panel[dir="rtl"] .cl-anchor-note{
        margin-left:auto;
        margin-right:14px;
      }

      .cl-suggestions{
        display:flex;
        flex-wrap:wrap;
        gap:9px;
        margin:10px 0 14px;
        padding-left:2px;
        position:relative;
        z-index:2;
      }

      .cl-suggestion{
        border:1px solid rgba(0,0,0,.16);
        border-radius:999px;
        background:rgba(255,255,255,.92);
        color:#111;
        padding:9px 12px;
        font:700 11px/1.15 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.01em;
        cursor:pointer;
        box-shadow:0 8px 22px rgba(0,0,0,.055);
        transition:transform .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
      }

      .cl-chat-panel[dir="rtl"] .cl-suggestions{
        justify-content:flex-end;
        padding-left:0;
        padding-right:2px;
      }

      .cl-chat-panel[dir="rtl"] .cl-chat-foot{
        direction:rtl;
      }

      .cl-chat-panel[dir="rtl"] .cl-in{
        text-align:right;
      }

      .cl-chat-panel[dir="rtl"] .cl-card-body,
      .cl-chat-panel[dir="rtl"] .cl-card-title,
      .cl-chat-panel[dir="rtl"] .cl-card-price,
      .cl-chat-panel[dir="rtl"] .cl-card-action{
        text-align:right;
      }

      .cl-chat-panel[dir="rtl"] .cl-card-badge{
        align-self:flex-end;
      }

      .cl-chat-panel[dir="rtl"] .cl-browse,
      .cl-chat-panel[dir="rtl"] .cl-guide-cta{
        text-align:right;
      }

      .cl-chat-foot{
        flex:0 0 auto;
        border-top:1px solid rgba(0,0,0,.08);
        padding:12px;
        display:flex;
        gap:10px;
        background:#fff;
        align-items:center;
      }

      .cl-in{
        flex:1;
        min-width:0;
        border:1px solid rgba(0,0,0,.15);
        border-radius:999px;
        padding:13px 15px;
        font:500 14px/1.2 Georgia, "Times New Roman", serif;
        outline:none;
        background:#fff;
        color:#111;
        transition:border-color .18s ease, box-shadow .18s ease;
      }

      .cl-in:focus{
        border-color:#111;
        box-shadow:0 0 0 3px rgba(0,0,0,.06);
      }

      .cl-in::placeholder{
        color:rgba(0,0,0,.42);
      }

      .cl-send{
        border:0;
        border-radius:999px;
        padding:13px 17px;
        background:#111;
        color:#fff;
        font:800 13px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        cursor:pointer;
        min-width:66px;
        transition:transform .18s ease, box-shadow .18s ease, background .18s ease;
      }

      .cl-cards{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        grid-auto-rows:max-content;
        align-items:start;
        gap:12px;
        margin:13px 0 4px;
        position:relative;
        z-index:2;
        pointer-events:auto;
      }

      .cl-card{
        display:flex;
        flex-direction:column;
        min-height:0;
        align-self:start;
        width:100%;
        border:1px solid rgba(0,0,0,.10);
        border-radius:20px;
        overflow:hidden;
        background:#fff;
        text-decoration:none;
        color:#111;
        position:relative;
        z-index:1;
        pointer-events:auto;
        cursor:default;
        -webkit-tap-highlight-color:transparent;
        box-shadow:0 12px 34px rgba(0,0,0,.045);
        transition:transform .22s ease, box-shadow .22s ease, border-color .22s ease;
      }

      .cl-card-link,
      .cl-card-media-link,
      .cl-card-title-link{
        text-decoration:none;
        color:inherit;
        -webkit-tap-highlight-color:transparent;
      }

      .cl-card-media-link{
        display:block;
      }

      .cl-card-title-link{
        display:block;
      }

      .cl-card-img{
        width:100%;
        height:178px;
        object-fit:contain;
        display:block;
        background:#f5f3f0;
        padding:12px;
        box-sizing:border-box;
        border-bottom:1px solid rgba(0,0,0,.06);
      }

      .cl-card-body{
        padding:12px 12px 13px;
        display:flex;
        flex-direction:column;
        flex:0 0 auto;
        min-height:0;
      }

      .cl-card-badge{
        align-self:flex-start;
        margin:0 0 8px;
        padding:5px 8px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:999px;
        background:#fbfaf8;
        color:rgba(0,0,0,.62);
        font:800 9px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
      }

      .cl-card-title{
        font:700 13px/1.34 Georgia, "Times New Roman", serif;
        letter-spacing:.01em;
        margin:0 0 7px;
        color:#111;
      }

      .cl-card-price{
        font:700 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color:rgba(0,0,0,.58);
        margin:0;
      }

      .cl-card-variant-note{
        margin:8px 0 0;
        color:rgba(0,0,0,.58);
        font:600 11px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-order-private { margin:16px 0; padding:18px; border:1px solid #ddd8ce; border-radius:16px; background:#faf8f3; color:#111; overflow-wrap:anywhere; }
      .cl-order-private[hidden] { display:none!important; }
      .cl-order-kicker { margin:0 0 12px; font:700 10px/1.4 system-ui,sans-serif; letter-spacing:.14em; }
      .cl-order-reply { margin:0 0 16px; font:400 14px/1.6 system-ui,sans-serif; }
      .cl-order-title { margin:0 0 8px; font:500 21px/1.2 Georgia,serif; color:#111; }
      .cl-order-meta { margin:7px 0; font:400 12px/1.55 system-ui,sans-serif; color:#57524c; }
      .cl-order-status { display:inline-flex; margin:4px 0 10px; padding:6px 10px; border:1px solid #c8c1b6; border-radius:999px; background:#fff; color:#27231e; font:600 11px/1.3 system-ui,sans-serif; }
      .cl-order-card { margin:14px 0 0; padding:16px; border:1px solid #ddd8ce; border-radius:12px; background:#fff; }
      .cl-order-item { display:flex; align-items:center; gap:12px; margin:13px 0; min-width:0; }
      .cl-order-item>div { flex:1; min-width:0; }
      .cl-order-item img { flex:none; width:56px; height:70px; object-fit:contain; border-radius:6px; background:#f1eee8; }
      .cl-order-item-title { margin:0; font:600 13px/1.45 system-ui,sans-serif; }
      .cl-order-actions { display:flex; flex-wrap:wrap; gap:8px; margin:14px 0 0; }
      .cl-order-private .cl-order-action { display:inline-flex; align-items:center; justify-content:center; box-sizing:border-box; min-height:44px; max-width:100%; margin:4px 0 0; padding:10px 14px; border:1px solid #bdb6aa; border-radius:999px; background:#fff; color:#111; font:600 12px/1.4 system-ui,sans-serif; text-decoration:none; text-align:center; cursor:pointer; }
      .cl-order-action:focus-visible { outline:2px solid #111; outline-offset:3px; }
      .cl-order-timeline { margin:16px 0 0; padding:0 0 0 18px; }
      .cl-order-timeline li { margin:0; padding:0 0 16px 6px; }
      .cl-order-timeline p { margin:0 0 5px; font:400 13px/1.5 system-ui,sans-serif; }
      .cl-order-timeline small { font:400 11px/1.5 system-ui,sans-serif; color:#625d55; }
      [dir="rtl"] .cl-order-timeline { padding:0 18px 0 0; }
      @media(max-width:480px) { .cl-order-private { padding:14px; } .cl-order-card { padding:12px; } .cl-order-actions>.cl-order-action { flex:1 1 125px; } }

      .cl-purchase-help{flex-wrap:wrap;max-height:260px;overflow-y:auto}
      .cl-purchase-help .cl-purchase-action{min-height:44px;white-space:normal;text-align:center;text-decoration:none}
      .cl-purchase-help.cl-purchase-chooser{display:block;width:100%;max-height:none;overflow:visible;box-sizing:border-box}
      .cl-purchase-grid{display:grid;grid-template-columns:minmax(0,1fr);gap:12px;width:100%;min-width:0}
      .cl-purchase-piece{display:grid;grid-template-columns:80px minmax(0,1fr);align-items:start;gap:12px;padding:12px;border:1px solid rgba(0,0,0,.12);border-radius:18px;background:#fff;color:#111;box-shadow:0 8px 24px rgba(0,0,0,.035);min-width:0;max-width:100%;box-sizing:border-box}
      .cl-purchase-media{display:flex;align-items:center;justify-content:center;width:80px;min-height:108px;background:#f5f3f0;border-radius:10px;overflow:hidden}
      .cl-purchase-media img{display:block;width:80px;height:108px;object-fit:contain}
      .cl-purchase-media span{padding:8px;text-align:center;font:400 10px/1.4 system-ui,sans-serif;color:#5b5854}
      .cl-purchase-media [hidden]{display:none!important}
      .cl-purchase-piece-body{display:flex;flex-direction:column;gap:7px;min-width:0;text-align:start;overflow-wrap:anywhere}
      .cl-purchase-piece .cl-card-title,.cl-purchase-piece .cl-card-price{margin:0;white-space:normal;overflow-wrap:anywhere}
      .cl-purchase-piece-details{margin:0;color:#555;font:400 11px/1.5 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;white-space:normal;overflow-wrap:anywhere}
      .cl-purchase-pick{appearance:none;display:block;width:100%;min-height:44px;padding:10px 12px;box-sizing:border-box;border:1px solid #111;border-radius:999px;background:#111;color:#fff;font:600 12px/1.4 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;text-align:center;white-space:normal;cursor:pointer;-webkit-tap-highlight-color:transparent}
      .cl-purchase-pick:focus-visible{outline:2px solid #111;outline-offset:3px}
      .cl-purchase-chooser>.cl-purchase-action{margin-block-start:12px}
      @media(max-width:380px){.cl-purchase-piece{grid-template-columns:64px minmax(0,1fr);gap:10px;padding:10px}.cl-purchase-media,.cl-purchase-media img{width:64px}.cl-purchase-media img{height:96px}.cl-purchase-media{min-height:96px}}
      .cl-purchase-bag{font-size:13px;line-height:1.6;padding:12px 16px;background:#f8f7f3;border-radius:16px;margin:10px 0;color:#171717}
      .cl-purchase-bag ul{padding-left:18px;margin:0}
      .cl-purchase-bag-item{display:flex;align-items:center;gap:10px;margin:8px 0;overflow-wrap:anywhere}
      .cl-purchase-bag-item img{width:56px;height:72px;flex:none;object-fit:contain;background:#f2f0eb;border-radius:8px}
      .cl-card-why{
        align-self:flex-start;
        margin:11px 0 0;
        padding:0 0 3px;
        border:0;
        border-bottom:1px solid rgba(0,0,0,.38);
        background:transparent;
        color:#111;
        cursor:pointer;
        font:800 9.5px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
        -webkit-tap-highlight-color:transparent;
      }

      .cl-card-stylist-note{
        margin:9px 0 0;
        padding:10px 0 0;
        border-top:1px solid rgba(0,0,0,.08);
        color:rgba(0,0,0,.66);
        font:600 11px/1.45 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-card-stylist-note[hidden]{
        display:none!important;
      }

      .cl-card-cart.requires-selection{
        background:#111;
        color:#fff;
        border-color:#111;
      }

      .cl-card-action{
        margin-top:auto;
        padding-top:10px;
        font:800 10px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
        color:#111;
      }

      .cl-card-cart{
        margin:0 12px 13px;
        border:1px solid #111;
        border-radius:999px;
        background:#111;
        color:#fff;
        cursor:pointer;
        padding:10px 12px;
        font:800 10px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
        transition:transform .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
      }


      .cl-card-cart:disabled{
        opacity:.58;
        cursor:default;
        transform:none;
      }

      .cl-card-cart.is-added{
        background:#fff;
        color:#111;
      }

      .cl-card-cart-control{
        margin:0 12px 13px;
        display:flex;
        flex-direction:column;
        gap:7px;
      }

      .cl-card-cart-status{
        border:1px solid rgba(0,0,0,.18);
        border-radius:999px;
        background:#fff;
        color:#111;
        padding:10px 12px;
        text-align:center;
        font:800 10px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
      }

      .cl-card-cart-stepper{
        display:grid;
        grid-template-columns:34px 1fr 34px;
        align-items:center;
        border:1px solid rgba(0,0,0,.18);
        background:#fff;
        min-height:38px;
      }

      .cl-card-cart-stepper button{
        border:0;
        background:transparent;
        color:#111;
        min-height:38px;
        cursor:pointer;
        font:400 19px/1 Georgia, "Times New Roman", serif;
      }

      .cl-card-cart-stepper button:disabled{
        opacity:.42;
        cursor:default;
      }

      .cl-card-cart-qty{
        text-align:center;
        font:500 14px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color:#111;
      }

      .cl-chat-btn,
      .cl-chat-close,
      .cl-suggestion,
      .cl-send,
      .cl-card-cart,
      .cl-card-cart-stepper button,
      .cl-card-why,
      .cl-shop-full-look,
      .cl-variant-choice,
      .cl-variant-primary,
      .cl-look-item-action,
      .cl-commerce-close,
      .cl-variant-details,
      .cl-atelier button,
      .cl-compare-actions button,
      .cl-new-response,
      .cl-card-atelier,
      .cl-my-atelier-open,
      .cl-my-atelier-item-actions button{
        -webkit-tap-highlight-color:transparent;
        touch-action:manipulation;
      }

      .cl-chat-launcher button:focus-visible,
      .cl-chat-panel button:focus-visible,
      .cl-chat-panel a:focus-visible{
        outline:2px solid #111;
        outline-offset:3px;
      }


      .cl-new-response{
        position:absolute;
        right:18px;
        bottom:78px;
        z-index:18;
        border:1px solid rgba(0,0,0,.16);
        border-radius:999px;
        background:#111;
        color:#fff;
        padding:9px 13px;
        box-shadow:0 12px 28px rgba(0,0,0,.18);
        cursor:pointer;
        font:800 9.5px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.07em;
        text-transform:uppercase;
        -webkit-tap-highlight-color:transparent;
      }

      .cl-new-response[hidden]{display:none!important}

      .cl-atelier-head-actions{
        display:flex;
        align-items:center;
        gap:8px;
        flex:0 0 auto;
      }

      .cl-my-atelier-open{
        border:1px solid rgba(0,0,0,.18);
        border-radius:999px;
        background:#fff;
        color:#111;
        padding:7px 10px;
        cursor:pointer;
        font:800 8.5px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.06em;
        text-transform:uppercase;
      }

      .cl-card-secondary-actions{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:8px;
        margin-top:11px;
      }

      .cl-card-secondary-actions .cl-card-why{
        flex:1 1 auto;
        min-width:0;
        align-self:center;
        display:flex;
        align-items:center;
        justify-content:center;
        text-align:center;
        margin-top:0;
        width:100%;
        box-sizing:border-box;
        min-height:44px;
        padding:10px 12px;
        border:1px solid #111;
        border-radius:999px;
        background:#111;
        color:#fff;
        font-weight:800;
        letter-spacing:.04em;
        text-decoration:none;
      }
      .cl-card-edit{
        display:flex;
        align-items:center;
        justify-content:center;
        width:100%;
        box-sizing:border-box;
        min-height:44px;
        margin:10px 0 0;
        padding:10px 12px;
        border:1px solid #111;
        border-radius:999px;
        background:#fff;
        color:#111;
        text-align:center;
        letter-spacing:.04em;
      }
      .cl-card-edit[aria-pressed="true"]{background:#f3f1ed;}
      .cl-card-edit:disabled{opacity:.58;cursor:default;}
      .cl-card-edit[hidden]{display:none!important;}

      .cl-card-atelier{
        border:0;
        border-bottom:1px solid rgba(0,0,0,.38);
        background:transparent;
        color:#111;
        padding:0 0 3px;
        cursor:pointer;
        text-align:right;
        font:800 9px/1.2 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.08em;
        text-transform:uppercase;
        -webkit-tap-highlight-color:transparent;
      }

      .cl-card-atelier[hidden]{display:none!important}

      .cl-stylist-insight{
        display:grid;
        grid-template-columns:86px minmax(0,1fr);
        gap:14px;
        align-items:start;
      }

      .cl-stylist-insight img{
        width:86px;
        height:112px;
        object-fit:contain;
        border-radius:14px;
        background:#f3f0eb;
      }

      .cl-stylist-insight h4{
        margin:0 0 8px;
        color:#111;
        font:700 17px/1.2 Georgia,"Times New Roman",serif;
      }

      .cl-stylist-insight p{
        margin:0;
        color:rgba(0,0,0,.68);
        font:600 13px/1.55 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-my-atelier-list{
        display:flex;
        flex-direction:column;
        gap:10px;
      }

      .cl-my-atelier-item{
        display:grid;
        grid-template-columns:72px minmax(0,1fr);
        gap:12px;
        padding:10px;
        border:1px solid rgba(0,0,0,.10);
        border-radius:16px;
        background:#fbfaf8;
      }

      .cl-my-atelier-item img{
        width:72px;
        height:88px;
        object-fit:contain;
        border-radius:11px;
        background:#f3f0eb;
      }

      .cl-my-atelier-item h4{
        margin:0 0 5px;
        font:700 14px/1.25 Georgia,"Times New Roman",serif;
      }

      .cl-my-atelier-item p{
        margin:0 0 8px;
        color:rgba(0,0,0,.58);
        font:600 10.5px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-my-atelier-item-actions{
        display:flex;
        flex-wrap:wrap;
        gap:7px;
      }

      .cl-my-atelier-item-actions button{
        min-height:34px;
        border:1px solid rgba(0,0,0,.16);
        border-radius:999px;
        background:#fff;
        color:#111;
        padding:8px 10px;
        cursor:pointer;
        font:800 8.5px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.05em;
        text-transform:uppercase;
      }

      .cl-my-atelier-empty{
        margin:0;
        padding:20px 0;
        color:rgba(0,0,0,.60);
        text-align:center;
        font:600 13px/1.5 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-atelier[hidden]{
        display:none!important;
      }

      .cl-atelier{
        flex:0 0 auto;
        position:relative;
        z-index:6;
        padding:12px 14px 13px;
        border-bottom:1px solid rgba(0,0,0,.08);
        background:linear-gradient(180deg,#fbfaf8 0%,#f5f1eb 100%);
        box-shadow:0 12px 26px rgba(0,0,0,.055);
      }

      .cl-atelier-head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin:0 0 9px;
      }

      .cl-atelier-title-wrap{
        min-width:0;
      }

      .cl-atelier-kicker{
        margin:0 0 3px;
        color:rgba(0,0,0,.48);
        font:800 8.5px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.18em;
        text-transform:uppercase;
      }

      .cl-atelier-title{
        margin:0;
        color:#111;
        font:700 15px/1.15 Georgia,"Times New Roman",serif;
      }

      .cl-atelier-toggle{
        flex:0 0 auto;
        border:0;
        background:transparent;
        color:rgba(0,0,0,.60);
        padding:5px;
        cursor:pointer;
        font:750 9px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.05em;
        text-decoration:underline;
        text-underline-offset:3px;
      }

      .cl-chat-panel .cl-edit-piece-wrap{flex:0 0 92px;min-width:0;display:flex;flex-direction:column;gap:4px}
      .cl-chat-panel .cl-edit-piece-wrap .cl-atelier-piece{flex:none;width:100%;min-height:86px}
      .cl-chat-panel .cl-edit-remove,.cl-chat-panel .cl-edit-undo{min-height:44px;border:1px solid rgba(0,0,0,.18);border-radius:12px;background:#fff;color:#111;padding:6px 8px;cursor:pointer;font:600 11px/1.3 system-ui,-apple-system,sans-serif}
      .cl-chat-panel .cl-edit-help,.cl-chat-panel .cl-edit-notice{margin:6px 0;color:#333;font:500 11px/1.45 system-ui,-apple-system,sans-serif;overflow-wrap:anywhere}
      .cl-chat-panel .cl-atelier.is-collapsed .cl-edit-help,.cl-chat-panel .cl-atelier.is-collapsed .cl-edit-notice,.cl-chat-panel .cl-atelier.is-collapsed .cl-edit-undo{display:none!important}
      .cl-chat-panel .cl-atelier button:disabled{cursor:wait;opacity:.55}
      .cl-chat-panel .cl-edit-remove:focus-visible,.cl-chat-panel .cl-edit-undo:focus-visible{outline:2px solid #111;outline-offset:2px}
      .cl-atelier-products{
        display:flex;
        gap:8px;
        overflow-x:auto;
        overscroll-behavior-inline:contain;
        scrollbar-width:none;
        padding:0 0 8px;
      }

      .cl-atelier-products::-webkit-scrollbar{display:none}

      .cl-atelier-piece{
        flex:0 0 76px;
        min-width:0;
        border:1px solid rgba(0,0,0,.10);
        border-radius:14px;
        background:#fff;
        padding:6px;
        cursor:pointer;
        text-align:left;
        box-shadow:0 8px 18px rgba(0,0,0,.045);
      }

      .cl-atelier-piece-image{
        width:100%;
        height:62px;
        object-fit:contain;
        display:block;
        border-radius:9px;
        background:#f3f0eb;
      }

      .cl-atelier-piece-meta{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:4px;
        margin-top:6px;
      }

      .cl-atelier-piece-slot{
        min-width:0;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        color:#111;
        font:800 8px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.08em;
        text-transform:uppercase;
      }

      .cl-atelier-piece-state{
        width:17px;
        height:17px;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        flex:0 0 auto;
        border-radius:999px;
        background:#111;
        color:#fff;
        font:800 10px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-atelier-piece.needs-selection .cl-atelier-piece-state{
        background:#fff;
        color:#111;
        border:1px solid rgba(0,0,0,.24);
      }

      .cl-atelier-summary{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:12px;
        margin:1px 0 9px;
      }

      .cl-atelier-readiness{
        margin:0;
        color:#111;
        font:750 10.5px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-atelier-next{
        margin:2px 0 0;
        color:rgba(0,0,0,.56);
        font:600 9.5px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-atelier-total{
        flex:0 0 auto;
        color:#111;
        font:800 11px/1.2 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        white-space:nowrap;
      }

      .cl-atelier-actions{
        display:grid;
        grid-template-columns:minmax(0,1fr) auto auto;
        gap:7px;
        align-items:center;
      }

      .cl-atelier-primary,
      .cl-atelier-secondary,
      .cl-atelier-compare{
        min-height:39px;
        border-radius:999px;
        cursor:pointer;
        font:800 9.5px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.08em;
        text-transform:uppercase;
      }

      .cl-atelier-primary{
        border:1px solid #111;
        background:#111;
        color:#fff;
        padding:10px 13px;
      }

      .cl-atelier-secondary,
      .cl-atelier-compare{
        border:1px solid rgba(0,0,0,.18);
        background:#fff;
        color:#111;
        padding:10px 12px;
      }

      .cl-atelier-refine{
        display:grid;
        grid-template-columns:repeat(3,minmax(0,1fr));
        gap:7px;
        padding-top:9px;
      }

      .cl-atelier-refine[hidden]{display:none!important}

      .cl-atelier-refine button{
        min-height:37px;
        border:1px solid rgba(0,0,0,.14);
        border-radius:12px;
        background:rgba(255,255,255,.88);
        color:#111;
        padding:8px 7px;
        cursor:pointer;
        font:750 9px/1.2 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-atelier.is-collapsed{
        padding-bottom:10px;
      }

      .cl-atelier.is-collapsed .cl-atelier-products,
      .cl-atelier.is-collapsed .cl-atelier-actions,
      .cl-atelier.is-collapsed .cl-atelier-refine,
      .cl-atelier.is-collapsed .cl-atelier-next{
        display:none!important;
      }

      .cl-atelier.is-collapsed .cl-atelier-head{
        margin-bottom:5px;
      }

      .cl-atelier.is-collapsed .cl-atelier-summary{
        display:none!important;
      }

      .cl-compare-grid{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:10px;
      }

      .cl-compare-column{
        border:1px solid rgba(0,0,0,.10);
        border-radius:18px;
        background:#fbfaf8;
        padding:11px;
      }

      .cl-compare-column h4{
        margin:0 0 9px;
        color:#111;
        font:700 14px/1.2 Georgia,"Times New Roman",serif;
      }

      .cl-compare-piece{
        display:grid;
        grid-template-columns:40px minmax(0,1fr);
        gap:8px;
        align-items:center;
        padding:7px 0;
        border-top:1px solid rgba(0,0,0,.07);
      }

      .cl-compare-piece:first-of-type{border-top:0}

      .cl-compare-piece img{
        width:40px;
        height:48px;
        object-fit:contain;
        border-radius:8px;
        background:#f0ede8;
      }

      .cl-compare-piece p{
        margin:0;
        color:#111;
        font:700 10px/1.3 Georgia,"Times New Roman",serif;
      }

      .cl-compare-total{
        margin:10px 0 0;
        color:#111;
        font:800 11px/1.2 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-compare-actions{
        display:flex;
        flex-wrap:wrap;
        gap:8px;
        margin-top:14px;
      }

      .cl-compare-actions button{
        flex:1 1 130px;
        min-height:42px;
        border:1px solid #111;
        border-radius:999px;
        background:#fff;
        color:#111;
        cursor:pointer;
        padding:10px 12px;
        font:800 9.5px/1.1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        letter-spacing:.06em;
        text-transform:uppercase;
      }

      .cl-compare-actions button.is-primary{
        background:#111;
        color:#fff;
      }

      .cl-card-selection-summary{
        min-height:14px;
        margin:7px 0 0;
        color:rgba(0,0,0,.60);
        font:700 9.5px/1.35 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
      }

      .cl-card-selection-summary:empty{display:none}

      .cl-card-cart.has-selection{
        background:#111;
        color:#fff;
        border-color:#111;
      }

      @media (hover:hover) and (pointer:fine){
        .cl-atelier-primary:hover,
        .cl-atelier-secondary:hover,
        .cl-atelier-compare:hover,
        .cl-atelier-piece:hover,
        .cl-atelier-refine button:hover,
        .cl-compare-actions button:hover{
          transform:translateY(-1px);
          box-shadow:0 10px 22px rgba(0,0,0,.09);
        }
      }

      @media (hover:none), (pointer:coarse), (any-pointer:coarse){
        .cl-atelier button,
        .cl-compare-actions button{
          transition:none!important;
          -webkit-tap-highlight-color:transparent;
          touch-action:manipulation;
        }

        .cl-atelier-primary,
        .cl-atelier-primary:hover,
        .cl-atelier-primary:active,
        .cl-compare-actions button.is-primary,
        .cl-compare-actions button.is-primary:hover,
        .cl-compare-actions button.is-primary:active{
          transform:none;
          background:#111;
          color:#fff;
          border-color:#111;
          box-shadow:none;
        }

        .cl-atelier-secondary,
        .cl-atelier-secondary:hover,
        .cl-atelier-secondary:active,
        .cl-atelier-compare,
        .cl-atelier-compare:hover,
        .cl-atelier-compare:active,
        .cl-atelier-piece,
        .cl-atelier-piece:hover,
        .cl-atelier-piece:active,
        .cl-atelier-refine button,
        .cl-atelier-refine button:hover,
        .cl-atelier-refine button:active,
        .cl-compare-actions button:not(.is-primary),
        .cl-compare-actions button:not(.is-primary):hover,
        .cl-compare-actions button:not(.is-primary):active{
          transform:none;
          background:#fff;
          color:#111;
          box-shadow:none;
        }
      }

      .cl-commerce-overlay{
        position:absolute;
        inset:0;
        z-index:100;
        display:flex;
        align-items:flex-end;
        justify-content:center;
        background:rgba(17,17,17,.28);
        backdrop-filter:blur(4px);
        -webkit-backdrop-filter:blur(4px);
        animation:clCommerceFade .18s ease both;
      }

      .cl-commerce-sheet{
        width:100%;
        max-height:92%;
        overflow:auto;
        overscroll-behavior:contain;
        background:#fff;
        border-radius:24px 24px 0 0;
        box-shadow:0 -20px 60px rgba(0,0,0,.20);
        animation:clCommerceUp .24s cubic-bezier(.2,.8,.2,1) both;
      }

      @keyframes clCommerceFade{ from{opacity:0} to{opacity:1} }
      @keyframes clCommerceUp{ from{transform:translateY(18px);opacity:.8} to{transform:translateY(0);opacity:1} }

      .cl-commerce-head{
        position:sticky;
        top:0;
        z-index:2;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        padding:15px 16px 13px;
        border-bottom:1px solid rgba(0,0,0,.08);
        background:rgba(255,255,255,.96);
        backdrop-filter:blur(12px);
        -webkit-backdrop-filter:blur(12px);
      }

      .cl-commerce-title{
        margin:0;
        color:#111;
        font:700 16px/1.25 Georgia, "Times New Roman", serif;
      }

      .cl-commerce-close{
        width:34px;
        height:34px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:999px;
        background:#fff;
        color:#111;
        cursor:pointer;
        font:400 20px/1 Georgia, "Times New Roman", serif;
      }

      .cl-commerce-content{
        padding:16px;
      }

      .cl-variant-product{
        display:grid;
        grid-template-columns:82px 1fr;
        gap:13px;
        align-items:center;
        margin:0 0 17px;
      }

      .cl-variant-product img{
        width:82px;
        height:96px;
        object-fit:contain;
        border-radius:14px;
        background:#f5f3f0;
      }

      .cl-variant-product-name{
        margin:0 0 5px;
        color:#111;
        font:700 16px/1.3 Georgia, "Times New Roman", serif;
      }

      .cl-variant-product-price{
        margin:0;
        color:rgba(0,0,0,.62);
        font:700 12px/1.25 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-variant-group{
        margin:0 0 17px;
      }

      .cl-variant-label{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin:0 0 9px;
        color:#111;
        font:800 10px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
      }

      .cl-variant-values{
        display:flex;
        flex-wrap:wrap;
        gap:8px;
      }

      .cl-variant-choice{
        min-height:42px;
        padding:9px 12px;
        border:1px solid rgba(0,0,0,.18);
        border-radius:999px;
        background:#fff;
        color:#111;
        cursor:pointer;
        font:700 12px/1.1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-variant-choice.is-selected{
        border-color:#111;
        background:#111;
        color:#fff;
      }

      .cl-variant-choice.is-swatch{
        display:inline-flex;
        align-items:center;
        gap:8px;
      }

      .cl-variant-swatch{
        width:18px;
        height:18px;
        flex:0 0 auto;
        border:1px solid rgba(0,0,0,.18);
        border-radius:999px;
        box-shadow:inset 0 0 0 2px rgba(255,255,255,.72);
      }

      .cl-variant-choice:disabled{
        opacity:.35;
        cursor:not-allowed;
        text-decoration:line-through;
      }

      .cl-variant-status{
        min-height:18px;
        margin:4px 0 10px;
        color:rgba(0,0,0,.62);
        font:600 11px/1.4 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-variant-status.is-error{
        color:#8b1f1f;
      }

      .cl-variant-primary{
        width:100%;
        min-height:48px;
        border:1px solid #111;
        border-radius:999px;
        background:#111;
        color:#fff;
        cursor:pointer;
        padding:13px 16px;
        font:800 11px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
      }

      .cl-variant-primary:disabled{
        opacity:.44;
        cursor:default;
      }

      .cl-variant-details{
        display:block;
        margin:13px auto 2px;
        width:max-content;
        color:#111;
        text-decoration:underline;
        text-underline-offset:3px;
        font:700 11px/1.3 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-variant-trust-note{
        margin:10px 0 0;
        text-align:center;
        color:rgba(0,0,0,.50);
        font:600 10px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-look-list{
        display:flex;
        flex-direction:column;
        gap:10px;
      }

      .cl-look-item{
        display:grid;
        grid-template-columns:58px minmax(0,1fr) auto;
        gap:10px;
        align-items:center;
        padding:10px;
        border:1px solid rgba(0,0,0,.10);
        border-radius:16px;
        background:#fbfaf8;
      }

      .cl-look-item img{
        width:58px;
        height:68px;
        object-fit:contain;
        border-radius:10px;
        background:#f2efeb;
      }

      .cl-look-item-title{
        margin:0 0 4px;
        color:#111;
        font:700 12px/1.3 Georgia, "Times New Roman", serif;
      }

      .cl-look-item-status{
        margin:0;
        color:rgba(0,0,0,.58);
        font:650 10px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-look-item-action{
        border:1px solid rgba(0,0,0,.22);
        border-radius:999px;
        background:#fff;
        color:#111;
        padding:8px 10px;
        cursor:pointer;
        font:800 9px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.08em;
        text-transform:uppercase;
      }

      .cl-look-summary{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin:15px 0 10px;
        color:#111;
        font:700 12px/1.3 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      @media (hover:hover) and (pointer:fine){
        .cl-chat-btn:hover{
          transform:translateY(-2px);
          box-shadow:0 22px 56px rgba(0,0,0,.28);
          background:#000;
        }

        .cl-chat-close:hover{
          background:#f4f1ed;
          border-color:rgba(0,0,0,.08);
          color:#111;
        }

        .cl-suggestion:hover{
          transform:translateY(-1px);
          background:#111;
          color:#fff;
          border-color:#111;
        }

        .cl-send:hover{
          transform:translateY(-1px);
          box-shadow:0 12px 26px rgba(0,0,0,.18);
          background:#000;
        }

        .cl-card:hover{
          transform:translateY(-3px);
          box-shadow:0 18px 44px rgba(0,0,0,.11);
          border-color:rgba(0,0,0,.18);
        }

        .cl-card-cart:hover,
        .cl-shop-full-look:hover,
        .cl-variant-primary:hover{
          transform:translateY(-1px);
          background:#000;
          color:#fff;
          border-color:#000;
        }

        .cl-card-cart-stepper button:hover{
          background:#f6f4f1;
        }

        .cl-card-why:hover,
        .cl-variant-details:hover{
          color:rgba(0,0,0,.62);
        }
      }

      @media (hover:none), (pointer:coarse), (any-pointer:coarse){
        .cl-chat-btn,
        .cl-chat-close,
        .cl-suggestion,
        .cl-send,
        .cl-card,
        .cl-card-cart,
        .cl-card-cart-stepper button,
        .cl-card-why,
        .cl-shop-full-look,
        .cl-variant-choice,
        .cl-variant-primary,
        .cl-look-item-action,
        .cl-commerce-close,
        .cl-variant-details,
        .cl-new-response,
        .cl-card-atelier,
        .cl-my-atelier-open,
        .cl-my-atelier-item-actions button{
          transition:none!important;
          -webkit-tap-highlight-color:transparent;
        }

        .cl-chat-btn,
        .cl-chat-btn:hover,
        .cl-chat-btn:active{
          transform:none;
          background:#101010;
          color:#fff;
          box-shadow:0 18px 46px rgba(0,0,0,.22);
        }

        .cl-chat-close,
        .cl-chat-close:hover,
        .cl-chat-close:active{
          background:transparent;
          border-color:transparent;
          color:rgba(0,0,0,.55);
        }

        .cl-suggestion,
        .cl-suggestion:hover,
        .cl-suggestion:active{
          transform:none;
          background:rgba(255,255,255,.92);
          color:#111;
          border-color:rgba(0,0,0,.16);
          box-shadow:0 8px 22px rgba(0,0,0,.055);
        }

        .cl-send,
        .cl-send:hover,
        .cl-send:active{
          transform:none;
          background:#111;
          color:#fff;
          box-shadow:none;
        }

        .cl-card,
        .cl-card:hover,
        .cl-card:active,
        .cl-card-cart,
        .cl-card-cart:hover,
        .cl-card-cart:active,
        .cl-card-cart.requires-selection,
        .cl-card-cart.requires-selection:hover,
        .cl-card-cart.requires-selection:active{
          transform:none;
        }

        .cl-card-cart,
        .cl-card-cart:hover,
        .cl-card-cart:active,
        .cl-card-cart.requires-selection,
        .cl-card-cart.requires-selection:hover,
        .cl-card-cart.requires-selection:active{
          background:#111;
          color:#fff;
          border-color:#111;
        }

        .cl-card-cart.is-added,
        .cl-card-cart.is-added:hover,
        .cl-card-cart.is-added:active{
          background:#fff;
          color:#111;
          border-color:#111;
        }

        .cl-card-cart-stepper button,
        .cl-card-cart-stepper button:hover,
        .cl-card-cart-stepper button:active{
          background:transparent;
          color:#111;
        }

        .cl-shop-full-look,
        .cl-shop-full-look:hover,
        .cl-shop-full-look:active,
        .cl-variant-primary,
        .cl-variant-primary:hover,
        .cl-variant-primary:active{
          transform:none;
          background:#111;
          color:#fff;
          border-color:#111;
        }

        .cl-shop-full-look.is-added,
        .cl-shop-full-look.is-added:hover,
        .cl-shop-full-look.is-added:active{
          background:#fff;
          color:#111;
        }

        .cl-variant-choice,
        .cl-variant-choice:hover,
        .cl-variant-choice:active{
          background:#fff;
          color:#111;
          border-color:rgba(0,0,0,.18);
        }

        .cl-variant-choice.is-selected,
        .cl-variant-choice.is-selected:hover,
        .cl-variant-choice.is-selected:active{
          background:#111;
          color:#fff;
          border-color:#111;
        }
      }

      .cl-full-look-actions{
        display:flex;
        flex-direction:column;
        gap:7px;
        margin:10px 0 2px;
      }

      .cl-shop-full-look{
        width:100%;
        border:1px solid #111;
        border-radius:999px;
        background:#111;
        color:#fff;
        cursor:pointer;
        padding:12px 14px;
        font:800 11px/1 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        letter-spacing:.12em;
        text-transform:uppercase;
        transition:transform .18s ease, background .18s ease, color .18s ease, border-color .18s ease;
      }

      .cl-shop-full-look:disabled{
        opacity:.58;
        cursor:default;
        transform:none;
      }

      .cl-shop-full-look.is-added{
        background:#fff;
        color:#111;
      }

      .cl-full-look-note{
        margin:0;
        color:rgba(0,0,0,.58);
        font:600 11px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }

      .cl-browse{
        display:block;
        margin:10px 0 0;
        font:800 12px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        text-decoration:underline;
        color:#111;
        position:relative;
        z-index:2;
        pointer-events:auto;
        cursor:pointer;
      }

      .cl-guide-cta{
        text-decoration:none;
        color:rgba(0,0,0,.72);
        font:700 12px/1.35 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        margin:12px 0 2px;
      }

      .cl-guide-cta a{
        color:#111;
        text-decoration:underline;
        font-weight:900;
      }

      @media (max-width: 640px){
        .cl-chat-launcher{
          right:16px;
          bottom:16px;
        }

        .cl-chat-btn{
          width:56px;
          height:56px;
        }

        .cl-chat-panel{
          left:8px;
          right:8px;
          bottom:78px;
          width:auto;
          max-width:none;
          height:min(650px, calc(100dvh - 96px));
          max-height:calc(100dvh - 96px);
          border-radius:22px;
        }

        .cl-chat-head{
          padding:15px 15px 13px;
        }

        .cl-atelier{
          padding:10px 10px 11px;
        }

        .cl-atelier-piece{
          flex-basis:70px;
        }

        .cl-atelier-piece-image{
          height:56px;
        }

        .cl-atelier-actions{
          grid-template-columns:minmax(0,1fr) auto;
        }

        .cl-atelier-compare{
          grid-column:1 / -1;
          min-height:34px;
        }

        .cl-atelier-refine{
          grid-template-columns:repeat(2,minmax(0,1fr));
        }

        .cl-chat-body{
          height:auto;
          min-height:0;
          padding:13px 10px 14px;
        }

        .cl-bubble{
          max-width:88%;
          font-size:14px;
          padding:11px 13px;
        }

        .cl-cards{
          grid-template-columns:repeat(2,minmax(0,1fr));
          gap:10px;
        }

        .cl-card{
          border-radius:18px;
        }

        .cl-card-img{
          height:154px;
          padding:10px;
        }

        .cl-card-body{
          padding:10px;
        }

        .cl-card-title{
          font-size:12px;
        }

        .cl-card-why{
          font-size:9px;
        }

        .cl-card-cart{
          min-height:44px;
        }

        .cl-commerce-sheet{
          max-height:94%;
          border-radius:22px 22px 0 0;
        }

        .cl-commerce-content{
          padding:14px;
        }

        .cl-variant-choice{
          min-height:44px;
        }

        .cl-suggestions{
          gap:8px;
        }

        .cl-suggestion{
          padding:8px 10px;
          font-size:10.5px;
        }

        .cl-chat-foot{
          padding:10px;
          gap:8px;
        }

        .cl-in{
          padding:12px 13px;
          font-size:14px;
        }

        .cl-send{
          min-width:64px;
          padding:12px 14px;
        }
      }

      @media (max-width: 390px){
        .cl-card-img{
          height:138px;
        }

        .cl-card-title{
          font-size:11.5px;
        }
      }
    `,
            elStyle = document.createElement("style");
        elStyle.setAttribute("data-consumerlite-chat-style", CONSUMERLITE_CHAT_WIDGET_VERSION), elStyle.textContent = STYLE, document.head.appendChild(elStyle);
        const launcher = document.createElement("div");
        launcher.className = "cl-chat-launcher", launcher.innerHTML = `
      <button class="cl-chat-btn" aria-label="Open stylist assistant" type="button">Stylist</button>
      <div class="cl-chat-panel" role="dialog" aria-label="Consumerlite chat">
        <div class="cl-chat-head">
          <div class="cl-chat-brand">
            <div class="cl-chat-title">Consumerlite</div>
            <div class="cl-chat-sub">Tellus Stylist Assistant</div>
          </div>
          <button class="cl-chat-close" aria-label="Close" type="button">\xD7</button>
        </div>
        <section class="cl-atelier" aria-label="Your Tellus edit" hidden></section>
        <div class="cl-chat-body"></div>
        <button class="cl-new-response" type="button" hidden>\u2193 New response</button>
        <div class="cl-chat-foot">
          <input class="cl-in" placeholder="Ask about styling, products, occasions\u2026" />
          <button class="cl-send" type="button">Send</button>
        </div>
      </div>
    `, document.body.appendChild(launcher);
        const btn = launcher.querySelector(".cl-chat-btn"),
            panel = launcher.querySelector(".cl-chat-panel"),
            closeBtn = launcher.querySelector(".cl-chat-close"),
            chatSubtitle = launcher.querySelector(".cl-chat-sub"),
            atelier = launcher.querySelector(".cl-atelier"),
            body = launcher.querySelector(".cl-chat-body"),
            newResponseButton = launcher.querySelector(".cl-new-response"),
            input = launcher.querySelector(".cl-in"),
            send = launcher.querySelector(".cl-send");
        // Widget controls own their interaction; storefront document delegates
        // must not interpret a stylist click or Enter press as a page action.
        ["click", "dblclick", "pointerdown", "pointerup", "mousedown", "mouseup", "touchstart", "touchend", "keydown", "keyup"].forEach(function(type) {
            launcher.addEventListener(type, function(event) { event.stopPropagation(); });
        });
        let consumerliteConversationNearBottom = !0,
            consumerliteProgrammaticScroll = !1,
            consumerliteResponseRenderLock = !1;

        function updateConsumerliteExperienceLabel() {
            const isMember = !!(consumerliteMemberAtelierState && consumerliteMemberAtelierState.authenticated),
                label = isMember ? uiText("TELLUS_ATELIER") : "Tellus Stylist Assistant";
            chatSubtitle && (chatSubtitle.textContent = label), panel && panel.setAttribute("aria-label", isMember ? "Consumerlite Tellus Atelier" : "Consumerlite Tellus Stylist Assistant")
        }
        updateConsumerliteExperienceLabel();

        function consumerliteIsNearConversationBottom(tolerance) {
            const safeTolerance = Number.isFinite(Number(tolerance)) ? Number(tolerance) : 120;
            return body.scrollHeight - body.scrollTop - body.clientHeight <= safeTolerance
        }

        function consumerliteUpdateNewResponseControl(show) {
            newResponseButton && (newResponseButton.hidden = !show)
        }

        function followConsumerliteConversation(force, announce) {
            consumerliteResponseRenderLock && !force || window.requestAnimationFrame(function() {
                !!force || consumerliteConversationNearBottom || consumerliteIsNearConversationBottom(120) ? (consumerliteProgrammaticScroll = !0, body.scrollTop = Math.max(0, body.scrollHeight - body.clientHeight), consumerliteConversationNearBottom = !0, consumerliteUpdateNewResponseControl(!1), window.requestAnimationFrame(function() {
                    consumerliteProgrammaticScroll = !1
                })) : announce && consumerliteUpdateNewResponseControl(!0)
            })
        }

        function focusConsumerliteResponseStart(anchor, announce) {
            window.requestAnimationFrame(function() {
                window.requestAnimationFrame(function() {
                    if (!anchor || !anchor.isConnected) return;
                    if (!(consumerliteConversationNearBottom || consumerliteIsNearConversationBottom(120))) {
                        announce && consumerliteUpdateNewResponseControl(!0);
                        return
                    }
                    const bodyRect = body.getBoundingClientRect(),
                        anchorRect = anchor.getBoundingClientRect(),
                        target = body.scrollTop + (anchorRect.top - bodyRect.top) - 12;
                    consumerliteProgrammaticScroll = !0, body.scrollTop = Math.max(0, target), consumerliteConversationNearBottom = consumerliteIsNearConversationBottom(120), consumerliteUpdateNewResponseControl(!1), window.requestAnimationFrame(function() {
                        consumerliteProgrammaticScroll = !1
                    })
                })
            })
        }

        function captureConsumerliteConversationViewport() {
            return {
                nearBottom: consumerliteIsNearConversationBottom(120),
                scrollTop: body.scrollTop
            }
        }

        function restoreConsumerliteConversationViewport(snapshot) {
            snapshot && window.requestAnimationFrame(function() {
                consumerliteProgrammaticScroll = !0, snapshot.nearBottom ? (body.scrollTop = Math.max(0, body.scrollHeight - body.clientHeight), consumerliteConversationNearBottom = !0) : (body.scrollTop = Math.max(0, snapshot.scrollTop), consumerliteConversationNearBottom = !1), window.requestAnimationFrame(function() {
                    consumerliteProgrammaticScroll = !1
                })
            })
        }
        body.addEventListener("scroll", function() {
            consumerliteProgrammaticScroll || (consumerliteConversationNearBottom = consumerliteIsNearConversationBottom(120), consumerliteConversationNearBottom && consumerliteUpdateNewResponseControl(!1))
        }, {
            passive: !0
        }), newResponseButton && newResponseButton.addEventListener("click", function() {
            consumerliteConversationNearBottom = !0, followConsumerliteConversation(!0, !1)
        }), applyInterfaceLocalization();

        function clearLegacyChatSessions() {
            try {
                if (!window.sessionStorage || !Array.isArray(LEGACY_CHAT_SESSION_KEYS)) return;
                LEGACY_CHAT_SESSION_KEYS.forEach(function(key) {
                    try {
                        window.sessionStorage.removeItem(key)
                    } catch {}
                })
            } catch {}
        }

        function getSessionNow() {
            return Date.now ? Date.now() : new Date().getTime()
        }

        function loadStoredChatSession() {
            try {
                if (!window.sessionStorage) return {};
                const raw = window.sessionStorage.getItem(CHAT_SESSION_STORAGE_KEY);
                if (!raw) return {};
                const parsed = JSON.parse(raw);
                if (!parsed || typeof parsed != "object") return {};
                if (![CONSUMERLITE_CHAT_WIDGET_VERSION, "V35.3.30_VISUAL_PURCHASE_CHOOSER", "V35.3.29_PURCHASE_OPTIONS_FIX", "V35.3.28_PURCHASE_ASSISTANCE", "V35.3.27_ORDER_INTENT_REOPEN", "V35.3.26_MEMBER_ORDERS", "V35.3.25_MEMBER_GREETINGS", "V35.3.24_ATELIER_BRIDGE", "V35.3.13_LAUNCHER_FOCUS", "V35.3.12_TELLUS_EDIT_CONTINUITY", "V35.3.11_TELLUS_EDIT_RESET", "V35.3.10_TRACKING_CROSS_TAB_DIVERSITY"].includes(parsed.version)) return window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY), {};
                const savedAt = Number(parsed.savedAt || 0);
                return savedAt && getSessionNow() - savedAt > CHAT_SESSION_TTL_MS ? (window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY), {}) : parsed
            } catch {
                return {}
            }
        }

        function compactHistoryForStorage(history) {
            return Array.isArray(history) ? history.map(function(item) {
                return {
                    role: normalizeRole(item && item.role ? item.role : ""),
                    text: String(item && item.text ? item.text : "").slice(0, 1800)
                }
            }).filter(function(item) {
                return item.role && item.text
            }).slice(-MAX_HISTORY_ITEMS) : []
        }

        function compactContextForStorage(context) {
            if (!context || typeof context != "object") return {};
            const clone = {};
            return Object.keys(context).forEach(function(key) {
                const value = context[key];
                if (key === "lastProducts" && Array.isArray(value)) {
                    clone[key] = value.slice(0, 6);
                    return
                }
                if (key === "lastCollections" && Array.isArray(value)) {
                    clone[key] = value.slice(0, 12);
                    return
                }
                if (key === "recentProductHandles" && Array.isArray(value)) {
                    clone[key] = value.map(String).filter(Boolean).slice(0, 30);
                    return
                }
                if (typeof value == "string") {
                    clone[key] = value.slice(0, 1800);
                    return
                }
                if (typeof value == "number" || typeof value == "boolean" || value === null) {
                    clone[key] = value;
                    return
                }
                if (Array.isArray(value)) {
                    clone[key] = value.slice(0, 24);
                    return
                }
                value && typeof value == "object" && (clone[key] = value)
            }), clone
        }

        function compactUiItemsForStorage(items) {
            return Array.isArray(items) ? items.map(function(item) {
                return !item || typeof item != "object" ? null : item.type === "msg" ? {
                    type: "msg",
                    role: item.role === "user" ? "user" : "ai",
                    text: String(item.text || "").slice(0, 1800)
                } : item.type === "products" ? {
                    type: "products",
                    products: Array.isArray(item.products) ? item.products.slice(0, 6) : []
                } : item.type === "collections" ? {
                    type: "collections",
                    collectionCards: Array.isArray(item.collectionCards) ? item.collectionCards.slice(0, 12) : []
                } : item.type === "cta" ? {
                    type: "cta",
                    cta: item.cta && typeof item.cta == "object" ? item.cta : null
                } : item.type === "anchor_note" ? {
                    type: "anchor_note",
                    text: String(item.text || "").slice(0, 280)
                } : item.type === "suggestions" ? {
                    type: "suggestions",
                    suggestions: Array.isArray(item.suggestions) ? item.suggestions.slice(0, 8) : []
                } : null
            }).filter(Boolean).slice(-MAX_UI_ITEMS) : []
        }

        function compactSelectedVariantsForStorage() {
            const out = {};
            let count = 0;
            return consumerliteSelectedVariants.forEach(function(record, handle) {
                if (count >= 12 || !record || !record.variant || !record.variant.id) return;
                const cleanHandle = String(handle || record && record.product && record.product.handle || "").trim();
                cleanHandle && (out[cleanHandle] = {
                    handle: cleanHandle,
                    product: record.product && typeof record.product == "object" ? record.product : {},
                    variant: record.variant && typeof record.variant == "object" ? record.variant : {},
                    selectedOptions: Array.isArray(record.selectedOptions) ? record.selectedOptions.slice(0, 10) : [],
                    checkedAt: Number(record.checkedAt || Date.now())
                }, count += 1)
            }), out
        }

        function compactAtelierStateForStorage() {
            const state = consumerliteAtelierState && typeof consumerliteAtelierState == "object" ? consumerliteAtelierState : {};
            return {
                currentLook: Array.isArray(state.currentLook) ? state.currentLook.slice(0, 6) : [],
                previousLook: Array.isArray(state.previousLook) ? state.previousLook.slice(0, 6) : [],
                refinedLook: Array.isArray(state.refinedLook) ? state.refinedLook.slice(0, 6) : [],
                comparison: state.comparison && typeof state.comparison == "object" ? state.comparison : null,
                readiness: state.readiness && typeof state.readiness == "object" ? state.readiness : null,
                sessionToken: String(state.sessionToken || "").slice(0, 18e4),
                sessionId: String(state.sessionId || "").slice(0, 120),
                revision: Number(state.revision || 0),
                collapsed: !!state.collapsed,
                editNotice: String(state.editNotice || "").slice(0,400),
            localUndo: state.localUndo ? {currentLook:sanitizeConsumerliteAtelierLook(state.localUndo.currentLook),previousLook:sanitizeConsumerliteAtelierLook(state.localUndo.previousLook),refinedLook:sanitizeConsumerliteAtelierLook(state.localUndo.refinedLook),productGroups:Array.isArray(state.localUndo.productGroups)?compactUiItemsForStorage(state.localUndo.productGroups).filter(item=>item.type==="products"):undefined} : null,
            updatedAt: Number(state.updatedAt || Date.now())
            }
        }

        function persistChatSession() {
            try {
                if (!window.sessionStorage) return;
                const payload = {
                    version: CONSUMERLITE_CHAT_WIDGET_VERSION,
                    savedAt: getSessionNow(),
                    panelOpen: lastPersistedPanelOpen,
                    history: compactHistoryForStorage(conversationHistory),
                    context: compactContextForStorage(conversationContext),
                    uiItems: compactUiItemsForStorage(conversationUiItems),
                    selectedVariants: compactSelectedVariantsForStorage(),
                    atelierState: compactAtelierStateForStorage()
                };
                window.sessionStorage.setItem(CHAT_SESSION_STORAGE_KEY, JSON.stringify(payload))
            } catch {}
        }

        function addUiItem(item) {
            !item || typeof item != "object" || (conversationUiItems.push(item), conversationUiItems.length > MAX_UI_ITEMS && conversationUiItems.splice(0, conversationUiItems.length - MAX_UI_ITEMS), persistChatSession())
        }

        function consumerliteChatAnalyticsAllowed() {
            try {
                const privacy = window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
                if (privacy && typeof privacy.analyticsProcessingAllowed == "function") return !!privacy.analyticsProcessingAllowed();
                if (privacy && typeof privacy.currentVisitorConsent == "function") {
                    const consent = privacy.currentVisitorConsent() || {};
                    return consent.analytics === "yes" || consent.analytics === !0 || consent.analyticsAllowed === !0
                }
                if (window.Shopify && window.Shopify.trackingConsent && typeof window.Shopify.trackingConsent.currentVisitorConsent == "function") {
                    const consent = window.Shopify.trackingConsent.currentVisitorConsent() || {};
                    return consent.analytics === "yes" || consent.analytics === !0
                }
            } catch {}
            return !1
        }

        function getChatAnalyticsSessionId() {
            if (conversationContext.analyticsSessionId) return String(conversationContext.analyticsSessionId);
            const value = "clchat_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
            return conversationContext.analyticsSessionId = value, persistChatSession(), value
        }

        function trackConsumerliteChatEvent(eventName, detail) {
            if (!consumerliteChatAnalyticsAllowed()) return;
            const cleanName = String(eventName || "").replace(/[^a-z0-9_]/gi, "_").toLowerCase();
            if (!cleanName) return;
            const safeDetail = detail && typeof detail == "object" ? Object.assign({}, detail) : {};
            delete safeDetail.message, delete safeDetail.email, delete safeDetail.phone, delete safeDetail.name;
            const payload = {
                event: "consumerlite_chat_" + cleanName,
                chatEvent: cleanName,
                chatVersion: CONSUMERLITE_CHAT_WIDGET_VERSION,
                analyticsSessionId: getChatAnalyticsSessionId(),
                pageType: /\/products\//i.test(location.pathname) ? "product" : /\/collections\//i.test(location.pathname) ? "collection" : "site",
                detail: safeDetail,
                timestamp: new Date().toISOString()
            };
            conversationContext.analyticsEvents = Array.isArray(conversationContext.analyticsEvents) ? conversationContext.analyticsEvents.slice(-29) : [], conversationContext.analyticsEvents.push({
                event: payload.event,
                chatEvent: payload.chatEvent,
                pageType: payload.pageType,
                detail: safeDetail,
                timestamp: payload.timestamp
            }), persistChatSession();
            try {
                window.dispatchEvent(new CustomEvent("consumerlite:chat:" + cleanName, {
                    detail: payload
                }))
            } catch {}
            try {
                window.dataLayer = window.dataLayer || [], window.dataLayer.push(payload)
            } catch {}
        }

        function trackIntentFromText(text, meta) {
            const m = normalizeLiteText(text || ""),
                info = meta && typeof meta == "object" ? meta : {};
            /\b(trending|trend|bestseller|best seller|popular)\b/.test(m) && trackConsumerliteChatEvent("trending_used", info), /\b(weather|temperature|rain|snow|hot|cold|forecast)\b/.test(m) && trackConsumerliteChatEvent("weather_flow_started", info), /\b(style this|style around this|style around these|build around this|what goes with this|pair this|match this|complete this look|complete the look)\b/.test(m) && trackConsumerliteChatEvent("style_around_product_used", info), /\b(collection|collections|browse)\b/.test(m) && trackConsumerliteChatEvent("collection_browse_started", info), /\b(total|full look|whole look|entire outfit|complete outfit|how much|cost|price)\b/.test(m) && trackConsumerliteChatEvent("total_price_requested", info), /\b(why this works|why this outfit|explain the outfit|explain this look)\b/.test(m) && trackConsumerliteChatEvent("why_this_works_requested", info), /^(men|women|male|female|man|woman)$/i.test(String(text || "").trim()) && trackConsumerliteChatEvent("gender_selected", {
                value: String(text || "").trim().toLowerCase()
            })
        }

        function removeExtraUiItems(preserveCards = false) {
            for (let i = conversationUiItems.length - 1; i >= 0; i--) {
                const type = conversationUiItems[i] && conversationUiItems[i].type;
                (preserveCards ? type === "suggestions" : type === "products" || type === "collections" || type === "cta" || type === "suggestions" || type === "anchor_note" || type === "fullLookAction") && conversationUiItems.splice(i, 1)
            }
            persistChatSession()
        }

        function resetStoredChatSession() {
            clearConsumerlitePurchaseHelp();
            clearConsumerlitePrivateOrders();
            consumerliteConversationGeneration += 1;
            consumerliteEditRevision += 1;
            consumerlitePendingSendCount = 0;
            try {
                window.sessionStorage && (window.sessionStorage.removeItem(CHAT_SESSION_STORAGE_KEY), clearLegacyChatSessions())
            } catch {}
            conversationHistory.splice(0, conversationHistory.length), Object.keys(conversationContext).forEach(function(key) {
                delete conversationContext[key]
            }), conversationUiItems.splice(0, conversationUiItems.length), consumerliteSelectedVariants.clear(), consumerliteAtelierState = {
                currentLook: [],
                previousLook: [],
                refinedLook: [],
                comparison: null,
                readiness: null,
                sessionToken: "",
                sessionId: "",
                revision: 0,
                collapsed: !0,
                updatedAt: Date.now()
            }, consumerliteAtelierSyncTimer && window.clearTimeout(consumerliteAtelierSyncTimer), consumerliteAtelierSyncTimer = null, closeConsumerliteCommerceOverlay(), atelier && (atelier.innerHTML = "", atelier.hidden = !0), lastPersistedPanelOpen = !1, body && (body.innerHTML = "", delete body.dataset.inited)
        }

        function sanitizeReplyText(text) {
            return String(text || "").replace(/\r/g, "").replace(/\*\*(.*?)\*\*/g, "$1").replace(/\*(.*?)\*/g, "$1").replace(/__(.*?)__/g, "$1").replace(/_(.*?)_/g, "$1").replace(/`{1,3}([^`]*)`{1,3}/g, "$1").replace(/\[(.*?)\]\((.*?)\)/g, "$1").replace(/^#{1,6}\s*/gm, "").replace(/\n{3,}/g, `

`).trim()
        }

        function normalizeRole(role) {
            const cleanRole = String(role || "").toLowerCase();
            return ["user", "customer", "visitor", "human", "me"].includes(cleanRole) ? "user" : ["ai", "assistant", "bot", "system", "consumerlite"].includes(cleanRole) ? "assistant" : cleanRole || "user"
        }

        function pushHistory(role, text) {
            const normalizedRole = normalizeRole(role),
                cleanText = String(text || "").trim();
            cleanText && (conversationHistory.push({
                role: normalizedRole,
                text: cleanText
            }), conversationHistory.length > MAX_HISTORY_ITEMS && conversationHistory.splice(0, conversationHistory.length - MAX_HISTORY_ITEMS), persistChatSession())
        }

// Whole replies only. The pending question decides what an affirmation accepts.
function tellusShortReplyKind(value = "") {
  const text = String(value || "").normalize("NFKC").toLowerCase()
    .replace(/[’']/g, " ").replace(/^[\s.!?,]+|[\s.!?,]+$/g, "")
    .replace(/\b(?:pls|plz)\b/g, "please").replace(/\s+/g, " ").trim();
  if (/^(?:yes|ya|yea|yah|yeah|yep|yup|yh|sure|okay|ok|absolutely|definitely|of course|please|please do|go ahead|do it|do that|let s do it|sounds good|bet|correct|that s right|okay do that|ok do that)(?: please)?$/.test(text)) return "affirm";
  if (/^(?:no|nope|nah|no thanks|no thank you|not now|skip|skip it|no thank you please)$/.test(text)) return "decline";
  if (/^(?:thanks|thank you|got it|understood|cool|nice|great|perfect|amazing)$/.test(text)) return "ack";
  return "";
}

        function isAudienceOnlyText(text) {
            const clean = normalizeLiteText(text);
            return /^(men|mens|man|male|hombre|homem|homme|uomo|mann|manne|mujer|mulher|femme|donna|frau|women|womens|woman|female|kids|kid|baby|boys|boy|girls|girl)$/i.test(clean)
        }

        function isGenderGateReply(text) {
            const clean = normalizeLiteText(text);
            return clean.includes("is this for men or women") || clean.includes("es para hombre o mujer") || clean.includes("e para homem ou mulher") || clean.includes("est-ce pour homme ou femme") || clean.includes("homme ou femme") || clean.includes("uomo o donna") || clean.includes("mann oder frau") || clean.includes("men or women") || clean.includes("hombre o mujer") || clean.includes("homem ou mulher")
        }

        function findLastMeaningfulUserRequest(excludeLatestAudienceOnly) {
            for (let i = conversationHistory.length - 1; i >= 0; i--) {
                const item = conversationHistory[i] || {},
                    role = normalizeRole(item.role || ""),
                    text = String(item.text || "").trim();
                if (role === "user" && text && !(excludeLatestAudienceOnly && (isAudienceOnlyText(text) || tellusShortReplyKind(text)))) return text
            }
            return ""
        }

        function rememberPendingRequestIfNeeded(userText, assistantReply) {
            const cleanUserText = String(userText || "").trim(),
                cleanReply = String(assistantReply || "").toLowerCase();
            if (cleanUserText) {
                if (conversationContext.lastUserMessage = cleanUserText, isGenderGateReply(cleanReply)) {
                    const priorRequest = conversationContext.tellusConversationState?.routingRequest || conversationContext.tellusConversationState?.originalRequest || ((isAudienceOnlyText(cleanUserText) || tellusShortReplyKind(cleanUserText)) ? findLastMeaningfulUserRequest(!0) : cleanUserText);
                    priorRequest && (conversationContext.pendingRequest = priorRequest, conversationContext.originalRequest = priorRequest, conversationContext.lastMeaningfulUserText = priorRequest)
                }
                (isAudienceOnlyText(cleanUserText) || tellusShortReplyKind(cleanUserText)) || (conversationContext.lastMeaningfulUserText = cleanUserText), persistChatSession()
            }
        }

        function mergeContextFromWorker(data) {
            if (!data || typeof data != "object") return;
            data.context && typeof data.context == "object" && Object.assign(conversationContext, data.context), data.contextPatch && typeof data.contextPatch == "object" && Object.assign(conversationContext, data.contextPatch);
            const mergedPatch = data.contextPatch && typeof data.contextPatch == "object" ? data.contextPatch : data.context && typeof data.context == "object" ? data.context : {};
            (mergedPatch.trackingPurchaseAnchorCleared === !0 || mergedPatch.trackingPurchaseAnchor === null) && clearConsumerliteTrackingPurchaseAnchor({
                clearSharedContext: !0
            }), responseWantsProductClear(data) && (delete conversationContext.lastProducts, delete conversationContext.lastProductHandles, delete conversationContext.recentProductHandles, delete conversationContext.lastCollections, delete conversationContext.clearProductCards), Array.isArray(data.products) && data.products.length > 0 && (conversationContext.lastProducts = data.products, conversationContext.recentProductHandles = data.products.map(function(p) {
                return p && p.handle ? String(p.handle) : ""
            }).filter(Boolean).concat(Array.isArray(conversationContext.recentProductHandles) ? conversationContext.recentProductHandles : []).slice(0, 24), delete conversationContext.pendingRequest, isConsumerliteTrackingPage() && conversationContext.trackingPurchaseAnchorActive === !0 && conversationContext.trackingPurchaseAnchor && rememberTrackingSharedDiversity(conversationContext.trackingPurchaseAnchor, data.products)), Array.isArray(data.collectionCards) && data.collectionCards.length > 0 && (conversationContext.lastCollections = data.collectionCards), applyInterfaceLocalization(), persistChatSession()
        }

        function textDirectionForContent(text) {
            const raw = String(text || ""),
                hasRtl = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/.test(raw),
                hasLtr = /[A-Za-z]/.test(raw);
            return hasRtl && !hasLtr ? "rtl" : hasRtl && hasLtr ? getLanguageDirection() === "rtl" ? "rtl" : "ltr" : getLanguageDirection()
        }

        function applyTextDirectionToElement(el, text) {
            if (!el) return;
            const direction = textDirectionForContent(text);
            el.setAttribute("dir", direction), el.style.textAlign = direction === "rtl" ? "right" : "left"
        }

        function addMsg(role, text, options) {
            const row = document.createElement("div");
            row.className = "cl-msg " + role;
            const bubble = document.createElement("div");
            bubble.className = "cl-bubble", bubble.textContent = role === "ai" ? sanitizeReplyText(text) : String(text || ""), applyTextDirectionToElement(bubble, bubble.textContent), row.setAttribute("dir", bubble.getAttribute("dir") || getLanguageDirection()), row.appendChild(bubble), body.appendChild(row);
            const forceFollow = !!(options && options.forceFollow) || role === "user";
            return followConsumerliteConversation(forceFollow, role === "ai" && !forceFollow), (!options || options.persist !== !1) && addUiItem({
                type: "msg",
                role: role === "user" ? "user" : "ai",
                text: role === "ai" ? sanitizeReplyText(text) : String(text || "")
            }), bubble
        }

        function clearOldExtras(preserveCards = false) {
            body.querySelectorAll(preserveCards ? ".cl-suggestions" : ".cl-cards, .cl-browse, .cl-suggestions, .cl-anchor-note").forEach(function(el) {
                el.remove()
            }), removeExtraUiItems(preserveCards)
        }

        function isClarificationResponse(replyText, data) {
            const text = normalizeLiteText(replyText || ""),
                intent = normalizeLiteText(data && data.debug && data.debug.intent ? data.debug.intent : ""),
                gate = normalizeLiteText(data && data.debug && data.debug.gate ? data.debug.gate : "");
            // A follow-up question is conversational, not a card-clearing gate,
            // when the server explicitly preserves the edit. Explicit clears win.
            const patch = data && (data.contextPatch || data.context) || {};
            // Successful product results outrank stale audience/location flags
            // echoed from the preceding clarification turn.
            if (data && data.showCards === true && Array.isArray(data.products) && data.products.length && !/ask_gender|needs_audience|location_needed|details_needed|clarification/.test(intent+' '+gate)) return false;
            if ((data && data.preserveCurrentLook === true || patch.preserveCurrentLook === true) &&
                !(data && data.contextPatch && data.contextPatch.clearProductCards === true) &&
                !(data && data.context && data.context.clearProductCards === true) &&
                !(data && data.showCards === true) && !(data && data.showCollectionCards === true)) return false;
            return !!(data && data.contextPatch && data.contextPatch.clearProductCards === !0 || data && data.context && data.context.clearProductCards === !0 || /ask_gender|needs_audience|clarification|details_needed|location_needed|page_product_style_needs_audience|product_category_needs_audience/.test(intent + " " + gate) || /\b(is this for men or women|men or women|for men or women|style .* for men or women|looking for styles for men or women)\b/.test(text) || /\b(what city|which city|what location|which location|what setting|which setting|what occasion|which occasion|are you playing or attending)\b/.test(text))
        }

        function responseWantsProductClear(data) {
            if (!data || typeof data != "object") return !1;
            const intent = normalizeLiteText(data.debug && data.debug.intent ? data.debug.intent : ""),
                mode = normalizeLiteText(data.debug && data.debug.mode ? data.debug.mode : "");
            return !!(data.contextPatch && data.contextPatch.clearProductCards === !0 || data.context && data.context.clearProductCards === !0 || /empty|no_products|needs_audience|ask_gender|clarification/.test(intent + " " + mode))
        }

        function safeUrl(u) {
            if (!u) return "";
            try {
                const raw = String(u || "").trim(),
                    parsed = /^https?:\/\//i.test(raw) ? new URL(raw) : new URL(raw, window.location.href);
                if (parsed.protocol === "http:" || parsed.protocol === "https:") return parsed.toString()
            } catch {}
            return ""
        }

        function normalizeSuggestion(item) {
            if (!item) return null;
            if (typeof item == "string") return {
                key: inferSuggestionKey(item, item),
                label: item,
                prompt: item
            };
            if (typeof item == "object") {
                const label = String(item.label || item.title || item.text || item.prompt || "").trim(),
                    prompt = String(item.prompt || item.message || item.value || label || "").trim(),
                    key = String(item.key || item.id || "").trim() || inferSuggestionKey(label, prompt),
                    action = String(item.action || "").trim(),
                    canonicalPrompt = String(item.canonicalPrompt || "").trim();
                return !label || !prompt ? null : {
                    key,
                    label,
                    prompt,
                    action,
                    canonicalPrompt
                }
            }
            return null
        }

        function removeSuggestionUiItemsOnly() {
            for (let i = conversationUiItems.length - 1; i >= 0; i--)(conversationUiItems[i] && conversationUiItems[i].type) === "suggestions" && conversationUiItems.splice(i, 1);
            persistChatSession()
        }

        function localizeUiText(key) {
            const code = getCurrentLanguageCode();
            return (UI_TRANSLATIONS[code] || UI_TRANSLATIONS.en)[key] || UI_TRANSLATIONS.en[key] || ""
        }

        function getSeasonalOutfitSuggestions() {
            return [{
                key: "SPRING_OUTFIT",
                label: "Spring",
                prompt: "I want a spring outfit",
                canonicalPrompt: "I want a spring outfit"
            }, {
                key: "SUMMER_OUTFIT",
                label: "Summer",
                prompt: "I want a summer outfit",
                canonicalPrompt: "I want a summer outfit"
            }, {
                key: "FALL_OUTFIT",
                label: "Fall",
                prompt: "I want a fall outfit",
                canonicalPrompt: "I want a fall outfit"
            }, {
                key: "WINTER_OUTFIT",
                label: "Winter",
                prompt: "I want a winter outfit",
                canonicalPrompt: "I want a winter outfit"
            }]
        }

        function showSeasonalOutfitChoices() {
            body.querySelectorAll(".cl-suggestions").forEach(function(el) {
                el.remove()
            }), removeSuggestionUiItemsOnly(), addMsg("ai", localizeUiText("SEASON_PROMPT") || "Which season would you like me to style an outfit for?"), pushHistory("assistant", localizeUiText("SEASON_PROMPT") || "Which season would you like me to style an outfit for?"), addSuggestions(getSeasonalOutfitSuggestions())
        }

        function consumerliteSuggestionIsClarification(item) {
            const key = String(item && (item.key || item.id) || "").toUpperCase();
            return /^(MEN|WOMEN|SPRING_OUTFIT|SUMMER_OUTFIT|FALL_OUTFIT|WINTER_OUTFIT|BACK|START_OVER)$/.test(key) || /RECIPIENT|BUDGET|OCCASION|CITY|DATE|COLLECTION/.test(key)
        }

        function prepareConsumerliteAtelierSuggestions(suggestions) {
            const list = Array.isArray(suggestions) ? suggestions.slice(0, 8) : [];
            if (!(Array.isArray(consumerliteAtelierState.currentLook) && consumerliteAtelierState.currentLook.length > 0) || list.length <= 4 || list.some(consumerliteSuggestionIsClarification)) return list;
            const priority = ["UNDO_LAST_CHANGE", "REDO_LAST_CHANGE", "TOTAL", "WHY_THIS_WORKS", "REROLL_OUTFIT"],
                selected = [];
            return priority.forEach(function(key) {
                const match = list.find(function(item) {
                    return String(item && item.key || "").toUpperCase() === key
                });
                match && selected.indexOf(match) < 0 && selected.push(match)
            }), list.forEach(function(item) {
                selected.length >= 3 || selected.indexOf(item) >= 0 || selected.push(item)
            }), selected.push({
                key: "ATELIER_REFINE",
                label: uiText("REFINE_LOOK"),
                prompt: "Refine look",
                action: "OPEN_ATELIER_REFINE"
            }), selected.slice(0, 4)
        }

        function addSuggestions(suggestions, options) {
            if (!Array.isArray(suggestions) || suggestions.length === 0) return;
            const wrap = document.createElement("div");
            wrap.className = "cl-suggestions", localizeSuggestionsForUi(prepareConsumerliteAtelierSuggestions(suggestions)).slice(0, 8).forEach(function(item) {
                const suggestion = normalizeSuggestion(item);
                if (!suggestion) return;
                const chip = document.createElement("button");
                chip.type = "button", chip.className = "cl-suggestion", chip.textContent = suggestion.label, chip.setAttribute("aria-label", suggestion.label), chip.addEventListener("click", function() {
                    if (trackConsumerliteChatEvent("starter_clicked", {
                            key: suggestion.key || "",
                            label: suggestion.label || ""
                        }), (suggestion.key === "MEN" || suggestion.key === "WOMEN") && trackConsumerliteChatEvent("gender_selected", {
                            value: String(suggestion.key || "").toLowerCase()
                        }), (/^BROWSE_/i.test(suggestion.key || "") || suggestion.key === "BROWSE_COLLECTIONS") && trackConsumerliteChatEvent("collection_browse_started", {
                            key: suggestion.key || ""
                        }), suggestion.key === "TRENDING" && trackConsumerliteChatEvent("trending_used", {
                            source: "starter"
                        }), (suggestion.key === "COMPLETE_LOOK_PRODUCT_PAGE" || suggestion.key === "STYLE_THIS_PRODUCT") && trackConsumerliteChatEvent("product_page_starter_clicked", {
                            key: suggestion.key || ""
                        }), /^(MORE_CASUAL|MORE_ELEVATED|TOO_EXPENSIVE|CHANGE_FOOTWEAR|REMOVE_ACCESSORY|REROLL_OUTFIT)$/i.test(suggestion.key || "") && trackConsumerliteChatEvent("adaptive_feedback_clicked", {
                            key: suggestion.key || ""
                        }), suggestion.action === "SHOW_SEASONS" || suggestion.key === "SEASONAL_OUTFIT") {
                        showSeasonalOutfitChoices();
                        return
                    }
                    if (suggestion.action === "OPEN_ATELIER_REFINE" || suggestion.key === "ATELIER_REFINE") {
                        consumerliteAtelierState.collapsed = !1, renderConsumerliteAtelierWorkspace();
                        const drawer = atelier && atelier.querySelector(".cl-atelier-refine");
                        drawer && (drawer.hidden = !1);
                        return
                    }
                    if (suggestion.key === "WHY_THESE_COLORS_WORK" || suggestion.key === "WHY_THIS_PALETTE") {
                        doSend({
                            displayText: suggestion.label || "Why these colors work",
                            sendText: "Explain why the colors in my current Tellus edit work together. Do not change, rebuild, or restart the outfit.",
                            source: "current_look_color_explanation",
                            suggestionKey: suggestion.key || "WHY_THESE_COLORS_WORK"
                        });
                        return
                    }
                    input.value = suggestion.prompt, doSend({
                        source: "suggestion",
                        suggestionKey: suggestion.key || ""
                    })
                }), wrap.appendChild(chip)
            }), wrap.childNodes.length && (body.appendChild(wrap), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                type: "suggestions",
                suggestions: localizeSuggestionsForUi(suggestions).slice(0, 8)
            }))
        }

        function addCta(cta, options) {
            if (cta = localizeCtaForUi(cta), !cta || !cta.url) return;
            const href = safeUrl(cta.url);
            if (!href) return;
            const prefix = String(cta.prefix || "").trim(),
                linkText = String(cta.linkText || "").trim();
            if (prefix && linkText) {
                const wrap = document.createElement("div");
                wrap.className = "cl-browse cl-guide-cta", wrap.appendChild(document.createTextNode(prefix + " "));
                const a2 = document.createElement("a");
                a2.href = href, a2.textContent = linkText, a2.setAttribute("aria-label", String(cta.label || linkText)), a2.addEventListener("click", function(ev) {
                    ev.defaultPrevented || (trackConsumerliteChatEvent("cta_clicked", {
                        label: cta && cta.label ? String(cta.label) : "",
                        url: href
                    }), window.location.href = href)
                }), wrap.appendChild(a2), body.appendChild(wrap), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                    type: "cta",
                    cta
                });
                return
            }
            const a = document.createElement("a");
            a.className = "cl-browse", a.href = href, a.textContent = cta.label ? String(cta.label) : uiText("BROWSE_COLLECTIONS"), a.addEventListener("click", function(ev) {
                ev.defaultPrevented || (window.location.href = href)
            }), body.appendChild(a), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                type: "cta",
                cta
            })
        }

        function addAnchorNote(text, options) {
            const clean = String(text || "").trim();
            if (!clean) return;
            body.querySelectorAll(".cl-anchor-note").forEach(function(el) {
                el.remove()
            });
            const note = document.createElement("div");
            note.className = "cl-anchor-note", note.textContent = clean, body.appendChild(note), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                type: "anchor_note",
                text: clean
            })
        }

        function formatProductSlotLabel(slot, product) {
            const clean = String(slot || "").toLowerCase().trim(),
                smartKey = String(product && (product.productLabelKey || product.slotLabelKey || product.outfitSlotLabelKey || product.labelKey) ? product.productLabelKey || product.slotLabelKey || product.outfitSlotLabelKey || product.labelKey : "").trim().toUpperCase(),
                titleText = normalizeLiteText(product && product.title ? product.title : ""),
                looksLikeSet = /\b(two piece|two-piece|matching set|shorts set|short set|skirt set|pants set|top.*shorts|set)\b/.test(titleText) && /\b(top|short|shorts|skirt|pants|set|matching|two piece|two-piece)\b/.test(titleText);
            if (looksLikeSet) return uiText("SET");
            if (smartKey === "OPTIONAL_BAG") return uiText("OPTIONAL_ACCESSORY");
            if (smartKey && !(smartKey === "ONE_PIECE" && looksLikeSet)) return uiText(smartKey);
            const labels = {
                top: "TOP",
                bottom: "BOTTOM",
                shoes: "FOOTWEAR",
                footwear: "FOOTWEAR",
                accessory: "OPTIONAL_ACCESSORY",
                accessories: "OPTIONAL_ACCESSORY",
                bag: "OPTIONAL_ACCESSORY",
                layer: "OPTIONAL_LAYER",
                onepiece: "ONE_PIECE",
                one_piece: "ONE_PIECE",
                set: "SET",
                sets: "SET",
                product_set: "SET"
            };
            return labels[clean] ? uiText(labels[clean]) : ""
        }

        function shopifyAjaxPath(path) {
            return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? String(window.Shopify.routes.root) : "/").replace(/\/?$/, "/") + String(path || "").replace(/^\/+/, "")
        }

        function consumerliteWorkerEndpoint(path) {
            const endpoint = String(window.CONSUMERLITE_CHAT_ENDPOINT || "").trim();
            if (!endpoint) return "";
            try {
                const url = new URL(endpoint, window.location.href);
                return url.pathname = String(path || "/product-options"), url.search = "", url.hash = "", url.toString()
            } catch {
                return ""
            }
        }

        function normalizeVariantOptionText(value) {
            return String(value || "").trim().toLowerCase().replace(/\s+/g, " ")
        }

        function selectedOptionsToMap(selectedOptions) {
            const map = new Map;
            return (Array.isArray(selectedOptions) ? selectedOptions : []).forEach(function(entry) {
                const name = normalizeVariantOptionText(entry && entry.name),
                    value = String(entry && entry.value || "").trim();
                name && value && map.set(name, value)
            }), map
        }

        function selectedOptionsFromMap(selectionMap, options) {
            return (Array.isArray(options) ? options : []).map(function(option) {
                const name = String(option && option.name || "").trim(),
                    value = selectionMap.get(normalizeVariantOptionText(name));
                return value ? {
                    name,
                    value
                } : null
            }).filter(Boolean)
        }

        function variantMatchesSelection(variant, selectionMap, excludedName) {
            const selected = selectedOptionsToMap(variant && variant.selectedOptions || []);
            for (const entry of selectionMap.entries()) {
                const name = entry[0],
                    value = entry[1];
                if (!(excludedName && name === normalizeVariantOptionText(excludedName)) && normalizeVariantOptionText(selected.get(name)) !== normalizeVariantOptionText(value)) return !1
            }
            return !0
        }

        function findExactAvailableVariant(variants, selectionMap, options) {
            const required = (Array.isArray(options) ? options : []).map(function(option) {
                return normalizeVariantOptionText(option && option.name)
            }).filter(Boolean);
            return required.every(function(name) {
                return selectionMap.has(name)
            }) && (Array.isArray(variants) ? variants : []).find(function(variant) {
                return variant && variant.availableForSale !== !1 && variantMatchesSelection(variant, selectionMap, "") && selectedOptionsToMap(variant.selectedOptions || []).size >= required.length
            }) || null
        }

        function findPreviewAvailableVariant(variants, selectionMap) {
            if (!(selectionMap instanceof Map) || selectionMap.size === 0) return null;
            const compatible = (Array.isArray(variants) ? variants : []).filter(function(variant) {
                return variant && variant.availableForSale !== !1 && variantMatchesSelection(variant, selectionMap, "")
            });
            return compatible.find(function(variant) {
                return !!(variant && variant.image && safeUrl(variant.image.url))
            }) || compatible[0] || null
        }

        function formatVariantMoney(price) {
            const amount = Number(price && price.amount),
                currency = String(price && price.currencyCode || "USD").toUpperCase();
            if (!Number.isFinite(amount)) return "";
            try {
                return new Intl.NumberFormat(getCurrentLanguageCode() || "en", {
                    style: "currency",
                    currency
                }).format(amount)
            } catch {
                return amount.toFixed(2) + " " + currency
            }
        }

        function formatVariantSelection(selectedOptions) {
            return (Array.isArray(selectedOptions) ? selectedOptions : []).map(function(entry) {
                return String(entry && entry.value || "").trim()
            }).filter(Boolean).join(" \xB7 ")
        }

        function recommendedColorRecordForProduct(product) {
            const recommendation = product && (product.recommendedColor || product.__recommendedColor);
            return recommendation ? typeof recommendation == "string" ? {
                name: String(recommendation).trim(),
                value: String(recommendation).trim(),
                hex: ""
            } : recommendation && typeof recommendation == "object" ? recommendation : null : null
        }

        function recommendedColorValueForProduct(product) {
            const recommendation = recommendedColorRecordForProduct(product);
            return recommendation ? String(recommendation.value || recommendation.name || "").trim() : ""
        }

        function normalizeConsumerliteHex(value) {
            const raw = String(value || "").trim().toUpperCase();
            return /^#[0-9A-F]{6}$/.test(raw) ? raw : /^#[0-9A-F]{3}$/.test(raw) ? "#" + raw.slice(1).split("").map(function(ch) {
                return ch + ch
            }).join("") : ""
        }

        function consumerliteRecommendedColorOptionValue(product, colorOption) {
            const recommendation = recommendedColorRecordForProduct(product);
            if (!recommendation || !colorOption) return "";
            const values = Array.isArray(colorOption.values) ? colorOption.values : [],
                candidateNames = [recommendation.value, recommendation.name].map(function(value) {
                    return String(value || "").trim()
                }).filter(Boolean);
            (Array.isArray(product && product.availableColorSwatches) ? product.availableColorSwatches : []).forEach(function(choice) {
                const choiceHex = normalizeConsumerliteHex(choice && choice.profile && choice.profile.hex || choice && choice.hex || ""),
                    recommendationHex = normalizeConsumerliteHex(recommendation.hex || "");
                if (normalizeVariantOptionText(choice && choice.profile && choice.profile.name || "") === normalizeVariantOptionText(recommendation.name || "") || choiceHex && recommendationHex && choiceHex === recommendationHex) {
                    const exactValue = String(choice && choice.value || "").trim();
                    exactValue && candidateNames.push(exactValue)
                }
            });
            for (const candidate of candidateNames) {
                const exact = values.find(function(entry) {
                    return entry && entry.available !== !1 && normalizeVariantOptionText(entry.value) === normalizeVariantOptionText(candidate)
                });
                if (exact) return String(exact.value || candidate)
            }
            const targetHex = normalizeConsumerliteHex(recommendation.hex || "");
            if (targetHex) {
                const bySwatch = values.find(function(entry) {
                    return entry && entry.available !== !1 && normalizeConsumerliteHex(entry.swatch || "") === targetHex
                });
                if (bySwatch) return String(bySwatch.value || "")
            }
            return ""
        }

        function buildRecommendedInitialSelectedOptions(product, options, existingSelectedOptions) {
            const existing = Array.isArray(existingSelectedOptions) ? existingSelectedOptions.slice() : [],
                selectionMap = selectedOptionsToMap(existing);
            if (!recommendedColorValueForProduct(product)) return existing;
            const colorOption = (Array.isArray(options) ? options : []).find(function(option) {
                return /color|colour|shade|finish/i.test(String(option && option.name || ""))
            });
            if (!colorOption) return existing;
            const optionKey = normalizeVariantOptionText(colorOption.name);
            if (selectionMap.has(optionKey)) return existing;
            const matchedValue = consumerliteRecommendedColorOptionValue(product, colorOption);
            return matchedValue ? (selectionMap.set(optionKey, matchedValue), selectedOptionsFromMap(selectionMap, options)) : existing
        }

        function consumerliteSelectedColorFromRecord(record) {
            const color = (Array.isArray(record && record.selectedOptions) ? record.selectedOptions : []).find(function(entry) {
                return /color|colour|shade|finish/i.test(String(entry && entry.name || ""))
            });
            return String(color && color.value || "").trim()
        }

        function consumerlitePresentedProductImage(product) {
            const selected = consumerliteAtelierRecordForProduct(product || {}),
                selectedImage = selected && selected.variant && selected.variant.image && selected.variant.image.url,
                recommendedImage = product && product.recommendedImage && product.recommendedImage.url;
            return String(selectedImage || recommendedImage || product && product.image || "").trim()
        }

        function consumerliteRemoveColorSentenceFromStylistNote(note) {
            return String(note || "").replace(/\s*Its\s+[^.]+\s+palette\s+keeps\s+the\s+edit\s+cohesive\.?\s*$/i, "").trim()
        }

        function consumerliteStylistNoteForPresentedProduct(product) {
            const selected = consumerliteAtelierRecordForProduct(product || {}),
                selectedColor = consumerliteSelectedColorFromRecord(selected),
                recommendation = recommendedColorRecordForProduct(product),
                recommendedColor = String(recommendation && (recommendation.value || recommendation.name) || "").trim(),
                recommendedVisual = !!(product && product.recommendedImage && product.recommendedImage.url),
                base = consumerliteRemoveColorSentenceFromStylistNote(product && product.stylistNote || buildFallbackStylistNote(product || {})),
                presentedColor = selectedColor || (recommendedVisual ? recommendedColor : "");
            return presentedColor ? base + " Its " + presentedColor.toLowerCase() + " palette keeps the edit cohesive." : base
        }
        async function hydrateRecommendedVariantImageForCard(product, imageElement) {
            if (!product || !imageElement) return;
            const recommendedColor = recommendedColorValueForProduct(product),
                handle = String(product.handle || "").trim();
            if (!recommendedColor || !handle) return;
            const alreadySelected = consumerliteAtelierRecordForProduct(product || {});
            if (alreadySelected && alreadySelected.variant && alreadySelected.variant.id) {
                const selectedImage = alreadySelected.variant.image && alreadySelected.variant.image.url;
                if (selectedImage) {
                    imageElement.src = safeUrl(selectedImage) || imageElement.src;
                    return
                }
            }
            const knownRecommendedImage = product.recommendedImage && product.recommendedImage.url;
            if (knownRecommendedImage) {
                imageElement.src = safeUrl(knownRecommendedImage) || imageElement.src;
                return
            }
            try {
                const payload = await requestConsumerliteProductOptions(handle, [], "load"),
                    optionList = Array.isArray(payload.options) ? payload.options : [],
                    variants = Array.isArray(payload.variants) ? payload.variants : [],
                    recommendedSelectedOptions = buildRecommendedInitialSelectedOptions(product, optionList, []);
                if (!recommendedSelectedOptions.length) {
                    product.recommendedColor && typeof product.recommendedColor == "object" && (product.recommendedColor.visualBacked = !1, product.recommendedColor.presentationVerified = !1), product.stylistNote = consumerliteStylistNoteForPresentedProduct(product);
                    return
                }
                const selectionMap = selectedOptionsToMap(recommendedSelectedOptions),
                    previewVariant = findPreviewAvailableVariant(variants, selectionMap),
                    recommendedImage = previewVariant && previewVariant.image && previewVariant.image.url;
                if (!recommendedImage) {
                    product.recommendedColor && typeof product.recommendedColor == "object" && (product.recommendedColor.visualBacked = !1, product.recommendedColor.presentationVerified = !1), product.stylistNote = consumerliteStylistNoteForPresentedProduct(product);
                    return
                }
                const exactColorEntry = recommendedSelectedOptions.find(function(entry) {
                        return /color|colour|shade|finish/i.test(String(entry && entry.name || ""))
                    }),
                    exactColorValue = String(exactColorEntry && exactColorEntry.value || recommendedColor).trim();
                product.recommendedImage = {
                    url: String(recommendedImage),
                    altText: String(previewVariant.image.altText || product.imageAlt || product.title || "")
                }, product.recommendedColor = Object.assign({}, product.recommendedColor || {}, {
                    value: exactColorValue,
                    selectedOptions: recommendedSelectedOptions,
                    variantId: String(previewVariant.id || ""),
                    variantGid: String(previewVariant.gid || ""),
                    variantBacked: !0,
                    visualBacked: !0,
                    presentationVerified: !0
                }), product.stylistNote = consumerliteStylistNoteForPresentedProduct(product), imageElement.src = safeUrl(recommendedImage) || imageElement.src, imageElement.alt = String(previewVariant.image.altText || product.imageAlt || product.title || uiText("PRODUCT")), synchronizeConsumerliteProductPresentation(product)
            } catch {
                product.recommendedColor && typeof product.recommendedColor == "object" && (product.recommendedColor.visualBacked = !1, product.recommendedColor.presentationVerified = !1), product.stylistNote = consumerliteStylistNoteForPresentedProduct(product)
            }
        }

        function buildFallbackStylistNote(product) {
            const slot = normalizeLiteText(product && product.outfitSlot || "");
            return /top|shirt|polo|sweater|blouse|tee/.test(slot) ? "Chosen to anchor the look with polished texture and an easy, versatile line." : /bottom|pant|trouser|jean|skirt|short/.test(slot) ? "Chosen to give the outfit a clean foundation and balanced proportion." : /shoe|footwear|boot|sandal|heel|loafer|sneaker/.test(slot) ? "Chosen to finish the look with structure and a refined everyday profile." : /layer|jacket|coat|blazer|cardigan/.test(slot) ? "Chosen to add depth and structure without overpowering the rest of the look." : /accessory|bag|belt|hat|jewelry/.test(slot) ? "Chosen as a deliberate finishing detail that keeps the look considered rather than overdone." : "Chosen for its versatility and its ability to work naturally with the rest of the edit."
        }

        function synchronizeConsumerliteProductPresentation(product) {
            const handle = String(product && product.handle || "").trim();
            if (!handle) return;
            const presentationPatch = {
                recommendedColor: product.recommendedColor && typeof product.recommendedColor == "object" ? product.recommendedColor : null,
                recommendedImage: product.recommendedImage && typeof product.recommendedImage == "object" ? product.recommendedImage : null,
                stylistNote: String(product.stylistNote || "")
            };

            function patchList(list) {
                (Array.isArray(list) ? list : []).forEach(function(entry) {
                    String(entry && entry.handle || "").trim() === handle && (presentationPatch.recommendedColor && (entry.recommendedColor = presentationPatch.recommendedColor), presentationPatch.recommendedImage && (entry.recommendedImage = presentationPatch.recommendedImage), presentationPatch.stylistNote && (entry.stylistNote = presentationPatch.stylistNote))
                })
            }
            patchList(consumerliteAtelierState.currentLook || []), patchList(consumerliteAtelierState.previousLook || []), patchList(consumerliteAtelierState.refinedLook || []), conversationUiItems.forEach(function(item) {
                !item || item.type !== "products" || !Array.isArray(item.products) || patchList(item.products)
            }), persistChatSession(), renderConsumerliteAtelierWorkspace()
        }

        function closeConsumerliteCommerceOverlay() {
            const overlay = activeConsumerliteCommerceOverlay;
            activeConsumerliteCommerceOverlay = null, overlay && overlay.parentNode && overlay.parentNode.removeChild(overlay);
            const focusTarget = activeConsumerliteCommerceReturnFocus;
            if (activeConsumerliteCommerceReturnFocus = null, focusTarget && typeof focusTarget.focus == "function" && document.contains(focusTarget)) try {
                focusTarget.focus({
                    preventScroll: !0
                })
            } catch {
                try {
                    focusTarget.focus()
                } catch {}
            }
        }

        function createConsumerliteCommerceOverlay(titleText, returnFocus) {
            closeConsumerliteCommerceOverlay(), activeConsumerliteCommerceReturnFocus = returnFocus || document.activeElement;
            const overlay = document.createElement("div");
            overlay.className = "cl-commerce-overlay", overlay.setAttribute("role", "presentation");
            const sheet = document.createElement("section");
            sheet.className = "cl-commerce-sheet", sheet.setAttribute("role", "dialog"), sheet.setAttribute("aria-modal", "true"), sheet.setAttribute("aria-label", titleText || uiText("OPTIONS_TITLE"));
            const head = document.createElement("div");
            head.className = "cl-commerce-head";
            const title = document.createElement("h3");
            title.className = "cl-commerce-title", title.textContent = titleText || uiText("OPTIONS_TITLE");
            const closeButton = document.createElement("button");
            closeButton.type = "button", closeButton.className = "cl-commerce-close", closeButton.textContent = "\xD7", closeButton.setAttribute("aria-label", uiText("CLOSE_OPTIONS")), closeButton.addEventListener("click", closeConsumerliteCommerceOverlay), head.appendChild(title), head.appendChild(closeButton);
            const content = document.createElement("div");
            return content.className = "cl-commerce-content", sheet.appendChild(head), sheet.appendChild(content), overlay.appendChild(sheet), panel.appendChild(overlay), activeConsumerliteCommerceOverlay = overlay, overlay.addEventListener("click", function(event) {
                event.target === overlay && closeConsumerliteCommerceOverlay()
            }), overlay.addEventListener("keydown", function(event) {
                event.key === "Escape" && closeConsumerliteCommerceOverlay()
            }), window.setTimeout(function() {
                try {
                    closeButton.focus({
                        preventScroll: !0
                    })
                } catch {}
            }, 0), {
                overlay,
                sheet,
                content,
                title,
                closeButton
            }
        }
        async function requestConsumerliteProductOptions(handle, selectedOptions, action) {
            const endpoint = consumerliteWorkerEndpoint("/product-options");
            if (!endpoint) throw new Error("variant_endpoint_missing");
            const cleanHandle = String(handle || "").trim(),
                requestAction = action === "resolve" ? "resolve" : "load";
            if (requestAction === "load" && cleanHandle) {
                const cached = consumerliteVariantLoadCache.get(cleanHandle);
                if (cached && cached.payload && Date.now() - Number(cached.cachedAt || 0) < CONSUMERLITE_VARIANT_LOAD_CACHE_TTL_MS) return cached.payload
            }
            const response = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        handle: cleanHandle,
                        selectedOptions: Array.isArray(selectedOptions) ? selectedOptions : [],
                        action: requestAction
                    })
                }),
                payload = await response.json().catch(function() {
                    return {}
                });
            if (!response.ok || !payload || payload.ok !== !0) {
                const error = new Error(String(payload && payload.message || "variant_options_failed"));
                throw error.code = String(payload && payload.code || "variant_options_failed"), error.productUrl = String(payload && payload.productUrl || ""), error
            }
            return requestAction === "load" && cleanHandle && consumerliteVariantLoadCache.set(cleanHandle, {
                cachedAt: Date.now(),
                payload
            }), payload
        }

        function consumerliteMemberAtelierProxyPath() {
            return String(window.CONSUMERLITE_ATELIER_PROXY_PATH || "/apps/tellus-atelier").trim() || "/apps/tellus-atelier"
        }

        function consumerliteMemberAtelierProxyUrl(action) {
            const configured = consumerliteMemberAtelierProxyPath(),
                url = /^https?:\/\//i.test(configured) ? new URL(configured) : new URL(configured, window.location.href);
            return url.searchParams.set("action", String(action || "load")), url
        }

        function consumerliteMemberAtelierHasHandle(handle) {
            const clean = String(handle || "").trim();
            return !!(clean && consumerliteMemberAtelierState.items.some(function(item) {
                return String(item && item.product && item.product.handle || "") === clean
            }))
        }
        async function requestConsumerliteMemberAtelier(action, payload) {
            const url = consumerliteMemberAtelierProxyUrl(action),
                method = action === "load" ? "GET" : "POST",
                response = await fetch(url.toString(), {
                    method,
                    headers: method === "POST" ? {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    } : {
                        Accept: "application/json"
                    },
                    body: method === "POST" ? JSON.stringify(Object.assign({
                        action
                    }, payload || {})) : void 0,
                    credentials: "same-origin"
                }),
                data = await response.json().catch(function() {
                    return {}
                });
            if (!response.ok || !data || data.ok !== !0) {
                const error = new Error(String(data && data.message || "member_atelier_unavailable"));
                throw error.code = String(data && data.code || "member_atelier_unavailable"), error.authenticated = !!(data && data.authenticated), error
            }
            return data
        }

        function publishConsumerliteMemberAtelierState() {
            const safeItems = (Array.isArray(consumerliteMemberAtelierState.items) ? consumerliteMemberAtelierState.items : []).slice(0, 60).map(function(item) {
                const product = item && item.product || {},
                    variantRecord = item && item.variantRecord || null;
                return {
                    id: String(item && item.id || product.handle || ""),
                    product: {
                        title: String(product.title || ""),
                        handle: String(product.handle || ""),
                        url: String(product.url || ""),
                        image: String(product.image || ""),
                        imageAlt: String(product.imageAlt || product.title || ""),
                        price: String(product.price || ""),
                        stylistNote: String(product.stylistNote || ""),
                        availableForSale: product.availableForSale !== !1,
                        requiresVariantSelection: !!product.requiresVariantSelection
                    },
                    selectedOptions: Array.isArray(item && item.selectedOptions) ? item.selectedOptions : [],
                    variantRecord,
                    optionsPending: !!(item && item.optionsPending)
                }
            });
            try {
                window.dispatchEvent(new CustomEvent("consumerlite:atelier:state", {
                    detail: {
                        status: String(consumerliteMemberAtelierState.status || "unknown"),
                        authenticated: !!consumerliteMemberAtelierState.authenticated,
                        itemCount: Number(consumerliteMemberAtelierState.itemCount || safeItems.length),
                        items: safeItems,
                        updatedAt: Number(consumerliteMemberAtelierState.updatedAt || Date.now())
                    }
                }))
            } catch {}
        }

        function refreshConsumerliteMemberAtelierControls() {
            document.querySelectorAll(".cl-card-atelier").forEach(function(button) {
                const handle = String(button.dataset.productHandle || "");
                if (button.hidden = !consumerliteMemberAtelierState.authenticated, !consumerliteMemberAtelierState.authenticated) return;
                const saved = consumerliteMemberAtelierHasHandle(handle);
                button.textContent = uiText(saved ? "SAVED_TO_MY_ATELIER" : "ADD_TO_MY_ATELIER"), button.setAttribute("aria-pressed", saved ? "true" : "false")
            })
        }
        async function loadConsumerliteMemberAtelier() {
            return consumerliteMemberAtelierLoadPromise || (consumerliteMemberAtelierState.status = "loading", consumerliteMemberAtelierLoadPromise = (async function() {
                try {
                    const data = await requestConsumerliteMemberAtelier("load", {}),
                        identity = data && data.chatIdentity && typeof data.chatIdentity == "object" ? data.chatIdentity : {};
                    consumerliteMemberAtelierState = {
                        status: "ready",
                        authenticated: !!data.authenticated,
                        items: Array.isArray(data.items) ? data.items : [],
                        itemCount: Number(data.itemCount || 0),
                        chatIdentityToken: identity.available === !0 ? String(identity.token || "") : "",
                        chatIdentityExpiresAt: identity.available === !0 ? Number(identity.expiresAt || 0) : 0,
                        updatedAt: Number(data.updatedAt || Date.now())
                    }
                } catch (error) {
                    consumerliteMemberAtelierState = {
                        status: "unavailable",
                        authenticated: !!(error && error.authenticated),
                        items: [],
                        itemCount: 0,
                        chatIdentityToken: "",
                        chatIdentityExpiresAt: 0,
                        updatedAt: Date.now()
                    }
                }
                updateConsumerliteExperienceLabel(), refreshConsumerliteMemberAtelierControls(), renderConsumerliteAtelierWorkspace(), publishConsumerliteMemberAtelierState()
            })().finally(function() {
                consumerliteMemberAtelierLoadPromise = null
            }), consumerliteMemberAtelierLoadPromise)
        }
        async function ensureConsumerliteMemberIdentityReady() {
            consumerliteMemberAtelierState.status === "unknown" && loadConsumerliteMemberAtelier();
            const pending = consumerliteMemberAtelierLoadPromise;
            pending && await Promise.race([pending.catch(function() {}), new Promise(function(resolve) {
                window.setTimeout(resolve, 2500)
            })])
        }
        async function saveConsumerliteProductToMyAtelier(product, triggerButton) {
            if (!consumerliteMemberAtelierState.authenticated) return;
            const handle = String(product && product.handle || "").trim();
            if (!handle) return;
            if (consumerliteMemberAtelierHasHandle(handle)) {
                openConsumerliteMyAtelier(triggerButton);
                return
            }
            const selectedRecord = consumerliteAtelierRecordForProduct(product || {});
            triggerButton && (triggerButton.disabled = !0, triggerButton.textContent = "Saving\u2026");
            try {
                const data = await requestConsumerliteMemberAtelier("add_item", {
                    item: {
                        product: sanitizeConsumerliteAtelierProduct(product || {}),
                        variantRecord: selectedRecord || null,
                        selectedOptions: selectedRecord && Array.isArray(selectedRecord.selectedOptions) ? selectedRecord.selectedOptions : []
                    }
                });
                consumerliteMemberAtelierState.items = Array.isArray(data.items) ? data.items : [], consumerliteMemberAtelierState.itemCount = Number(data.itemCount || consumerliteMemberAtelierState.items.length), consumerliteMemberAtelierState.updatedAt = Number(data.updatedAt || Date.now()), trackConsumerliteChatEvent("member_atelier_item_saved", {
                    handle,
                    hasVariant: !!(selectedRecord && selectedRecord.variant && selectedRecord.variant.id)
                })
            } catch (error) {
                trackConsumerliteChatEvent("member_atelier_item_save_failed", {
                    handle,
                    code: String(error && error.code || "")
                })
            } finally {
                triggerButton && (triggerButton.disabled = !1), refreshConsumerliteMemberAtelierControls(), renderConsumerliteAtelierWorkspace(), publishConsumerliteMemberAtelierState()
            }
        }
        async function removeConsumerliteProductFromMyAtelier(handle, returnFocus) {
            const clean = String(handle || "").trim();
            if (!(!clean || !consumerliteMemberAtelierState.authenticated)) try {
                const data = await requestConsumerliteMemberAtelier("remove_item", {
                    handle: clean
                });
                consumerliteMemberAtelierState.items = Array.isArray(data.items) ? data.items : [], consumerliteMemberAtelierState.itemCount = Number(data.itemCount || consumerliteMemberAtelierState.items.length), consumerliteMemberAtelierState.updatedAt = Number(data.updatedAt || Date.now()), refreshConsumerliteMemberAtelierControls(), publishConsumerliteMemberAtelierState(), openConsumerliteMyAtelier(returnFocus)
            } catch {}
        }

        function openConsumerliteStylistInsight(product, returnFocus) {
            const ui = createConsumerliteCommerceOverlay(uiText("WHY_THIS_PIECE"), returnFocus);
            ui.content.textContent = "";
            const wrap = document.createElement("div");
            wrap.className = "cl-stylist-insight";
            const image = document.createElement("img");
            image.src = safeUrl(consumerlitePresentedProductImage(product || {})) || "", image.alt = String(product && (product.imageAlt || product.title) || uiText("PRODUCT"));
            const copy = document.createElement("div"),
                title = document.createElement("h4");
            title.textContent = String(product && product.title || uiText("PRODUCT"));
            const note = document.createElement("p");
            note.textContent = consumerliteStylistNoteForPresentedProduct(product || {}), copy.appendChild(title), copy.appendChild(note), wrap.appendChild(image), wrap.appendChild(copy), ui.content.appendChild(wrap), trackConsumerliteChatEvent("why_this_piece_opened", {
                handle: String(product && product.handle || ""),
                recommendedColor: recommendedColorValueForProduct(product || ""),
                presentationImage: !!consumerlitePresentedProductImage(product || {})
            })
        }

        function openConsumerliteMyAtelier(returnFocus) {
            if (!consumerliteMemberAtelierState.authenticated) return;
            document.querySelector(".cl-commerce-overlay") && closeConsumerliteCommerceOverlay();
            const ui = createConsumerliteCommerceOverlay(uiText("TELLUS_ATELIER"), returnFocus);
            ui.content.textContent = "";
            const items = Array.isArray(consumerliteMemberAtelierState.items) ? consumerliteMemberAtelierState.items : [];
            if (!items.length) {
                const empty = document.createElement("p");
                empty.className = "cl-my-atelier-empty", empty.textContent = "Save pieces from Tellus to build your private Atelier.", ui.content.appendChild(empty);
                return
            }
            const list = document.createElement("div");
            list.className = "cl-my-atelier-list", items.forEach(function(item) {
                const product = item && item.product || {},
                    row = document.createElement("article");
                row.className = "cl-my-atelier-item";
                const image = document.createElement("img"),
                    variantImage = item && item.variantRecord && item.variantRecord.variant && item.variantRecord.variant.image && item.variantRecord.variant.image.url;
                image.src = safeUrl(variantImage || product.image) || "", image.alt = String(product.imageAlt || product.title || uiText("PRODUCT"));
                const content = document.createElement("div"),
                    title = document.createElement("h4");
                title.textContent = String(product.title || uiText("PRODUCT"));
                const selected = document.createElement("p");
                selected.textContent = item && Array.isArray(item.selectedOptions) && item.selectedOptions.length ? formatVariantSelection(item.selectedOptions) : uiText("NEEDS_OPTIONS");
                const actions = document.createElement("div");
                actions.className = "cl-my-atelier-item-actions";
                const style = document.createElement("button");
                style.type = "button", style.textContent = uiText("STYLE_AROUND_THIS"), style.addEventListener("click", function() {
                    conversationContext.memberAtelierAnchor = product, closeConsumerliteCommerceOverlay(), doSend({
                        displayText: uiText("STYLE_AROUND_THIS") + ": " + String(product.title || uiText("PRODUCT")),
                        sendText: "Complete the look around this product",
                        source: "member_atelier"
                    })
                });
                const remove = document.createElement("button");
                remove.type = "button", remove.textContent = uiText("REMOVE_FROM_MY_ATELIER"), remove.addEventListener("click", function() {
                    removeConsumerliteProductFromMyAtelier(product.handle, returnFocus)
                }), actions.appendChild(style), actions.appendChild(remove), content.appendChild(title), content.appendChild(selected), content.appendChild(actions), row.appendChild(image), row.appendChild(content), list.appendChild(row)
            }), ui.content.appendChild(list)
        }

        function sanitizeConsumerliteAtelierProduct(product) {
            if (!product || typeof product != "object") return null;
            const handle = String(product.handle || "").trim();
            return handle ? {
                title: String(product.title || "Product").slice(0, 180),
                handle,
                url: String(product.url || "").slice(0, 600),
                image: String(product.image || "").slice(0, 900),
                imageAlt: String(product.imageAlt || product.title || "Product").slice(0, 240),
                price: String(product.price || "").slice(0, 80),
                outfitSlot: String(product.outfitSlot || product.productLabelKey || "").slice(0, 80),
                stylistNote: String(product.stylistNote || "").slice(0, 500),
                recommendedColor: product.recommendedColor && typeof product.recommendedColor == "object" ? product.recommendedColor : null,
                recommendedImage: product.recommendedImage && typeof product.recommendedImage == "object" ? product.recommendedImage : null,
                availableColorSwatches: Array.isArray(product.availableColorSwatches) ? product.availableColorSwatches.slice(0, 12) : [],
                selectedOptions: (Array.isArray(product.selectedOptions) ? product.selectedOptions : []).filter(function(o) { return o && typeof o.name === "string" && typeof o.value === "string"; }).slice(0, 10).map(function(o) { return {name:o.name.slice(0,80),value:o.value.slice(0,120)}; }),
                availableForSale: product.availableForSale !== !1,
                variantCount: Number(product.variantCount || 0),
                availableVariantCount: Number(product.availableVariantCount || 0),
                requiresVariantSelection: !!(product.requiresVariantSelection || product.variantSelectionRequired),
                canAddToCart: !!product.canAddToCart,
                variantId: String(product.variantId || product.cartVariantId || ""),
                cartVariantId: String(product.cartVariantId || product.variantId || "")
            } : null
        }

        function sanitizeConsumerliteAtelierLook(products) {
            const seen = new Set,
                out = [];
            return (Array.isArray(products) ? products : []).forEach(function(product) {
                if (out.length >= 6) return;
                const clean = sanitizeConsumerliteAtelierProduct(product);
                !clean || seen.has(clean.handle) || (seen.add(clean.handle), out.push(clean))
            }), out
        }

        function consumerliteLookHandleSignature(products) {
            return sanitizeConsumerliteAtelierLook(products).map(function(product) {
                return product.handle
            }).join("|")
        }

        function consumerliteAtelierMoney(value) {
            const match = String(value ?? "").replace(/,/g, "").match(/-?\d+(?:\.\d+)?/),
                amount = match ? Number(match[0]) : 0;
            return Number.isFinite(amount) ? amount : 0
        }

        function consumerliteAtelierRecordForProduct(product) {
            const handle = String(product && product.handle || "").trim();
            return handle && consumerliteSelectedVariants.get(handle) || null
        }

        function consumerliteAtelierPiecePriceInfo(product) {
            const record = consumerliteAtelierRecordForProduct(product),
                liveAmount = Number(record && record.variant && record.variant.price && record.variant.price.amount);
            if (Number.isFinite(liveAmount) && liveAmount > 0) return {
                known: !0,
                amount: liveAmount
            };
            const match = String(product && product.price == null ? "" : product.price).replace(/,/g, "").match(/-?\d+(?:\.\d+)?/),
                amount = match ? Number(match[0]) : NaN;
            return Number.isFinite(amount) && amount > 0 ? {
                known: !0,
                amount
            } : {
                known: !1,
                amount: 0
            }
        }

        function consumerliteAtelierPiecePrice(product) {
            return consumerliteAtelierPiecePriceInfo(product).amount
        }

        function consumerliteAtelierCurrencyCode(products) {
            for (const product of Array.isArray(products) ? products : []) {
                const record = consumerliteAtelierRecordForProduct(product),
                    code = String(record && record.variant && record.variant.price && record.variant.price.currencyCode || "").toUpperCase();
                if (code) return code;
                const match = String(product && product.price || "").match(/\b[A-Z]{3}\b/);
                if (match) return match[0]
            }
            return "USD"
        }

        function formatConsumerliteAtelierTotal(value, products) {
            const amount = Number(value || 0),
                currency = consumerliteAtelierCurrencyCode(products);
            try {
                return new Intl.NumberFormat(getCurrentLanguageCode() || "en", {
                    style: "currency",
                    currency
                }).format(amount)
            } catch {
                return amount.toFixed(2) + " " + currency
            }
        }

        function buildConsumerliteAtelierReadiness(products) {
            const list = sanitizeConsumerliteAtelierLook(products);
            let readyCount = 0,
                pricedCount = 0,
                total = 0;
            const pieces = list.map(function(product) {
                    const prepared = preparedVariantForProduct(product),
                        directReady = !!(productCartVariantId(product || {}) && product.canAddToCart && !productRequiresVariantSelection(product || {})),
                        ready = !!(product.availableForSale !== !1 && (prepared && prepared.variant && prepared.variant.id || directReady)),
                        priceInfo = consumerliteAtelierPiecePriceInfo(product);
                    return ready && (readyCount += 1), priceInfo.known && (pricedCount += 1), total += priceInfo.amount, {
                        handle: product.handle,
                        title: product.title,
                        outfitSlot: product.outfitSlot,
                        ready,
                        priceKnown: priceInfo.known,
                        selectedOptions: prepared && Array.isArray(prepared.selectedOptions) ? prepared.selectedOptions : []
                    }
                }),
                next = pieces.find(function(piece) {
                    return !piece.ready
                }) || null;
            return {
                status: list.length && readyCount === list.length ? "ready" : list.length ? "needs_selection" : "empty",
                readyCount,
                totalCount: list.length,
                pricedCount,
                hasCompletePrice: !!(list.length && pricedCount === list.length && total > 0),
                total: Math.round(total * 100) / 100,
                pieces,
                nextAction: next ? {
                    type: "select_options",
                    handle: next.handle,
                    title: next.title,
                    outfitSlot: next.outfitSlot
                } : null
            }
        }

        function consumerliteAtelierStatePayload() {
            return {
                currentLook: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook || []),
                previousLook: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.previousLook || []),
                refinedLook: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.refinedLook || []),
                comparison: consumerliteAtelierState.comparison || null,
                selectedVariants: compactSelectedVariantsForStorage(),
                lastActionId: String(consumerliteAtelierState.lastActionId || "")
            }
        }
        async function syncConsumerliteAtelierSession(action, detail) {
            if (consumerliteAtelierSyncInFlight) return null;
            const endpoint = consumerliteWorkerEndpoint("/atelier-session");
            if (!endpoint) return null;
            consumerliteAtelierSyncInFlight = !0;
            const generation = consumerliteConversationGeneration, editRevision = consumerliteEditRevision;
            const extra = detail && typeof detail == "object" ? detail : {};
            try {
                const response = await fetch(endpoint, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(Object.assign({
                            action: action || "sync",
                            sessionToken: String(consumerliteAtelierState.sessionToken || ""),
                            sessionId: String(consumerliteAtelierState.sessionId || ""),
                            state: consumerliteAtelierStatePayload()
                        }, extra))
                    }),
                    payload = await response.json().catch(function() {
                        return null
                    });
                if (generation !== consumerliteConversationGeneration || editRevision !== consumerliteEditRevision) return null;
                return !response.ok || !payload || payload.ok !== !0 ? null : (consumerliteAtelierState.sessionToken = String(payload.sessionToken || consumerliteAtelierState.sessionToken || ""), consumerliteAtelierState.sessionId = String(payload.sessionId || consumerliteAtelierState.sessionId || ""), consumerliteAtelierState.revision = Number(payload.revision || consumerliteAtelierState.revision || 0), consumerliteAtelierState.readiness = payload.readiness && typeof payload.readiness == "object" ? payload.readiness : consumerliteAtelierState.readiness, payload.state && payload.state.selectedVariants && typeof payload.state.selectedVariants == "object" && Object.keys(payload.state.selectedVariants).forEach(function(handle) {
                    const record = payload.state.selectedVariants[handle];
                    !record || !record.variant || !record.variant.id || (consumerliteSelectedVariants.set(String(handle), record), trustedCartVariantIds.add(String(record.variant.id)))
                }), consumerliteAtelierState.updatedAt = Date.now(), renderConsumerliteAtelierWorkspace(), persistChatSession(), payload)
            } catch {
                return null
            } finally {
                consumerliteAtelierSyncInFlight = !1;
                if (generation !== consumerliteConversationGeneration || editRevision !== consumerliteEditRevision) scheduleConsumerliteAtelierSync("sync", {});
            }
        }

        function scheduleConsumerliteAtelierSync(action, detail) {
            consumerliteAtelierSyncTimer && window.clearTimeout(consumerliteAtelierSyncTimer), consumerliteAtelierSyncTimer = window.setTimeout(function() {
                consumerliteAtelierSyncTimer = null, syncConsumerliteAtelierSession(action || "sync", detail || {})
            }, 180)
        }

        function updateConsumerliteAtelierFromResponse(data) {
            if (!data || typeof data != "object") return;
            const patch = data.contextPatch && typeof data.contextPatch == "object" ? data.contextPatch : data.context && typeof data.context == "object" ? data.context : {};
            if (patch.atelierLookState === null && Array.isArray(patch.currentLookProducts) && patch.currentLookProducts.length === 0) {
                consumerliteSelectedVariants.clear(), consumerliteAtelierState = {
                    currentLook: [],
                    previousLook: [],
                    refinedLook: [],
                    comparison: null,
                    readiness: null,
                    sessionToken: "",
                    sessionId: "",
                    revision: 0,
                    collapsed: !0,
                    updatedAt: Date.now()
                }, renderConsumerliteAtelierWorkspace(), persistChatSession(), scheduleConsumerliteAtelierSync("reset", {});
                return
            }
            const returnedProducts = Array.isArray(data.products) && data.products.length ? data.products : [],
                intent = normalizeLiteText(data && data.debug && data.debug.intent ? data.debug.intent : "");
            // A reply about the edit is not an edit mutation. Context echoes may
            // contain the same look; preserve its Undo, selections and notice.
            if (!returnedProducts.length && !responseWantsProductClear(data) &&
                (data.preserveCurrentLook === true || patch.preserveCurrentLook === true)) {
                renderConsumerliteAtelierWorkspace();
                return;
            }
            if (patch.currentLookResponse === !1 || patch.browseOnlyResponse === !0 || /^(trending|gift_advisor_inventory|shop|collection|browse|product_search|fallback_search)/.test(intent)) {
                renderConsumerliteAtelierWorkspace();
                return
            }
            const contextProducts = Array.isArray(patch.currentLookProducts) && patch.currentLookProducts.length ? patch.currentLookProducts : [],
                returnedSlots = new Set(returnedProducts.map(function(product) {
                    return normalizeLiteText(product && (product.outfitSlot || product.productLabelKey) || "")
                }).filter(Boolean)),
                returnedLooksLikeEdit = returnedProducts.length >= 2 && returnedSlots.size >= 2 && /outfit|look|weather|occasion|adaptive|refinement|complete/.test(intent),
                nextCurrent = sanitizeConsumerliteAtelierLook(contextProducts.length ? contextProducts : returnedLooksLikeEdit ? returnedProducts : []);
            if (!nextCurrent.length) {
                renderConsumerliteAtelierWorkspace();
                return
            }
            consumerliteEditRevision += 1;
            consumerliteAtelierState.localUndo = null;
            consumerliteAtelierState.editNotice = "";
            const oldCurrent = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook || []),
                isFirstTellusEdit = oldCurrent.length === 0;
            oldCurrent.length && consumerliteLookHandleSignature(oldCurrent) !== consumerliteLookHandleSignature(nextCurrent) && (consumerliteAtelierState.previousLook = oldCurrent), consumerliteAtelierState.currentLook = nextCurrent, isFirstTellusEdit && (consumerliteAtelierState.collapsed = !0), Array.isArray(patch.previousLookProducts) && patch.previousLookProducts.length && (consumerliteAtelierState.previousLook = sanitizeConsumerliteAtelierLook(patch.previousLookProducts));
            const refinedSource = Array.isArray(patch.proposedLookProducts) && patch.proposedLookProducts.length ? patch.proposedLookProducts : Array.isArray(patch.redoLookProducts) && patch.redoLookProducts.length ? patch.redoLookProducts : [];
            refinedSource.length && (consumerliteAtelierState.refinedLook = sanitizeConsumerliteAtelierLook(refinedSource)), data.lookComparison && typeof data.lookComparison == "object" ? consumerliteAtelierState.comparison = data.lookComparison : patch.lookComparison && typeof patch.lookComparison == "object" && (consumerliteAtelierState.comparison = patch.lookComparison), consumerliteAtelierState.readiness = buildConsumerliteAtelierReadiness(nextCurrent), consumerliteAtelierState.updatedAt = Date.now(), renderConsumerliteAtelierWorkspace(), persistChatSession(), scheduleConsumerliteAtelierSync("sync", {})
        }

        function refreshConsumerliteProductSelectionUi(handle) {
            const cleanHandle = String(handle || "").trim();
            if (!cleanHandle) return;
            const record = consumerliteSelectedVariants.get(cleanHandle) || null,
                selectionText = record ? formatVariantSelection(record.selectedOptions || []) : "";
            document.querySelectorAll('.cl-card-selection-summary[data-product-handle="' + cssEscapeValue(cleanHandle) + '"]').forEach(function(el) {
                el.textContent = selectionText ? uiText("SELECTED_OPTIONS") + ": " + selectionText : ""
            }), document.querySelectorAll('.cl-card-cart[data-product-handle="' + cssEscapeValue(cleanHandle) + '"]').forEach(function(button) {
                !record || !record.variant || !record.variant.id || button.classList.contains("is-added") || (button.classList.remove("requires-selection"), button.classList.add("has-selection"), button.textContent = uiText("ADD_TO_BAG"), button.setAttribute("aria-label", uiText("ADD_TO_BAG") + ": " + cleanHandle))
            });
            const selectedImage = record && record.variant && record.variant.image && record.variant.image.url;
            selectedImage && document.querySelectorAll('.cl-card-img[data-product-handle="' + cssEscapeValue(cleanHandle) + '"]').forEach(function(image) {
                image.src = safeUrl(selectedImage) || image.src, record.variant.image.altText && (image.alt = String(record.variant.image.altText))
            }), consumerliteAtelierState.readiness = buildConsumerliteAtelierReadiness(consumerliteAtelierState.currentLook || []), renderConsumerliteAtelierWorkspace(), persistChatSession()
        }

        function cssEscapeValue(value) {
            return window.CSS && typeof window.CSS.escape == "function" ? window.CSS.escape(String(value || "")) : String(value || "").replace(/["\\]/g, "\\$&")
        }

        function consumerliteAtelierRefineActions() {
            return [{
                label: uiText("MORE_CASUAL") || "More casual",
                prompt: "More casual"
            }, {
                label: uiText("MORE_ELEVATED") || "More elevated",
                prompt: "More elevated"
            }, {
                label: uiText("TOO_EXPENSIVE") || "Less expensive",
                prompt: "Less expensive"
            }, {
                label: uiText("CHANGE_FOOTWEAR") || "Change footwear",
                prompt: "Change footwear"
            }, {
                label: uiText("REMOVE_ACCESSORY") || "Remove accessory",
                prompt: "Remove accessory"
            }, {
                label: uiText("REROLL_OUTFIT") || "Show another outfit",
                prompt: "Show another outfit"
            }]
        }

function openConsumerliteAtelierComparison(returnFocus) {
    if (consumerlitePendingSendCount) return;
    const current = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook);
    let alternative = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.previousLook);
    let alternativeLabel = uiText("PREVIOUS_LOOK");
    if (!alternative.length) {
        alternative = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.refinedLook);
        alternativeLabel = uiText("REFINED_LOOK");
    }
    if (!current.length || !alternative.length) return;
    const revision = consumerliteEditRevision, generation = consumerliteConversationGeneration;
    const ui = createConsumerliteCommerceOverlay(uiText("COMPARE_LOOKS"), returnFocus);
    ui.content.textContent = "";
    const grid = document.createElement("div");
    grid.className = "cl-compare-grid";
    function buildColumn(label, products) {
        const column = document.createElement("section");
        column.className = "cl-compare-column";
        const heading = document.createElement("h4");
        heading.textContent = label;
        column.appendChild(heading);
        products.forEach(function(product) {
            const row = document.createElement("div");
            row.className = "cl-compare-piece";
            const image = document.createElement("img");
            const prepared = preparedVariantForProduct(product);
            image.src = safeUrl(prepared?.variant?.image?.url || consumerlitePresentedProductImage(product)) || "";
            image.alt = String(product.imageAlt || product.title || uiText("PRODUCT"));
            const name = document.createElement("p");
            name.textContent = String(product.title || uiText("PRODUCT"));
            row.appendChild(image); row.appendChild(name); column.appendChild(row);
        });
        const total = document.createElement("p");
        total.className = "cl-compare-total";
        const price = consumerliteComparablePrice(products);
        total.textContent = price.known ? "Estimated " + formatConsumerliteAtelierTotal(price.total, products) : consumerliteEditText("EDIT_PRICE_UNKNOWN");
        column.appendChild(total);
        return column;
    }
    grid.appendChild(buildColumn(uiText("CURRENT_LOOK"), current));
    grid.appendChild(buildColumn(alternativeLabel, alternative));
    ui.content.appendChild(grid);
    const explanation = document.createElement("p");
    explanation.className = "cl-edit-help";
    explanation.textContent = consumerliteEditText("EDIT_SELECTION_NOTE");
    ui.content.appendChild(explanation);
    const actions = document.createElement("div");
    actions.className = "cl-compare-actions";
    const choices = [
        {label: uiText("KEEP_CURRENT"), products: current, primary: true},
        {label: alternativeLabel === uiText("REFINED_LOOK") ? uiText("KEEP_REFINED") : uiText("KEEP_PREVIOUS"), products: alternative}
    ];
    const currentPrice = consumerliteComparablePrice(current), alternativePrice = consumerliteComparablePrice(alternative);
    if (currentPrice.known && alternativePrice.known && currentPrice.currency === alternativePrice.currency) {
        choices.push({label: uiText("KEEP_CHEAPER"), products: alternativePrice.total < currentPrice.total ? alternative : current});
    }
    choices.forEach(function(choice) {
        const button = document.createElement("button");
        button.type = "button";
        button.textContent = choice.label;
        if (choice.primary) button.classList.add("is-primary");
        button.addEventListener("click", function() {
            consumerliteChooseComparedLook(choice.products, revision, generation);
        });
        actions.appendChild(button);
    });
    ui.content.appendChild(actions);
}


        function renderConsumerliteAtelierWorkspace() {
            consumerliteRefreshEditButtons();
            if (!atelier) return;
            const viewportSnapshot = captureConsumerliteConversationViewport(),
                products = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook || []);
            if (!products.length) {
                atelier.innerHTML = "";
                atelier.hidden = !consumerliteAtelierState.localUndo;
                if (!atelier.hidden) {
                    atelier.classList.remove("is-collapsed");
                    const empty = document.createElement("p");
                    empty.className = "cl-edit-help";
                    empty.textContent = consumerliteEditText("EMPTY_EDIT");
                    atelier.appendChild(empty);
                    consumerliteRenderEditNotice();
                }
                restoreConsumerliteConversationViewport(viewportSnapshot);
                return;
            }
            const readiness = buildConsumerliteAtelierReadiness(products);
            consumerliteAtelierState.readiness = readiness, atelier.hidden = !1, atelier.classList.toggle("is-collapsed", !!consumerliteAtelierState.collapsed), atelier.innerHTML = "";
            const head = document.createElement("div");
            head.className = "cl-atelier-head";
            const titleWrap = document.createElement("div");
            titleWrap.className = "cl-atelier-title-wrap";
            const kicker = document.createElement("p");
            kicker.className = "cl-atelier-kicker", kicker.textContent = "Tellus";
            const title = document.createElement("h3");
            title.className = "cl-atelier-title", title.textContent = uiText("ATELIER_TITLE"), titleWrap.appendChild(kicker), titleWrap.appendChild(title);
            const toggle2 = document.createElement("button");
            toggle2.type = "button", toggle2.className = "cl-atelier-toggle", toggle2.textContent = consumerliteAtelierState.collapsed ? uiText("SHOW_WORKSPACE") : uiText("HIDE_WORKSPACE"), toggle2.addEventListener("click", function() {
                consumerliteAtelierState.collapsed = !consumerliteAtelierState.collapsed, renderConsumerliteAtelierWorkspace(), persistChatSession()
            });
            const headActions = document.createElement("div");
            if (headActions.className = "cl-atelier-head-actions", consumerliteMemberAtelierState.authenticated) {
                const myAtelier = document.createElement("button");
                myAtelier.type = "button", myAtelier.className = "cl-my-atelier-open", myAtelier.textContent = uiText("MY_ATELIER") + (consumerliteMemberAtelierState.itemCount ? " \xB7 " + consumerliteMemberAtelierState.itemCount : ""), myAtelier.addEventListener("click", function() {
                    openConsumerliteMyAtelier(myAtelier)
                }), headActions.appendChild(myAtelier)
            }
            headActions.appendChild(toggle2), head.appendChild(titleWrap), head.appendChild(headActions), atelier.appendChild(head);
            const help = document.createElement("p");
            help.className = "cl-edit-help";
            help.textContent = consumerliteEditText("EDIT_HELP");
            atelier.appendChild(help);
            consumerliteRenderEditNotice();
            const strip = document.createElement("div");
            strip.className = "cl-atelier-products", products.forEach(function(product) {
                const prepared = preparedVariantForProduct(product),
                    directReady = !!(productCartVariantId(product || {}) && product.canAddToCart && !productRequiresVariantSelection(product || {})),
                    pieceReady = !!(prepared || directReady),
                    piece = document.createElement("button");
                piece.type = "button", piece.className = "cl-atelier-piece" + (pieceReady ? " is-ready" : " needs-selection"), piece.setAttribute("aria-label", uiText(pieceReady ? "CHANGE" : "SELECT_OPTIONS") + ": " + product.title);
                const image = document.createElement("img");
                image.className = "cl-atelier-piece-image";
                const variantImage = prepared && prepared.variant && prepared.variant.image && prepared.variant.image.url;
                image.src = safeUrl(variantImage || consumerlitePresentedProductImage(product || {})) || "", image.alt = String(product.imageAlt || product.title || uiText("PRODUCT"));
                const meta = document.createElement("span");
                meta.className = "cl-atelier-piece-meta";
                const slot = document.createElement("span");
                slot.className = "cl-atelier-piece-slot", slot.textContent = formatProductSlotLabel(product.outfitSlot || "", product) || uiText("PRODUCT");
                const state = document.createElement("span");
                state.className = "cl-atelier-piece-state", state.textContent = pieceReady ? "\u2713" : "!", meta.appendChild(slot), meta.appendChild(state), piece.appendChild(image), piece.appendChild(meta), piece.addEventListener("click", function() {
                    openConsumerliteVariantConcierge(product, {
                        mode: "select_only",
                        triggerButton: piece,
                        onSelect: function() {
                            renderConsumerliteAtelierWorkspace(), refreshConsumerliteProductSelectionUi(product.handle)
                        }
                    })
                });
                piece.disabled = consumerlitePendingSendCount > 0;
                const wrap = document.createElement("div");
                wrap.className = "cl-edit-piece-wrap";
                const remove = document.createElement("button");
                remove.type = "button";
                remove.className = "cl-edit-remove";
                remove.textContent = "× " + consumerliteEditText("REMOVE_EDIT_SHORT");
                remove.setAttribute("aria-label", consumerliteEditText("REMOVE_EDIT") + ": " + product.title);
                remove.disabled = consumerlitePendingSendCount > 0;
                remove.addEventListener("click", function() { removeConsumerliteEditPiece(product.handle); });
                wrap.appendChild(piece); wrap.appendChild(remove); strip.appendChild(wrap);
            }), atelier.appendChild(strip);
            const summary = document.createElement("div");
            summary.className = "cl-atelier-summary";
            const summaryText = document.createElement("div"),
                readinessText = document.createElement("p");
            readinessText.className = "cl-atelier-readiness", readinessText.textContent = readiness.status === "ready" ? uiText("LOOK_READY") : "Choose options for the pieces you want to add.";
            const next = document.createElement("p");
            next.className = "cl-atelier-next", next.textContent = readiness.nextAction ? uiText("NEXT_STEP") + ": " + uiText("SELECT_OPTIONS") + " \u2014 " + readiness.nextAction.title : uiText("LIVE_PRICE_NOTE"), summaryText.appendChild(readinessText), summaryText.appendChild(next);
            const total = document.createElement("div");
            total.className = "cl-atelier-total", total.hidden = !readiness.hasCompletePrice, total.textContent = readiness.hasCompletePrice ? (readiness.status === "ready" ? "Confirmed " : "Estimated ") + formatConsumerliteAtelierTotal(readiness.total, products) : "", summary.appendChild(summaryText), summary.appendChild(total), atelier.appendChild(summary);
            const actions = document.createElement("div");
            actions.className = "cl-atelier-actions";
            const primary = document.createElement("button");
            primary.type = "button", primary.className = "cl-atelier-primary", primary.textContent = readiness.status === "ready" ? consumerliteEditText("REVIEW_EDIT") : consumerliteEditText("CHOOSE_EDIT_OPTIONS"), primary.addEventListener("click", function() {
                openConsumerliteLookConcierge(products, primary)
            });
            const refine = document.createElement("button");
            refine.type = "button", refine.className = "cl-atelier-secondary", refine.textContent = uiText("REFINE_LOOK");
            const compare = document.createElement("button");
            compare.type = "button", compare.className = "cl-atelier-compare", compare.textContent = uiText("COMPARE_LOOKS");
            const canCompare = !!((consumerliteAtelierState.previousLook || []).length || (consumerliteAtelierState.refinedLook || []).length);
            primary.disabled = refine.disabled = compare.disabled = consumerlitePendingSendCount > 0;
            compare.hidden = !canCompare, compare.addEventListener("click", function() {
                openConsumerliteAtelierComparison(compare)
            }), actions.appendChild(primary), actions.appendChild(refine), actions.appendChild(compare), atelier.appendChild(actions);
            const drawer = document.createElement("div");
            drawer.className = "cl-atelier-refine", drawer.hidden = !0, consumerliteAtelierRefineActions().forEach(function(action) {
                const button = document.createElement("button");
                button.type = "button", button.textContent = action.label, button.disabled = consumerlitePendingSendCount > 0, button.addEventListener("click", function() {
                    doSend({
                        displayText: action.label,
                        sendText: action.prompt,
                        source: "tellus_edit_refine"
                    })
                }), drawer.appendChild(button)
            }), refine.addEventListener("click", function() {
                drawer.hidden = !drawer.hidden, refine.setAttribute("aria-expanded", drawer.hidden ? "false" : "true")
            }), atelier.appendChild(drawer), restoreConsumerliteConversationViewport(viewportSnapshot)
        }

        function registerTrustedResolvedVariant(record) {
            const variantId = String(record && record.variant && record.variant.id || "").trim();
            if (!variantId) return;
            trustedCartVariantIds.add(variantId);
            const handle = String(record && record.product && record.product.handle || record && record.handle || "").trim();
            handle && (consumerliteSelectedVariants.set(handle, record), refreshConsumerliteProductSelectionUi(handle), scheduleConsumerliteAtelierSync("selection", {
                handle,
                selectedOptions: Array.isArray(record.selectedOptions) ? record.selectedOptions : []
            }))
        }
        async function addResolvedVariantToCart(product, variant, selectedOptions, triggerButton) {
            const variantId = String(variant && variant.id || "").trim();
            if (!variantId || !trustedCartVariantIds.has(variantId)) throw new Error("untrusted_resolved_variant");
            const response = await fetch(shopifyAjaxPath("cart/add.js"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });
            if (!response.ok) throw new Error("cart_add_failed");
            const addPayload = await response.json().catch(function() {
                    return {
                        quantity: 1
                    }
                }),
                cart = await fetchConsumerliteCart();
            return cart && updateThemeCartCount(cart), trackConsumerliteChatEvent("variant_concierge_add_to_bag", {
                handle: product && product.handle ? String(product.handle) : "",
                variantId,
                selectedOptionCount: Array.isArray(selectedOptions) ? selectedOptions.length : 0
            }), dispatchConsumerliteCartSync("consumerlite:cart:add", {
                product: product || {},
                variantId,
                quantity: Number(addPayload && addPayload.quantity || 1)
            }, cart), triggerButton && triggerButton.parentNode && (triggerButton.disabled = !1, triggerButton.textContent = uiText("ADDED_TO_CART") || "Added", triggerButton.classList.remove("requires-selection"), triggerButton.classList.add("is-added"), renderCartQuantityControls(product || {}, triggerButton, variantId, addPayload || {
                quantity: 1
            })), renderConsumerliteAtelierWorkspace(), persistChatSession(), addPayload
        }

        function openProductDetailsFallback(product, explicitUrl) {
            const href = safeUrl(explicitUrl || product && product.url);
            href && (window.location.href = href)
        }
        async function openConsumerliteVariantConcierge(product, settings) {
            const options = settings && typeof settings == "object" ? settings : {},
                handle = String(product && product.handle || "").trim(),
                triggerButton = options.triggerButton || null;
            if (!handle) {
                openProductDetailsFallback(product);
                return
            }
            const ui = createConsumerliteCommerceOverlay(uiText("OPTIONS_TITLE"), triggerButton);
            ui.content.textContent = uiText("LOADING_OPTIONS"), trackConsumerliteChatEvent("variant_concierge_opened", {
                handle,
                mode: options.mode || "add"
            });
            let payload;
            try {
                payload = await requestConsumerliteProductOptions(handle, [], "load")
            } catch (error) {
                ui.content.textContent = "";
                const status = document.createElement("p");
                status.className = "cl-variant-status is-error", status.textContent = String(error && error.message || uiText("FALLBACK"));
                const details = document.createElement("a");
                details.className = "cl-variant-details", details.href = safeUrl(error && error.productUrl || product && product.url) || "#", details.textContent = uiText("VIEW_FULL_DETAILS"), ui.content.appendChild(status), ui.content.appendChild(details);
                return
            }
            if (payload.product && payload.product.requiresProductPage) {
                ui.content.textContent = "";
                const status = document.createElement("p");
                status.className = "cl-variant-status", status.textContent = "This piece requires the full product page to complete its options.";
                const details = document.createElement("a");
                details.className = "cl-variant-details", details.href = safeUrl(payload.product.url || product && product.url) || "#", details.textContent = uiText("VIEW_FULL_DETAILS"), ui.content.appendChild(status), ui.content.appendChild(details);
                return
            }
            const storedSelection = consumerliteSelectedVariants.get(handle),
                preparedSelection = preparedVariantForProduct(product),
                exactCardVariant = preparedSelection && (payload.variants || []).find(function(v) { return String(v.id || "").replace(/\D/g, "") === String(preparedSelection.variant.id || "").replace(/\D/g, ""); }),
                initialSelectedOptions = Array.isArray(options.initialSelectedOptions) ? options.initialSelectedOptions : storedSelection && storedSelection.selectedOptions && storedSelection.selectedOptions.length ? storedSelection.selectedOptions : preparedSelection && preparedSelection.selectedOptions && preparedSelection.selectedOptions.length ? preparedSelection.selectedOptions : exactCardVariant && exactCardVariant.selectedOptions || [],
                optionList = Array.isArray(payload.options) ? payload.options : [],
                variants = Array.isArray(payload.variants) ? payload.variants : [],
                recommendedInitialSelectedOptions = buildRecommendedInitialSelectedOptions(product, optionList, initialSelectedOptions),
                selectionMap = selectedOptionsToMap(recommendedInitialSelectedOptions);
            optionList.forEach(function(option) {
                const values = Array.isArray(option && option.values) ? option.values.filter(function(value) {
                    return value && value.available !== !1
                }) : [];
                values.length === 1 && optionList.length === 1 && !/size|color|colour/i.test(String(option && option.name || "")) && selectionMap.set(normalizeVariantOptionText(option.name), String(values[0].value || ""))
            });

            function renderSelector(message, isError) {
                ui.content.textContent = "";
                const exactVariant = findExactAvailableVariant(variants, selectionMap, optionList),
                    previewVariant = exactVariant || findPreviewAvailableVariant(variants, selectionMap),
                    productBlock = document.createElement("div");
                productBlock.className = "cl-variant-product";
                const image = document.createElement("img"),
                    selectedImage = previewVariant && previewVariant.image && previewVariant.image.url;
                image.src = safeUrl(selectedImage || payload.product && payload.product.image && payload.product.image.url || product && product.image) || "", image.alt = String(previewVariant && previewVariant.image && previewVariant.image.altText || payload.product && payload.product.title || product && product.title || uiText("PRODUCT")), image.loading = "eager", image.decoding = "async";
                const productInfo = document.createElement("div"),
                    name = document.createElement("p");
                name.className = "cl-variant-product-name", name.textContent = String(payload.product && payload.product.title || product && product.title || uiText("PRODUCT"));
                const price = document.createElement("p");
                price.className = "cl-variant-product-price", price.textContent = exactVariant ? formatVariantMoney(exactVariant.price) : String(product && product.price || ""), productInfo.appendChild(name), productInfo.appendChild(price), productBlock.appendChild(image), productBlock.appendChild(productInfo), ui.content.appendChild(productBlock), optionList.forEach(function(option, optionIndex) {
                    const group = document.createElement("div");
                    group.className = "cl-variant-group";
                    const label = document.createElement("div");
                    label.className = "cl-variant-label";
                    const labelName = document.createElement("span");
                    labelName.textContent = String(option && option.name || "Option");
                    const selectedValue = document.createElement("span");
                    selectedValue.textContent = String(selectionMap.get(normalizeVariantOptionText(option && option.name)) || ""), label.appendChild(labelName), label.appendChild(selectedValue);
                    const values = document.createElement("div");
                    values.className = "cl-variant-values", (Array.isArray(option && option.values) ? option.values : []).forEach(function(entry) {
                        const value = String(entry && entry.value || ""),
                            optionNameKey = normalizeVariantOptionText(option && option.name),
                            testMap = new Map(selectionMap);
                        testMap.set(optionNameKey, value);
                        const compatible = variants.some(function(variant) {
                                return variant && variant.availableForSale !== !1 && variantMatchesSelection(variant, testMap, "")
                            }),
                            choice = document.createElement("button");
                        if (choice.type = "button", choice.className = "cl-variant-choice", option && option.presentation === "swatch" && choice.classList.add("is-swatch"), normalizeVariantOptionText(selectionMap.get(optionNameKey)) === normalizeVariantOptionText(value) && choice.classList.add("is-selected"), choice.disabled = !compatible, choice.setAttribute("aria-pressed", choice.classList.contains("is-selected") ? "true" : "false"), entry && entry.swatch) {
                            const swatch = document.createElement("span");
                            swatch.className = "cl-variant-swatch", swatch.style.background = String(entry.swatch), choice.appendChild(swatch)
                        }
                        const text = document.createElement("span");
                        text.textContent = value, choice.appendChild(text), choice.addEventListener("click", function() {
                            selectionMap.set(optionNameKey, value), optionList.slice(optionIndex + 1).forEach(function(laterOption) {
                                const laterKey = normalizeVariantOptionText(laterOption && laterOption.name);
                                if (!selectionMap.has(laterKey)) return;
                                variants.some(function(variant) {
                                    return variant && variant.availableForSale !== !1 && variantMatchesSelection(variant, selectionMap, "")
                                }) || selectionMap.delete(laterKey)
                            }), renderSelector("", !1)
                        }), values.appendChild(choice)
                    }), group.appendChild(label), group.appendChild(values), ui.content.appendChild(group)
                });
                const status = document.createElement("p");
                status.className = "cl-variant-status" + (isError ? " is-error" : ""), status.textContent = message || "", ui.content.appendChild(status);
                const primary = document.createElement("button");
                primary.type = "button", primary.className = "cl-variant-primary";
                const complete = !!exactVariant;
                primary.disabled = !complete, complete ? options.mode === "select_only" ? primary.textContent = uiText("USE_SELECTION") : primary.textContent = uiText("ADD_TO_BAG") + (formatVariantMoney(exactVariant.price) ? " \u2014 " + formatVariantMoney(exactVariant.price) : "") : primary.textContent = uiText("SELECT_ALL_OPTIONS"), primary.addEventListener("click", async function() {
                    if (!exactVariant) return;
                    primary.disabled = !0, primary.textContent = uiText("CHECKING_AVAILABILITY");
                    const selectedOptions = selectedOptionsFromMap(selectionMap, optionList);
                    try {
                        const resolved = await requestConsumerliteProductOptions(handle, selectedOptions, "resolve"),
                            liveVariant = resolved && resolved.selectedVariant;
                        if (!liveVariant || liveVariant.availableForSale === !1 || !liveVariant.id) throw new Error(uiText("UNAVAILABLE"));
                        const record = {
                            product: resolved.product || payload.product || product,
                            variant: liveVariant,
                            selectedOptions,
                            checkedAt: Date.now()
                        };
                        if (registerTrustedResolvedVariant(record), options.mode === "select_only") {
                            closeConsumerliteCommerceOverlay(), typeof options.onSelect == "function" && options.onSelect(record);
                            return
                        }
                        await addResolvedVariantToCart(product || {}, liveVariant, selectedOptions, triggerButton), closeConsumerliteCommerceOverlay()
                    } catch (error) {
                        trackConsumerliteChatEvent("variant_concierge_resolution_failed", {
                            handle,
                            code: String(error && error.code || "")
                        }), renderSelector(String(error && error.message || uiText("TRY_ANOTHER_OPTION")), !0)
                    }
                }), ui.content.appendChild(primary);
                const details = document.createElement("a");
                details.className = "cl-variant-details", details.href = safeUrl(payload.product && payload.product.url || product && product.url) || "#", details.textContent = uiText("VIEW_FULL_DETAILS"), details.addEventListener("click", function() {
                    trackConsumerliteChatEvent("variant_concierge_full_details", {
                        handle
                    })
                }), ui.content.appendChild(details);
                const trust = document.createElement("p");
                trust.className = "cl-variant-trust-note", trust.textContent = uiText("LIVE_PRICE_NOTE"), ui.content.appendChild(trust)
            }
            renderSelector("", !1)
        }

        function preparedVariantForProduct(product) {
            const handle = String(product && product.handle || "").trim(),
                selected = handle ? consumerliteSelectedVariants.get(handle) : null;
            if (selected && selected.variant && selected.variant.id) return selected;
            const directId = productCartVariantId(product || {});
            return directId && isTrustedProductCardVariant(product || {}, directId) ? {
                product: product || {},
                variant: {
                    id: directId,
                    price: null,
                    selectedOptions: Array.isArray(product.selectedOptions) ? product.selectedOptions : []
                },
                selectedOptions: Array.isArray(product.selectedOptions) ? product.selectedOptions : []
            } : null
        }

        async function openConsumerliteLookConcierge(products, returnFocus) {
            const list = Array.isArray(products) ? products.filter(Boolean).slice(0, 6) : [];
            if (!list.length) return;
            const ui = createConsumerliteCommerceOverlay(consumerliteEditText("CHOOSE_EDIT_OPTIONS"), returnFocus);
            // Older theme adapters omit selectedOptions. Recover only the exact
            // trusted variant ID, never the first variant or an inferred shade.
            const missingDetails = new Set();
            ui.content.textContent = uiText("LOADING_OPTIONS");
            const detailsNeeded=list.filter(function(product) { const prepared=preparedVariantForProduct(product);return prepared && !(prepared.selectedOptions && prepared.selectedOptions.length); });
            if (detailsNeeded.length) await Promise.all(detailsNeeded.map(async function(product) {
                const prepared = preparedVariantForProduct(product);
                if (!prepared || prepared.selectedOptions && prepared.selectedOptions.length) return;
                try {
                    const payload = await requestConsumerliteProductOptions(product.handle, [], "load");
                    const wanted = String(prepared.variant.id).replace(/\D/g, "");
                    const variant = (payload.variants || []).find(function(v) { return String(v.id || "").replace(/\D/g, "") === wanted; });
                    if (!variant || variant.availableForSale === false || !Array.isArray(variant.selectedOptions) || !variant.selectedOptions.length) throw new Error("missing_variant_options");
                    registerTrustedResolvedVariant({product:payload.product || product,variant:variant,selectedOptions:variant.selectedOptions,checkedAt:Date.now()});
                } catch (_) { missingDetails.add(product.handle); }
            }));

            function renderLook(message, isError) {
                ui.content.textContent = "";
                const lookList = document.createElement("div");
                lookList.className = "cl-look-list";
                let readyCount = 0;
                list.forEach(function(product) {
                    const prepared = missingDetails.has(product.handle) ? null : preparedVariantForProduct(product);
                    prepared && (readyCount += 1);
                    const row = document.createElement("div");
                    row.className = "cl-look-item";
                    const image = document.createElement("img");
                    image.src = safeUrl(product && product.image) || "", image.alt = String(product && (product.imageAlt || product.title) || uiText("PRODUCT"));
                    const info = document.createElement("div"),
                        title = document.createElement("p");
                    title.className = "cl-look-item-title", title.textContent = String(product && product.title || uiText("PRODUCT"));
                    const status2 = document.createElement("p");
                    status2.className = "cl-look-item-status", status2.textContent = prepared ? formatVariantSelection(prepared.selectedOptions) || uiText("READY") : uiText("SELECT_OPTIONS"), info.appendChild(title), info.appendChild(status2);
                    const action = document.createElement("button");
                    action.type = "button", action.className = "cl-look-item-action", action.textContent = uiText(prepared ? "CHANGE" : "SELECT"), action.addEventListener("click", function() {
                        openConsumerliteVariantConcierge(product, {
                            mode: "select_only",
                            triggerButton: action,
                            onSelect: function() {
                                openConsumerliteLookConcierge(list, returnFocus)
                            }
                        })
                    }), row.appendChild(image), row.appendChild(info), row.appendChild(action), lookList.appendChild(row)
                }), ui.content.appendChild(lookList);
                const summary = document.createElement("div");
                summary.className = "cl-look-summary", summary.textContent = readyCount + " / " + list.length + " " + uiText("READY"), ui.content.appendChild(summary);
                const status = document.createElement("p");
                status.className = "cl-variant-status" + (isError ? " is-error" : ""), status.textContent = message || "", ui.content.appendChild(status);
                const primary = document.createElement("button");
                primary.type = "button", primary.className = "cl-variant-primary", primary.disabled = readyCount !== list.length, primary.textContent = readyCount === list.length ? uiText("ADD_LOOK_TO_BAG") : uiText("COMPLETE_SELECTIONS"), primary.addEventListener("click", async function() {
                    if (readyCount === list.length) {
                        primary.disabled = !0, primary.textContent = uiText("CHECKING_AVAILABILITY");
                        try {
                            const resolvedRecords = [];
                            for (const product of list) {
                                const prepared = preparedVariantForProduct(product),
                                    selectedOptions = prepared && Array.isArray(prepared.selectedOptions) ? prepared.selectedOptions : [],
                                    resolved = await requestConsumerliteProductOptions(product.handle, selectedOptions, "resolve");
                                if (!resolved || !resolved.selectedVariant || !resolved.selectedVariant.id || resolved.selectedVariant.availableForSale === !1) throw new Error(String(product && product.title || uiText("PRODUCT")) + ": " + uiText("UNAVAILABLE"));
                                const record = {
                                    product: resolved.product || product,
                                    variant: resolved.selectedVariant,
                                    selectedOptions,
                                    checkedAt: Date.now()
                                };
                                registerTrustedResolvedVariant(record), resolvedRecords.push({
                                    product,
                                    record
                                })
                            }
                            const response = await fetch(shopifyAjaxPath("cart/add.js"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json"
                                },
                                body: JSON.stringify({
                                    items: resolvedRecords.map(function(entry) {
                                        return {
                                            id: entry.record.variant.id,
                                            quantity: 1
                                        }
                                    })
                                })
                            });
                            if (!response.ok) throw new Error("full_look_add_failed");
                            await response.json().catch(function() {
                                return {}
                            });
                            const cart = await fetchConsumerliteCart();
                            cart && updateThemeCartCount(cart), dispatchConsumerliteCartSync("consumerlite:cart:full-look-add", {
                                productCount: resolvedRecords.length
                            }, cart), trackConsumerliteChatEvent("variant_concierge_full_look_added", {
                                productCount: resolvedRecords.length
                            }), consumerliteAtelierState.readiness = buildConsumerliteAtelierReadiness(list), renderConsumerliteAtelierWorkspace(), persistChatSession(), scheduleConsumerliteAtelierSync("revalidate", {}), primary.textContent = uiText("LOOK_ADDED"), window.setTimeout(closeConsumerliteCommerceOverlay, 650)
                        } catch (error) {
                            trackConsumerliteChatEvent("variant_concierge_full_look_failed", {
                                productCount: list.length
                            }), renderLook(String(error && error.message || uiText("FALLBACK")), !0)
                        }
                    }
                }), ui.content.appendChild(primary)
            }
            renderLook("", !1)
        }

        function productCartVariantId(product) {
            const raw = String(product && (product.variantId || product.cartVariantId || product.variant_id || product.id) ? product.variantId || product.cartVariantId || product.variant_id || product.id : "").trim();
            if (!raw) return "";
            const match = raw.match(/ProductVariant\/(\d+)/i) || raw.match(/(\d+)$/);
            return match ? match[1] : raw
        }

        function registerTrustedCartVariantFromProduct(product) {
            const variantId = productCartVariantId(product || {});
            variantId && (productRequiresVariantSelection(product || {}) || product && product.canAddToCart === !1 || trustedCartVariantIds.add(String(variantId)))
        }

        function isTrustedProductCardVariant(product, variantId) {
            const cleanVariant = String(variantId || "").trim();
            return !(!cleanVariant || !trustedCartVariantIds.has(cleanVariant) || productRequiresVariantSelection(product || {}) || product && product.canAddToCart === !1)
        }

        function productRequiresVariantSelection(product) {
            if (!product || typeof product != "object" || product.requiresVariantSelection === !0 || product.canAddToCart === !1) return !0;
            const variantCount = Number(product.variantCount || 0),
                availableVariantCount = Number(product.availableVariantCount || 0);
            return variantCount > 1 || availableVariantCount > 1
        }

        function createProductCartButton(product) {
            const cartButton = document.createElement("button");
            cartButton.type = "button", cartButton.className = "cl-card-cart";
            const needsOptions = productRequiresVariantSelection(product || {}),
                preparedSelection = needsOptions ? consumerliteAtelierRecordForProduct(product || {}) : null,
                hasPreparedSelection = !!(preparedSelection && preparedSelection.variant && preparedSelection.variant.id),
                buttonText = hasPreparedSelection ? uiText("ADD_TO_BAG") || "Add to bag" : needsOptions ? uiText("SELECT_OPTIONS") || "Select options" : uiText("ADD_TO_CART") || "Add to cart";
            return needsOptions && !hasPreparedSelection && cartButton.classList.add("requires-selection"), hasPreparedSelection && cartButton.classList.add("has-selection"), cartButton.dataset.productHandle = String(product && product.handle || ""), cartButton.textContent = buttonText, cartButton.setAttribute("aria-label", buttonText + ": " + (product && product.title ? String(product.title) : uiText("PRODUCT"))), cartButton.addEventListener("click", function(ev) {
                ev.preventDefault(), ev.stopPropagation(), addProductCardToCart(product, cartButton)
            }), cartButton
        }
        async function fetchConsumerliteCart() {
            try {
                const response = await fetch(shopifyAjaxPath("cart.js"), {
                    method: "GET",
                    headers: {
                        Accept: "application/json"
                    }
                });
                return response.ok ? await response.json().catch(function() {
                    return null
                }) : null
            } catch {
                return null
            }
        }

        function updateThemeCartCount(cart) {
            if (!cart || typeof cart != "object") return;
            const count = Number(cart.item_count || 0);
            if (!Number.isFinite(count)) return;
            ["[data-cart-count]", ".cart-count-bubble span[aria-hidden='true']", ".cart-count-bubble span", ".cart-count", "#CartCount"].forEach(function(selector) {
                document.querySelectorAll(selector).forEach(function(el) {
                    el && (el.textContent = String(count), count > 0 && el.removeAttribute("hidden"))
                })
            }), document.body && document.body.classList.toggle("cl-cart-has-items", count > 0)
        }

        function findCartLineQuantity(cart, lineKey, variantId) {
            if (!cart || !Array.isArray(cart.items)) return null;
            const key = String(lineKey || "").trim(),
                variant = String(variantId || "").replace(/\D/g, ""),
                line = cart.items.find(function(item) {
                    const itemKey = String(item && item.key || "").trim(),
                        itemVariant = String(item && (item.variant_id || item.id) || "").replace(/\D/g, "");
                    return key && itemKey === key || variant && itemVariant === variant
                });
            if (!line) return null;
            const qty = Number(line.quantity || 0);
            return Number.isFinite(qty) ? qty : null
        }

        function dispatchConsumerliteCartSync(eventName, detail, cart) {
            try {
                window.dispatchEvent(new CustomEvent("consumerlite:cart:sync", {
                    detail: Object.assign({
                        cart: cart || null
                    }, detail || {})
                })), window.dispatchEvent(new CustomEvent(eventName || "consumerlite:cart:change", {
                    detail: Object.assign({
                        cart: cart || null
                    }, detail || {})
                })), document.dispatchEvent(new CustomEvent("cart:refresh")), document.dispatchEvent(new CustomEvent("cart:updated", {
                    detail: {
                        cart: cart || null
                    }
                }))
            } catch {}
        }
        async function changeCartQuantity(product, variantId, lineKey, quantity) {
            const safeId = String(lineKey || variantId || "").trim();
            if (!safeId) throw new Error("missing_cart_line");
            const response = await fetch(shopifyAjaxPath("cart/change.js"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    id: safeId,
                    quantity: Math.max(0, Number(quantity) || 0)
                })
            });
            if (!response.ok) throw new Error("cart_change_failed");
            const cart = await response.json().catch(function() {
                return {}
            });
            return updateThemeCartCount(cart), cart
        }

        function replaceQuantityControlWithButton(control, product) {
            const nextButton = createProductCartButton(product || {});
            control && control.parentNode && control.parentNode.replaceChild(nextButton, control)
        }

        function convertElementToViewPieceAction(element, product) {
            const href = safeUrl(product && product.url);
            element && (element.classList && (element.classList.remove("is-added"), element.classList.add("requires-selection")), element.textContent = uiText("VIEW_FULL_DETAILS") || "View full details", "disabled" in element && (element.disabled = !1), element.onclick = function(ev) {
                ev.preventDefault(), ev.stopPropagation(), href && (window.location.href = href)
            })
        }

        function renderCartQuantityControls(product, button, variantId, addPayload) {
            if (!button || !button.parentNode) return;
            let quantity = Number(addPayload && addPayload.quantity ? addPayload.quantity : 1) || 1;
            const lineKey = String(addPayload && (addPayload.key || addPayload.id) || variantId || "").trim(),
                control = document.createElement("div");
            control.className = "cl-card-cart-control";
            const status = document.createElement("div");
            status.className = "cl-card-cart-status", status.textContent = uiText("ADDED_TO_CART") || "Added", control.appendChild(status);
            const stepper = document.createElement("div");
            stepper.className = "cl-card-cart-stepper", stepper.setAttribute("aria-label", "Cart quantity");
            const minus = document.createElement("button");
            minus.type = "button", minus.textContent = "\u2212", minus.setAttribute("aria-label", "Decrease quantity");
            const qty = document.createElement("span");
            qty.className = "cl-card-cart-qty", qty.textContent = String(quantity);
            const plus = document.createElement("button");
            plus.type = "button", plus.textContent = "+", plus.setAttribute("aria-label", "Increase quantity");

            function setBusy(isBusy) {
                minus.disabled = !!isBusy, plus.disabled = !!isBusy
            }
            async function updateQuantity(nextQuantity) {
                const cleanNext = Math.max(0, Number(nextQuantity) || 0);
                setBusy(!0);
                try {
                    const cart = await changeCartQuantity(product || {}, variantId, lineKey, cleanNext),
                        syncedQuantity = findCartLineQuantity(cart, lineKey, variantId);
                    if (quantity = syncedQuantity === null ? cleanNext : syncedQuantity, trackConsumerliteChatEvent(quantity > 0 ? "cart_quantity_changed" : "cart_item_removed", {
                            handle: product && product.handle ? String(product.handle) : "",
                            variantId,
                            quantity
                        }), dispatchConsumerliteCartSync(quantity > 0 ? "consumerlite:cart:quantity" : "consumerlite:cart:remove", {
                            product: product || {},
                            variantId,
                            quantity
                        }, cart), quantity <= 0) {
                        replaceQuantityControlWithButton(control, product || {});
                        return
                    }
                    qty.textContent = String(quantity)
                } catch {
                    status.textContent = uiText("ADD_TO_CART_ERROR") || "View piece", trackConsumerliteChatEvent("cart_quantity_update_failed", {
                        handle: product && product.handle ? String(product.handle) : "",
                        variantId
                    }), convertElementToViewPieceAction(control, product || {})
                } finally {
                    setBusy(!1)
                }
            }
            minus.addEventListener("click", function(ev) {
                ev.preventDefault(), ev.stopPropagation(), updateQuantity(quantity - 1)
            }), plus.addEventListener("click", function(ev) {
                ev.preventDefault(), ev.stopPropagation(), updateQuantity(quantity + 1)
            }), stepper.appendChild(minus), stepper.appendChild(qty), stepper.appendChild(plus), control.appendChild(stepper), button.parentNode.replaceChild(control, button)
        }
        async function addProductCardToCart(product, button) {
            const variantId = productCartVariantId(product || {}),
                href = safeUrl(product && product.url),
                prepared = consumerliteAtelierRecordForProduct(product || {});
            if (productRequiresVariantSelection(product || {}) && prepared && prepared.variant && prepared.variant.id) {
                const originalText2 = button ? button.textContent : "";
                button && (button.disabled = !0, button.textContent = uiText("CHECKING_AVAILABILITY"));
                try {
                    const resolved = await requestConsumerliteProductOptions(product.handle, prepared.selectedOptions || [], "resolve"),
                        liveVariant = resolved && resolved.selectedVariant;
                    if (!liveVariant || liveVariant.availableForSale === !1 || !liveVariant.id) throw new Error(uiText("UNAVAILABLE"));
                    const record = {
                        product: resolved.product || product,
                        variant: liveVariant,
                        selectedOptions: Array.isArray(prepared.selectedOptions) ? prepared.selectedOptions : [],
                        checkedAt: Date.now()
                    };
                    registerTrustedResolvedVariant(record), await addResolvedVariantToCart(product || {}, liveVariant, record.selectedOptions, button), renderConsumerliteAtelierWorkspace()
                } catch {
                    button && (button.disabled = !1, button.textContent = originalText2 || uiText("SELECT_OPTIONS")), openConsumerliteVariantConcierge(product || {}, {
                        mode: "add",
                        triggerButton: button
                    })
                }
                return
            }
            if (variantId && !isTrustedProductCardVariant(product || {}, variantId)) {
                trackConsumerliteChatEvent("add_to_cart_untrusted_variant_blocked", {
                    handle: product && product.handle ? String(product.handle) : "",
                    variantId
                }), button && (button.textContent = uiText("SELECT_OPTIONS") || "Select options", button.classList.add("requires-selection")), openConsumerliteVariantConcierge(product || {}, {
                    mode: "add",
                    triggerButton: button
                });
                return
            }
            if (productRequiresVariantSelection(product || {}) || !variantId) {
                trackConsumerliteChatEvent("add_to_cart_variant_selection_required", {
                    handle: product && product.handle ? String(product.handle) : "",
                    title: product && product.title ? String(product.title).slice(0, 80) : "",
                    variantCount: Number(product && product.variantCount ? product.variantCount : 0),
                    availableVariantCount: Number(product && product.availableVariantCount ? product.availableVariantCount : 0)
                }), button && (button.textContent = uiText("SELECT_OPTIONS") || "Select options", button.classList.add("requires-selection")), openConsumerliteVariantConcierge(product || {}, {
                    mode: "add",
                    triggerButton: button
                });
                return
            }
            const originalText = button ? button.textContent : "";
            button && (button.disabled = !0, button.textContent = uiText("ADDING_TO_CART") || "Adding\u2026");
            try {
                const response = await fetch(shopifyAjaxPath("cart/add.js"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                });
                if (!response.ok) throw new Error("cart_add_failed");
                const addPayload = await response.json().catch(function() {
                    return {
                        quantity: 1
                    }
                });
                trackConsumerliteChatEvent("add_to_cart_clicked", {
                    handle: product && product.handle ? String(product.handle) : "",
                    title: product && product.title ? String(product.title).slice(0, 80) : "",
                    variantId
                });
                const cart = await fetchConsumerliteCart();
                cart && updateThemeCartCount(cart);
                const syncedQuantity = findCartLineQuantity(cart, addPayload && addPayload.key, variantId),
                    safeAddPayload = Object.assign({}, addPayload || {}, {
                        quantity: syncedQuantity === null ? addPayload && addPayload.quantity ? addPayload.quantity : 1 : syncedQuantity
                    });
                button && (button.disabled = !1, button.textContent = uiText("ADDED_TO_CART") || "Added", button.classList.add("is-added"), renderCartQuantityControls(product || {}, button, variantId, safeAddPayload)), dispatchConsumerliteCartSync("consumerlite:cart:add", {
                    product: product || {},
                    variantId,
                    quantity: safeAddPayload.quantity || 1
                }, cart)
            } catch {
                trackConsumerliteChatEvent("add_to_cart_failed", {
                    handle: product && product.handle ? String(product.handle) : "",
                    variantId
                }), button && convertElementToViewPieceAction(button, product || {})
            }
        }

        function productCanDirectAddFromCard(product) {
            const variantId = productCartVariantId(product || {});
            return !!(variantId && isTrustedProductCardVariant(product || {}, variantId))
        }

        function visibleProductsCanShopFullLook(products) {
            const list = Array.isArray(products) ? products.filter(Boolean).slice(0, 6) : [];
            return list.length < 2 ? !1 : list.every(productCanDirectAddFromCard)
        }
        async function addFullLookToCart(products, button) {
            const list = Array.isArray(products) ? products.filter(Boolean).slice(0, 6) : [],
                items = list.map(function(product) {
                    return {
                        product,
                        id: productCartVariantId(product || {})
                    }
                }).filter(function(item) {
                    return item.id && productCanDirectAddFromCard(item.product || {})
                });
            if (items.length !== list.length || !items.length) return button && (button.textContent = uiText("SHOP_FULL_LOOK_ERROR") || "Choose options", button.disabled = !1), !1;
            const originalText = button ? button.textContent : "";
            button && (button.disabled = !0, button.textContent = uiText("SHOPPING_FULL_LOOK") || "Adding look\u2026");
            try {
                const response = await fetch(shopifyAjaxPath("cart/add.js"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        items: items.map(function(item) {
                            return {
                                id: item.id,
                                quantity: 1
                            }
                        })
                    })
                });
                if (!response.ok) throw new Error("full_look_add_failed");
                await response.json().catch(function() {
                    return {}
                });
                const cart = await fetchConsumerliteCart();
                return cart && updateThemeCartCount(cart), trackConsumerliteChatEvent("shop_full_look_clicked", {
                    productCount: items.length
                }), dispatchConsumerliteCartSync("consumerlite:cart:full-look-add", {
                    productCount: items.length
                }, cart), button && (button.disabled = !1, button.classList.add("is-added"), button.textContent = uiText("SHOP_FULL_LOOK_ADDED") || "Look added"), !0
            } catch {
                return trackConsumerliteChatEvent("shop_full_look_failed", {
                    productCount: items.length
                }), button && (button.disabled = !1, button.textContent = originalText || uiText("SHOP_FULL_LOOK") || "Shop full look"), !1
            }
        }

        function addShopFullLookAction(products, options) {
            const list = Array.isArray(products) ? products.filter(Boolean).slice(0, 6) : [];
            if (list.length < 2) return;
            const canDirectAdd = visibleProductsCanShopFullLook(list),
                wrap = document.createElement("div");
            wrap.className = "cl-full-look-actions";
            const button = document.createElement("button");
            if (button.type = "button", button.className = "cl-shop-full-look", button.textContent = canDirectAdd ? uiText("SHOP_FULL_LOOK") || "Shop full look" : uiText("PREPARE_LOOK"), button.setAttribute("aria-label", button.textContent), button.addEventListener("click", function(ev) {
                    ev.preventDefault(), ev.stopPropagation(), canDirectAdd ? addFullLookToCart(list, button) : openConsumerliteLookConcierge(list, button)
                }), wrap.appendChild(button), !canDirectAdd) {
                const note = document.createElement("p");
                note.className = "cl-full-look-note", note.textContent = "Select each piece inside Tellus, then add the complete look together.", wrap.appendChild(note)
            }
            body.appendChild(wrap), (!options || options.persist !== !1) && addUiItem({
                type: "fullLookAction",
                products: list
            })
        }

        function addProductCards(products, options) {
            if (!Array.isArray(products) || products.length === 0) return;
            const grid = document.createElement("div");
            grid.className = "cl-cards", products.slice(0, 6).forEach(function(p) {
                const href = safeUrl(p && p.url);
                if (!href) return;
                const card = document.createElement("article");
                card.className = "cl-card";
                const mediaLink = document.createElement("a");
                mediaLink.className = "cl-card-media-link", mediaLink.href = href, mediaLink.setAttribute("aria-label", String(p && p.title || uiText("PRODUCT"))), mediaLink.addEventListener("click", function() {
                    trackConsumerliteChatEvent("product_clicked", {
                        handle: p && p.handle ? String(p.handle) : "",
                        title: p && p.title ? String(p.title).slice(0, 80) : "",
                        url: href,
                        source: "product_image"
                    })
                });
                const img = document.createElement("img");
                img.className = "cl-card-img", img.dataset.productHandle = String(p && p.handle || "");
                const preparedCardVariant = consumerliteAtelierRecordForProduct(p || {}),
                    preparedCardVariantImage = preparedCardVariant && preparedCardVariant.variant && preparedCardVariant.variant.image && preparedCardVariant.variant.image.url;
                img.alt = p && (p.imageAlt || p.title) ? p.imageAlt || p.title : uiText("PRODUCT"), img.loading = "lazy", img.decoding = "async", img.referrerPolicy = "no-referrer", img.src = safeUrl(consumerlitePresentedProductImage(p || {})) || "", mediaLink.appendChild(img), preparedCardVariantImage || hydrateRecommendedVariantImageForCard(p || {}, img), card.appendChild(mediaLink);
                const cardBody = document.createElement("div");
                cardBody.className = "cl-card-body", cardBody.setAttribute("dir", getLanguageDirection());
                const slotLabel = formatProductSlotLabel(p && p.outfitSlot ? p.outfitSlot : "", p);
                if (slotLabel) {
                    const badge = document.createElement("div");
                    badge.className = "cl-card-badge", badge.textContent = slotLabel, cardBody.appendChild(badge)
                }
                const titleLink = document.createElement("a");
                titleLink.className = "cl-card-title-link", titleLink.href = href;
                const title = document.createElement("p");
                title.className = "cl-card-title", title.textContent = p && p.title ? String(p.title) : uiText("PRODUCT"), titleLink.appendChild(title), titleLink.addEventListener("click", function() {
                    trackConsumerliteChatEvent("product_clicked", {
                        handle: p && p.handle ? String(p.handle) : "",
                        title: p && p.title ? String(p.title).slice(0, 80) : "",
                        url: href,
                        source: "product_title"
                    })
                }), cardBody.appendChild(titleLink);
                const price = document.createElement("p");
                price.className = "cl-card-price", price.textContent = p && p.price ? String(p.price) : "", cardBody.appendChild(price);
                const selectionSummary = document.createElement("p");
                selectionSummary.className = "cl-card-selection-summary", selectionSummary.dataset.productHandle = String(p && p.handle || "");
                const selectedRecord = consumerliteAtelierRecordForProduct(p || {}),
                    selectedText = selectedRecord ? formatVariantSelection(selectedRecord.selectedOptions || []) : "";
                selectionSummary.textContent = selectedText ? uiText("SELECTED_OPTIONS") + ": " + selectedText : "", cardBody.appendChild(selectionSummary);
                const secondaryActions = document.createElement("div");
                secondaryActions.className = "cl-card-secondary-actions";
                const whyButton = document.createElement("button");
                whyButton.type = "button", whyButton.className = "cl-card-why", whyButton.textContent = uiText("WHY_THIS_PIECE"), whyButton.addEventListener("click", function() {
                    openConsumerliteStylistInsight(p || {}, whyButton)
                });
                const atelierButton = document.createElement("button");
                atelierButton.type = "button", atelierButton.className = "cl-card-atelier", atelierButton.dataset.productHandle = String(p && p.handle || ""), atelierButton.hidden = !consumerliteMemberAtelierState.authenticated, atelierButton.textContent = consumerliteMemberAtelierHasHandle(p && p.handle) ? uiText("SAVED_TO_MY_ATELIER") : uiText("ADD_TO_MY_ATELIER"), atelierButton.addEventListener("click", function() {
                    saveConsumerliteProductToMyAtelier(p || {}, atelierButton)
                }), secondaryActions.appendChild(whyButton), secondaryActions.appendChild(atelierButton), cardBody.appendChild(secondaryActions), card.appendChild(cardBody), registerTrustedCartVariantFromProduct(p || {});
                if (p && p.handle) {
                    const editButton = document.createElement('button');
                    editButton.type = 'button';editButton.className = 'cl-card-why cl-card-edit';
                    editButton.dataset.productHandle = String(p.handle);editButton.dataset.productTitle=String(p.title||uiText('PRODUCT'));
                    editButton.style.width = '100%';
                    const selected = (consumerliteAtelierState.currentLook || []).some(item=>item.handle === p.handle);
                    editButton.textContent = consumerliteEditActionText(selected);
                    editButton.setAttribute('aria-label',consumerliteEditActionText(selected)+': '+String(p.title||uiText('PRODUCT')));
                    editButton.setAttribute("aria-pressed", selected ? "true" : "false");
                    editButton.disabled = consumerlitePendingSendCount > 0;
                    editButton.addEventListener('click',function(ev) {ev.preventDefault();ev.stopPropagation();consumerliteActivateEditCard(p);});
                    cardBody.appendChild(editButton);
                }
                const cartButton = createProductCartButton(p);
                card.appendChild(cartButton), grid.appendChild(card)
            }), body.appendChild(grid), refreshConsumerliteMemberAtelierControls(), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                type: "products",
                products: products.slice(0, 6)
            })
        }

        function collectionHandleFromUrl(url) {
            const href = safeUrl(url);
            if (!href) return "";
            try {
                const parts = new URL(href, window.location.origin).pathname.split("/").filter(Boolean),
                    index = parts.indexOf("collections");
                if (index >= 0 && parts[index + 1]) return String(parts[index + 1]).trim()
            } catch {}
            return ""
        }

        function openCollectionInsideChat(collectionCard) {
            if (!collectionCard || typeof collectionCard != "object") return;
            const title = String(collectionCard.title || uiText("COLLECTION")).trim(),
                handle = String(collectionCard.handle || collectionHandleFromUrl(collectionCard.url) || "").trim();
            if (!title && !handle) return;
            const display = title ? "Open " + title : "Open collection",
                prompt = handle ? "Open collection in chat: " + handle : "Show products from " + title + " collection";
            input.value = prompt, doSend({
                displayText: display,
                sendText: prompt
            })
        }

        function addCollectionCards(collectionCards, options) {
            if (!Array.isArray(collectionCards) || collectionCards.length === 0) return;
            const grid = document.createElement("div");
            grid.className = "cl-cards", collectionCards.slice(0, 12).forEach(function(c) {
                const href = safeUrl(c && c.url);
                if (!href) return;
                const a = document.createElement("a");
                a.className = "cl-card", a.href = href, a.addEventListener("click", function(ev) {
                    ev.preventDefault(), !(ev.defaultPrevented && ev.type !== "click") && (trackConsumerliteChatEvent("collection_opened", {
                        handle: c && c.handle ? String(c.handle) : collectionHandleFromUrl(c && c.url),
                        source: "collection_card"
                    }), openCollectionInsideChat(c))
                });
                const img = document.createElement("img");
                img.className = "cl-card-img", img.alt = c && (c.imageAlt || c.title) ? c.imageAlt || c.title : uiText("COLLECTION"), img.loading = "lazy", img.decoding = "async", img.referrerPolicy = "no-referrer";
                const src = c && c.image ? String(c.image) : "";
                img.src = safeUrl(src) || "", a.appendChild(img);
                const cardBody = document.createElement("div");
                cardBody.className = "cl-card-body", cardBody.setAttribute("dir", getLanguageDirection());
                const title = document.createElement("p");
                title.className = "cl-card-title", title.textContent = c && c.title ? String(c.title) : uiText("COLLECTION"), cardBody.appendChild(title);
                const action = document.createElement("div");
                action.className = "cl-card-action", action.textContent = uiText("VIEW_COLLECTION"), cardBody.appendChild(action), a.appendChild(cardBody), grid.appendChild(a)
            }), body.appendChild(grid), followConsumerliteConversation(!1, !1), (!options || options.persist !== !1) && addUiItem({
                type: "collections",
                collectionCards: collectionCards.slice(0, 12)
            })
        }

        function restoreChatBodyFromSession(options) {
            body.setAttribute("data-tellus-fresh-start-home", conversationContext.tellusFreshStartHome === true ? "true" : "false");
            const opts = options && typeof options == "object" ? options : {};
            if (!body.dataset.inited) {
                reconcileConsumerliteOpeningGreeting();
                if (body.dataset.inited = "1", !conversationUiItems.length) {
                    if (opts.suppressIntro === !0) return;
                    const opening = consumerliteOpeningGreetingText();
                    addMsg("ai", opening), pushHistory("assistant", opening), addSuggestions(localizeSuggestionsForUi(getIntroSuggestions()));
                    return
                }
                conversationUiItems.forEach(function(item) {
                    if (!(!item || typeof item != "object")) {
                        if (item.type === "msg") {
                            addMsg(item.role === "user" ? "user" : "ai", item.text || "", {
                                persist: !1
                            });
                            return
                        }
                        if (item.type === "products") {
                            addProductCards(item.products || [], {
                                persist: !1,
                                updateAtelier: !1
                            });
                            return
                        }
                        if (item.type === "collections") {
                            addCollectionCards(item.collectionCards || [], {
                                persist: !1
                            });
                            return
                        }
                        if (item.type === "cta") {
                            addCta(item.cta || null, {
                                persist: !1
                            });
                            return
                        }
                        if (item.type === "anchor_note") {
                            addAnchorNote(item.text || "", {
                                persist: !1
                            });
                            return
                        }
                        item.type === "suggestions" && addSuggestions(item.suggestions || [], {
                            persist: !1
                        })
                    }
                }), renderConsumerliteAtelierWorkspace(), followConsumerliteConversation(!0, !1)
            }
        }

        function open(options) {
            if (consumerliteOrderRoot) { consumerliteOrderRoot.hidden = true; recheckConsumerliteOrderSession(); }
            const opts = options && typeof options == "object" ? options : {};
            panel.style.display = "flex", lastPersistedPanelOpen = !0, restoreChatBodyFromSession(opts), renderConsumerliteAtelierWorkspace(), loadConsumerliteMemberAtelier(), persistChatSession();
            if (!consumerlitePurchaseRoot && conversationContext.tellusPurchaseHelp) {
                const savedPurchase = conversationContext.tellusPurchaseHelp;
                const product = sanitizeConsumerliteAtelierProduct(savedPurchase.product);
                consumerlitePurchase = {stage:product ? "confirm_product" : "discover",product,selectedOptions:Array.isArray(savedPurchase.selectedOptions) ? savedPurchase.selectedOptions : []};
                const savedHandles = Array.isArray(savedPurchase.choiceHandles) ? savedPurchase.choiceHandles.slice(0,6) : [];
                const candidates = consumerlitePurchaseCandidates();
                const savedChoices = savedHandles.length ? savedHandles.map(handle=>candidates.find(candidate=>candidate.handle===handle)).filter(Boolean) : candidates;
                if (savedPurchase.stage === "choose_product" && savedChoices.length) consumerlitePurchaseChooseProducts(savedChoices,"Which piece would you like to continue with? Choose its photo and options below.");
                else if (product) consumerlitePurchaseSay("Would you like to continue with " + product.title + "? I’ll check its options again before adding anything.", [
                    {label:"Continue choosing options",run:()=>consumerlitePurchasePrepare(product,consumerlitePurchase.selectedOptions)},
                    {label:"Review my bag",run:()=>consumerlitePurchaseBag(false)}
                ]);
                else consumerlitePurchaseSay("Would you like to continue shopping?", [
                    {label:"Help me choose",run:consumerlitePurchaseFind},
                    {label:"Review my bag",run:()=>consumerlitePurchaseBag(false)}
                ]);
            }
            try { if (window.sessionStorage.getItem("consumerlite_tellus_resume_orders_v1") === "true") { window.sessionStorage.removeItem("consumerlite_tellus_resume_orders_v1"); handleConsumerliteOrderRequest("Show my orders"); } } catch {}
        }

        function close() {
            if (consumerliteOrderRoot) consumerliteOrderRoot.hidden = true;
            panel.contains(document.activeElement) && document.activeElement.blur(), closeConsumerliteCommerceOverlay(), panel.style.display = "none", lastPersistedPanelOpen = !1, persistChatSession()
        }

        function toggle() {
            panel.style.display === "flex" ? close() : open()
        }
        btn.onclick = toggle, closeBtn.onclick = close;
        async function openConsumerliteAtelierFromPublic(returnFocus) {
            return open(), await loadConsumerliteMemberAtelier(), consumerliteMemberAtelierState.authenticated ? (openConsumerliteMyAtelier(returnFocus || btn), !0) : !1
        }

        function normalizeConsumerliteAccountAtelierItem(detail) {
            const source = detail && typeof detail == "object" ? detail : {},
                item = source.item && typeof source.item == "object" ? source.item : source,
                productSource = item.product && typeof item.product == "object" ? item.product : item,
                product = sanitizeConsumerliteAtelierProduct(productSource || {});
            return product ? {
                product,
                selectedOptions: Array.isArray(item.selectedOptions) ? item.selectedOptions : [],
                variantRecord: item.variantRecord && typeof item.variantRecord == "object" ? item.variantRecord : null
            } : null
        }

        function styleConsumerliteAtelierItemFromPublic(detail) {
            const item = normalizeConsumerliteAccountAtelierItem(detail);
            if (!item || consumerlitePendingSendCount) return false;
            open();
            resetTrackingActivationContextState(conversationContext);
            delete conversationContext.tellusConversationState;
            conversationContext.tellusFreshStartHome = false;
            conversationContext.memberAtelierAnchor = item.product;
            const mode = detail && detail.mode;
            return doSend({
                displayText: (mode === "another_way" ? "Style another way" : mode === "complete_look" ? "Complete the look" : uiText("STYLE_AROUND_THIS")) + ": " + item.product.title,
                sendText: mode === "another_way" ? "Style this product another way with different companion pieces" : "Style this product",
                source: "member_atelier_account"
            });
        }

        function consumerliteSavedStylingContext(source) {
            const state = source && typeof source === "object" ? source : {};
            const budget = state.budget && Number(state.budget.max) > 0 ? {
                max: Number(state.budget.max), currency: /^[A-Z]{3}$/.test(state.budget.currency || "") ? state.budget.currency : "USD",
                scope: state.budget.scope === "item" ? "item" : "outfit"
            } : null;
            return {audience: ["MEN","WOMEN","KIDS_BABY"].includes(state.audience) ? state.audience : "UNKNOWN",
                occasion: String(state.occasion || "").slice(0,120), budget,
                exclusions: (Array.isArray(state.exclusions) ? state.exclusions : []).filter(x=>typeof x==="string").slice(0,20),
                styles: (Array.isArray(state.styles) ? state.styles : []).filter(x=>typeof x==="string").slice(0,12)};
        }

        async function continueConsumerliteAtelierLookFromPublic(detail) {
            if (consumerlitePendingSendCount) return false;
            const source = detail && typeof detail === "object" ? detail : {};
            const requested = Array.isArray(source.products) && source.products.length ? source.products :
                Array.isArray(source.items) ? source.items.map(item=>({...item.product,selectedOptions:item.selectedOptions || item.product?.selectedOptions || []})) : [];
            let products = sanitizeConsumerliteAtelierLook(requested);
            if (!products.length && Array.isArray(source.productHandles)) {
                // Older recent entries contain handles only. Resolve their own products,
                // never substitute whatever happens to be in the active chat.
                const resolved = await Promise.all(source.productHandles.slice(0,6).map(async handle=>{
                    if (!/^[a-z0-9][a-z0-9-]*$/.test(String(handle))) return null;
                    try { const result=await requestConsumerliteProductOptions(handle,[],"options"); return result?.product || null; } catch { return null; }
                }));
                products = sanitizeConsumerliteAtelierLook(resolved.filter(Boolean));
                if (products.length !== new Set(source.productHandles.slice(0,6)).size) products=[];
            }
            if (!products.length || consumerlitePendingSendCount) {
                open(); addMsg("ai","I couldn’t restore the products in that saved look. Your current edit is unchanged. Refresh Atelier and try again."); return false;
            }
            const styling=consumerliteSavedStylingContext(source.stylingContext || source);
            const retained={};
            for(const key of ["customerIdentityToken","languageCode","replyLanguageCode","explicitLanguagePreference","languagePreferenceSource","languageDirection"]) {
                if(Object.prototype.hasOwnProperty.call(conversationContext,key)) retained[key]=conversationContext[key];
            }
            Object.keys(conversationContext).forEach(key=>delete conversationContext[key]);
            Object.assign(conversationContext,retained,{lastAudience:styling.audience,trackingPurchaseAnchorCleared:true,trackingPurchaseAnchorActive:false,tellusFreshStartHome:false});
            const title=String(source.title || "Saved Tellus look").slice(0,180);
            const request="Continue my saved outfit"+(styling.occasion?" for "+styling.occasion:"");
            conversationContext.tellusConversationState={version:"CL-TELLUS-CONVERSATION-V53.7.0",revision:0,activeTask:"outfit",originalRequest:request,routingRequest:request,
                ...styling,anchor:{category:"",color:"",material:"",label:"",source:""},garmentRequests:[],pendingQuestion:null};
            conversationContext.currentLookRequest=request;
            conversationContext.originalRequest=request;
            if(source.weatherContext && typeof source.weatherContext==="object") conversationContext.weatherContext={...source.weatherContext,isVerified:false};
            consumerliteSelectedVariants.clear(); trustedCartVariantIds.clear();
            products=products.map(product=>({...product,canAddToCart:false,requiresVariantSelection:true,variantId:"",cartVariantId:""}));
            open(); closeConsumerliteCommerceOverlay();
            clearConsumerlitePrivateOrders();
            conversationHistory.splice(0,conversationHistory.length);
            addMsg("user",request+": "+title); pushHistory("user",request);
            consumerliteCommitEdit(products,"Restored "+title+". Choose a piece to change, or tell me how you’d like to refine the look.");
            const text="I’ve opened "+title+" with its saved pieces. What would you like to change?";
            addMsg("ai",text); pushHistory("assistant",text);
            addSuggestions([{label:"More casual",prompt:"More casual"},{label:"Change footwear",prompt:"Change footwear"}]);
            persistChatSession(); return true;
        }

        async function saveConsumerliteCurrentLookFromPublic(detail) {
            if(consumerlitePendingSendCount) throw new Error("Wait for the current styling response before saving.");
            const products=sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook || []);
            if(!products.length) throw new Error("Create or restore a Tellus Edit before saving it.");
            const loaded=await requestConsumerliteMemberAtelier("load",{});
            const id="look_"+Date.now().toString(36)+"_"+Math.random().toString(36).slice(2,10);
            const result=await requestConsumerliteMemberAtelier("save_look",{expectedRevision:Number(loaded.revision || 0),mutationId:id,
                look:{id,title:String(detail?.title || "Saved Tellus Edit").slice(0,60),sourceType:"tellus_edit",products,items:products.map(product=>{const record=consumerliteSelectedVariants.get(product.handle);return {product,selectedOptions:record?.selectedOptions || product.selectedOptions || [],variantRecord:record || null};}),
                    stylingContext:consumerliteSavedStylingContext(conversationContext.tellusConversationState),
                    occasion:conversationContext.tellusConversationState?.occasion || "",createdAt:Date.now(),updatedAt:Date.now()}});
            window.dispatchEvent(new CustomEvent("consumerlite:atelier:refresh")); return result;
        }

        function selectConsumerliteAtelierItemOptionsFromPublic(detail, returnFocus) {
            const item = normalizeConsumerliteAccountAtelierItem(detail);
            return item ? (open(), openConsumerliteVariantConcierge(item.product, {
                mode: "select_only",
                triggerButton: returnFocus || null,
                initialSelectedOptions: item.selectedOptions,
                onSelect: async function(record) {
                    try {
                        const data = await requestConsumerliteMemberAtelier("add_item", {
                            item: {
                                product: sanitizeConsumerliteAtelierProduct(record && record.product || item.product),
                                variantRecord: record || null,
                                selectedOptions: record && Array.isArray(record.selectedOptions) ? record.selectedOptions : []
                            }
                        });
                        consumerliteMemberAtelierState.items = Array.isArray(data.items) ? data.items : [], consumerliteMemberAtelierState.itemCount = Number(data.itemCount || consumerliteMemberAtelierState.items.length), consumerliteMemberAtelierState.updatedAt = Number(data.updatedAt || Date.now()), refreshConsumerliteMemberAtelierControls(), renderConsumerliteAtelierWorkspace(), publishConsumerliteMemberAtelierState()
                    } catch (error) {
                        trackConsumerliteChatEvent("member_atelier_variant_save_failed", {
                            handle: String(item.product.handle || ""),
                            code: String(error && error.code || "")
                        })
                    }
                }
            }), !0) : !1
        }
        async function addConsumerliteAtelierItemToBagFromPublic(detail, triggerButton) {
            const item = normalizeConsumerliteAccountAtelierItem(detail);
            if (!item) return !1;
            if (!Array.isArray(item.selectedOptions) || !item.selectedOptions.length) return selectConsumerliteAtelierItemOptionsFromPublic(item, triggerButton || null);
            try {
                triggerButton && (triggerButton.disabled = !0, triggerButton.textContent = uiText("CHECKING_AVAILABILITY"));
                const resolved = await requestConsumerliteProductOptions(item.product.handle, item.selectedOptions, "resolve"),
                    liveVariant = resolved && resolved.selectedVariant;
                if (!liveVariant || liveVariant.availableForSale === !1 || !liveVariant.id) throw new Error(uiText("UNAVAILABLE"));
                const record = {
                    product: resolved.product || item.product,
                    variant: liveVariant,
                    selectedOptions: item.selectedOptions,
                    checkedAt: Date.now()
                };
                return registerTrustedResolvedVariant(record), await addResolvedVariantToCart(item.product, liveVariant, item.selectedOptions, triggerButton || null), !0
            } catch (error) {
                throw trackConsumerliteChatEvent("member_atelier_add_to_bag_failed", {
                    handle: String(item.product.handle || ""),
                    code: String(error && error.code || "")
                }), error
            } finally {
                triggerButton && (triggerButton.disabled = !1)
            }
        }
        window.ConsumerliteChat = {
            open,
            close,
            toggle,
            openAtelier: openConsumerliteAtelierFromPublic,
            styleAroundAtelierItem: styleConsumerliteAtelierItemFromPublic,
            continueRecentAtelierStyling: continueConsumerliteAtelierLookFromPublic,
            saveCurrentLookToAtelier: saveConsumerliteCurrentLookFromPublic,
            styleTrackingPurchase: styleConsumerliteTrackingPurchaseFromPublic,
            selectAtelierItemOptions: selectConsumerliteAtelierItemOptionsFromPublic,
            addAtelierItemToBag: addConsumerliteAtelierItemToBagFromPublic,
            refreshAtelier: loadConsumerliteMemberAtelier,
            getCurrentEditContext: function() {
                return {
                    currentLookProducts: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook || []),
                    previousLookProducts: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.previousLook || []),
                    atelierLookState: consumerliteAtelierStatePayload(),
                    atelierRevision: Number(consumerliteAtelierState.revision || 0)
                };
            },
            getAtelierState: function() {
                return {
                    status: String(consumerliteMemberAtelierState.status || "unknown"),
                    authenticated: !!consumerliteMemberAtelierState.authenticated,
                    verifiedGreetingIdentityAvailable: !!(consumerliteMemberAtelierState.chatIdentityToken && Number(consumerliteMemberAtelierState.chatIdentityExpiresAt || 0) > Date.now()),
                    itemCount: Number(consumerliteMemberAtelierState.itemCount || 0),
                    items: Array.isArray(consumerliteMemberAtelierState.items) ? consumerliteMemberAtelierState.items.slice() : [],
                    updatedAt: Number(consumerliteMemberAtelierState.updatedAt || 0)
                }
            },
            reset: resetConsumerliteConversation,
            version: CONSUMERLITE_CHAT_WIDGET_VERSION,
            storageKey: CHAT_SESSION_STORAGE_KEY
        }, window.openConsumerliteChat = open, window.closeConsumerliteChat = close, window.addEventListener("consumerlite:atelier:open", function(event) {
            openConsumerliteAtelierFromPublic(event && event.detail && event.detail.returnFocus || null)
        }), window.addEventListener("consumerlite:atelier:style-item", function(event) {
            styleConsumerliteAtelierItemFromPublic(event && event.detail || {})
        }), window.addEventListener("consumerlite:atelier:select-options", function(event) {
            selectConsumerliteAtelierItemOptionsFromPublic(event && event.detail || {}, event && event.detail && event.detail.returnFocus || null)
        }), window.addEventListener("consumerlite:atelier:add-to-bag", function(event) {
            addConsumerliteAtelierItemToBagFromPublic(event && event.detail || {}, event && event.detail && event.detail.returnFocus || null)
        }), window.addEventListener("consumerlite:atelier:continue-recent", function(event) {
            continueConsumerliteAtelierLookFromPublic(event && event.detail || {}).catch(function(){ addMsg("ai","That saved look could not be opened. Please try again."); });
        }), window.addEventListener("consumerlite:atelier:save-current-look", function(event) {
            saveConsumerliteCurrentLookFromPublic(event && event.detail || {}).catch(function(error){ addMsg("ai",error.message || "That look could not be saved."); });
        }), window.addEventListener("consumerlite:atelier:refresh", function() {
            loadConsumerliteMemberAtelier()
        });

        function isConsumerliteChatTrigger(element) {
            if (!element) return !1;
            if (element.closest("[data-consumerlite-chat-open]")) return !0;
            const link = element.closest("a");
            if (!link) return !1;
            const rawHref = String(link.getAttribute("href") || "").trim();
            if (!rawHref) return !1;
            const lowerHref = rawHref.toLowerCase();
            if (lowerHref === "#consumerlite-live-chat" || lowerHref === "#live-chat" || lowerHref === "#chat" || lowerHref === "/#consumerlite-live-chat" || lowerHref === "/#live-chat" || lowerHref === "/#chat") return !0;
            try {
                const url = new URL(rawHref, window.location.origin),
                    sameSite = url.origin === window.location.origin,
                    liveChatHash = url.hash === "#consumerlite-live-chat" || url.hash === "#live-chat" || url.hash === "#chat";
                return sameSite && liveChatHash
            } catch {
                return !1
            }
        }
        document.addEventListener("click", function(event) {
            if (isConsumerliteChatTrigger(event.target)) {
                event.preventDefault(), open();
                try {
                    window.history && window.history.replaceState && window.history.replaceState(null, document.title, window.location.pathname + window.location.search)
                } catch {}
            }
        });

        function openFromHashIfNeeded() {
            const hash = String(window.location.hash || "").toLowerCase();
            if (hash === "#consumerlite-live-chat" || hash === "#live-chat" || hash === "#chat") {
                open();
                try {
                    window.history && window.history.replaceState && window.history.replaceState(null, document.title, window.location.pathname + window.location.search)
                } catch {}
            }
        }
        // Restore the conversation, not a delayed panel-open action from the prior page.
        // A queued automatic open can race the customer's first launcher click.
        window.addEventListener("hashchange", openFromHashIfNeeded), openFromHashIfNeeded();

        function isLikelyAudienceAnswer(text) {
            return /^(men|mens|man|male|women|womens|woman|female|hombre|mujer|homem|mulher|homme|femme|uomo|donna)$/i.test(String(text || "").trim())
        }

        function readMetaContent(selector) {
            try {
                const el = document.querySelector(selector);
                return el ? String(el.getAttribute("content") || "").trim() : ""
            } catch {
                return ""
            }
        }

        function parseProductJsonLd() {
            try {
                const scripts = Array.prototype.slice.call(document.querySelectorAll('script[type="application/ld+json"]'));
                for (let i = 0; i < scripts.length; i++) {
                    const raw = String(scripts[i].textContent || "").trim();
                    if (!raw) continue;
                    const parsed = JSON.parse(raw),
                        candidates = Array.isArray(parsed) ? parsed : Array.isArray(parsed["@graph"]) ? parsed["@graph"] : [parsed];
                    for (let j = 0; j < candidates.length; j++) {
                        const item = candidates[j] || {};
                        if (String(item["@type"] || item.type || "").toLowerCase().indexOf("product") !== -1) return item
                    }
                }
            } catch {}
            return null
        }

        function extractHandleFromProductUrl(urlText) {
            try {
                const match = new URL(urlText || location.href, location.origin).pathname.match(/\/products\/([^/?#]+)/i);
                return match ? decodeURIComponent(match[1]) : ""
            } catch {
                return ""
            }
        }

        function inferPageProductAudienceHint(title, handle, productType) {
            const text = normalizeLiteText([title || "", handle || "", productType || "", document.body ? document.body.innerText.slice(0, 5e3) : ""].join(" "));
            return /\b(mens|men s|men|male)\b/.test(text) && !/\b(womens|women s|women|female)\b/.test(text) ? "MEN" : /\b(womens|women s|women|female|ladies)\b/.test(text) && !/\b(mens|men s|men|male)\b/.test(text) ? "WOMEN" : "UNKNOWN"
        }

        function collectProductMetaValues(selector) {
            try {
                return Array.prototype.slice.call(document.querySelectorAll(selector)).map(function(el) {
                    return String(el.getAttribute("content") || el.textContent || "").trim()
                }).filter(Boolean).slice(0, 30)
            } catch {
                return []
            }
        }

        function collectPageCollectionSignals() {
            const handles = [],
                titles = [];
            try {
                Array.prototype.slice.call(document.querySelectorAll('a[href*="/collections/"]')).forEach(function(a) {
                    const href = String(a.getAttribute("href") || ""),
                        handle = collectionHandleFromUrl(href);
                    if (!handle || /^(all|frontpage)$/i.test(handle)) return;
                    const label = String(a.textContent || "").replace(/\s+/g, " ").trim();
                    !a.closest('[class*="breadcrumb"], [class*="product"], [id*="product"], main') && handles.length >= 4 || (handles.indexOf(handle) === -1 && handles.push(handle), label && titles.indexOf(label) === -1 && titles.push(label))
                })
            } catch {}
            return {
                handles: handles.slice(0, 12),
                titles: titles.slice(0, 12)
            }
        }

        function inferPageProductSlotHint(title, handle, productType, tags, collectionHandles) {
            const text = normalizeLiteText([title || "", handle || "", productType || "", (tags || []).join(" "), (collectionHandles || []).join(" ")].join(" "));
            return /\b(two piece|two-piece|matching set|set|sets|shorts set|skirt set|pants set|top.*shorts)\b/.test(text) ? "set" : /\b(dress|jumpsuit|romper|one piece|one-piece)\b/.test(text) ? "onepiece" : /\b(short|shorts|pant|pants|trouser|trousers|jean|jeans|denim|skirt|bottom)\b/.test(text) ? "bottom" : /\b(shoe|shoes|sneaker|sneakers|boot|boots|sandal|sandals|heel|heels|loafer|loafers)\b/.test(text) ? "footwear" : /\b(jacket|coat|blazer|cardigan|overshirt|outerwear|layer)\b/.test(text) ? "layer" : /\b(shirt|tee|t shirt|t-shirt|top|tank|polo|blouse|sweater|hoodie)\b/.test(text) ? "top" : /\b(bag|handbag|purse|belt|hat|cap|sunglasses|accessory|jewelry)\b/.test(text) ? "accessory" : ""
        }

        function buildPageProductIntelligence(title, handle, productType, tags, collectionHandles) {
            const slot = inferPageProductSlotHint(title, handle, productType, tags, collectionHandles),
                audience = inferPageProductAudienceHint(title, handle, [productType || "", (tags || []).join(" "), (collectionHandles || []).join(" ")].join(" "));
            return {
                slot: slot || "",
                gender: audience && audience !== "UNKNOWN" ? audience.toLowerCase() : "",
                signals: (tags || []).concat(collectionHandles || []).slice(0, 30)
            }
        }

        function extractSelectedVariantIdFromPage() {
            try {
                const input2 = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action="/cart/add"] input[name="id"], select[name="id"]');
                if (input2 && input2.value) return String(input2.value).trim()
            } catch {}
            try {
                const match = String(location.search || "").match(/[?&]variant=(\d+)/i);
                if (match) return match[1]
            } catch {}
            return ""
        }

        function extractCurrentPageProductContext() {
            try {
                if (!/\/products\//i.test(location.pathname)) return null;
                const jsonProduct = parseProductJsonLd() || {},
                    title = String(jsonProduct.name || readMetaContent('meta[property="og:title"]') || readMetaContent('meta[name="twitter:title"]') || (document.querySelector("h1") ? document.querySelector("h1").textContent : "") || "").replace(/\s+[-|–]\s+Consumerlite.*$/i, "").trim(),
                    imageValue = Array.isArray(jsonProduct.image) ? jsonProduct.image[0] : jsonProduct.image || readMetaContent('meta[property="og:image"]'),
                    offer = Array.isArray(jsonProduct.offers) ? jsonProduct.offers[0] : jsonProduct.offers || {},
                    currency = offer && offer.priceCurrency ? String(offer.priceCurrency) : readMetaContent('meta[property="product:price:currency"]'),
                    priceAmount = offer && offer.price ? String(offer.price) : readMetaContent('meta[property="product:price:amount"]'),
                    price = priceAmount ? String(priceAmount) + (currency ? " " + currency : "") : "",
                    url = String(jsonProduct.url || readMetaContent('meta[property="og:url"]') || location.href).trim(),
                    handle = extractHandleFromProductUrl(url || location.href),
                    brandObj = jsonProduct.brand || {},
                    vendor = String((typeof brandObj == "string" ? brandObj : brandObj.name || "") || readMetaContent('meta[property="product:brand"]') || "").trim(),
                    metaTags = collectProductMetaValues('meta[property="product:tag"], meta[name="product:tag"], meta[name="keywords"]'),
                    domTags = collectProductMetaValues("[data-product-tags], [data-tags], [data-product-tag]"),
                    tags = metaTags.concat(domTags.join(",").split(",")).map(function(x) {
                        return String(x || "").trim()
                    }).filter(Boolean).slice(0, 40),
                    collectionSignals = collectPageCollectionSignals(),
                    productType = String(jsonProduct.category || readMetaContent('meta[property="product:category"]') || "").trim();
                if (!title && !handle) return null;
                const productIntelligence = buildPageProductIntelligence(title, handle, productType, tags, collectionSignals.handles);
                return {
                    title,
                    handle,
                    url: url || location.href,
                    image: String(imageValue || ""),
                    price: String(price || ""),
                    productType,
                    vendor,
                    tags,
                    collectionHandles: collectionSignals.handles,
                    collectionTitles: collectionSignals.titles,
                    productIntelligence,
                    audienceHint: productIntelligence.gender ? productIntelligence.gender.toUpperCase() : inferPageProductAudienceHint(title, handle, [productType, tags.join(" "), collectionSignals.handles.join(" ")].join(" ")),
                    slotHint: productIntelligence.slot || "",
                    variantId: extractSelectedVariantIdFromPage(),
                    cartVariantId: extractSelectedVariantIdFromPage()
                }
            } catch {
                return null
            }
        }

        function buildConsumerliteAtelierProgressStages(userText) {
            const m = normalizeLiteText(userText || "");
            return /total|cost|price|how much/.test(m) ? ["Reviewing the edit\u2026", uiText("CHECKING_AVAILABILITY")] : /another|replace|change|swap|remove|casual|elevated|expensive|refine/.test(m) ? [uiText("UNDERSTANDING_REQUEST"), "Refining the edit\u2026", uiText("CHECKING_AVAILABILITY")] : /outfit|look|style|occasion|weather|season|gift|trending|product|complete/.test(m) ? [uiText("UNDERSTANDING_REQUEST"), uiText("BUILDING_EDIT"), uiText("CHECKING_AVAILABILITY"), uiText("PREPARING_LOOK")] : [uiText("UNDERSTANDING_REQUEST"), uiText("BUILDING_EDIT")]
        }

        function startConsumerliteAtelierProgress(bubble, userText) {
            const stages = buildConsumerliteAtelierProgressStages(userText);
            let index = 0,
                stopped = !1;
            bubble && stages.length && (bubble.textContent = stages[0]);
            const timer = window.setInterval(function() {
                stopped || !bubble || !bubble.isConnected || index < stages.length - 1 && (index += 1, bubble.textContent = stages[index])
            }, 850);
            return {
                stop: function() {
                    stopped = !0, window.clearInterval(timer)
                }
            }
        }

        function buildLoadingMessage(userText) {
            const raw = String(userText || "").trim(),
                m = normalizeLiteText(raw),
                hasAudience = !!(conversationContext.lastAudience || conversationContext.pendingAudience),
                hasPendingRequest = !!(conversationContext.pendingRequest || conversationContext.originalRequest || conversationContext.lastMeaningfulUserText);
            return m ? /how much|full look|whole look|entire outfit|complete outfit|total|cost|price/.test(m) ? "Reviewing the edit\u2026" : /under|below|less than|max|maximum|budget|affordable|premium|higher end|higher-end/.test(m) ? "Checking the best matches\u2026" : /style this|style around this|build around this|what goes with this|pair this|match this|complete this look|complete the look/.test(m) ? hasAudience || hasPendingRequest ? "Refining the edit\u2026" : uiText("ONE_MOMENT") : /collection|collections|browse|category|categories|coleccion|colecciones/.test(m) ? "Reviewing the collection\u2026" : /trending|trend|bestseller|best seller|popular|recommend|product|products|shop|buy|gift|boyfriend|girlfriend|husband|wife/.test(m) ? "Checking the best matches\u2026" : /another|reroll|replace|change|swap|remove|more casual|more elevated|refine|different|show me another/.test(m) ? "Refining the edit\u2026" : isLikelyAudienceAnswer(raw) ? hasPendingRequest ? "Checking the best matches\u2026" : uiText("ONE_MOMENT") : /outfit|look|style|occasion|weather|season|beach|dinner|party|wedding|travel|vacation|work|office/.test(m) ? hasAudience || hasPendingRequest ? "Curating the look\u2026" : "Checking the best matches\u2026" : uiText("ONE_MOMENT") : uiText("ONE_MOMENT")
        }
        async function callApi(userText, expectedGeneration = consumerliteConversationGeneration) {
            const endpoint = window.CONSUMERLITE_CHAT_ENDPOINT;
            if (!endpoint) return {
                reply: "Chat endpoint missing. Please set window.CONSUMERLITE_CHAT_ENDPOINT."
            };
            const cleanUserText = String(userText || "").trim();
            await ensureConsumerliteMemberIdentityReady();
            if (expectedGeneration !== consumerliteConversationGeneration) throw new Error("conversation_reset");
            const payloadContext = Object.assign({}, conversationContext),
                identityToken = String(consumerliteMemberAtelierState.chatIdentityToken || ""),
                identityExpiresAt = Number(consumerliteMemberAtelierState.chatIdentityExpiresAt || 0);
            identityToken && identityExpiresAt > Date.now() ? payloadContext.customerIdentityToken = identityToken : delete payloadContext.customerIdentityToken, payloadContext.atelierSessionToken = String(consumerliteAtelierState.sessionToken || ""), payloadContext.atelierSessionId = String(consumerliteAtelierState.sessionId || ""), payloadContext.atelierRevision = Number(consumerliteAtelierState.revision || 0), payloadContext.atelierLookState = consumerliteAtelierStatePayload(), payloadContext.atelierReadiness = buildConsumerliteAtelierReadiness(consumerliteAtelierState.currentLook || []);
            const analyticsAllowed = consumerliteChatAnalyticsAllowed();
            payloadContext.analyticsConsent = analyticsAllowed ? "granted" : "not_granted", analyticsAllowed ? (payloadContext.analyticsSessionId = getChatAnalyticsSessionId(), payloadContext.recentChatAnalytics = Array.isArray(conversationContext.analyticsEvents) ? conversationContext.analyticsEvents.slice(-12) : []) : (delete payloadContext.analyticsSessionId, delete payloadContext.recentChatAnalytics);
            const trackingPurchaseAnchor = getActiveConsumerliteTrackingPurchaseAnchor();
            trackingPurchaseAnchor ? (payloadContext.trackingPurchaseAnchor = trackingPurchaseAnchor, payloadContext.trackingPurchaseAnchorActive = !0, payloadContext.trackingPurchaseAnchorCleared = !1) : (delete payloadContext.trackingPurchaseAnchor, payloadContext.trackingPurchaseAnchorActive = !1);
            const memberAtelierAnchor = conversationContext.memberAtelierAnchor && typeof conversationContext.memberAtelierAnchor == "object" ? conversationContext.memberAtelierAnchor : null,
                pageProductContext = memberAtelierAnchor || extractCurrentPageProductContext();
            pageProductContext && (payloadContext.pageProduct = pageProductContext, payloadContext.currentPageProduct = pageProductContext, memberAtelierAnchor && (payloadContext.memberAtelierAnchor = memberAtelierAnchor));
            // Send the actual customer turn. The Worker owns continuation of its typed state.
            // Routing summaries must never re-enter reference extraction as user messages.
            delete payloadContext.visibleMessage;
            delete payloadContext.effectiveMessage;
            const payloadHistory = conversationHistory.slice(-24);
            return await (await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    message: cleanUserText,
                    pageUrl: location.href,
                    history: payloadHistory,
                    context: payloadContext
                })
            })).json()
        }
// Runs inside the existing widget closure, using its real conversation and edit.
function consumerliteEditText(key) {
    const labels = {
        en: ["Okay, let’s start fresh. What would you like help with?", "Choose sizes & colors", "Review selected pieces", "Remove", "Remove from edit", "Undo", "Removed from your edit", "Your edit is empty. You can undo or ask for a new outfit.", "Your chosen look is now in your edit.", "Tap a piece to choose its size and color. Remove pieces you don’t want.", "Selection does not add anything to your bag. Review your choices before adding.", "Price unavailable"],
        es: ["De acuerdo, empecemos de nuevo. ¿En qué te ayudo?", "Elegir tallas y colores", "Revisar las prendas elegidas", "Quitar", "Quitar del look", "Deshacer", "Quitado de tu look", "Tu look está vacío. Puedes deshacer o pedir otro conjunto.", "El look elegido está en tu selección.", "Toca una prenda para elegir talla y color. Quita las que no quieras.", "Elegir opciones no añade prendas a la bolsa. Revisa antes de añadir.", "Precio no disponible"],
        pt: ["Tudo bem, vamos começar de novo. Como posso ajudar?", "Escolher tamanhos e cores", "Rever peças escolhidas", "Remover", "Remover do look", "Desfazer", "Removido do seu look", "Seu look está vazio. Desfaça ou peça outro look.", "O look escolhido está na sua seleção.", "Toque numa peça para escolher tamanho e cor. Remova as que não quiser.", "Escolher opções não adiciona à sacola. Revise antes de adicionar.", "Preço indisponível"],
        fr: ["D’accord, repartons de zéro. Comment puis-je vous aider ?", "Choisir tailles et couleurs", "Vérifier les articles choisis", "Retirer", "Retirer de la sélection", "Annuler", "Retiré de votre sélection", "Votre sélection est vide. Annulez ou demandez une nouvelle tenue.", "La tenue choisie est dans votre sélection.", "Touchez un article pour choisir taille et couleur. Retirez ceux que vous ne voulez pas.", "Choisir des options n’ajoute rien au panier. Vérifiez avant d’ajouter.", "Prix indisponible"],
        de: ["Okay, beginnen wir neu. Wobei kann ich helfen?", "Größen und Farben wählen", "Ausgewählte Artikel prüfen", "Entfernen", "Aus dem Look entfernen", "Rückgängig", "Aus Ihrem Look entfernt", "Ihr Look ist leer. Machen Sie dies rückgängig oder fragen Sie nach einem neuen Outfit.", "Der gewählte Look ist jetzt in Ihrer Auswahl.", "Tippen Sie auf einen Artikel, um Größe und Farbe zu wählen. Entfernen Sie unerwünschte Artikel.", "Die Auswahl legt nichts in den Warenkorb. Prüfen Sie Ihre Auswahl vor dem Hinzufügen.", "Preis nicht verfügbar"],
        it: ["Va bene, ricominciamo. Come posso aiutarti?", "Scegli taglie e colori", "Rivedi i capi scelti", "Rimuovi", "Rimuovi dal look", "Annulla", "Rimosso dal tuo look", "Il look è vuoto. Annulla o chiedi un altro outfit.", "Il look scelto è nella tua selezione.", "Tocca un capo per scegliere taglia e colore. Rimuovi quelli che non vuoi.", "Scegliere le opzioni non aggiunge nulla alla borsa. Controlla prima di aggiungere.", "Prezzo non disponibile"]
    };
    const keys = ["RESET_ACK", "CHOOSE_EDIT_OPTIONS", "REVIEW_EDIT", "REMOVE_EDIT_SHORT", "REMOVE_EDIT", "UNDO_EDIT", "REMOVED_EDIT", "EMPTY_EDIT", "CHOSEN_EDIT", "EDIT_HELP", "EDIT_SELECTION_NOTE", "EDIT_PRICE_UNKNOWN"];
    const index = keys.indexOf(key);
    return index < 0 ? key : (labels[getCurrentLanguageCode()] || labels.en)[index];
}

function consumerliteIsFreshStartRequest(message, suggestionKey) {
    if (suggestionKey === "START_OVER") return true;
    const text = String(message || "").normalize("NFKC").toLowerCase().replace(/[.!?]+$/g, "").trim();
    return /^(?:please\s+)?(?:start\s*over|strat\s+over|start again|reset(?: (?:chat|conversation))?|restart(?: (?:chat|conversation))?|new (?:chat|conversation))(?:\s+please)?$/.test(text)
        || /^(?:empezar de nuevo|reiniciar|começar de novo|recomeçar|recommencer|neu anfangen|ricominciare)$/.test(text);
}

function resetConsumerliteConversation(options) {
    const opts = options && typeof options === "object" ? options : {};
    const retained = {};
    for (const key of ["customerIdentityToken", "languageCode", "replyLanguageCode", "explicitLanguagePreference", "languagePreferenceSource", "languageDirection"]) {
        if (Object.prototype.hasOwnProperty.call(conversationContext, key)) retained[key] = conversationContext[key];
    }
    const wasOpen = lastPersistedPanelOpen;
    closeConsumerliteCommerceOverlay();
    resetStoredChatSession();
    Object.assign(conversationContext, retained);
    conversationContext.trackingPurchaseAnchorCleared = true;
    conversationContext.trackingPurchaseAnchorActive = false;
    conversationContext.tellusFreshStartHome = opts.home !== false;
    lastPersistedPanelOpen = wasOpen;
    input.value = "";
    body.dataset.inited = "1";
    body.setAttribute("data-tellus-fresh-start-home", opts.home === false ? "false" : "true");
    const opening = consumerliteOpeningGreetingText({newConversation: true});
    if (opts.acknowledge !== false) {
        const reply = opening === INTRO_TEXT ? consumerliteEditText("RESET_ACK") : "Okay, let’s start fresh. " + opening;
        if (conversationContext.tellusOpeningGreeting) conversationContext.tellusOpeningGreeting.text = reply;
        addMsg("ai", reply, {forceFollow: true});
        pushHistory("assistant", reply);
    } else {
        addMsg("ai", opening);
        pushHistory("assistant", opening);
    }
    addSuggestions(localizeSuggestionsForUi(getIntroSuggestions()));
    applyInterfaceLocalization();
    persistChatSession();
    scheduleConsumerliteAtelierSync("reset", {});
}

function consumerliteNotifyEditContext() {
    if (typeof window.ConsumerliteTellusFix?.updateEditContext === "function") {
        window.ConsumerliteTellusFix.updateEditContext(conversationContext);
    }
}

function consumerliteReplaceEditCards(products) {
    // Retain spoken conversation; replace the active product presentation only.
    body.querySelectorAll(".cl-cards, .cl-full-look-actions").forEach(function(node) { node.remove(); });
    for (let i = conversationUiItems.length - 1; i >= 0; i--) {
        if (["products", "collections", "fullLookAction"].includes(conversationUiItems[i]?.type)) conversationUiItems.splice(i, 1);
    }
    if (products.length) addProductCards(products, {updateAtelier: false});
}

function consumerliteEditActionText(selected) {
    const labels={en:['Add to edit','In your edit'],es:['Añadir a la selección','En tu selección'],pt:['Adicionar ao look','No seu look'],fr:['Ajouter à la sélection','Dans votre sélection'],de:['Zum Look hinzufügen','In Ihrem Look'],it:['Aggiungi alla selezione','Nella tua selezione']};
    return (labels[getCurrentLanguageCode()]||labels.en)[selected?1:0];
}
function consumerliteEditProductRoles(product) {
    const explicit=product.occupiedSlots || product.productIntelligence && product.productIntelligence.occupiedSlots;
    if (/\bset\b/.test(normalizeLiteText(product.productLabelKey || "")) && (!Array.isArray(explicit) || explicit.length < 2)) return ["top","bottom"];
    if (Array.isArray(explicit) && explicit.length) return explicit.flatMap(role=>/one.?piece|set/.test(role)?['top','bottom']:role==='footwear'?['shoes']:[role]);
    let role=normalizeLiteText(product.outfitSlot || product.productLabelKey || '');
    if (!role || role==='product' || role==='unknown') {
        const identity=normalizeLiteText(product.title||'');
        role=/\b(?:dress|jumpsuit|romper|matching set|two piece set)\b/.test(identity)?'onepiece':/\b(?:clogs?|sneakers?|trainers?|loafers?|boots?|sandals?|heels?|flats?|shoes?)\b/.test(identity)?'shoes':/\b(?:blazers?|jackets?|coats?|cardigans?)\b/.test(identity)?'layer':/\b(?:trousers?|pants?|jeans?|skirts?|shorts?|skorts?)\b/.test(identity)?'bottom':/\b(?:tops?|shirts?|t shirts?|tees?|blouses?|sweaters?|hoodies?)\b/.test(identity)?'top':/\b(?:bags?|totes?|clutches?)\b/.test(identity)?'bag':'';
    }
    if (/footwear|shoe/.test(role)) role='shoes';
    if (/one.?piece|set/.test(role)) return ['top','bottom'];
    if (/layer/.test(role)) role='layer';
    if (/accessor/.test(role)) role='accessory';
    return role?[role]:[];
}
function consumerliteRefreshEditButtons() {
    const handles=new Set((consumerliteAtelierState.currentLook||[]).map(p=>p.handle));
    document.querySelectorAll('.cl-card-edit').forEach(button=>{
        const selected=handles.has(button.dataset.productHandle);
        button.textContent=consumerliteEditActionText(selected);
        button.setAttribute('aria-label',consumerliteEditActionText(selected)+': '+String(button.dataset.productTitle||uiText('PRODUCT')));
        button.hidden=false;
        button.setAttribute("aria-pressed",selected?"true":"false");
        button.disabled=consumerlitePendingSendCount>0;
    });
}
function consumerliteActivateEditCard(product) {
    if (consumerlitePendingSendCount>0) return;
    const selected=(consumerliteAtelierState.currentLook||[]).some(p=>p.handle===product.handle);
    if (!selected) return consumerliteAddProductToEdit(product);
    consumerliteAtelierState.collapsed=false;
    renderConsumerliteAtelierWorkspace();
    persistChatSession();
    atelier?.querySelector('.cl-atelier-piece')?.focus({preventScroll:true});
}
function consumerliteProductPresentation() {
    return compactUiItemsForStorage(conversationUiItems).filter(item=>item.type==='products');
}
function consumerliteRestoreProductPresentation(groups) {
    const saved=compactUiItemsForStorage(groups).filter(item=>item.type==='products');
    if (JSON.stringify(consumerliteProductPresentation())===JSON.stringify(saved)) return;
    body.querySelectorAll('.cl-cards').forEach(node=>node.remove());
    for(let i=conversationUiItems.length-1;i>=0;i--) if(conversationUiItems[i]?.type==='products') conversationUiItems.splice(i,1);
    for(const group of saved) addProductCards(group.products,{updateAtelier:false});
    consumerliteRefreshEditButtons();
}
function consumerliteAddProductToEdit(product) {
    if (!product || !product.handle || consumerlitePendingSendCount>0) return;
    const current=sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook||[]);
    if (current.some(p=>p.handle===product.handle)) return;
    const roles=consumerliteEditProductRoles(product);
    const next=current.filter(p=>!consumerliteEditProductRoles(p).some(role=>roles.includes(role)));
    next.push(product);
    consumerliteCommitEdit(next,String(product.title||'Piece')+' added to your edit. Choose size and color when ready.',{preserveCards:true});
    consumerliteRefreshEditButtons();
}
function consumerliteCommitEdit(products, notice, options) {
    const next = sanitizeConsumerliteAtelierLook(products);
    const previous = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook);
    const opts = options || {};
    consumerliteEditRevision += 1;
    if (opts.remember !== false) {
        consumerliteAtelierState.localUndo = {
            currentLook: previous,
            previousLook: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.previousLook),
            refinedLook: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.refinedLook),
            productGroups: consumerliteProductPresentation()
        };
        if (consumerliteLookHandleSignature(previous) !== consumerliteLookHandleSignature(next)) consumerliteAtelierState.previousLook = previous;
    }
    consumerliteAtelierState.currentLook = next;
    consumerliteAtelierState.comparison = null;
    consumerliteAtelierState.collapsed = false;
    consumerliteAtelierState.editNotice = String(notice || "").slice(0, 400);
    consumerliteAtelierState.readiness = buildConsumerliteAtelierReadiness(next);
    consumerliteAtelierState.updatedAt = Date.now();
    Object.assign(conversationContext, {
        currentLookProducts: next, lastProducts: next,
        previousLookProducts: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.previousLook),
        proposedLookProducts: sanitizeConsumerliteAtelierLook(consumerliteAtelierState.refinedLook),
        redoLookProducts: [], lookComparison: null, atelierReadiness: consumerliteAtelierState.readiness,
        atelierLookState: consumerliteAtelierStatePayload(), clearProductCards: !next.length,
        currentLookResponse: true, browseOnlyResponse: false, preserveCurrentLook: true,
        pendingRequest: "", canUndoRefinement: false, canRedoRefinement: false,
        tellusPreviousConversationState: null, tellusRedoConversationState: null
    });
    if (conversationContext.tellusConversationState && typeof conversationContext.tellusConversationState === "object") {
        conversationContext.tellusConversationState = {...conversationContext.tellusConversationState, revision: Number(conversationContext.tellusConversationState.revision || 0) + 1, pendingQuestion: null};
    }
    consumerliteNotifyEditContext();
    if (!opts.preserveCards) consumerliteReplaceEditCards(next);
    renderConsumerliteAtelierWorkspace();
    persistChatSession();
    scheduleConsumerliteAtelierSync("sync", {});
}

function removeConsumerliteEditPiece(handle) {
    if (consumerlitePendingSendCount) return false;
    const current = sanitizeConsumerliteAtelierLook(consumerliteAtelierState.currentLook);
    const product = current.find(function(piece) { return piece.handle === handle; });
    if (!product) return false;
    consumerliteCommitEdit(current.filter(function(piece) { return piece.handle !== handle; }), consumerliteEditText("REMOVED_EDIT") + ": " + product.title, {preserveCards:true});
    // Selection records stay available for Undo, but never enter the active look.
    const first = atelier?.querySelector(".cl-edit-remove") || atelier?.querySelector(".cl-edit-undo");
    first?.focus({preventScroll: true});
    return true;
}

function undoConsumerliteEditChange() {
    if (consumerlitePendingSendCount) return false;
    const undo = consumerliteAtelierState.localUndo;
    if (!undo || !Array.isArray(undo.currentLook)) return false;
    consumerliteAtelierState.previousLook = sanitizeConsumerliteAtelierLook(undo.previousLook);
    consumerliteAtelierState.refinedLook = sanitizeConsumerliteAtelierLook(undo.refinedLook);
    consumerliteAtelierState.localUndo = null;
    consumerliteCommitEdit(undo.currentLook, consumerliteEditText("CHOSEN_EDIT"), {remember:false,preserveCards:Array.isArray(undo.productGroups)});
    if (Array.isArray(undo.productGroups)) consumerliteRestoreProductPresentation(undo.productGroups);
    consumerliteRefreshEditButtons();
    persistChatSession();
    atelier?.querySelector(".cl-atelier-toggle")?.focus({preventScroll: true});
    return true;
}

function consumerliteRenderEditNotice() {
    if (!atelier) return;
    const notice = document.createElement("p");
    notice.className = "cl-edit-notice";
    notice.setAttribute("role", "status");
    notice.setAttribute("aria-live", "polite");
    notice.textContent = consumerliteAtelierState.editNotice || "";
    if (notice.textContent) atelier.appendChild(notice);
    if (consumerliteAtelierState.localUndo) {
        const undo = document.createElement("button");
        undo.type = "button";
        undo.className = "cl-edit-undo";
        undo.textContent = consumerliteEditText("UNDO_EDIT");
        undo.disabled = consumerlitePendingSendCount > 0;
        undo.addEventListener("click", undoConsumerliteEditChange);
        atelier.appendChild(undo);
    }
}

function consumerliteChooseComparedLook(products, expectedRevision, expectedGeneration) {
    if (consumerlitePendingSendCount || expectedRevision !== consumerliteEditRevision || expectedGeneration !== consumerliteConversationGeneration) return false;
    closeConsumerliteCommerceOverlay();
    consumerliteCommitEdit(products, consumerliteEditText("CHOSEN_EDIT"));
    atelier?.querySelector(".cl-atelier-toggle")?.focus({preventScroll: true});
    return true;
}

function consumerliteComparablePrice(products) {
    const readiness = buildConsumerliteAtelierReadiness(products);
    const currencies = new Set(products.map(function(product) {
        const price = consumerliteAtelierPiecePriceInfo(product);
        const prepared = preparedVariantForProduct(product);
        return String(prepared?.variant?.price?.currencyCode || price.currency || String(product.price || "").match(/\b[A-Z]{3}\b/)?.[0] || "USD").toUpperCase();
    }));
    return {known: readiness.hasCompletePrice && currencies.size === 1, total: readiness.total, currency: Array.from(currencies)[0]};
}


        // Private order views are transient DOM and memory only. They never enter
        // conversationHistory, conversationUiItems, analytics or the styling Worker.
        function clearConsumerlitePrivateOrders() {
            consumerliteOrderEpoch++;
            consumerliteOrderBusy=false;
            if(consumerliteOrderRoot)consumerliteOrderRoot.remove();
            consumerliteOrderRoot=null;
            consumerliteOrders={active:false,orders:[],selected:null,ownerRef:"",checkedAt:"",hasNextPage:false,endCursor:""};
        }
        function consumerliteOrderIntent(text) {
            if (tellusPurchaseHelpIntent(text)) return false;
            const m=String(text || "").normalize("NFKC").toLowerCase().replace(/[’‘]/g,"'").replace(/\s+/g," ").trim();
            if(/\b(?:place|make|create|start|submit) (?:a |an |my |the |new )?order\b/.test(m)&&!/\b(?:status|tracking|where|shipped|arrive|existing|previous|already)\b/.test(m))return false;
            // Account-order language is recognized before generic shopping or social replies.
            // Possessive/account qualifiers keep clothing purchase quantities and styling help separate.
            const accountOrder=/\b(?:my|our|the|this|that|an?|last|latest|newest|recent|open|past|previous|other)\s+(?:(?:last|latest|newest|recent|open|past|previous|current|online|first|second|third)\s+)?(?:orders?|purchases?|shipments?|packages?|parcels?)\b/.test(m);
            const orderRequest=/\b(?:help|assist(?:ance)?|support|trouble|problems?|issues?|questions?|details|status|tracking|track|check|show|view|find|see|where|when|shipp?(?:ed|ing)?|deliver(?:ed|y)?|arriv(?:e|al|ed|ing)?|updates?|cancel|refund|missing|wrong)\b/.test(m);
            if(accountOrder&&orderRequest)return true;
            if(/^(?:(?:please|pls|plz) )?(?:(?:my|our|all(?: my)?|open|recent|past|previous|latest|last|newest) )?(?:orders?|order history|purchases?|purchase history)(?: (?:please|pls|plz))?[.!?]*$/.test(m))return true;
            if(/\border(?:s)? (?:help|support|details)\b|\b(?:what|items?|products?|pieces?) i (?:ordered|bought|purchased)\b/.test(m))return true;
            if(/\border\s*(?:number\s*|no\.?\s*|#\s*)[a-z0-9_-]*\d[a-z0-9_-]*\b/.test(m)||/\b(?:where|status|tracking|track|check|shipped|arrive|delivered|update)\b/.test(m)&&/\border\s+[a-z0-9_-]*\d[a-z0-9_-]*\b/.test(m))return true;
            if(/\b(?:order(?:s)? (?:status|tracking|history|updates?)|track (?:my |an? |the )?(?:order|package|parcel)|(?:show|view|check|find) (?:me )?(?:my |the |open |recent |past |all )?orders?|what (?:did|have) i (?:order|purchase|buy))\b/.test(m))return true;
            if(/\b(?:my|our|the|this|that|latest|last|recent|other) (?:order|package|parcel|shipment)s?\b/.test(m)&&/where|when|ship|deliver|arriv|status|track|update|show|view|check|cancel|problem|wrong|missing|how much|refund/.test(m))return true;
            if(/\border\s*#[a-z0-9_-]+\b/.test(m))return true;
            if(consumerliteOrders.active&&(/^(?:the )?(?:first|second|third|fourth|fifth|latest|newest)(?: one| order)?[.!?]*$/.test(m.trim())||/\b(?:not received|haven.t received|never received|hasn.t arrived|delivered but|wrong item|missing item)\b/.test(m)))return true;
            if(consumerliteOrders.active&&/^(?:status|updates?|any updates?|refresh|check again)(?: please| pls)?[.!?]*$/.test(m.trim()))return true;
            return consumerliteOrders.active&&/^(?:please[, ]+)?(?:when will (?:it|they|this|my package) arrive\??|any updates\??|what(?:'s|s| is) the status\??|has it shipped\??|(?:show|view)(?: me)? (?:the )?(?:items|tracking|timeline|details)|what about (?:the |my )?(?:other|second|first) (?:package|parcel|order|item)\??|refresh(?: status)?|track (?:it|this)|it (?:says delivered|hasn.t arrived).*|#?[a-z0-9_-]*\d[a-z0-9_-]*)[.!?]*$/i.test(m.trim());
        }
        function orderNode(tag,text,className) {
            const node=document.createElement(tag);if(text!=null)node.textContent=String(text);if(className)node.className=className;return node;
        }
        function orderDate(value,withTime) {
            if(!value)return "";
            try{return new Intl.DateTimeFormat(getCurrentLanguageCode() || "en",withTime?{month:"short",day:"numeric",hour:"numeric",minute:"2-digit"}:{month:"short",day:"numeric",year:"numeric"}).format(new Date(value));}catch{return "";}
        }
        function orderAction(parent,label,callback) {
            const button=orderNode("button",label,"cl-order-action");button.type="button";
            button.addEventListener("click",()=>{if(!consumerliteOrderBusy)callback();});parent.appendChild(button);return button;
        }
        function orderLink(parent,label,href) {
            const url=safeUrl(href);if(!url||!url.startsWith("https:"))return;
            const link=orderNode("a",label,"cl-order-action");link.href=url;link.rel="noopener noreferrer";parent.appendChild(link);return link;
        }
        function orderView(reply,containsOrderData=false) {
            if(consumerliteOrderRoot)consumerliteOrderRoot.remove();
            const root=orderNode("section",null,"cl-order-private");root.setAttribute("aria-label","Your orders");root.setAttribute("aria-live","polite");
            root.dataset.orderPrivacy=containsOrderData?"private":"public-message";
            root.appendChild(orderNode("p","TELLUS · YOUR ORDERS","cl-order-kicker"));
            if(reply)root.appendChild(orderNode("p",reply,"cl-order-reply"));
            if(consumerliteOrders.notice)root.appendChild(orderNode("p",consumerliteOrders.notice,"cl-order-meta"));
            body.appendChild(root);consumerliteOrderRoot=root;consumerliteOrders.active=true;
            followConsumerliteConversation(true,false);focusConsumerliteResponseStart(root,true);return root;
        }
        function orderSignIn() {
            clearConsumerlitePrivateOrders();
            const root=orderView("Sign in to your Consumerlite account and I can check your orders here. Your order information is available only while you’re signed in.");
            const actions=orderNode("div",null,"cl-order-actions");root.appendChild(actions);
            const link=orderLink(actions,"Sign in to view orders","/account/login?return_url="+encodeURIComponent("/account#consumerlite-live-chat"));
            if(link)link.addEventListener("click",()=>{try{window.sessionStorage.setItem("consumerlite_tellus_resume_orders_v1","true");}catch{}});
        }
        async function requestConsumerlitePrivateOrders(action,params) {
            const url=consumerliteMemberAtelierProxyUrl(action);
            if(url.origin!==window.location.origin)throw {code:"orders_access_unavailable"};
            Object.entries(params || {}).forEach(([key,value])=>{if(value)url.searchParams.set(key,String(value));});
            const controller=new AbortController();const timer=window.setTimeout(()=>controller.abort(),16000);
            try {
                const response=await fetch(url.href,{method:"GET",headers:{Accept:"application/json"},credentials:"same-origin",cache:"no-store",signal:controller.signal});
                const data=await response.json().catch(()=>({}));
                if(response.status===401||data.code==="orders_sign_in_required"||data.ok===true&&data.authenticated===false)throw {code:"orders_sign_in_required"};
                if(!response.ok||data.ok!==true||data.authenticated!==true)throw {code:String(data.code || "orders_access_unavailable")};
                return data;
            }finally{window.clearTimeout(timer);}
        }
        function orderFailure(error) {
            if(error&&error.code==="orders_sign_in_required"){orderSignIn();return;}
            clearConsumerlitePrivateOrders();
            const root=orderView(error&&error.code==="orders_session_changed"?"Your account session has changed. Ask me to check your orders again.":error&&error.code==="order_unavailable"?"I couldn’t find that order in the orders available to this account. Choose another order, or review your order history.":"I can’t check your order details in Tellus right now. Please try again, or view your orders in your account.");
            const actions=orderNode("div",null,"cl-order-actions");root.appendChild(actions);
            orderAction(actions,"Try again",()=>loadConsumerliteOrderList());orderLink(actions,"View account","/account");
        }
        function orderItem(parent,item) {
            const row=orderNode("div",null,"cl-order-item");
            const imageUrl=safeUrl(item.image);
            if(imageUrl&&imageUrl.startsWith("https:")){const img=document.createElement("img");img.src=imageUrl;img.alt=item.imageAlt||item.title||"Ordered item";img.loading="lazy";img.referrerPolicy="no-referrer";row.appendChild(img);}
            const copy=orderNode("div");copy.appendChild(orderNode("p",item.title,"cl-order-item-title"));
            copy.appendChild(orderNode("p",[item.variantTitle&&item.variantTitle!=="Default Title"?item.variantTitle:"","Quantity: "+item.quantity].filter(Boolean).join(" · "),"cl-order-meta"));row.appendChild(copy);parent.appendChild(row);
        }
        function renderConsumerliteOrderList() {
            const all=consumerliteOrders.orders;
            const openOrders=all.filter(order=>order.isOpen);
            const visible=consumerliteOrders.includeClosed?all:openOrders.length?openOrders:all;
            const root=orderView(visible.length?(openOrders.length?"Here are your open or unconfirmed deliveries. Which order would you like me to check?":"Here are the recent orders available to your account. Which would you like to review?"):"I couldn’t find an order available to this account in Tellus. You can review your order history in your account.",true);
            visible.forEach(order=>{
                const card=orderNode("article",null,"cl-order-card");card.appendChild(orderNode("h3","Order "+order.name,"cl-order-title"));
                card.appendChild(orderNode("p",orderDate(order.createdAt),"cl-order-meta"));card.appendChild(orderNode("span",order.label,"cl-order-status"));
                (order.items || []).slice(0,3).forEach(item=>orderItem(card,item));
                const actions=orderNode("div",null,"cl-order-actions");card.appendChild(actions);
                orderAction(actions,"View order "+order.name,()=>loadConsumerliteOrderDetail(order.id,{view:consumerliteOrders.view}));root.appendChild(card);
            });
            const actions=orderNode("div",null,"cl-order-actions");root.appendChild(actions);
            if(consumerliteOrders.hasNextPage)orderAction(actions,"More orders",()=>loadConsumerliteOrderList(consumerliteOrders.endCursor));
            if(openOrders.length&&all.length>openOrders.length)orderAction(actions,consumerliteOrders.includeClosed?"Show open orders":"Include delivered and closed orders",()=>{
                consumerliteOrders.includeClosed=!consumerliteOrders.includeClosed;renderConsumerliteOrderList();
            });
            orderLink(actions,"View account","/account");
        }
        function orderReply(order) {
            const name="Your order "+order.name;
            if(order.code==="CANCELLED")return name+" is marked as cancelled. You can review its details below.";
            if(order.code==="REFUNDED")return name+" is marked as refunded. You can review the order below.";
            if(order.code==="PAYMENT_PENDING")return name+" is awaiting payment confirmation. It hasn’t shipped yet.";
            if(order.code==="NO_SHIPPING_REQUIRED")return name+" is marked as fulfilled and doesn’t require a physical delivery. Here are the order details.";
            if(order.code==="DIGITAL_PENDING")return name+" doesn’t require physical shipping. It is confirmed, and completion is still pending.";
            if(order.code==="DELIVERED")return order.shipments?.length===1&&order.shipments[0].deliveredAt?"The carrier marked order "+order.name+" as delivered on "+orderDate(order.shipments[0].deliveredAt,true)+". You can review the delivery update below.":"The delivery records for order "+order.name+" show that its shipments have been delivered or collected. You can review each update below.";
            if(order.code==="PARTIAL")return name+(order.hasOutstandingItems?" has items still awaiting shipment. Here are the available shipment updates.":" has "+order.shipments.length+" packages with separate updates. "+order.shipments.slice(0,3).map((s,i)=>"Package "+(i+1)+": "+s.label.toLowerCase()).join("; ")+".");
            const shipment=order.shipments?.[0];
            if(order.code==="OUT_FOR_DELIVERY")return name+" is out for delivery. The carrier’s latest update and any delivery estimate are shown below.";
            if(["IN_TRANSIT","CARRIER_PICKED_UP"].includes(order.code))return name+" is on its way"+(shipment?.tracking?.[0]?.company?" with "+shipment.tracking[0].company:"")+". Here’s the latest shipment information.";
            if(["LABEL_PURCHASED","LABEL_PRINTED","SHIPPING_DETAILS"].includes(order.code))return "Shipping details are available for order "+order.name+". I don’t yet have confirmation of carrier pickup.";
            if(order.code==="DELAYED")return "The carrier has reported a delay with order "+order.name+". Here’s the latest update"+(shipment?.estimatedDeliveryAt?" and the available delivery estimate.":". A revised delivery estimate isn’t available in Tellus yet.");
            if(order.code==="ATTEMPTED_DELIVERY")return "The carrier reports an attempted delivery for order "+order.name+". Please review the latest update below for any instructions.";
            if(order.code==="FAILURE")return "The carrier has reported a delivery issue with order "+order.name+". Here’s the latest information and a way to contact Consumerlite for help.";
            if(order.code==="READY_FOR_PICKUP")return name+" is ready for collection. Please review the carrier’s collection instructions.";
            return name+(order.code==="CONFIRMED"?" is confirmed and hasn’t shipped yet.":" is awaiting confirmation. I don’t have a confirmed shipment update yet.");
        }
        function renderConsumerliteOrderDetail(view) {
            const order=consumerliteOrders.selected;if(!order)return;
            const root=orderView(orderReply(order),true);
            root.appendChild(orderNode("h3","Order "+order.name,"cl-order-title"));root.appendChild(orderNode("span",order.label,"cl-order-status"));
            root.appendChild(orderNode("p","Placed "+orderDate(order.createdAt)+" · Checked "+orderDate(consumerliteOrders.checkedAt,true),"cl-order-meta"));
            if(order.total){try{root.appendChild(orderNode("p","Order total: "+new Intl.NumberFormat(getCurrentLanguageCode(),{style:"currency",currency:order.total.currencyCode}).format(Number(order.total.amount)),"cl-order-meta"));}catch{}}
            const actions=orderNode("div",null,"cl-order-actions");root.appendChild(actions);
            if(order.shipments?.length)orderAction(actions,view==="tracking"?"View order items":"Track package",()=>loadConsumerliteOrderDetail(order.id,{view:view==="tracking"?"items":"tracking"}));
            orderAction(actions,"Refresh status",()=>loadConsumerliteOrderDetail(order.id,{view}));
            orderAction(actions,"Other orders",()=>loadConsumerliteOrderList());
            if(view!=="tracking"||!order.shipments?.length){
                (order.items || []).forEach(item=>orderItem(root,item));
                if(order.moreItems)orderAction(root,"More order items",()=>loadConsumerliteOrderDetail(order.id,{view:"items",lineAfter:order.itemCursor}));
            }
            (order.shipments || []).forEach((shipment,index)=>{
                const card=orderNode("article",null,"cl-order-card");card.appendChild(orderNode("h4","Package "+(index+1),"cl-order-title"));card.appendChild(orderNode("span",shipment.label,"cl-order-status"));
                if(shipment.estimatedDeliveryAt)card.appendChild(orderNode("p","Estimated delivery: "+orderDate(shipment.estimatedDeliveryAt),"cl-order-meta"));
                else if(shipment.code!=="DELIVERED")card.appendChild(orderNode("p","A delivery estimate isn’t available yet.","cl-order-meta"));
                shipment.tracking.forEach(tracking=>{card.appendChild(orderNode("p",[tracking.company,tracking.number].filter(Boolean).join(" · "),"cl-order-meta"));});
                if(!shipment.sharedItems){const quantities=new Map((shipment.items || []).map(i=>[i.lineId,i.quantity]));(order.items || []).filter(item=>quantities.has(item.id)).forEach(item=>orderItem(card,{...item,quantity:quantities.get(item.id)}));}
                else card.appendChild(orderNode("p","These parcels share a shipment record; item allocation between parcels isn’t provided.","cl-order-meta"));
                if(shipment.moreItems)card.appendChild(orderNode("p","This shipment contains additional items. View the order items for the full order list.","cl-order-meta"));
                if(view==="tracking"){
                    const events=orderNode("ol",null,"cl-order-timeline");
                    shipment.events.forEach(event=>{const li=orderNode("li");li.appendChild(orderNode("p",event.message||String(event.status).replace(/_/g," ")));li.appendChild(orderNode("small",[orderDate(event.happenedAt,true),event.city,event.source].filter(Boolean).join(" · ")));events.appendChild(li);});
                    if(!shipment.events.length)card.appendChild(orderNode("p","Carrier checkpoints aren’t available in Tellus right now. You can refresh here or open carrier tracking.","cl-order-meta"));
                    card.appendChild(events);
                    shipment.tracking.forEach(tracking=>{if(tracking.url)orderLink(card,"Open carrier tracking",tracking.url);});
                }
                root.appendChild(card);
            });
            if(order.hasOutstandingItems&&order.code!=="DIGITAL_PENDING")root.appendChild(orderNode("p","Some items don’t have shipment details yet. I don’t have a confirmed shipping update for those items.","cl-order-meta"));
            if(order.moreShipments)root.appendChild(orderNode("p","Additional shipment records are available in your account.","cl-order-meta"));
            const help=orderNode("div",null,"cl-order-actions");orderLink(help,"Order help","/pages/customer-service");orderLink(help,"View account","/account");root.appendChild(help);
        }
        async function loadConsumerliteOrderList(after,includeClosed,latest) {
            if(consumerliteOrderBusy)return;consumerliteOrderBusy=true;
            const epoch=consumerliteOrderEpoch;orderView("I’m checking the orders available to your account…");
            try{
                const data=await requestConsumerlitePrivateOrders("member_orders",{after});if(epoch!==consumerliteOrderEpoch)return;
                const session=await requestConsumerlitePrivateOrders("member_order_session",{});if(epoch!==consumerliteOrderEpoch)return;
                if(session.ownerRef!==data.ownerRef)throw {code:"orders_session_changed"};
                const previous=after&&consumerliteOrders.ownerRef===data.ownerRef?consumerliteOrders.orders:[];
                consumerliteOrders.orders=[...new Map([...previous,...data.orders].map(order=>[order.id,order])).values()];consumerliteOrders.ownerRef=data.ownerRef;
                consumerliteOrders.selected=null;consumerliteOrders.checkedAt=data.checkedAt;consumerliteOrders.hasNextPage=data.hasNextPage;consumerliteOrders.endCursor=data.endCursor;
                if(!after)consumerliteOrders.includeClosed=!!includeClosed;
                const open=consumerliteOrders.orders.filter(order=>order.isOpen);
                if(latest&&consumerliteOrders.orders.length){consumerliteOrderBusy=false;await loadConsumerliteOrderDetail(consumerliteOrders.orders[0].id,{view:consumerliteOrders.view});return;}
                if(open.length===1&&!data.hasNextPage&&!consumerliteOrders.includeClosed){consumerliteOrderBusy=false;await loadConsumerliteOrderDetail(open[0].id,{view:consumerliteOrders.view});return;}
                renderConsumerliteOrderList();
            }catch(error){if(epoch===consumerliteOrderEpoch)orderFailure(error);}finally{if(epoch===consumerliteOrderEpoch)consumerliteOrderBusy=false;}
        }
        async function loadConsumerliteOrderDetail(id,options) {
            if(consumerliteOrderBusy)return;consumerliteOrderBusy=true;
            const opts=options||{},epoch=consumerliteOrderEpoch,previous=consumerliteOrders.selected;
            orderView("I’m checking the latest information for your order…");
            try{
                const data=await requestConsumerlitePrivateOrders("member_order",{orderId:id,reference:opts.reference,lineAfter:opts.lineAfter});if(epoch!==consumerliteOrderEpoch)return;
                const session=await requestConsumerlitePrivateOrders("member_order_session",{});if(epoch!==consumerliteOrderEpoch)return;
                if(session.ownerRef!==data.ownerRef)throw {code:"orders_session_changed"};
                const order=data.orders?.[0];if(!order)throw {code:"order_unavailable"};
                consumerliteOrders.view=opts.view||"items";
                if(opts.lineAfter&&previous?.id===order.id&&consumerliteOrders.ownerRef===data.ownerRef)order.items=[...new Map([...previous.items,...order.items].map(item=>[item.id,item])).values()];
                consumerliteOrders.selected=order;consumerliteOrders.ownerRef=data.ownerRef;consumerliteOrders.checkedAt=data.checkedAt;renderConsumerliteOrderDetail(opts.view||"items");
            }catch(error){if(epoch===consumerliteOrderEpoch)orderFailure(error);}finally{if(epoch===consumerliteOrderEpoch)consumerliteOrderBusy=false;}
        }
        async function handleConsumerliteOrderRequest(text) {
            if(consumerliteOrderBusy)return;
            input.value="";
            consumerliteOrders.notice=/\bcancel|\brefund|change.*address/i.test(text)?"I can check the order here. For a cancellation, refund or address change, please use Order help to contact Consumerlite.":"";
            consumerliteOrders.view=/track|where|arriv|deliver|updates|ship|package|parcel/i.test(text)?"tracking":/items|bought|ordered|purchase|details|history/i.test(text)?"items":consumerliteOrders.view||"items";
            const reference=String(text).match(/\border\s*(?:(?:number|no\.?)\s*)?#?\s*([a-z0-9_-]*\d[a-z0-9_-]*)\b/i)?.[1] || (consumerliteOrders.active ? String(text).trim().match(/^#?([a-z0-9_-]*\d[a-z0-9_-]*)[.!?]*$/i)?.[1] : "");
            if(reference){await loadConsumerliteOrderDetail("",{reference,view:consumerliteOrders.view});return;}
            if(/\b(?:latest|newest|most recent|last) order\b/i.test(text)){await loadConsumerliteOrderList(undefined,true,true);return;}
            const ordinal=String(text).toLowerCase().trim().match(/^(?:the )?(first|second|third|fourth|fifth|latest|newest)(?: one| order)?[.!?]*$/)?.[1];
            if(ordinal){const open=consumerliteOrders.orders.filter(order=>order.isOpen);const visible=consumerliteOrders.includeClosed?consumerliteOrders.orders:open.length?open:consumerliteOrders.orders;const index={first:0,second:1,third:2,fourth:3,fifth:4,latest:0,newest:0}[ordinal];if(visible[index]){await loadConsumerliteOrderDetail(visible[index].id,{view:consumerliteOrders.view});return;}}
            if(/other orders|all (?:my )?orders|order history|past orders|open orders/i.test(text)){await loadConsumerliteOrderList(undefined,/all (?:my )?orders|order history|past orders/i.test(text));return;}
            if(consumerliteOrders.selected){await loadConsumerliteOrderDetail(consumerliteOrders.selected.id,{view:/track|where|arriv|deliver|updates|ship|package|parcel/i.test(text)?"tracking":"items"});return;}
            await loadConsumerliteOrderList();
        }
        async function recheckConsumerliteOrderSession() {
            if(!consumerliteOrderRoot||!consumerliteOrderRoot.isConnected)return;
            // Safe sign-in/error messages have no customer data and can reopen immediately.
            // Real order views stay hidden until the current account is verified again.
            if(!consumerliteOrders.ownerRef){
                if(consumerliteOrderRoot.dataset.orderPrivacy==="public-message")consumerliteOrderRoot.hidden=false;
                return;
            }
            if(consumerliteOrderBusy)return;
            const epoch=consumerliteOrderEpoch;
            try{
                const data=await requestConsumerlitePrivateOrders("member_order_session",{});if(epoch!==consumerliteOrderEpoch)return;
                if(data.ownerRef!==consumerliteOrders.ownerRef){clearConsumerlitePrivateOrders();orderView("Your account session has changed. Ask me to check your orders again.");return;}
                consumerliteOrderRoot.hidden=false;
            }catch(error){if(epoch===consumerliteOrderEpoch)orderFailure(error);}
        }
        document.addEventListener("visibilitychange",()=>{
            if(!consumerliteOrderRoot)return;
            if(document.hidden)consumerliteOrderRoot.hidden=true;
            else if(panel.style.display==="flex")recheckConsumerliteOrderSession();
        });
        document.addEventListener("click",event=>{
            const link=event.target&&event.target.closest&&event.target.closest("a[href]");
            if(link&&/\/account\/logout(?:[?#]|$)/.test(link.getAttribute("href")||""))clearConsumerlitePrivateOrders();
        },true);
        window.addEventListener("pagehide",clearConsumerlitePrivateOrders);
        window.setInterval(()=>{if(consumerliteOrderRoot&&consumerliteOrderRoot.isConnected&&!document.hidden&&panel.style.display==="flex")recheckConsumerliteOrderSession();},60000);


// Shared by the storefront widget and Worker. No cart mutation is authorized here.
function tellusPurchaseHelpIntent(message) {
    const m = String(message || "").normalize("NFKC").toLowerCase().replace(/[’‘]/g, "'").replace(/\s+/g, " ").trim();
    if (!m || /\b(?:track(?:ing)?|order (?:status|history|number)|where (?:is|are)|already (?:ordered|placed|paid)|(?:order|ordered)\s*#|refund|returns?|exchange|cancel|shipment|parcel|hasn't arrived|haven't received|did not (?:order|place)|didn't (?:order|place))\b/.test(m)) return "";
    if (/\b(?:status|shipped|delivered|arriv(?:e|al|ing))\b/.test(m) && /\borders?\b/.test(m)) return "";
    if (/\b(?:payment|pay(?:pal)?|google|apple|crypto|usdc|discount|promo|declined|failed|error)\b/.test(m)) return "";
    if (/\b(?:review|show|view|check|open|see|what(?:'s| is))\b.*\b(?:my |the )?(?:bag|basket|cart)\b/.test(m) || /^(?:my )?(?:bag|basket|cart)[.!?]*$/.test(m)) return "bag";
    if (/\b(?:head|go|proceed|take me|ready|continue|help(?: me)?(?: with)?|how (?:do|can) i)\b.*\b(?:checkout|check out)\b/.test(m) || /^(?:checkout|check out)(?: please)?[.!?]*$/.test(m)) return "checkout";
    if (tellusPurchaseProductRequest(m)) return "";
    if (/\b(?:place|placing|make|making|create|start|submit) (?:a |an |my |the |new |a new |my first |a first )?order\b/.test(m) ||
        /\b(?:help|assist)(?: me)? (?:to )?(?:buy|order|purchase)\b/.test(m) ||
        /\b(?:how (?:do|can) i|how to) (?:buy|order|purchase)\b/.test(m) ||
        /\b(?:i (?:want|would like)|i'd like|can (?:i|you)) to (?:buy|order|purchase) (?:this|that|it|these|those)\b/.test(m) ||
        /\bcan (?:i|you) (?:buy|order|purchase) (?:this|that|it|these|those)\b/.test(m)) return "start";
    return "";
}

function tellusPurchaseProductRequest(message) {
    const m=String(message || '').normalize('NFKC').toLowerCase().replace(/[’‘]/g,"'").replace(/\s+/g,' ').trim();
    if (/\b(?:tracking|status|history|refund|return|cancel|already|shipped|shipment|where is|order number|account)\b/.test(m)) return '';
    const match=/\b(?:help(?: me)? (?:to )?(?:buy|order|purchase)|(?:i (?:want|would like)|i'd like) to (?:buy|order|purchase)|(?:can|could) (?:i|you) (?:buy|order|purchase)|^(?:please )?(?:buy|order|purchase))\s+(.+?)[.!?]*$/.exec(m);
    const target=match?.[1] || '';
    return target && !/^(?:this|that|it|these|those|one|an? order|my order|the order)\b/.test(target) ? target : '';
}

        // Purchase assistance uses the existing verified variant and Shopify bag paths.
        // Only a fresh, explicit add action can mutate the bag; reopening never does.
        function clearConsumerlitePurchaseHelp() {
            consumerlitePurchaseEpoch++;
            consumerlitePurchaseBusy = false;
            if (consumerlitePurchaseRoot) consumerlitePurchaseRoot.remove();
            document.querySelectorAll('.cl-chat-body .cl-purchase-bag').forEach(el=>el.remove());
            consumerlitePurchaseRoot = null;
            consumerlitePurchase = {stage:"", product:null, selectedOptions:[]};
            delete conversationContext.tellusPurchaseHelp;
        }
        function consumerlitePurchaseRemember() {
            conversationContext.tellusPurchaseHelp = {
                stage: consumerlitePurchase.stage,
                product: sanitizeConsumerliteAtelierProduct(consumerlitePurchase.product),
                choiceHandles: consumerlitePurchase.stage === 'choose_product' ? (consumerlitePurchase.choices || []).map(product=>product.handle).slice(0,6) : [],
                selectedOptions: (consumerlitePurchase.selectedOptions || []).slice(0,10).map(o=>({name:String(o.name),value:String(o.value)}))
            };
            persistChatSession();
        }
        function consumerlitePurchaseSay(text, actions) {
            if (consumerlitePurchaseRoot) consumerlitePurchaseRoot.remove();
            body.querySelectorAll('.cl-purchase-bag').forEach(el=>el.remove());
            body.querySelectorAll('.cl-suggestions').forEach(el=>el.remove());
            removeSuggestionUiItemsOnly();
            const bubble = addMsg('ai', text, {forceFollow:true});
            pushHistory('assistant', text);
            const root = document.createElement('div');
            root.className = 'cl-purchase-help cl-suggestions';
            root.setAttribute('role', 'group');
            root.setAttribute('aria-label', 'Shopping assistance');
            (actions || []).forEach(action=>{
                const button = document.createElement(action.href ? 'a' : 'button');
                button.className = 'cl-suggestion cl-purchase-action';
                button.textContent = action.label;
                if (action.href) button.href = action.href;
                else {
                    button.type = 'button';
                    button.addEventListener('click', ()=>{
                        if (!consumerlitePurchaseBusy && consumerlitePendingSendCount === 0) action.run();
                    });
                }
                root.appendChild(button);
            });
            body.appendChild(root);
            consumerlitePurchaseRoot = root;
            consumerlitePurchaseRemember();
            focusConsumerliteResponseStart(bubble, true);
        }
        function consumerlitePurchasePageProduct() {
            if (!/\/products\/[^/]+/.test(location.pathname)) return null;
            const base = extractCurrentPageProductContext() || {};
            let seed = {};
            try { seed = JSON.parse(document.querySelector('#cl-tellus-page-product-data')?.textContent || '{}'); } catch {}
            const pageHandle = extractHandleFromProductUrl(location.href);
            const product = seed.handle === pageHandle ? Object.assign({}, base, seed) : base;
            if (!product.handle || !product.title) return null;
            const main = document.querySelector('main'), picker = main?.querySelector('variant-picker');
            const form = picker?.getAttribute('form') ? document.getElementById(picker.getAttribute('form')) :
                main?.querySelector('form[action*="/cart/add"]');
            const selected = (product.selectedOptions || []).map(o=>({name:String(o.name),value:String(o.value)}));
            const controls = picker ? Array.from(picker.querySelectorAll('input[type="radio"]:checked,select')) :
                Array.from(main?.querySelectorAll('input[type="radio"]:checked,select') || []).filter(c=>form && c.form === form && /option/i.test(c.name || ''));
            for (const control of controls) {
                const name = /^options\[(.+)\]$/i.exec(control.name || '')?.[1];
                const position = Number(control.getAttribute('data-option-position')) || Number(/option(\d+)$/i.exec(control.name || '')?.[1]);
                const index = name ? selected.findIndex(o=>o.name.toLowerCase() === name.toLowerCase()) : position-1;
                if (index < 0 || index >= selected.length) continue;
                const label = control.tagName === 'SELECT' ? control.selectedOptions?.[0]?.textContent : Array.from(control.labels || []).map(l=>l.textContent?.trim()).find(Boolean);
                const value = label || control.getAttribute('data-option-value') || (!/^\d+$/.test(control.value || '') ? control.value : '');
                if (value) selected[index].value = String(value).trim();
            }
            return Object.assign({}, product, {selectedOptions:selected, variantId:String(form?.querySelector('[name="id"]')?.value || product.variantId || '')});
        }
        function consumerlitePurchaseCandidates() {
            if (consumerlitePurchase.stage === 'choose_product' && consumerlitePurchase.choices?.length) return consumerlitePurchase.choices.slice(0,6);
            const products = Array.from(body.querySelectorAll('.cl-card')).map(card=>{
                const handle = card.dataset.productHandle || extractHandleFromProductUrl(card.querySelector('a[href]')?.href || '');
                return (conversationContext.lastProducts || []).find(p=>p.handle === handle);
            }).filter(Boolean);
            const source = (products.length ? products : (conversationContext.lastProducts || [])).concat(consumerliteAtelierState.currentLook || []);
            return source.filter((p,i,a)=>p?.handle && a.findIndex(q=>q.handle===p.handle)===i).slice(0,6);
        }
        function consumerlitePurchaseListing(product, fresh) {
            const live=Object.assign({},product,fresh || {},{handle:product.handle});
            const media=fresh?.image || product.image;
            live.image=safeUrl(typeof media==='string' ? media : media?.url || '');
            live.imageAlt=String((typeof media==='object' && media?.altText) || product.imageAlt || live.title || 'Product');
            const range=fresh?.priceRange || product.priceRange;
            const min=range?.min, max=range?.max;
            if (min && /^\d+(?:\.\d+)?$/.test(String(min.amount)) && /^[A-Z]{3}$/.test(String(min.currencyCode))) {
                try {
                    const formatter=new Intl.NumberFormat(getCurrentLanguageCode() || 'en',{style:'currency',currency:min.currencyCode});
                    live.price=formatter.format(Number(min.amount));
                    if (max && /^\d+(?:\.\d+)?$/.test(String(max.amount)) && max.currencyCode===min.currencyCode && Number(max.amount)>Number(min.amount)) live.price+='–'+formatter.format(Number(max.amount));
                } catch {}
            }
            return live;
        }
        function consumerlitePurchaseListingDetails(options) {
            const ordered=(Array.isArray(options) ? options : []).slice().sort((a,b)=>Number(!/colou?r|shade|finish/i.test(a.name))-Number(!/colou?r|shade|finish/i.test(b.name)));
            const lines=[];
            for (const option of ordered) {
                const values=(option.values || []).filter(value=>value.available === true && value.value && value.value !== 'Default Title').map(value=>String(value.value));
                if (!values.length) continue;
                const unique=Array.from(new Set(values)), label=/^(?:colou?r)$/i.test(option.name) ? 'Colors' : String(option.name);
                lines.push(label+': '+unique.slice(0,6).join(', ')+(unique.length>6?' +'+(unique.length-6)+' more':''));
                if (lines.length===2) break;
            }
            return lines.join(' · ');
        }
        function consumerlitePurchaseChooseProducts(products, message) {
            const choices=(products || []).filter((product,index,list)=>product?.handle && list.findIndex(other=>other?.handle===product.handle)===index).slice(0,6);
            if (!choices.length) return consumerlitePurchaseFind();
            consumerlitePurchase.stage='choose_product';
            consumerlitePurchase.product=null;
            consumerlitePurchase.selectedOptions=[];
            consumerlitePurchase.payload=null;
            consumerlitePurchase.variant=null;
            consumerlitePurchase.choices=choices;
            consumerlitePurchaseSay(message || 'Of course. Which piece would you like to order? Choose a piece below, and I’ll help with its options.',[{label:'Something else',run:consumerlitePurchaseFind}]);
            const root=consumerlitePurchaseRoot, epoch=consumerlitePurchaseEpoch;
            root.classList.add('cl-purchase-chooser');
            const grid=document.createElement('div');
            grid.className='cl-purchase-grid';
            grid.setAttribute('role','list');
            grid.setAttribute('aria-label','Pieces to choose from');
            root.insertBefore(grid,root.firstChild);
            choices.forEach((product,index)=>{
                const card=document.createElement('article');
                card.className='cl-purchase-piece';
                card.dataset.productHandle=product.handle;
                card.setAttribute('role','listitem');
                const media=document.createElement('div');media.className='cl-purchase-media';
                const image=document.createElement('img');image.loading='lazy';image.decoding='async';image.referrerPolicy='no-referrer';
                const unavailable=document.createElement('span');unavailable.textContent='Image unavailable';unavailable.hidden=true;
                image.addEventListener('error',()=>{image.hidden=true;unavailable.hidden=false;});
                media.appendChild(image);media.appendChild(unavailable);card.appendChild(media);
                const content=document.createElement('div');content.className='cl-purchase-piece-body';
                const title=document.createElement('p');title.className='cl-card-title';content.appendChild(title);
                const price=document.createElement('p');price.className='cl-card-price';content.appendChild(price);
                const details=document.createElement('p');details.className='cl-purchase-piece-details';details.textContent='Checking color and option details…';content.appendChild(details);
                const button=document.createElement('button');button.type='button';button.className='cl-purchase-pick';button.textContent='Choose this piece';
                content.appendChild(button);card.appendChild(content);grid.appendChild(card);
                let current=consumerlitePurchaseListing(product);
                const duplicate=choices.some((other,otherIndex)=>otherIndex!==index && normalizeLiteText(other.title)===normalizeLiteText(product.title));
                function render() {
                    title.textContent=String(current.title || 'Product');
                    price.textContent=String(current.price || '');price.hidden=!current.price;
                    const imageUrl=safeUrl(current.image);
                    if (imageUrl && image.getAttribute('src')!==imageUrl) { image.hidden=false;unavailable.hidden=true;image.src=imageUrl; }
                    else if (!imageUrl) { image.hidden=true;unavailable.hidden=false; }
                    image.alt=String(current.imageAlt || current.title || 'Product');
                    button.setAttribute('aria-label','Choose '+String(current.title || 'this piece')+(details.textContent && details.dataset.checked==='true' ? '. '+details.textContent : '')+(duplicate ? '. Option '+(index+1)+' of '+choices.length : ''));
                    card.setAttribute('aria-label',String(current.title || 'Product')+(duplicate ? ', option '+(index+1)+' of '+choices.length : ''));
                }
                render();
                button.addEventListener('click',()=>{if(!consumerlitePurchaseBusy && consumerlitePendingSendCount===0 && root===consumerlitePurchaseRoot)consumerlitePurchasePrepare(current);});
                requestConsumerliteProductOptions(product.handle,[],'load').then(payload=>{
                    if (epoch!==consumerlitePurchaseEpoch || root!==consumerlitePurchaseRoot || !root.isConnected) return;
                    if (payload.product?.handle && payload.product.handle!==product.handle) throw new Error('listing_mismatch');
                    current=consumerlitePurchaseListing(product,payload.product);
                    choices[index]=current;
                    details.textContent=consumerlitePurchaseListingDetails(payload.options) || 'Choose this piece to review its options.';
                    details.dataset.checked='true';render();
                }).catch(()=>{
                    if (epoch!==consumerlitePurchaseEpoch || root!==consumerlitePurchaseRoot || !root.isConnected) return;
                    details.textContent='Choose this piece to check its options.';details.dataset.checked='true';render();
                });
            });
        }
        function consumerlitePurchaseFind() {
            consumerlitePurchase.stage = 'finding';
            consumerlitePurchase.product = null;
            consumerlitePurchaseSay('What would you like to find? Tell me the type of piece, an occasion, or a style you have in mind.', []);
        }
        async function consumerlitePurchaseBegin() {
            const page = consumerlitePurchasePageProduct();
            const candidates = consumerlitePurchaseCandidates();
            if (page) {
                consumerlitePurchase.product = page;
                consumerlitePurchase.selectedOptions = page.selectedOptions || [];
                consumerlitePurchase.stage = 'confirm_product';
                consumerlitePurchaseSay('Of course. Would you like to order the ' + page.title + ' you’re viewing?', [
                    {label:'Yes, this piece',run:consumerlitePurchaseConfirmProduct},
                    {label:'Something else',run:consumerlitePurchaseFind},
                    {label:'Review my bag',run:()=>consumerlitePurchaseBag(false)}
                ]);
            } else if (candidates.length) {
                consumerlitePurchaseChooseProducts(candidates);
            } else {
                consumerlitePurchase.stage = 'discover';
                consumerlitePurchaseSay('Of course. Is there a piece you already have your eye on, or would you like help choosing?', [
                    {label:'I have a piece in mind',run:()=>{
                        consumerlitePurchase.stage='finding';
                        consumerlitePurchaseSay('Which piece would you like? You can tell me its name or share its Consumerlite product link.',[]);
                    }},
                    {label:'Help me choose',run:consumerlitePurchaseFind},
                    {label:'Review my bag',run:()=>consumerlitePurchaseBag(false)}
                ]);
            }
        }
        function consumerlitePurchaseSelectionText(product, selected) {
            const parts = (selected || []).filter(o=>o.value && o.value !== 'Default Title').map(o=>/^(?:color|colour)$/i.test(o.name) ? o.value : /size/i.test(o.name) ? 'size '+o.value : o.name+': '+o.value);
            return String(product.title || 'this piece') + (parts.length ? ' in '+parts.join(', ') : '');
        }
        function consumerlitePurchaseConfirmProduct() {
            const current=consumerlitePurchasePageProduct();
            const product=current?.handle===consumerlitePurchase.product?.handle ? current : consumerlitePurchase.product;
            return consumerlitePurchasePrepare(product,product.selectedOptions?.length ? product.selectedOptions : consumerlitePurchase.selectedOptions?.length ? consumerlitePurchase.selectedOptions : undefined);
        }
        async function consumerlitePurchaseChangeOptions() {
            const product = consumerlitePurchase.product;
            if (!product) return consumerlitePurchaseBegin();
            if (!consumerlitePurchase.payload) return consumerlitePurchasePrepare(product, []);
            const options = (consumerlitePurchase.payload.options || []).filter(option=>
                (option.values || []).some(value=>value.value && value.value !== 'Default Title'));
            const choose = option=>consumerlitePurchasePrepare(product, consumerlitePurchase.selectedOptions.filter(
                selected=>normalizeVariantOptionText(selected.name) !== normalizeVariantOptionText(option.name)));
            if (options.length === 1) return choose(options[0]);
            consumerlitePurchase.stage = 'options';
            consumerlitePurchase.variant = null;
            if (!options.length) {
                consumerlitePurchaseSay('This piece doesn’t list additional options to change. You can review its details or choose another piece.', [
                    {label:'View product',href:safeUrl(product.url) || shopifyAjaxPath('products/'+encodeURIComponent(product.handle))},
                    {label:'Find another piece',run:consumerlitePurchaseFind}
                ]);
                return;
            }
            consumerlitePurchaseSay('You currently have '+consumerlitePurchaseSelectionText(product,consumerlitePurchase.selectedOptions)+'. Which option would you like to change?',
                options.map(option=>({label:String(option.name),run:()=>choose(option)})).concat([
                    {label:'View all options',run:()=>openConsumerliteVariantConcierge(product,{mode:'select_only',initialSelectedOptions:consumerlitePurchase.selectedOptions,onSelect:record=>consumerlitePurchasePrepare(product,record.selectedOptions)})}
                ]));
        }
        function consumerlitePurchaseResumeControl() {
            if (consumerlitePurchase.stage!=='paused' || !consumerlitePurchase.product) return;
            if (consumerlitePurchaseRoot) consumerlitePurchaseRoot.remove();
            const root=document.createElement('div');root.className='cl-purchase-help cl-suggestions';root.setAttribute('role','group');root.setAttribute('aria-label','Continue shopping');
            const button=document.createElement('button');button.type='button';button.className='cl-suggestion cl-purchase-action';button.textContent='Continue with '+consumerlitePurchase.product.title;
            button.addEventListener('click',()=>{if(!consumerlitePurchaseBusy&&consumerlitePendingSendCount===0)consumerlitePurchasePrepare(consumerlitePurchase.product,consumerlitePurchase.selectedOptions);});
            root.appendChild(button);body.appendChild(root);consumerlitePurchaseRoot=root;
        }
        async function consumerlitePurchasePrepare(product, explicitOptions, clarifySize) {
            if (consumerlitePurchaseBusy) return;
            const epoch = consumerlitePurchaseEpoch;
            consumerlitePurchaseBusy = true;
            try {
                const payload = await requestConsumerliteProductOptions(product.handle, [], 'load');
                if (epoch !== consumerlitePurchaseEpoch) return;
                if (payload.product?.handle && payload.product.handle!==product.handle) throw new Error('listing_mismatch');
                if (payload.product?.requiresProductPage) {
                    consumerlitePurchase.stage='details';
                    consumerlitePurchaseSay('This piece has additional options to complete on its product page. Open its details to choose them, then add it to your bag.',[
                        {label:'Choose options',href:safeUrl(payload.product.url || product.url) || shopifyAjaxPath('products/'+encodeURIComponent(product.handle))}
                    ]);
                    return;
                }
                const live = consumerlitePurchaseListing(product,payload.product);
                const options = Array.isArray(payload.options) ? payload.options : [];
                const variants = (payload.variants || []).filter(v=>v.availableForSale === true);
                const prepared = consumerliteSelectedVariants.get(product.handle);
                // An explicit empty selection means the customer is choosing again.
                // Only an omitted selection may fall back to the original page variant.
                const hasExplicitOptions = Array.isArray(explicitOptions);
                const desired = hasExplicitOptions ? explicitOptions : prepared?.selectedOptions || product.selectedOptions || [];
                const selected = new Map();
                for (const option of options) {
                    const wanted = desired.find(o=>normalizeVariantOptionText(o.name) === normalizeVariantOptionText(option.name));
                    const values = (option.values || []).filter(v=>v.available !== false);
                    const match = wanted && values.find(v=>normalizeVariantOptionText(v.value) === normalizeVariantOptionText(wanted.value));
                    if (match) selected.set(normalizeVariantOptionText(option.name), String(match.value));
                    else if (values.length === 1 && !/size|colou?r/i.test(option.name)) selected.set(normalizeVariantOptionText(option.name), String(values[0].value));
                }
                // Prefer the live page variant when the theme exposes its ID but omits option labels.
                if (!hasExplicitOptions && !desired.length && product.variantId) {
                    const pageVariant = variants.find(v=>String(v.id).replace(/\D/g,'') === String(product.variantId).replace(/\D/g,''));
                    for (const o of pageVariant?.selectedOptions || []) selected.set(normalizeVariantOptionText(o.name),o.value);
                }
                consumerlitePurchase.product=live;
                consumerlitePurchase.payload=payload;
                consumerlitePurchase.selectedOptions=selectedOptionsFromMap(selected, options);
                consumerlitePurchase.variant=null;
                if (!variants.length) {
                    consumerlitePurchase.stage='unavailable';
                    consumerlitePurchaseSay('I couldn’t find an available option for '+live.title+'. Would you like help finding another piece?', [{label:'Find another piece',run:consumerlitePurchaseFind}]);
                    return;
                }
                const missing = options.find(o=>!selected.has(normalizeVariantOptionText(o.name)));
                const exact = findExactAvailableVariant(variants, selected, options);
                if (!missing && exact) {
                    consumerlitePurchase.variant=exact;
                    consumerlitePurchase.stage='confirm_add';
                    consumerlitePurchaseSay('You’ve selected '+consumerlitePurchaseSelectionText(live,consumerlitePurchase.selectedOptions)+'. Would you like me to add one to your bag?',[
                        {label:'Add to bag',run:consumerlitePurchaseAdd},
                        {label:'Change options',run:consumerlitePurchaseChangeOptions}
                    ]);
                    return;
                }
                consumerlitePurchase.stage='options';
                const next = missing || options[options.length-1];
                if (!next) throw new Error('missing_product_options');
                const choices = (next.values || []).filter(v=>v.available !== false).filter(v=>{
                    const candidate = new Map(selected); candidate.set(normalizeVariantOptionText(next.name),String(v.value));
                    return variants.some(variant=>variantMatchesSelection(variant,candidate,''));
                });
                const actions = choices.map(value=>({label:String(value.value),run:()=>{
                    const changed = consumerlitePurchase.selectedOptions.filter(o=>normalizeVariantOptionText(o.name)!==normalizeVariantOptionText(next.name));
                    changed.push({name:next.name,value:String(value.value)});
                    return consumerlitePurchasePrepare(live,changed);
                }}));
                actions.push({label:'View all options',run:()=>openConsumerliteVariantConcierge(live,{mode:'select_only',initialSelectedOptions:consumerlitePurchase.selectedOptions,onSelect:record=>consumerlitePurchasePrepare(live,record.selectedOptions)})});
                const question = !choices.length ? 'I couldn’t find an available '+String(next.name).toLowerCase()+' with the current choices for '+live.title+'. Open all options to review other combinations.' :
                    clarifySize && /size/i.test(next.name) ? 'I couldn’t match that size to an available option for '+live.title+'. Which size would you like from the choices below?' :
                    missing ? 'Which '+String(next.name).toLowerCase()+' would you like for '+live.title+'?' : 'That size and color combination isn’t available. Which '+String(next.name).toLowerCase()+' would you like to change to?';
                consumerlitePurchaseSay(question,actions);
            } catch {
                if (epoch === consumerlitePurchaseEpoch) {
                    consumerlitePurchase.stage='retry'; consumerlitePurchase.product=product;
                    consumerlitePurchaseSay('I couldn’t check the options for '+String(product.title || 'this piece')+' just now. Would you like me to try again?',[
                        {label:'Try again',run:()=>consumerlitePurchasePrepare(product,explicitOptions,clarifySize)},
                        {label:'View product',href:safeUrl(product.url) || shopifyAjaxPath('products/'+encodeURIComponent(product.handle))}
                    ]);
                }
            } finally { if (epoch === consumerlitePurchaseEpoch) consumerlitePurchaseBusy=false; }
        }
        async function consumerlitePurchaseAdd() {
            if (consumerlitePurchaseBusy || consumerlitePurchase.stage !== 'confirm_add') return;
            const epoch=consumerlitePurchaseEpoch, product=consumerlitePurchase.product, selected=consumerlitePurchase.selectedOptions.slice();
            consumerlitePurchaseBusy=true;
            consumerlitePurchaseRoot?.querySelectorAll('button').forEach(button=>button.disabled=true);
            try {
                const resolved=await requestConsumerliteProductOptions(product.handle,selected,'resolve');
                if (epoch !== consumerlitePurchaseEpoch) return;
                const variant=resolved.selectedVariant;
                if (!variant?.id || variant.availableForSale !== true || !selected.every(o=>(variant.selectedOptions || []).some(v=>normalizeVariantOptionText(v.name)===normalizeVariantOptionText(o.name)&&normalizeVariantOptionText(v.value)===normalizeVariantOptionText(o.value)))) throw new Error('selection_unavailable');
                registerTrustedResolvedVariant({product:resolved.product || product,variant,selectedOptions:selected,checkedAt:Date.now()});
                await addResolvedVariantToCart(product,variant,selected,null);
                if (epoch !== consumerlitePurchaseEpoch) return;
                consumerlitePurchase.stage='added';
                consumerlitePurchaseSay('Your '+consumerlitePurchaseSelectionText(product,selected)+' is in your bag. Would you like to head to checkout or keep shopping?',[
                    {label:'Checkout',run:()=>consumerlitePurchaseBag(true)},
                    {label:'Keep shopping',run:consumerlitePurchaseKeepShopping},
                    {label:'Review my bag',run:()=>consumerlitePurchaseBag(false)}
                ]);
            } catch {
                if (epoch === consumerlitePurchaseEpoch) {
                    consumerlitePurchase.stage='retry';
                    consumerliteVariantLoadCache.delete(product.handle);
                    consumerlitePurchaseSay('I couldn’t confirm that this piece was added. Please review your bag before trying again.',[
                        {label:'Review my bag',run:()=>consumerlitePurchaseBag(false)},
                        {label:'Check options again',run:()=>consumerlitePurchasePrepare(product,selected)}
                    ]);
                }
            } finally { if (epoch === consumerlitePurchaseEpoch) consumerlitePurchaseBusy=false; }
        }
        function consumerlitePurchaseKeepShopping() {
            clearConsumerlitePurchaseHelp();
            const text='Of course. What would you like to look for next?';
            addMsg('ai',text,{forceFollow:true}); pushHistory('assistant',text);
            addSuggestions(localizeSuggestionsForUi(getIntroSuggestions()));
        }
        async function consumerlitePurchaseBag(checkout) {
            if (consumerlitePurchaseBusy) return;
            const epoch=consumerlitePurchaseEpoch;
            consumerlitePurchaseBusy=true;
            try {
                const cart=await fetchConsumerliteCart();
                if (epoch !== consumerlitePurchaseEpoch) return;
                consumerlitePurchase.stage='bag';
                if (!cart || !Array.isArray(cart.items)) {
                    consumerlitePurchaseSay('I couldn’t load your bag just now. You can try again or open your bag to continue.',[
                        {label:'Try again',run:()=>consumerlitePurchaseBag(checkout)},
                        {label:'Open bag',href:shopifyAjaxPath('cart')}
                    ]); return;
                }
                if (!cart.items.length) {
                    consumerlitePurchaseSay('Your bag is empty at the moment. Would you like help finding your first piece?',[
                        {label:'Help me choose',run:consumerlitePurchaseFind}
                    ]); return;
                }
                const count=cart.items.reduce((n,item)=>n+Number(item.quantity || 0),0);
                const title=count===1?'There’s one piece in your bag.':'There are '+count+' pieces in your bag.';
                consumerlitePurchaseSay(title+' '+(checkout?'Review your choices below, then continue to checkout to complete your purchase.':'Here are your current choices. Would you like to continue to checkout or keep shopping?'),[
                    {label:'Checkout',href:shopifyAjaxPath('checkout')},
                    {label:'Keep shopping',run:consumerlitePurchaseKeepShopping},
                    {label:'Edit bag',href:shopifyAjaxPath('cart')}
                ]);
                const summary=document.createElement('div'); summary.className='cl-purchase-bag';
                const list=document.createElement('ul');
                cart.items.slice(0,30).forEach(item=>{
                    const row=document.createElement('li'); row.className='cl-purchase-bag-item';
                    const imageUrl=safeUrl(item.featured_image?.url || item.image);
                    if (imageUrl) { const image=document.createElement('img');image.src=imageUrl;image.alt=String(item.product_title || item.title || 'Product');image.loading='lazy';row.appendChild(image); }
                    const details=document.createElement('div');
                    const options=(item.options_with_values || []).filter(o=>o.value && o.value!=='Default Title').map(o=>o.name+': '+o.value).join(', ');
                    details.textContent=String(item.product_title || item.title || 'Product')+(options?' · '+options:'')+' · Quantity: '+Number(item.quantity || 1);
                    row.appendChild(details);
                    list.appendChild(row);
                }); summary.appendChild(list);
                if (Number.isFinite(Number(cart.total_price)) && /^[A-Z]{3}$/.test(String(cart.currency || ''))) {
                    const total=document.createElement('p');
                    try { total.textContent='Bag total: '+new Intl.NumberFormat(getCurrentLanguageCode() || 'en',{style:'currency',currency:cart.currency}).format(Number(cart.total_price)/100)+'. Final shipping and taxes are shown at checkout.'; } catch {}
                    summary.appendChild(total);
                }
                consumerlitePurchaseRoot.parentNode.insertBefore(summary,consumerlitePurchaseRoot);
            } finally { if (epoch===consumerlitePurchaseEpoch) consumerlitePurchaseBusy=false; }
        }
        function consumerlitePurchaseTypedOptions(text) {
            const m=normalizeVariantOptionText(text).replace(/[,!?;]/g,' ').replace(/\.(?!\d)/g,' ').replace(/[–—-]/g,' ').replace(/\s+/g,' ').trim(), updates=[];
            // A new shopping/style request must not become a correction to an old piece.
            if (/\b(?:show|find|recommend|looking for|style|outfit|weather|trending|track|orders?|buy|purchase)\b/.test(m) || m.split(/\s+/).length>24) return updates;
            // Product questions are not option selections unless the customer is
            // explicitly correcting a choice.
            if (/\b(?:size (?:chart|guide|table|conversion)|sizing|measurements?|fit|materials?|fabric|stretch|care|shipping|payment)\b/.test(m) && !/\b(?:actually|instead|change|make that|i meant)\b/.test(m)) return updates;
            const sizeNames=[['xxs','2xs','xx small','extra extra small','double extra small'],['xs','extra small','x small'],['s','small'],['m','medium'],['l','large'],['xl','extra large','x large']];
            for (let count=2;count<=6;count++) sizeNames.push([String(count)+'xl',String(count)+' xl',String(count)+'x','x'.repeat(count)+'l','x'.repeat(count)+' large',Array(count).fill('extra').join(' ')+' large',...(count===2?['double extra large']:count===3?['triple extra large']:[])]);
            for (const option of consumerlitePurchase.payload?.options || []) {
                const matches=[], padded=' '+m+' ';
                for (const entry of option.values || []) {
                    const value=normalizeVariantOptionText(entry.value).replace(/[–—-]/g,' ');
                    const aliases=/size/i.test(option.name) ? sizeNames.find(group=>group.includes(value)) || [value] : [value];
                    const numeric=/size/i.test(option.name) && /^(?:us|uk|eu)\s+(\d+(?:\.\d+)?)$/.exec(value);
                    for (const alias of new Set(numeric ? aliases.concat(numeric[1]) : aliases)) {
                        if (!alias) continue;
                        let start=padded.indexOf(' '+alias+' ');
                        while (start!==-1) {
                            matches.push({entry,start,end:start+alias.length+1});
                            start=padded.indexOf(' '+alias+' ',start+1);
                        }
                    }
                }
                // A longer requested size still matters when it is absent from the
                // product: "extra small" must never fall back to the available S.
                if (/size/i.test(option.name)) {
                    const requestedAliases=sizeNames.flat().concat(m.match(/\b(?:us|uk|eu)\s+\d+(?:\.\d+)?\b/g) || []);
                    for (const alias of requestedAliases) {
                        let start=padded.indexOf(' '+alias+' ');
                        while (start!==-1) {
                            matches.push({entry:null,start,end:start+alias.length+1});
                            start=padded.indexOf(' '+alias+' ',start+1);
                        }
                    }
                }
                // Prefer a complete size/color phrase over a shorter match inside it.
                const precise=matches.filter(match=>!matches.some(other=>other.start<=match.start && other.end>=match.end && other.end-other.start>match.end-match.start));
                let found=(option.values || []).filter(entry=>precise.some(match=>match.entry===entry));
                if (!found.length && /colou?r/i.test(option.name)) {
                    const words=m.split(/\s+/).filter(word=>word.length>2&&!/^(?:actually|make|that|the|one|please|want|would|like|change|colour|color|instead)$/.test(word));
                    found=(option.values || []).filter(v=>words.some(word=>(' '+normalizeVariantOptionText(v.value)+' ').includes(' '+word+' ')));
                }
                if (found.length===1) updates.push({name:option.name,value:String(found[0].value)});
                else if (found.length>1) updates.ambiguousOption=option.name;
            }
            if (updates.some((a,i)=>updates.some((b,j)=>i!==j&&normalizeVariantOptionText(a.value)===normalizeVariantOptionText(b.value)))) {
                updates.splice(0,updates.length);updates.ambiguousOption='';updates.ambiguous=true;
            }
            const sizeOption=(consumerlitePurchase.payload?.options || []).find(option=>/size/i.test(option.name));
            const sizeWords=/(?:^|\s)(?:small|medium|large|xx?s|[sml]|x{1,6}l|[2-9]\s*x(?:l)?)(?=\s|$)/.test(m);
            const numericSize=/^(?:(?:actually|no|make that|i meant|instead|i want|i would like|can i have)\s+)?(?:(?:size|us|uk|eu)\s*)?\d+(?:\.\d+)?(?:\s+(?:please|instead))?$/.test(m);
            const explicitSize=/^(?:(?:actually|no|make that|i meant|i want|i would like|can i have)\s+)?(?:the |a )?size\s+\S+/.test(m);
            if (sizeOption && !updates.some(update=>normalizeVariantOptionText(update.name)===normalizeVariantOptionText(sizeOption.name)) && !updates.ambiguousOption && !updates.ambiguous && (sizeWords || numericSize || explicitSize)) updates.unmatchedSize=String(sizeOption.name);
            return updates;
        }
        async function handleConsumerlitePurchaseHelp(text, optionPayload) {
            const intent=tellusPurchaseHelpIntent(text), m=normalizeLiteText(text).replace(/,/g,' ').replace(/[.!?]+$/,'').replace(/\s+/g,' ').trim();
            if (!intent && !consumerlitePurchase.stage) return false;
            if (consumerlitePurchaseBusy) return true;
            if (consumerlitePendingSendCount>0) return false;
            const affirmative=tellusShortReplyKind(text) === "affirm" || /^(?:yes (?:this|that) (?:one|piece)|this one|that one|add (?:it|this|one)(?: to (?:my |the )?(?:bag|cart|basket))?)$/.test(m);
            const negative=tellusShortReplyKind(text) === "decline" || /^(?:something else|another piece)$/.test(m);
            const typedOptions=consumerlitePurchaseTypedOptions(text);
            const candidates=consumerlitePurchaseCandidates();
            const named=candidates.filter(p=>normalizeLiteText(p.title)===m);
            const ordinal=/^(?:the )?(first|second|third|fourth|fifth|sixth)(?: one| piece)?$/.exec(m);
            let linked=null;
            try { const url=new URL(text); if (url.origin===location.origin && /^\/products\/[-a-z0-9]+\/?$/i.test(url.pathname)) linked={handle:extractHandleFromProductUrl(url.href),title:'this piece',url:url.href}; } catch {}
            const isFind=/^(?:help me choose|help me find something|i have a piece in mind|something else|not sure|i'm not sure)$/.test(m);
            const active=consumerlitePurchase.stage;
            const resume=active==='paused' && /^(?:continue (?:my |the )?(?:purchase|order)|back to (?:the |my )?(?:purchase|order))$/.test(m);
            const handlesReply=intent || isFind || linked || resume || named.length>0 || (ordinal && active==='choose_product') ||
                (affirmative && ['confirm_product','confirm_add','options','retry','discover','added'].includes(active)) ||
                (negative && active) || ((typedOptions.length || typedOptions.ambiguousOption || typedOptions.ambiguous || typedOptions.unmatchedSize) && ['options','confirm_add'].includes(active)) ||
                /^(?:change options|keep shopping|continue shopping)$/.test(m);
            if (!handlesReply) {
                const newTask=/\b(?:show|find|recommend|looking for|style|outfit|weather|trending|buy|order|purchase)\b/.test(m);
                const sideQuestion=consumerlitePurchase.product && !newTask && (active==='paused' || /^(?:what|which|how|does|do|can|is|are|will)\b|\b(?:pay(?:ment)?|shipping|fit|material|care|size (?:chart|guide|table|conversion)|sizing|measurements?)\b/.test(m));
                if (sideQuestion) {
                    consumerlitePurchase.stage='paused';
                    if (consumerlitePurchaseRoot) consumerlitePurchaseRoot.remove();
                    consumerlitePurchaseRoot=null;
                    consumerlitePurchaseRemember();
                } else clearConsumerlitePurchaseHelp();
                return false;
            }
            if (consumerliteOrders.active) clearConsumerlitePrivateOrders();
            input.value='';
            if (optionPayload?.preserveLanguage !== true) setUiLanguageFromText(text);
            addMsg('user',String(optionPayload?.displayText || text),{forceFollow:true});
            pushHistory('user',text);
            if (intent==='bag' || intent==='checkout') await consumerlitePurchaseBag(intent==='checkout');
            else if (intent==='start') { clearConsumerlitePurchaseHelp(); await consumerlitePurchaseBegin(); }
            else if (m==='keep shopping' || m==='continue shopping') consumerlitePurchaseKeepShopping();
            else if (isFind || negative) consumerlitePurchaseFind();
            else if (m==='change options') await consumerlitePurchaseChangeOptions();
            else if (resume) await consumerlitePurchasePrepare(consumerlitePurchase.product,consumerlitePurchase.selectedOptions);
            else if (named.length>1) consumerlitePurchaseChooseProducts(named,'There’s more than one listing with that name. Choose the photo and color options you have in mind below.');
            else if (linked || named.length===1) await consumerlitePurchasePrepare(linked || named[0]);
            else if (ordinal && candidates[Number({first:0,second:1,third:2,fourth:3,fifth:4,sixth:5}[ordinal[1]])]) await consumerlitePurchasePrepare(candidates[{first:0,second:1,third:2,fourth:3,fifth:4,sixth:5}[ordinal[1]]]);
            else if (affirmative && active==='options') {
                const missing=(consumerlitePurchase.payload?.options || []).some(option=>!consumerlitePurchase.selectedOptions.some(selected=>normalizeVariantOptionText(selected.name)===normalizeVariantOptionText(option.name)));
                if (missing) await consumerlitePurchasePrepare(consumerlitePurchase.product,consumerlitePurchase.selectedOptions);
                else await consumerlitePurchaseChangeOptions();
            }
            else if (typedOptions.ambiguous) {
                consumerlitePurchaseSay('Which option would you like to change? Open the choices below so we can get the right combination.',[{label:'View all options',run:()=>openConsumerliteVariantConcierge(consumerlitePurchase.product,{mode:'select_only',initialSelectedOptions:consumerlitePurchase.selectedOptions,onSelect:record=>consumerlitePurchasePrepare(consumerlitePurchase.product,record.selectedOptions)})}]);
            } else if (typedOptions.ambiguousOption) {
                await consumerlitePurchasePrepare(consumerlitePurchase.product,consumerlitePurchase.selectedOptions.filter(o=>o.name!==typedOptions.ambiguousOption));
            } else if (typedOptions.unmatchedSize) {
                const selected=consumerlitePurchase.selectedOptions.filter(option=>normalizeVariantOptionText(option.name)!==normalizeVariantOptionText(typedOptions.unmatchedSize) && !typedOptions.some(update=>normalizeVariantOptionText(update.name)===normalizeVariantOptionText(option.name))).concat(typedOptions);
                await consumerlitePurchasePrepare(consumerlitePurchase.product,selected,true);
            } else if (typedOptions.length) {
                const selected=consumerlitePurchase.selectedOptions.filter(o=>!typedOptions.some(t=>normalizeVariantOptionText(t.name)===normalizeVariantOptionText(o.name))).concat(typedOptions);
                await consumerlitePurchasePrepare(consumerlitePurchase.product,selected);
            } else if (affirmative && active==='confirm_add') await consumerlitePurchaseAdd();
            else if (affirmative && active==='confirm_product') await consumerlitePurchaseConfirmProduct();
            else if (affirmative && active==='retry') await consumerlitePurchasePrepare(consumerlitePurchase.product,consumerlitePurchase.selectedOptions);
            else if (active==='added') await consumerlitePurchaseBag(false);
            else await consumerlitePurchaseBegin();
            return true;
        }

        async function doSend(sendOptions) {
            const optionPayload = sendOptions && typeof sendOptions == "object" ? sendOptions : {},
                rawText = optionPayload.sendText || input.value || "",
                text = String(rawText || "").trim();
            if (!text) return;
            if (consumerliteIsFreshStartRequest(text, optionPayload.suggestionKey)) {
                input.value = "";
                window.ConsumerliteChat.reset({acknowledge:true, home:true});
                return;
            }
            if (consumerliteOrderIntent(text)) { clearConsumerlitePurchaseHelp(); await handleConsumerliteOrderRequest(text); return; }
            if (await handleConsumerlitePurchaseHelp(text, optionPayload)) return;
            if (consumerliteOrders.active) clearConsumerlitePrivateOrders();
            conversationContext.tellusFreshStartHome = false;
            body.setAttribute("data-tellus-fresh-start-home", "false");
            const generation = consumerliteConversationGeneration;
            consumerlitePendingSendCount += 1;
            renderConsumerliteAtelierWorkspace();
            const displayText = String(optionPayload.displayText || text).trim(),
                historyText = String(optionPayload.historyText || (optionPayload.suppressUserBubble === !0 ? text : displayText)).trim();
            input.value = "", optionPayload.preserveLanguage !== !0 && setUiLanguageFromText(displayText), optionPayload.suppressUserBubble !== !0 && addMsg("user", displayText, {
                forceFollow: !0
            }), pushHistory("user", historyText || text), trackIntentFromText(text, {
                source: optionPayload.source || "typed",
                suggestionKey: optionPayload.suggestionKey || ""
            });
            const waitingBubble = addMsg("ai", String(optionPayload.loadingText || buildLoadingMessage(text)), {
                    persist: !1,
                    forceFollow: !0
                }),
                progressController = startConsumerliteAtelierProgress(waitingBubble, text);
            let responseRenderToken = "";
            try {
                const data = await callApi(text, generation);
                responseRenderToken = String(data && data.tellusRenderToken || "");
                if (generation !== consumerliteConversationGeneration) { progressController.stop(); return; }
                const replyText = data && data.reply ? sanitizeReplyText(String(data.reply)) : "No reply.",
                    clarificationResponse = !!(data && (data?.debug?.trackingInitialBuildHardRoute === !0 || data?.contextPatch?.trackingInitialBuildHardRoute === !0 || data?.context?.trackingInitialBuildHardRoute === !0) && data.showCards === !0 && Array.isArray(data.products) && data.products.length > 0) ? !1 : isClarificationResponse(replyText, data || {});
                clarificationResponse && data && (data.showCards = !1, data.products = [], data.showCollectionCards = !1, data.collectionCards = []), progressController.stop(), waitingBubble.textContent = replyText, addUiItem({
                    type: "msg",
                    role: "ai",
                    text: replyText
                }), pushHistory("assistant", replyText), trackConsumerliteChatEvent("response_received", {
                    intent: data && data.debug && data.debug.intent ? String(data.debug.intent) : "",
                    showProducts: !!(data && data.showCards),
                    showCollections: !!(data && data.showCollectionCards),
                    hasSuggestions: !!(data && Array.isArray(data.suggestions) && data.suggestions.length)
                }), /\b(did not find|could not load|not find|no matching|not enough price information)\b/i.test(replyText) && trackConsumerliteChatEvent("no_match_shown", {
                    intent: data && data.debug && data.debug.intent ? String(data.debug.intent) : ""
                });
                const hasProductResults = !!(data && data.showCards && Array.isArray(data.products) && data.products.length),
                    hasCollectionResults = !!(data && data.showCollectionCards && Array.isArray(data.collectionCards) && data.collectionCards.length);
                consumerliteResponseRenderLock = !0;
                try {
                    rememberPendingRequestIfNeeded(text, replyText), mergeContextFromWorker(data), updateConsumerliteAtelierFromResponse(data), (clarificationResponse || responseWantsProductClear(data) || data && (hasProductResults || hasCollectionResults || data.cta || Array.isArray(data.suggestions) && data.suggestions.length)) && clearOldExtras(!clarificationResponse && !responseWantsProductClear(data) && !hasProductResults && !hasCollectionResults);
                    const anchorNote = data && data.contextPatch && data.contextPatch.styleAroundNote ? data.contextPatch.styleAroundNote : data && data.context && data.context.styleAroundNote ? data.context.styleAroundNote : "";
                    anchorNote && addAnchorNote(anchorNote), hasProductResults ? addProductCards(data.products, {
                        responseData: data,
                        updateAtelier: !1
                    }) : hasCollectionResults && addCollectionCards(data.collectionCards);
                    const postOutfitFollowUp = data && data.followUpQuestion ? sanitizeReplyText(String(data.followUpQuestion)) : "";
                    postOutfitFollowUp && normalizeLiteText(postOutfitFollowUp) !== normalizeLiteText(replyText) && (addMsg("ai", postOutfitFollowUp, {
                        forceFollow: !1
                    }), pushHistory("assistant", postOutfitFollowUp), trackConsumerliteChatEvent("post_outfit_precision_question_shown", {
                        intent: data && data.debug && data.debug.intent ? String(data.debug.intent) : ""
                    })), data && data.cta && addCta(data.cta), body.querySelectorAll(".cl-suggestions").forEach(el => el.remove()), removeSuggestionUiItemsOnly(), data && Array.isArray(data.suggestions) && addSuggestions(data.suggestions)
                } finally {
                    consumerliteResponseRenderLock = !1
                }
                hasProductResults || hasCollectionResults ? focusConsumerliteResponseStart(waitingBubble, !0) : followConsumerliteConversation(!1, !0)
            } catch {
                consumerliteResponseRenderLock = !1, progressController.stop();
                if (generation !== consumerliteConversationGeneration) return;
                const fallback = uiText("FALLBACK");
                waitingBubble.textContent = fallback, addUiItem({
                    type: "msg",
                    role: "ai",
                    text: fallback
                }), pushHistory("assistant", fallback)
            } finally {
                progressController.stop();
                if (generation === consumerliteConversationGeneration) {
                    consumerlitePendingSendCount = Math.max(0, consumerlitePendingSendCount - 1);
                    renderConsumerliteAtelierWorkspace();
                    consumerlitePurchaseResumeControl();
                }
                window.ConsumerliteTellusFix?.responseRendered?.(responseRenderToken);
            }
        }
        send.onclick = doSend, input.addEventListener("keydown", function(e) {
            e.key === "Enter" && doSend()
        }), window.addEventListener("pagehide", function() {
            persistChatSession(), window.removeEventListener("consumerlite:tellus-context", handleConsumerliteTellusTrackingContext), window.removeEventListener("consumerlite:tellus-style-purchase", handleConsumerliteTellusTrackingAutoStyle)
        })
    }
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init()
})();
